export const WORDS = [
  { word: 'ABACK', frequency: 9.77e-07, inWordle: true },
  { word: 'ABASE', frequency: 3.63e-08, inWordle: true },
  { word: 'ABATE', frequency: 4.79e-07, inWordle: true },
  { word: 'ABBEY', frequency: 7.59e-06, inWordle: true },
  { word: 'ABBOT', frequency: 2.69e-06, inWordle: true },
  { word: 'ABHOR', frequency: 4.37e-07, inWordle: true },
  { word: 'ABIDE', frequency: 3.89e-06, inWordle: true },
  { word: 'ABLED', frequency: 1.95e-07, inWordle: true },
  { word: 'ABODE', frequency: 1.35e-06, inWordle: true },
  { word: 'ABORT', frequency: 1.86e-06, inWordle: true },
  { word: 'ABOUT', frequency: 0.00251, inWordle: true },
  { word: 'ABOVE', frequency: 0.000158, inWordle: true },
  { word: 'ABUSE', frequency: 4.57e-05, inWordle: true },
  { word: 'ABYSS', frequency: 2.51e-06, inWordle: true },
  { word: 'ACORN', frequency: 1.2e-06, inWordle: true },
  { word: 'ACRID', frequency: 2.34e-07, inWordle: true },
  { word: 'ACTOR', frequency: 4.47e-05, inWordle: true },
  { word: 'ACUTE', frequency: 1e-05, inWordle: true },
  { word: 'ADAGE', frequency: 8.91e-07, inWordle: true },
  { word: 'ADAPT', frequency: 9.55e-06, inWordle: true },
  { word: 'ADEPT', frequency: 2.14e-06, inWordle: true },
  { word: 'ADMIN', frequency: 8.32e-06, inWordle: true },
  { word: 'ADMIT', frequency: 3.8e-05, inWordle: true },
  { word: 'ADOBE', frequency: 3.39e-06, inWordle: true },
  { word: 'ADOPT', frequency: 1.55e-05, inWordle: true },
  { word: 'ADORE', frequency: 5.01e-06, inWordle: true },
  { word: 'ADORN', frequency: 1.02e-06, inWordle: true },
  { word: 'ADULT', frequency: 6.31e-05, inWordle: true },
  { word: 'AFFIX', frequency: 4.27e-07, inWordle: true },
  { word: 'AFIRE', frequency: 2.88e-07, inWordle: true },
  { word: 'AFOOT', frequency: 7.76e-07, inWordle: true },
  { word: 'AFOUL', frequency: 4.27e-07, inWordle: true },
  { word: 'AFTER', frequency: 0.00129, inWordle: true },
  { word: 'AGAIN', frequency: 0.000501, inWordle: true },
  { word: 'AGAPE', frequency: 4.47e-07, inWordle: true },
  { word: 'AGATE', frequency: 6.46e-07, inWordle: true },
  { word: 'AGENT', frequency: 6.46e-05, inWordle: true },
  { word: 'AGILE', frequency: 2.57e-06, inWordle: true },
  { word: 'AGING', frequency: 1.1e-05, inWordle: true },
  { word: 'AGLOW', frequency: 1.62e-07, inWordle: true },
  { word: 'AGONY', frequency: 3.98e-06, inWordle: true },
  { word: 'AGREE', frequency: 9.33e-05, inWordle: true },
  { word: 'AHEAD', frequency: 0.000102, inWordle: true },
  { word: 'AIDER', frequency: 8.71e-08, inWordle: true },
  { word: 'AISLE', frequency: 5.25e-06, inWordle: true },
  { word: 'ALARM', frequency: 1.91e-05, inWordle: true },
  { word: 'ALBUM', frequency: 0.000105, inWordle: true },
  { word: 'ALERT', frequency: 2.14e-05, inWordle: true },
  { word: 'ALGAE', frequency: 3.47e-06, inWordle: true },
  { word: 'ALIBI', frequency: 1.26e-06, inWordle: true },
  { word: 'ALIEN', frequency: 1.95e-05, inWordle: true },
  { word: 'ALIGN', frequency: 4.27e-06, inWordle: true },
  { word: 'ALIKE', frequency: 1.35e-05, inWordle: true },
  { word: 'ALIVE', frequency: 5.75e-05, inWordle: true },
  { word: 'ALLAY', frequency: 4.9e-07, inWordle: true },
  { word: 'ALLEY', frequency: 7.41e-06, inWordle: true },
  { word: 'ALLOT', frequency: 6.17e-07, inWordle: true },
  { word: 'ALLOW', frequency: 0.000102, inWordle: true },
  { word: 'ALLOY', frequency: 4.07e-06, inWordle: true },
  { word: 'ALOFT', frequency: 1.2e-06, inWordle: true },
  { word: 'ALONE', frequency: 0.000145, inWordle: true },
  { word: 'ALONG', frequency: 0.00024, inWordle: true },
  { word: 'ALOOF', frequency: 9.77e-07, inWordle: true },
  { word: 'ALOUD', frequency: 3.24e-06, inWordle: true },
  { word: 'ALPHA', frequency: 1.78e-05, inWordle: true },
  { word: 'ALTAR', frequency: 6.31e-06, inWordle: true },
  { word: 'ALTER', frequency: 1.12e-05, inWordle: true },
  { word: 'AMASS', frequency: 5.89e-07, inWordle: true },
  { word: 'AMAZE', frequency: 1.55e-06, inWordle: true },
  { word: 'AMBER', frequency: 9.33e-06, inWordle: true },
  { word: 'AMBLE', frequency: 2e-07, inWordle: true },
  { word: 'AMEND', frequency: 3.55e-06, inWordle: true },
  { word: 'AMISS', frequency: 8.51e-07, inWordle: true },
  { word: 'AMITY', frequency: 7.76e-07, inWordle: true },
  { word: 'AMONG', frequency: 0.000204, inWordle: true },
  { word: 'AMPLE', frequency: 5.13e-06, inWordle: true },
  { word: 'AMPLY', frequency: 4.07e-07, inWordle: true },
  { word: 'AMUSE', frequency: 1.32e-06, inWordle: true },
  { word: 'ANGEL', frequency: 2.82e-05, inWordle: true },
  { word: 'ANGER', frequency: 2.63e-05, inWordle: true },
  { word: 'ANGLE', frequency: 2.4e-05, inWordle: true },
  { word: 'ANGRY', frequency: 4.57e-05, inWordle: true },
  { word: 'ANGST', frequency: 1.82e-06, inWordle: true },
  { word: 'ANIME', frequency: 1.82e-05, inWordle: true },
  { word: 'ANKLE', frequency: 9.33e-06, inWordle: true },
  { word: 'ANNEX', frequency: 3.16e-06, inWordle: true },
  { word: 'ANNOY', frequency: 2.88e-06, inWordle: true },
  { word: 'ANNUL', frequency: 3.09e-07, inWordle: true },
  { word: 'ANODE', frequency: 7.24e-07, inWordle: true },
  { word: 'ANTIC', frequency: 2.14e-07, inWordle: true },
  { word: 'ANVIL', frequency: 1.1e-06, inWordle: true },
  { word: 'AORTA', frequency: 8.32e-07, inWordle: true },
  { word: 'APART', frequency: 6.03e-05, inWordle: true },
  { word: 'APHID', frequency: 2.45e-07, inWordle: true },
  { word: 'APING', frequency: 1.23e-07, inWordle: true },
  { word: 'APNEA', frequency: 1e-06, inWordle: true },
  { word: 'APPLE', frequency: 5.75e-05, inWordle: true },
  { word: 'APPLY', frequency: 6.46e-05, inWordle: true },
  { word: 'APRON', frequency: 2.29e-06, inWordle: true },
  { word: 'APTLY', frequency: 1.32e-06, inWordle: true },
  { word: 'ARBOR', frequency: 3.09e-06, inWordle: true },
  { word: 'ARDOR', frequency: 2.19e-07, inWordle: true },
  { word: 'ARENA', frequency: 2.14e-05, inWordle: true },
  { word: 'ARGUE', frequency: 2.88e-05, inWordle: true },
  { word: 'ARISE', frequency: 8.51e-06, inWordle: true },
  { word: 'ARMOR', frequency: 9.33e-06, inWordle: true },
  { word: 'AROMA', frequency: 1.7e-06, inWordle: true },
  { word: 'AROSE', frequency: 5.37e-06, inWordle: true },
  { word: 'ARRAY', frequency: 1.26e-05, inWordle: true },
  { word: 'ARROW', frequency: 1.35e-05, inWordle: true },
  { word: 'ARSON', frequency: 2.51e-06, inWordle: true },
  { word: 'ARTSY', frequency: 7.76e-07, inWordle: true },
  { word: 'ASCOT', frequency: 1.15e-06, inWordle: true },
  { word: 'ASHEN', frequency: 3.02e-07, inWordle: true },
  { word: 'ASIDE', frequency: 3.89e-05, inWordle: true },
  { word: 'ASKEW', frequency: 5.25e-07, inWordle: true },
  { word: 'ASSAY', frequency: 1.91e-06, inWordle: true },
  { word: 'ASSET', frequency: 1.7e-05, inWordle: true },
  { word: 'ATOLL', frequency: 7.08e-07, inWordle: true },
  { word: 'ATONE', frequency: 7.24e-07, inWordle: true },
  { word: 'ATTIC', frequency: 4.27e-06, inWordle: true },
  { word: 'AUDIO', frequency: 2.95e-05, inWordle: true },
  { word: 'AUDIT', frequency: 1.1e-05, inWordle: true },
  { word: 'AUGUR', frequency: 3.02e-07, inWordle: true },
  { word: 'AUNTY', frequency: 1.45e-06, inWordle: true },
  { word: 'AVAIL', frequency: 3.89e-06, inWordle: true },
  { word: 'AVERT', frequency: 1.38e-06, inWordle: true },
  { word: 'AVIAN', frequency: 1.38e-06, inWordle: true },
  { word: 'AVOID', frequency: 7.41e-05, inWordle: true },
  { word: 'AWAIT', frequency: 4.27e-06, inWordle: true },
  { word: 'AWAKE', frequency: 1.38e-05, inWordle: true },
  { word: 'AWARD', frequency: 7.59e-05, inWordle: true },
  { word: 'AWARE', frequency: 6.03e-05, inWordle: true },
  { word: 'AWASH', frequency: 5.75e-07, inWordle: true },
  { word: 'AWFUL', frequency: 2.88e-05, inWordle: true },
  { word: 'AWOKE', frequency: 1.41e-06, inWordle: true },
  { word: 'AXIAL', frequency: 1.41e-06, inWordle: true },
  { word: 'AXIOM', frequency: 1.05e-06, inWordle: true },
  { word: 'AXION', frequency: 8.51e-08, inWordle: true },
  { word: 'AZURE', frequency: 2.24e-06, inWordle: true },
  { word: 'BACON', frequency: 1.41e-05, inWordle: true },
  { word: 'BADGE', frequency: 1.05e-05, inWordle: true },
  { word: 'BADLY', frequency: 2.75e-05, inWordle: true },
  { word: 'BAGEL', frequency: 1.51e-06, inWordle: true },
  { word: 'BAGGY', frequency: 1.45e-06, inWordle: true },
  { word: 'BAKER', frequency: 1.7e-05, inWordle: true },
  { word: 'BALER', frequency: 1.82e-07, inWordle: true },
  { word: 'BALMY', frequency: 5.01e-07, inWordle: true },
  { word: 'BANAL', frequency: 7.59e-07, inWordle: true },
  { word: 'BANJO', frequency: 1.86e-06, inWordle: true },
  { word: 'BARGE', frequency: 3.16e-06, inWordle: true },
  { word: 'BARON', frequency: 7.59e-06, inWordle: true },
  { word: 'BASAL', frequency: 2.51e-06, inWordle: true },
  { word: 'BASIC', frequency: 7.76e-05, inWordle: true },
  { word: 'BASIL', frequency: 4.47e-06, inWordle: true },
  { word: 'BASIN', frequency: 1.2e-05, inWordle: true },
  { word: 'BASIS', frequency: 6.46e-05, inWordle: true },
  { word: 'BASTE', frequency: 2.45e-07, inWordle: true },
  { word: 'BATCH', frequency: 8.13e-06, inWordle: true },
  { word: 'BATHE', frequency: 1.66e-06, inWordle: true },
  { word: 'BATON', frequency: 4.37e-06, inWordle: true },
  { word: 'BATTY', frequency: 6.17e-07, inWordle: true },
  { word: 'BAWDY', frequency: 3.63e-07, inWordle: true },
  { word: 'BAYOU', frequency: 1.38e-06, inWordle: true },
  { word: 'BEACH', frequency: 8.32e-05, inWordle: true },
  { word: 'BEADY', frequency: 3.02e-07, inWordle: true },
  { word: 'BEARD', frequency: 1.17e-05, inWordle: true },
  { word: 'BEAST', frequency: 1.95e-05, inWordle: true },
  { word: 'BEECH', frequency: 1.86e-06, inWordle: true },
  { word: 'BEEFY', frequency: 5.5e-07, inWordle: true },
  { word: 'BEFIT', frequency: 1.17e-07, inWordle: true },
  { word: 'BEGAN', frequency: 0.000117, inWordle: true },
  { word: 'BEGAT', frequency: 2.57e-07, inWordle: true },
  { word: 'BEGET', frequency: 2.45e-07, inWordle: true },
  { word: 'BEGIN', frequency: 6.92e-05, inWordle: true },
  { word: 'BEGUN', frequency: 2.29e-05, inWordle: true },
  { word: 'BEING', frequency: 0.000891, inWordle: true },
  { word: 'BELCH', frequency: 1.86e-07, inWordle: true },
  { word: 'BELIE', frequency: 2.82e-07, inWordle: true },
  { word: 'BELLE', frequency: 6.17e-06, inWordle: true },
  { word: 'BELLY', frequency: 1.26e-05, inWordle: true },
  { word: 'BELOW', frequency: 0.000112, inWordle: true },
  { word: 'BENCH', frequency: 2.45e-05, inWordle: true },
  { word: 'BERET', frequency: 8.32e-07, inWordle: true },
  { word: 'BERRY', frequency: 9.33e-06, inWordle: true },
  { word: 'BERTH', frequency: 2.75e-06, inWordle: true },
  { word: 'BESET', frequency: 1.2e-06, inWordle: true },
  { word: 'BETEL', frequency: 3.39e-07, inWordle: true },
  { word: 'BEVEL', frequency: 4.07e-07, inWordle: true },
  { word: 'BEZEL', frequency: 6.31e-07, inWordle: true },
  { word: 'BIBLE', frequency: 3.47e-05, inWordle: true },
  { word: 'BICEP', frequency: 5.25e-07, inWordle: true },
  { word: 'BIDDY', frequency: 2.45e-07, inWordle: true },
  { word: 'BIGOT', frequency: 1.51e-06, inWordle: true },
  { word: 'BILGE', frequency: 4.68e-07, inWordle: true },
  { word: 'BILLY', frequency: 2.14e-05, inWordle: true },
  { word: 'BINGE', frequency: 3.98e-06, inWordle: true },
  { word: 'BINGO', frequency: 5.13e-06, inWordle: true },
  { word: 'BIOME', frequency: 5.37e-07, inWordle: true },
  { word: 'BIRCH', frequency: 3.16e-06, inWordle: true },
  { word: 'BIRTH', frequency: 5.89e-05, inWordle: true },
  { word: 'BISON', frequency: 1.82e-06, inWordle: true },
  { word: 'BITTY', frequency: 6.17e-07, inWordle: true },
  { word: 'BLACK', frequency: 0.000288, inWordle: true },
  { word: 'BLADE', frequency: 1.55e-05, inWordle: true },
  { word: 'BLAME', frequency: 4.27e-05, inWordle: true },
  { word: 'BLAND', frequency: 3.16e-06, inWordle: true },
  { word: 'BLANK', frequency: 1.38e-05, inWordle: true },
  { word: 'BLARE', frequency: 2.45e-07, inWordle: true },
  { word: 'BLAST', frequency: 2.09e-05, inWordle: true },
  { word: 'BLAZE', frequency: 4.9e-06, inWordle: true },
  { word: 'BLEAK', frequency: 2.69e-06, inWordle: true },
  { word: 'BLEAT', frequency: 1.32e-07, inWordle: true },
  { word: 'BLEED', frequency: 5.25e-06, inWordle: true },
  { word: 'BLEEP', frequency: 1.2e-06, inWordle: true },
  { word: 'BLEND', frequency: 8.91e-06, inWordle: true },
  { word: 'BLESS', frequency: 1.48e-05, inWordle: true },
  { word: 'BLIMP', frequency: 6.03e-07, inWordle: true },
  { word: 'BLIND', frequency: 3.31e-05, inWordle: true },
  { word: 'BLINK', frequency: 5.37e-06, inWordle: true },
  { word: 'BLISS', frequency: 6.03e-06, inWordle: true },
  { word: 'BLITZ', frequency: 3.72e-06, inWordle: true },
  { word: 'BLOAT', frequency: 3.98e-07, inWordle: true },
  { word: 'BLOCK', frequency: 7.59e-05, inWordle: true },
  { word: 'BLOKE', frequency: 3.55e-06, inWordle: true },
  { word: 'BLOND', frequency: 3.55e-06, inWordle: true },
  { word: 'BLOOD', frequency: 0.000126, inWordle: true },
  { word: 'BLOOM', frequency: 8.51e-06, inWordle: true },
  { word: 'BLOWN', frequency: 1.62e-05, inWordle: true },
  { word: 'BLUER', frequency: 1.66e-07, inWordle: true },
  { word: 'BLUFF', frequency: 3.8e-06, inWordle: true },
  { word: 'BLUNT', frequency: 7.94e-06, inWordle: true },
  { word: 'BLURB', frequency: 6.17e-07, inWordle: true },
  { word: 'BLURT', frequency: 3.02e-07, inWordle: true },
  { word: 'BLUSH', frequency: 3.63e-06, inWordle: true },
  { word: 'BOARD', frequency: 0.000174, inWordle: true },
  { word: 'BOAST', frequency: 3.24e-06, inWordle: true },
  { word: 'BOBBY', frequency: 1.66e-05, inWordle: true },
  { word: 'BONEY', frequency: 3.16e-07, inWordle: true },
  { word: 'BONGO', frequency: 7.41e-07, inWordle: true },
  { word: 'BONUS', frequency: 2.82e-05, inWordle: true },
  { word: 'BOOBY', frequency: 9.55e-07, inWordle: true },
  { word: 'BOOST', frequency: 2.57e-05, inWordle: true },
  { word: 'BOOTH', frequency: 1.26e-05, inWordle: true },
  { word: 'BOOTY', frequency: 3.89e-06, inWordle: true },
  { word: 'BOOZE', frequency: 4.47e-06, inWordle: true },
  { word: 'BOOZY', frequency: 3.31e-07, inWordle: true },
  { word: 'BORAX', frequency: 3.02e-07, inWordle: true },
  { word: 'BORNE', frequency: 4.68e-06, inWordle: true },
  { word: 'BOSOM', frequency: 1.12e-06, inWordle: true },
  { word: 'BOSSY', frequency: 9.33e-07, inWordle: true },
  { word: 'BOTCH', frequency: 2.51e-07, inWordle: true },
  { word: 'BOUGH', frequency: 5.37e-07, inWordle: true },
  { word: 'BOULE', frequency: 1.32e-07, inWordle: true },
  { word: 'BOUND', frequency: 2.88e-05, inWordle: true },
  { word: 'BOWEL', frequency: 3.55e-06, inWordle: true },
  { word: 'BOXER', frequency: 5.5e-06, inWordle: true },
  { word: 'BRACE', frequency: 5.25e-06, inWordle: true },
  { word: 'BRAID', frequency: 1.74e-06, inWordle: true },
  { word: 'BRAIN', frequency: 8.71e-05, inWordle: true },
  { word: 'BRAKE', frequency: 8.91e-06, inWordle: true },
  { word: 'BRAND', frequency: 6.76e-05, inWordle: true },
  { word: 'BRASH', frequency: 8.91e-07, inWordle: true },
  { word: 'BRASS', frequency: 1.12e-05, inWordle: true },
  { word: 'BRAVE', frequency: 2.14e-05, inWordle: true },
  { word: 'BRAVO', frequency: 5.89e-06, inWordle: true },
  { word: 'BRAWL', frequency: 3.39e-06, inWordle: true },
  { word: 'BRAWN', frequency: 5.75e-07, inWordle: true },
  { word: 'BREAD', frequency: 3.16e-05, inWordle: true },
  { word: 'BREAK', frequency: 0.000151, inWordle: true },
  { word: 'BREED', frequency: 1.2e-05, inWordle: true },
  { word: 'BRIAR', frequency: 7.24e-07, inWordle: true },
  { word: 'BRIBE', frequency: 3.16e-06, inWordle: true },
  { word: 'BRICK', frequency: 1.78e-05, inWordle: true },
  { word: 'BRIDE', frequency: 1.2e-05, inWordle: true },
  { word: 'BRIEF', frequency: 3.31e-05, inWordle: true },
  { word: 'BRINE', frequency: 1.17e-06, inWordle: true },
  { word: 'BRING', frequency: 0.000186, inWordle: true },
  { word: 'BRINK', frequency: 3.24e-06, inWordle: true },
  { word: 'BRINY', frequency: 1.58e-07, inWordle: true },
  { word: 'BRISK', frequency: 1.58e-06, inWordle: true },
  { word: 'BROAD', frequency: 3.39e-05, inWordle: true },
  { word: 'BROIL', frequency: 2.75e-07, inWordle: true },
  { word: 'BROKE', frequency: 7.08e-05, inWordle: true },
  { word: 'BROOD', frequency: 1.78e-06, inWordle: true },
  { word: 'BROOK', frequency: 5.5e-06, inWordle: true },
  { word: 'BROOM', frequency: 2.63e-06, inWordle: true },
  { word: 'BROTH', frequency: 2.45e-06, inWordle: true },
  { word: 'BROWN', frequency: 0.000102, inWordle: true },
  { word: 'BRUNT', frequency: 1.32e-06, inWordle: true },
  { word: 'BRUSH', frequency: 1.7e-05, inWordle: true },
  { word: 'BRUTE', frequency: 2.63e-06, inWordle: true },
  { word: 'BUDDY', frequency: 2.51e-05, inWordle: true },
  { word: 'BUDGE', frequency: 1.7e-06, inWordle: true },
  { word: 'BUGGY', frequency: 2.09e-06, inWordle: true },
  { word: 'BUGLE', frequency: 8.32e-07, inWordle: true },
  { word: 'BUILD', frequency: 0.00011, inWordle: true },
  { word: 'BUILT', frequency: 0.000117, inWordle: true },
  { word: 'BULGE', frequency: 1.74e-06, inWordle: true },
  { word: 'BULKY', frequency: 2e-06, inWordle: true },
  { word: 'BULLY', frequency: 7.41e-06, inWordle: true },
  { word: 'BUNCH', frequency: 3.72e-05, inWordle: true },
  { word: 'BUNNY', frequency: 7.59e-06, inWordle: true },
  { word: 'BURLY', frequency: 6.61e-07, inWordle: true },
  { word: 'BURNT', frequency: 1.07e-05, inWordle: true },
  { word: 'BURST', frequency: 1.41e-05, inWordle: true },
  { word: 'BUSED', frequency: 1.29e-07, inWordle: true },
  { word: 'BUSHY', frequency: 9.55e-07, inWordle: true },
  { word: 'BUTCH', frequency: 2.34e-06, inWordle: true },
  { word: 'BUTTE', frequency: 1.23e-06, inWordle: true },
  { word: 'BUXOM', frequency: 2.4e-07, inWordle: true },
  { word: 'BUYER', frequency: 1.07e-05, inWordle: true },
  { word: 'BYLAW', frequency: 3.98e-07, inWordle: true },
  { word: 'CABAL', frequency: 1.1e-06, inWordle: true },
  { word: 'CABBY', frequency: 8.91e-08, inWordle: true },
  { word: 'CABIN', frequency: 1.35e-05, inWordle: true },
  { word: 'CABLE', frequency: 3.47e-05, inWordle: true },
  { word: 'CACAO', frequency: 7.24e-07, inWordle: true },
  { word: 'CACHE', frequency: 4.27e-06, inWordle: true },
  { word: 'CACTI', frequency: 5.62e-07, inWordle: true },
  { word: 'CADDY', frequency: 9.12e-07, inWordle: true },
  { word: 'CADET', frequency: 2.24e-06, inWordle: true },
  { word: 'CAGEY', frequency: 2.45e-07, inWordle: true },
  { word: 'CAIRN', frequency: 7.41e-07, inWordle: true },
  { word: 'CAMEL', frequency: 4.37e-06, inWordle: true },
  { word: 'CAMEO', frequency: 3.02e-06, inWordle: true },
  { word: 'CANAL', frequency: 1.66e-05, inWordle: true },
  { word: 'CANDY', frequency: 1.95e-05, inWordle: true },
  { word: 'CANNY', frequency: 7.76e-07, inWordle: true },
  { word: 'CANOE', frequency: 3.16e-06, inWordle: true },
  { word: 'CANON', frequency: 1.29e-05, inWordle: true },
  { word: 'CAPER', frequency: 7.24e-07, inWordle: true },
  { word: 'KAPUT', frequency: 1.35e-07, inWordle: false },
  { word: 'CARAT', frequency: 1.41e-06, inWordle: true },
  { word: 'CARGO', frequency: 1.55e-05, inWordle: true },
  { word: 'CAROL', frequency: 1.05e-05, inWordle: true },
  { word: 'CARRY', frequency: 7.76e-05, inWordle: true },
  { word: 'CARVE', frequency: 2.57e-06, inWordle: true },
  { word: 'CASTE', frequency: 3.98e-06, inWordle: true },
  { word: 'CATCH', frequency: 7.41e-05, inWordle: true },
  { word: 'CATER', frequency: 3.55e-06, inWordle: true },
  { word: 'CATTY', frequency: 3.63e-07, inWordle: true },
  { word: 'CAULK', frequency: 1.95e-07, inWordle: true },
  { word: 'CAUSE', frequency: 0.000224, inWordle: true },
  { word: 'CAVIL', frequency: 1.1e-07, inWordle: true },
  { word: 'CEASE', frequency: 1.07e-05, inWordle: true },
  { word: 'CEDAR', frequency: 5.75e-06, inWordle: true },
  { word: 'CELLO', frequency: 1.95e-06, inWordle: true },
  { word: 'CHAFE', frequency: 2.51e-07, inWordle: true },
  { word: 'CHAFF', frequency: 5.62e-07, inWordle: true },
  { word: 'CHAIN', frequency: 4.47e-05, inWordle: true },
  { word: 'CHAIR', frequency: 4.9e-05, inWordle: true },
  { word: 'CHALK', frequency: 4.9e-06, inWordle: true },
  { word: 'CHAMP', frequency: 7.94e-06, inWordle: true },
  { word: 'CHANT', frequency: 3.98e-06, inWordle: true },
  { word: 'CHAOS', frequency: 1.86e-05, inWordle: true },
  { word: 'CHARD', frequency: 5.13e-07, inWordle: true },
  { word: 'CHARM', frequency: 1.32e-05, inWordle: true },
  { word: 'CHART', frequency: 2.95e-05, inWordle: true },
  { word: 'CHASE', frequency: 2.75e-05, inWordle: true },
  { word: 'CHASM', frequency: 9.12e-07, inWordle: true },
  { word: 'CHEAP', frequency: 5.13e-05, inWordle: true },
  { word: 'CHEAT', frequency: 1.15e-05, inWordle: true },
  { word: 'CHECK', frequency: 0.000204, inWordle: true },
  { word: 'CHEEK', frequency: 9.12e-06, inWordle: true },
  { word: 'CHEER', frequency: 1.15e-05, inWordle: true },
  { word: 'CHESS', frequency: 8.71e-06, inWordle: true },
  { word: 'CHEST', frequency: 3.31e-05, inWordle: true },
  { word: 'CHICK', frequency: 1.2e-05, inWordle: true },
  { word: 'CHIDE', frequency: 1.51e-07, inWordle: true },
  { word: 'CHIEF', frequency: 0.000129, inWordle: true },
  { word: 'CHILD', frequency: 0.0002, inWordle: true },
  { word: 'CHILI', frequency: 5.37e-06, inWordle: true },
  { word: 'CHILL', frequency: 1.51e-05, inWordle: true },
  { word: 'CHIME', frequency: 1.38e-06, inWordle: true },
  { word: 'CHINA', frequency: 0.000126, inWordle: true },
  { word: 'CHIRP', frequency: 6.17e-07, inWordle: true },
  { word: 'CHOCK', frequency: 7.24e-07, inWordle: true },
  { word: 'CHOIR', frequency: 7.59e-06, inWordle: true },
  { word: 'CHOKE', frequency: 5.25e-06, inWordle: true },
  { word: 'CHORD', frequency: 4.47e-06, inWordle: true },
  { word: 'CHORE', frequency: 1.41e-06, inWordle: true },
  { word: 'CHOSE', frequency: 3.55e-05, inWordle: true },
  { word: 'CHUCK', frequency: 1.48e-05, inWordle: true },
  { word: 'CHUMP', frequency: 8.13e-07, inWordle: true },
  { word: 'CHUNK', frequency: 4.37e-06, inWordle: true },
  { word: 'CHURN', frequency: 1.17e-06, inWordle: true },
  { word: 'CHUTE', frequency: 1.55e-06, inWordle: true },
  { word: 'CIDER', frequency: 3.16e-06, inWordle: true },
  { word: 'CIGAR', frequency: 3.72e-06, inWordle: true },
  { word: 'CINCH', frequency: 4.47e-07, inWordle: true },
  { word: 'CIRCA', frequency: 3.72e-06, inWordle: true },
  { word: 'CIVIC', frequency: 1e-05, inWordle: true },
  { word: 'CIVIL', frequency: 8.51e-05, inWordle: true },
  { word: 'CLACK', frequency: 4.07e-07, inWordle: true },
  { word: 'CLAIM', frequency: 8.91e-05, inWordle: true },
  { word: 'CLAMP', frequency: 2.82e-06, inWordle: true },
  { word: 'CLANG', frequency: 4.27e-07, inWordle: true },
  { word: 'CLANK', frequency: 4.57e-07, inWordle: true },
  { word: 'CLASH', frequency: 9.33e-06, inWordle: true },
  { word: 'CLASP', frequency: 1.26e-06, inWordle: true },
  { word: 'CLASS', frequency: 0.000229, inWordle: true },
  { word: 'CLEAN', frequency: 9.33e-05, inWordle: true },
  { word: 'CLEAR', frequency: 0.000178, inWordle: true },
  { word: 'CLEAT', frequency: 2.34e-07, inWordle: true },
  { word: 'CLEFT', frequency: 8.71e-07, inWordle: true },
  { word: 'CLERK', frequency: 1e-05, inWordle: true },
  { word: 'CLICK', frequency: 6.61e-05, inWordle: true },
  { word: 'CLIFF', frequency: 1.26e-05, inWordle: true },
  { word: 'CLIMB', frequency: 1.66e-05, inWordle: true },
  { word: 'CLING', frequency: 3.09e-06, inWordle: true },
  { word: 'CLINK', frequency: 4.17e-07, inWordle: true },
  { word: 'CLOAK', frequency: 3.72e-06, inWordle: true },
  { word: 'CLOCK', frequency: 2.69e-05, inWordle: true },
  { word: 'CLONE', frequency: 4.79e-06, inWordle: true },
  { word: 'CLOSE', frequency: 0.000229, inWordle: true },
  { word: 'CLOTH', frequency: 1.07e-05, inWordle: true },
  { word: 'CLOUD', frequency: 2.88e-05, inWordle: true },
  { word: 'CLOUT', frequency: 1.7e-06, inWordle: true },
  { word: 'CLOVE', frequency: 8.13e-07, inWordle: true },
  { word: 'CLOWN', frequency: 8.51e-06, inWordle: true },
  { word: 'CLUCK', frequency: 2.09e-07, inWordle: true },
  { word: 'CLUED', frequency: 2.51e-07, inWordle: true },
  { word: 'CLUMP', frequency: 8.71e-07, inWordle: true },
  { word: 'CLUNG', frequency: 9.55e-07, inWordle: true },
  { word: 'COACH', frequency: 9.12e-05, inWordle: true },
  { word: 'COAST', frequency: 7.41e-05, inWordle: true },
  { word: 'COBRA', frequency: 3.24e-06, inWordle: true },
  { word: 'COCOA', frequency: 4.37e-06, inWordle: true },
  { word: 'COLON', frequency: 3.98e-06, inWordle: true },
  { word: 'COLOR', frequency: 8.13e-05, inWordle: true },
  { word: 'COMET', frequency: 4.37e-06, inWordle: true },
  { word: 'COMFY', frequency: 4.27e-06, inWordle: true },
  { word: 'COMIC', frequency: 2.63e-05, inWordle: true },
  { word: 'COMMA', frequency: 1.86e-06, inWordle: true },
  { word: 'CONCH', frequency: 6.17e-07, inWordle: true },
  { word: 'CONDO', frequency: 4.27e-06, inWordle: true },
  { word: 'CONIC', frequency: 2.63e-07, inWordle: true },
  { word: 'COPSE', frequency: 2.19e-07, inWordle: true },
  { word: 'CORAL', frequency: 7.24e-06, inWordle: true },
  { word: 'CORER', frequency: 3.8e-08, inWordle: true },
  { word: 'CORNY', frequency: 1.7e-06, inWordle: true },
  { word: 'COUCH', frequency: 1.48e-05, inWordle: true },
  { word: 'COUGH', frequency: 8.91e-06, inWordle: true },
  { word: 'COULD', frequency: 0.00115, inWordle: true },
  { word: 'COUNT', frequency: 6.76e-05, inWordle: true },
  { word: 'COUPE', frequency: 2.19e-06, inWordle: true },
  { word: 'COURT', frequency: 0.000257, inWordle: true },
  { word: 'COVEN', frequency: 1e-06, inWordle: true },
  { word: 'COVER', frequency: 0.00012, inWordle: true },
  { word: 'COVET', frequency: 6.61e-07, inWordle: true },
  { word: 'COVEY', frequency: 4.07e-07, inWordle: true },
  { word: 'COWER', frequency: 3.55e-07, inWordle: true },
  { word: 'COYLY', frequency: 1.2e-07, inWordle: true },
  { word: 'CRACK', frequency: 2.57e-05, inWordle: true },
  { word: 'CRAFT', frequency: 2e-05, inWordle: true },
  { word: 'CRAMP', frequency: 1.1e-06, inWordle: true },
  { word: 'CRANE', frequency: 8.32e-06, inWordle: true },
  { word: 'CRANK', frequency: 4.07e-06, inWordle: true },
  { word: 'CRASH', frequency: 3.55e-05, inWordle: true },
  { word: 'CRASS', frequency: 9.12e-07, inWordle: true },
  { word: 'CRATE', frequency: 2.95e-06, inWordle: true },
  { word: 'CRAVE', frequency: 2.95e-06, inWordle: true },
  { word: 'CRAWL', frequency: 5.89e-06, inWordle: true },
  { word: 'CRAZE', frequency: 2.24e-06, inWordle: true },
  { word: 'CRAZY', frequency: 0.000117, inWordle: true },
  { word: 'CREAK', frequency: 3.31e-07, inWordle: true },
  { word: 'CREAM', frequency: 4.17e-05, inWordle: true },
  { word: 'CREDO', frequency: 5.89e-07, inWordle: true },
  { word: 'CREED', frequency: 5.01e-06, inWordle: true },
  { word: 'CREEK', frequency: 2.34e-05, inWordle: true },
  { word: 'CREEP', frequency: 6.92e-06, inWordle: true },
  { word: 'CREME', frequency: 1.32e-06, inWordle: true },
  { word: 'CREPE', frequency: 7.41e-07, inWordle: true },
  { word: 'CREPT', frequency: 1.41e-06, inWordle: true },
  { word: 'CRESS', frequency: 3.09e-07, inWordle: true },
  { word: 'CREST', frequency: 4.47e-06, inWordle: true },
  { word: 'CRICK', frequency: 6.31e-07, inWordle: true },
  { word: 'CRIED', frequency: 1.55e-05, inWordle: true },
  { word: 'CRIER', frequency: 2.63e-07, inWordle: true },
  { word: 'CRIME', frequency: 7.76e-05, inWordle: true },
  { word: 'CRIMP', frequency: 4.07e-07, inWordle: true },
  { word: 'CRISP', frequency: 5.01e-06, inWordle: true },
  { word: 'CROAK', frequency: 2.51e-07, inWordle: true },
  { word: 'CROCK', frequency: 1.07e-06, inWordle: true },
  { word: 'CRONE', frequency: 3.98e-07, inWordle: true },
  { word: 'CRONY', frequency: 5.37e-07, inWordle: true },
  { word: 'CROOK', frequency: 2.57e-06, inWordle: true },
  { word: 'CROSS', frequency: 0.0001, inWordle: true },
  { word: 'CROUP', frequency: 1.7e-07, inWordle: true },
  { word: 'CROWD', frequency: 5.01e-05, inWordle: true },
  { word: 'CROWN', frequency: 3.63e-05, inWordle: true },
  { word: 'CRUDE', frequency: 1e-05, inWordle: true },
  { word: 'CRUEL', frequency: 1.32e-05, inWordle: true },
  { word: 'CRUMB', frequency: 9.33e-07, inWordle: true },
  { word: 'CRUMP', frequency: 5.62e-07, inWordle: true },
  { word: 'CRUSH', frequency: 1.48e-05, inWordle: true },
  { word: 'CRUST', frequency: 5.01e-06, inWordle: true },
  { word: 'CRYPT', frequency: 1.26e-06, inWordle: true },
  { word: 'CUBIC', frequency: 5.13e-06, inWordle: true },
  { word: 'CUMIN', frequency: 1.02e-06, inWordle: true },
  { word: 'CURIO', frequency: 2.69e-07, inWordle: true },
  { word: 'CURLY', frequency: 3.98e-06, inWordle: true },
  { word: 'CURRY', frequency: 9.12e-06, inWordle: true },
  { word: 'CURSE', frequency: 1.17e-05, inWordle: true },
  { word: 'CURVE', frequency: 1.38e-05, inWordle: true },
  { word: 'CURVY', frequency: 1.41e-06, inWordle: true },
  { word: 'CUTIE', frequency: 2.09e-06, inWordle: true },
  { word: 'CYBER', frequency: 9.55e-06, inWordle: true },
  { word: 'CYCLE', frequency: 3.98e-05, inWordle: true },
  { word: 'CYNIC', frequency: 6.46e-07, inWordle: true },
  { word: 'DADDY', frequency: 2.29e-05, inWordle: true },
  { word: 'DAILY', frequency: 0.000117, inWordle: true },
  { word: 'DAIRY', frequency: 1.23e-05, inWordle: true },
  { word: 'DAISY', frequency: 6.03e-06, inWordle: true },
  { word: 'DALLY', frequency: 6.03e-07, inWordle: true },
  { word: 'DANCE', frequency: 8.51e-05, inWordle: true },
  { word: 'DANDY', frequency: 1.78e-06, inWordle: true },
  { word: 'DATUM', frequency: 3.31e-07, inWordle: true },
  { word: 'DAUNT', frequency: 1.1e-07, inWordle: true },
  { word: 'DEALT', frequency: 1.58e-05, inWordle: true },
  { word: 'DEATH', frequency: 0.000251, inWordle: true },
  { word: 'DEBAR', frequency: 9.12e-08, inWordle: true },
  { word: 'DEBIT', frequency: 4.17e-06, inWordle: true },
  { word: 'DEBUG', frequency: 7.24e-07, inWordle: true },
  { word: 'DEBUT', frequency: 3.31e-05, inWordle: true },
  { word: 'DECAL', frequency: 1.02e-06, inWordle: true },
  { word: 'DECAY', frequency: 6.76e-06, inWordle: true },
  { word: 'DECOR', frequency: 4.47e-06, inWordle: true },
  { word: 'DECOY', frequency: 1.1e-06, inWordle: true },
  { word: 'DECRY', frequency: 3.98e-07, inWordle: true },
  { word: 'DEFER', frequency: 1.58e-06, inWordle: true },
  { word: 'DEIGN', frequency: 1.82e-07, inWordle: true },
  { word: 'DEITY', frequency: 3.55e-06, inWordle: true },
  { word: 'DELAY', frequency: 2.51e-05, inWordle: true },
  { word: 'DELTA', frequency: 1.32e-05, inWordle: true },
  { word: 'DELVE', frequency: 1.38e-06, inWordle: true },
  { word: 'DEMON', frequency: 1.15e-05, inWordle: true },
  { word: 'DEMUR', frequency: 6.03e-08, inWordle: true },
  { word: 'DENIM', frequency: 3.31e-06, inWordle: true },
  { word: 'DENSE', frequency: 9.55e-06, inWordle: true },
  { word: 'DEPOT', frequency: 8.91e-06, inWordle: true },
  { word: 'DEPTH', frequency: 3.55e-05, inWordle: true },
  { word: 'DERBY', frequency: 1.26e-05, inWordle: true },
  { word: 'DETER', frequency: 3.02e-06, inWordle: true },
  { word: 'DETOX', frequency: 1.95e-06, inWordle: true },
  { word: 'DEUCE', frequency: 8.71e-07, inWordle: true },
  { word: 'DEVIL', frequency: 2e-05, inWordle: true },
  { word: 'DIARY', frequency: 1.23e-05, inWordle: true },
  { word: 'DICEY', frequency: 4.68e-07, inWordle: true },
  { word: 'DIGIT', frequency: 5.89e-06, inWordle: true },
  { word: 'DILLY', frequency: 4.37e-07, inWordle: true },
  { word: 'DIMLY', frequency: 6.17e-07, inWordle: true },
  { word: 'DINER', frequency: 3.02e-06, inWordle: true },
  { word: 'DINGO', frequency: 5.62e-07, inWordle: true },
  { word: 'DINGY', frequency: 6.61e-07, inWordle: true },
  { word: 'DIODE', frequency: 1.15e-06, inWordle: true },
  { word: 'DIRGE', frequency: 2.4e-07, inWordle: true },
  { word: 'DIRTY', frequency: 3.55e-05, inWordle: true },
  { word: 'DISCO', frequency: 6.03e-06, inWordle: true },
  { word: 'DITCH', frequency: 7.94e-06, inWordle: true },
  { word: 'DITTO', frequency: 2.4e-06, inWordle: true },
  { word: 'DITTY', frequency: 3.8e-07, inWordle: true },
  { word: 'DIVER', frequency: 2.57e-06, inWordle: true },
  { word: 'DIZZY', frequency: 2.69e-06, inWordle: true },
  { word: 'DODGE', frequency: 8.51e-06, inWordle: true },
  { word: 'DODGY', frequency: 2.09e-06, inWordle: true },
  { word: 'DOGMA', frequency: 1.86e-06, inWordle: true },
  { word: 'DOING', frequency: 0.000398, inWordle: true },
  { word: 'DOLLY', frequency: 3.47e-06, inWordle: true },
  { word: 'DONOR', frequency: 8.32e-06, inWordle: true },
  { word: 'DONUT', frequency: 2.04e-06, inWordle: true },
  { word: 'DOPEY', frequency: 4.79e-07, inWordle: true },
  { word: 'DOUBT', frequency: 7.94e-05, inWordle: true },
  { word: 'DOUGH', frequency: 7.24e-06, inWordle: true },
  { word: 'DOWDY', frequency: 2.57e-07, inWordle: true },
  { word: 'DOWEL', frequency: 2.4e-07, inWordle: true },
  { word: 'DOWNY', frequency: 3.98e-07, inWordle: true },
  { word: 'DOWRY', frequency: 1.35e-06, inWordle: true },
  { word: 'DOZEN', frequency: 2.24e-05, inWordle: true },
  { word: 'DRAFT', frequency: 4.07e-05, inWordle: true },
  { word: 'DRAIN', frequency: 1.17e-05, inWordle: true },
  { word: 'DRAKE', frequency: 9.12e-06, inWordle: true },
  { word: 'DRAMA', frequency: 4.68e-05, inWordle: true },
  { word: 'DRANK', frequency: 8.91e-06, inWordle: true },
  { word: 'DRAPE', frequency: 5.5e-07, inWordle: true },
  { word: 'DRAWL', frequency: 3.02e-07, inWordle: true },
  { word: 'DRAWN', frequency: 3.39e-05, inWordle: true },
  { word: 'DREAD', frequency: 4.37e-06, inWordle: true },
  { word: 'DREAM', frequency: 8.13e-05, inWordle: true },
  { word: 'DRESS', frequency: 5.75e-05, inWordle: true },
  { word: 'DRIED', frequency: 1.1e-05, inWordle: true },
  { word: 'DRIER', frequency: 1.55e-06, inWordle: true },
  { word: 'DRIFT', frequency: 6.61e-06, inWordle: true },
  { word: 'DRILL', frequency: 1.23e-05, inWordle: true },
  { word: 'DRINK', frequency: 7.94e-05, inWordle: true },
  { word: 'DRIVE', frequency: 0.000135, inWordle: true },
  { word: 'DROIT', frequency: 3.16e-07, inWordle: true },
  { word: 'DROLL', frequency: 3.8e-07, inWordle: true },
  { word: 'DRONE', frequency: 1e-05, inWordle: true },
  { word: 'DROOL', frequency: 1.1e-06, inWordle: true },
  { word: 'DROOP', frequency: 3.24e-07, inWordle: true },
  { word: 'DROSS', frequency: 2.34e-07, inWordle: true },
  { word: 'DROVE', frequency: 2.29e-05, inWordle: true },
  { word: 'DROWN', frequency: 4.79e-06, inWordle: true },
  { word: 'DRUID', frequency: 9.77e-07, inWordle: true },
  { word: 'DRUNK', frequency: 4.07e-05, inWordle: true },
  { word: 'DRYER', frequency: 3.47e-06, inWordle: true },
  { word: 'DRYLY', frequency: 2.14e-07, inWordle: true },
  { word: 'DUCHY', frequency: 1e-06, inWordle: true },
  { word: 'DULLY', frequency: 7.41e-08, inWordle: true },
  { word: 'DUMMY', frequency: 4.37e-06, inWordle: true },
  { word: 'DUMPY', frequency: 2.09e-07, inWordle: true },
  { word: 'DUNCE', frequency: 3.16e-07, inWordle: true },
  { word: 'DUSKY', frequency: 6.76e-07, inWordle: true },
  { word: 'DUSTY', frequency: 4.68e-06, inWordle: true },
  { word: 'DUTCH', frequency: 2.57e-05, inWordle: true },
  { word: 'DUVET', frequency: 9.77e-07, inWordle: true },
  { word: 'DWARF', frequency: 5.62e-06, inWordle: true },
  { word: 'DWELL', frequency: 3.72e-06, inWordle: true },
  { word: 'DWELT', frequency: 4.47e-07, inWordle: true },
  { word: 'DYING', frequency: 4.27e-05, inWordle: true },
  { word: 'EAGER', frequency: 1.07e-05, inWordle: true },
  { word: 'EAGLE', frequency: 1.35e-05, inWordle: true },
  { word: 'EARLY', frequency: 0.000269, inWordle: true },
  { word: 'EARTH', frequency: 0.000115, inWordle: true },
  { word: 'EASEL', frequency: 4.79e-07, inWordle: true },
  { word: 'EATEN', frequency: 1.35e-05, inWordle: true },
  { word: 'EATER', frequency: 2.63e-06, inWordle: true },
  { word: 'EBONY', frequency: 2.19e-06, inWordle: true },
  { word: 'ECLAT', frequency: 4.68e-08, inWordle: true },
  { word: 'EDICT', frequency: 1.26e-06, inWordle: true },
  { word: 'EDIFY', frequency: 9.12e-08, inWordle: true },
  { word: 'EERIE', frequency: 2.14e-06, inWordle: true },
  { word: 'EGRET', frequency: 2.09e-07, inWordle: true },
  { word: 'EIGHT', frequency: 0.000105, inWordle: true },
  { word: 'EJECT', frequency: 9.77e-07, inWordle: true },
  { word: 'EKING', frequency: 8.71e-08, inWordle: true },
  { word: 'ELATE', frequency: 2.14e-08, inWordle: true },
  { word: 'ELBOW', frequency: 6.92e-06, inWordle: true },
  { word: 'ELDER', frequency: 1.15e-05, inWordle: true },
  { word: 'ELECT', frequency: 1.07e-05, inWordle: true },
  { word: 'ELEGY', frequency: 5.13e-07, inWordle: true },
  { word: 'ELFIN', frequency: 1.82e-07, inWordle: true },
  { word: 'ELIDE', frequency: 5.62e-08, inWordle: true },
  { word: 'ELITE', frequency: 2.51e-05, inWordle: true },
  { word: 'ELOPE', frequency: 3.16e-07, inWordle: true },
  { word: 'ELUDE', frequency: 6.03e-07, inWordle: true },
  { word: 'EMAIL', frequency: 4.79e-05, inWordle: true },
  { word: 'EMBED', frequency: 8.71e-07, inWordle: true },
  { word: 'EMBER', frequency: 9.33e-07, inWordle: true },
  { word: 'EMCEE', frequency: 5.37e-07, inWordle: true },
  { word: 'EMPTY', frequency: 3.89e-05, inWordle: true },
  { word: 'ENACT', frequency: 2.69e-06, inWordle: true },
  { word: 'ENDOW', frequency: 2.69e-07, inWordle: true },
  { word: 'ENEMA', frequency: 7.08e-07, inWordle: true },
  { word: 'ENEMY', frequency: 5.01e-05, inWordle: true },
  { word: 'ENJOY', frequency: 0.000123, inWordle: true },
  { word: 'ENNUI', frequency: 2.57e-07, inWordle: true },
  { word: 'ENSUE', frequency: 8.13e-07, inWordle: true },
  { word: 'ENTER', frequency: 6.46e-05, inWordle: true },
  { word: 'ENTRY', frequency: 4.68e-05, inWordle: true },
  { word: 'ENVOY', frequency: 3.02e-06, inWordle: true },
  { word: 'EPOCH', frequency: 1.55e-06, inWordle: true },
  { word: 'EPOXY', frequency: 1.26e-06, inWordle: true },
  { word: 'EQUAL', frequency: 4.47e-05, inWordle: true },
  { word: 'EQUIP', frequency: 3.16e-06, inWordle: true },
  { word: 'ERASE', frequency: 4.57e-06, inWordle: true },
  { word: 'ERECT', frequency: 3.31e-06, inWordle: true },
  { word: 'ERODE', frequency: 1.07e-06, inWordle: true },
  { word: 'ERROR', frequency: 3.55e-05, inWordle: true },
  { word: 'ERUPT', frequency: 9.33e-07, inWordle: true },
  { word: 'ESSAY', frequency: 1.7e-05, inWordle: true },
  { word: 'ESTER', frequency: 1.15e-06, inWordle: true },
  { word: 'ETHER', frequency: 2.51e-06, inWordle: true },
  { word: 'ETHIC', frequency: 3.47e-06, inWordle: true },
  { word: 'ETHOS', frequency: 2.09e-06, inWordle: true },
  { word: 'ETUDE', frequency: 3.72e-07, inWordle: true },
  { word: 'EVADE', frequency: 2.45e-06, inWordle: true },
  { word: 'EVENT', frequency: 0.000151, inWordle: true },
  { word: 'EVERY', frequency: 0.000617, inWordle: true },
  { word: 'EVICT', frequency: 9.33e-07, inWordle: true },
  { word: 'EVOKE', frequency: 1.86e-06, inWordle: true },
  { word: 'EXACT', frequency: 3.24e-05, inWordle: true },
  { word: 'EXALT', frequency: 3.98e-07, inWordle: true },
  { word: 'EXCEL', frequency: 5.37e-06, inWordle: true },
  { word: 'EXERT', frequency: 2.29e-06, inWordle: true },
  { word: 'EXILE', frequency: 6.92e-06, inWordle: true },
  { word: 'EXIST', frequency: 5.37e-05, inWordle: true },
  { word: 'EXPEL', frequency: 1.82e-06, inWordle: true },
  { word: 'EXTOL', frequency: 2e-07, inWordle: true },
  { word: 'EXTRA', frequency: 9.55e-05, inWordle: true },
  { word: 'EXULT', frequency: 6.31e-08, inWordle: true },
  { word: 'EYING', frequency: 1.38e-07, inWordle: true },
  { word: 'FABLE', frequency: 1.45e-06, inWordle: true },
  { word: 'FACET', frequency: 1.51e-06, inWordle: true },
  { word: 'FAINT', frequency: 6.03e-06, inWordle: true },
  { word: 'FAIRY', frequency: 1.2e-05, inWordle: true },
  { word: 'FAITH', frequency: 6.61e-05, inWordle: true },
  { word: 'FALSE', frequency: 4.27e-05, inWordle: true },
  { word: 'FANCY', frequency: 2.24e-05, inWordle: true },
  { word: 'FANNY', frequency: 2.95e-06, inWordle: true },
  { word: 'FARCE', frequency: 2.14e-06, inWordle: true },
  { word: 'FATAL', frequency: 1.26e-05, inWordle: true },
  { word: 'FATTY', frequency: 6.31e-06, inWordle: true },
  { word: 'FAULT', frequency: 4.37e-05, inWordle: true },
  { word: 'FAUNA', frequency: 3.31e-06, inWordle: true },
  { word: 'FAVOR', frequency: 3.8e-05, inWordle: true },
  { word: 'FEAST', frequency: 8.91e-06, inWordle: true },
  { word: 'FECAL', frequency: 1.02e-06, inWordle: true },
  { word: 'FEIGN', frequency: 3.8e-07, inWordle: true },
  { word: 'FELLA', frequency: 3.09e-06, inWordle: true },
  { word: 'FELON', frequency: 1.48e-06, inWordle: true },
  { word: 'FEMME', frequency: 1.55e-06, inWordle: true },
  { word: 'FEMUR', frequency: 1e-06, inWordle: true },
  { word: 'FENCE', frequency: 1.62e-05, inWordle: true },
  { word: 'FERAL', frequency: 1.95e-06, inWordle: true },
  { word: 'FERRY', frequency: 1.05e-05, inWordle: true },
  { word: 'FETAL', frequency: 2.51e-06, inWordle: true },
  { word: 'FETCH', frequency: 4.47e-06, inWordle: true },
  { word: 'FETID', frequency: 1.95e-07, inWordle: true },
  { word: 'FETUS', frequency: 3.98e-06, inWordle: true },
  { word: 'FEVER', frequency: 1.66e-05, inWordle: true },
  { word: 'FEWER', frequency: 2.04e-05, inWordle: true },
  { word: 'FIBER', frequency: 1.15e-05, inWordle: true },
  { word: 'FIBRE', frequency: 4.68e-06, inWordle: false },
  { word: 'FICUS', frequency: 2.63e-07, inWordle: true },
  { word: 'FIELD', frequency: 0.000174, inWordle: true },
  { word: 'FIEND', frequency: 1.26e-06, inWordle: true },
  { word: 'FIERY', frequency: 3.72e-06, inWordle: true },
  { word: 'FIFTH', frequency: 6.03e-05, inWordle: true },
  { word: 'FIFTY', frequency: 1.95e-05, inWordle: true },
  { word: 'FIGHT', frequency: 0.00017, inWordle: true },
  { word: 'FILER', frequency: 2.82e-07, inWordle: true },
  { word: 'FILET', frequency: 6.31e-07, inWordle: true },
  { word: 'FILLY', frequency: 1.41e-06, inWordle: true },
  { word: 'FILMY', frequency: 1.35e-07, inWordle: true },
  { word: 'FILTH', frequency: 2.57e-06, inWordle: true },
  { word: 'FINAL', frequency: 0.000191, inWordle: true },
  { word: 'FINCH', frequency: 3.55e-06, inWordle: true },
  { word: 'FINER', frequency: 2.51e-06, inWordle: true },
  { word: 'FIRST', frequency: 0.00129, inWordle: true },
  { word: 'FISHY', frequency: 1.91e-06, inWordle: true },
  { word: 'FIXER', frequency: 1.1e-06, inWordle: true },
  { word: 'FIZZY', frequency: 6.61e-07, inWordle: true },
  { word: 'FJORD', frequency: 6.46e-07, inWordle: true },
  { word: 'FLACK', frequency: 8.91e-07, inWordle: true },
  { word: 'FLAIL', frequency: 3.55e-07, inWordle: true },
  { word: 'FLAIR', frequency: 3.47e-06, inWordle: true },
  { word: 'FLAKE', frequency: 1.62e-06, inWordle: true },
  { word: 'FLAKY', frequency: 7.41e-07, inWordle: true },
  { word: 'FLAME', frequency: 1.17e-05, inWordle: true },
  { word: 'FLANK', frequency: 4.37e-06, inWordle: true },
  { word: 'FLARE', frequency: 4.37e-06, inWordle: true },
  { word: 'FLASH', frequency: 2.82e-05, inWordle: true },
  { word: 'FLASK', frequency: 1.58e-06, inWordle: true },
  { word: 'FLECK', frequency: 3.72e-07, inWordle: true },
  { word: 'FLEET', frequency: 2.14e-05, inWordle: true },
  { word: 'FLESH', frequency: 1.58e-05, inWordle: true },
  { word: 'FLICK', frequency: 4.27e-06, inWordle: true },
  { word: 'FLIER', frequency: 8.32e-07, inWordle: true },
  { word: 'FLING', frequency: 2.14e-06, inWordle: true },
  { word: 'FLINT', frequency: 5.89e-06, inWordle: true },
  { word: 'FLIRT', frequency: 3.31e-06, inWordle: true },
  { word: 'FLOAT', frequency: 8.71e-06, inWordle: true },
  { word: 'FLOCK', frequency: 4.9e-06, inWordle: true },
  { word: 'FLOOD', frequency: 2.19e-05, inWordle: true },
  { word: 'FLOOR', frequency: 8.71e-05, inWordle: true },
  { word: 'FLORA', frequency: 5.01e-06, inWordle: true },
  { word: 'FLOSS', frequency: 1.51e-06, inWordle: true },
  { word: 'FLOUR', frequency: 1e-05, inWordle: true },
  { word: 'FLOUT', frequency: 1.78e-07, inWordle: true },
  { word: 'FLOWN', frequency: 6.76e-06, inWordle: true },
  { word: 'FLUFF', frequency: 1.58e-06, inWordle: true },
  { word: 'FLUID', frequency: 1.66e-05, inWordle: true },
  { word: 'FLUKE', frequency: 1.38e-06, inWordle: true },
  { word: 'FLUME', frequency: 6.46e-07, inWordle: true },
  { word: 'FLUNG', frequency: 2.14e-06, inWordle: true },
  { word: 'FLUNK', frequency: 1.48e-07, inWordle: true },
  { word: 'FLUSH', frequency: 6.31e-06, inWordle: true },
  { word: 'FLUTE', frequency: 3.31e-06, inWordle: true },
  { word: 'FLYER', frequency: 3.8e-06, inWordle: true },
  { word: 'FOAMY', frequency: 2.57e-07, inWordle: true },
  { word: 'FOCAL', frequency: 4.68e-06, inWordle: true },
  { word: 'FOCUS', frequency: 0.0001, inWordle: true },
  { word: 'FOGGY', frequency: 1.55e-06, inWordle: true },
  { word: 'FOIST', frequency: 1.38e-07, inWordle: true },
  { word: 'FOLIO', frequency: 1.29e-06, inWordle: true },
  { word: 'FOLLY', frequency: 2.19e-06, inWordle: true },
  { word: 'FORAY', frequency: 1.1e-06, inWordle: true },
  { word: 'FORCE', frequency: 0.00017, inWordle: true },
  { word: 'FORGE', frequency: 6.03e-06, inWordle: true },
  { word: 'FORGO', frequency: 9.77e-07, inWordle: true },
  { word: 'FORTE', frequency: 1.74e-06, inWordle: true },
  { word: 'FORTH', frequency: 2.51e-05, inWordle: true },
  { word: 'FORTY', frequency: 1.58e-05, inWordle: true },
  { word: 'FORUM', frequency: 2.4e-05, inWordle: true },
  { word: 'FOUND', frequency: 0.000479, inWordle: true },
  { word: 'FOYER', frequency: 1.23e-06, inWordle: true },
  { word: 'FRAIL', frequency: 1.91e-06, inWordle: true },
  { word: 'FRAME', frequency: 3.8e-05, inWordle: true },
  { word: 'FRANK', frequency: 5.62e-05, inWordle: true },
  { word: 'FRAUD', frequency: 2.34e-05, inWordle: true },
  { word: 'FREAK', frequency: 1.2e-05, inWordle: true },
  { word: 'FREED', frequency: 7.08e-06, inWordle: true },
  { word: 'FREER', frequency: 9.77e-07, inWordle: true },
  { word: 'FRESH', frequency: 6.76e-05, inWordle: true },
  { word: 'FRIAR', frequency: 1.1e-06, inWordle: true },
  { word: 'FRIED', frequency: 1.15e-05, inWordle: true },
  { word: 'FRILL', frequency: 2.04e-07, inWordle: true },
  { word: 'FRISK', frequency: 8.32e-07, inWordle: true },
  { word: 'FRITZ', frequency: 2.63e-06, inWordle: true },
  { word: 'FROCK', frequency: 7.59e-07, inWordle: true },
  { word: 'FROND', frequency: 1.7e-07, inWordle: true },
  { word: 'FRONT', frequency: 0.000191, inWordle: true },
  { word: 'FROST', frequency: 8.91e-06, inWordle: true },
  { word: 'FROTH', frequency: 5.62e-07, inWordle: true },
  { word: 'FROWN', frequency: 1.82e-06, inWordle: true },
  { word: 'FROZE', frequency: 2.63e-06, inWordle: true },
  { word: 'FRUIT', frequency: 3.72e-05, inWordle: true },
  { word: 'FUDGE', frequency: 2.14e-06, inWordle: true },
  { word: 'FUGUE', frequency: 5.37e-07, inWordle: true },
  { word: 'FULLY', frequency: 7.76e-05, inWordle: true },
  { word: 'FUNGI', frequency: 3.02e-06, inWordle: true },
  { word: 'FUNKY', frequency: 4.27e-06, inWordle: true },
  { word: 'FUNNY', frequency: 0.000105, inWordle: true },
  { word: 'FUROR', frequency: 3.31e-07, inWordle: true },
  { word: 'FURRY', frequency: 3.63e-06, inWordle: true },
  { word: 'FUSSY', frequency: 1.1e-06, inWordle: true },
  { word: 'FUZZY', frequency: 4.47e-06, inWordle: true },
  { word: 'GAFFE', frequency: 4.57e-07, inWordle: true },
  { word: 'GAILY', frequency: 1.58e-07, inWordle: true },
  { word: 'GAMER', frequency: 4.17e-06, inWordle: true },
  { word: 'GAMMA', frequency: 5.01e-06, inWordle: true },
  { word: 'GAMUT', frequency: 7.41e-07, inWordle: true },
  { word: 'GASSY', frequency: 2.4e-07, inWordle: true },
  { word: 'GAUDY', frequency: 6.76e-07, inWordle: true },
  { word: 'GAUGE', frequency: 1.05e-05, inWordle: true },
  { word: 'GAUNT', frequency: 7.94e-07, inWordle: true },
  { word: 'GAUZE', frequency: 7.76e-07, inWordle: true },
  { word: 'GAVEL', frequency: 4.57e-07, inWordle: true },
  { word: 'GAWKY', frequency: 8.13e-08, inWordle: true },
  { word: 'GAYER', frequency: 2.34e-07, inWordle: true },
  { word: 'GAYLY', frequency: 1.48e-08, inWordle: true },
  { word: 'GAZER', frequency: 9.12e-08, inWordle: true },
  { word: 'GECKO', frequency: 8.13e-07, inWordle: true },
  { word: 'GEEKY', frequency: 8.71e-07, inWordle: true },
  { word: 'GEESE', frequency: 2.24e-06, inWordle: true },
  { word: 'GENIE', frequency: 2.57e-06, inWordle: true },
  { word: 'GENRE', frequency: 1.48e-05, inWordle: true },
  { word: 'GHOST', frequency: 2.63e-05, inWordle: true },
  { word: 'GHOUL', frequency: 7.76e-07, inWordle: true },
  { word: 'GIANT', frequency: 4.17e-05, inWordle: true },
  { word: 'GIDDY', frequency: 1.66e-06, inWordle: true },
  { word: 'GIRLY', frequency: 1.7e-06, inWordle: true },
  { word: 'GIRTH', frequency: 8.32e-07, inWordle: true },
  { word: 'GIVEN', frequency: 0.000257, inWordle: true },
  { word: 'GIVER', frequency: 1.58e-06, inWordle: true },
  { word: 'GLADE', frequency: 6.03e-07, inWordle: true },
  { word: 'GLAND', frequency: 2.4e-06, inWordle: true },
  { word: 'GLARE', frequency: 2.29e-06, inWordle: true },
  { word: 'GLASS', frequency: 7.08e-05, inWordle: true },
  { word: 'GLAZE', frequency: 1.91e-06, inWordle: true },
  { word: 'GLEAM', frequency: 9.33e-07, inWordle: true },
  { word: 'GLEAN', frequency: 5.37e-07, inWordle: true },
  { word: 'GLIDE', frequency: 2.14e-06, inWordle: true },
  { word: 'GLINT', frequency: 4.47e-07, inWordle: true },
  { word: 'GLOAT', frequency: 4.17e-07, inWordle: true },
  { word: 'GLOBE', frequency: 1.91e-05, inWordle: true },
  { word: 'GLOOM', frequency: 2.04e-06, inWordle: true },
  { word: 'GLORY', frequency: 2.29e-05, inWordle: true },
  { word: 'GLOSS', frequency: 2.95e-06, inWordle: true },
  { word: 'GLOVE', frequency: 5.37e-06, inWordle: true },
  { word: 'GLYPH', frequency: 5.01e-07, inWordle: true },
  { word: 'GNASH', frequency: 1.07e-07, inWordle: true },
  { word: 'GNOME', frequency: 1.58e-06, inWordle: true },
  { word: 'GODLY', frequency: 1.82e-06, inWordle: true },
  { word: 'GOING', frequency: 0.000871, inWordle: true },
  { word: 'GOLEM', frequency: 6.17e-07, inWordle: true },
  { word: 'GOLLY', frequency: 5.13e-07, inWordle: true },
  { word: 'GONAD', frequency: 7.59e-08, inWordle: true },
  { word: 'GONER', frequency: 2.82e-07, inWordle: true },
  { word: 'GOODY', frequency: 1.1e-06, inWordle: true },
  { word: 'GOOEY', frequency: 7.24e-07, inWordle: true },
  { word: 'GOOFY', frequency: 3.72e-06, inWordle: true },
  { word: 'GOOSE', frequency: 6.92e-06, inWordle: true },
  { word: 'GORGE', frequency: 2.51e-06, inWordle: true },
  { word: 'GOUGE', frequency: 5.13e-07, inWordle: true },
  { word: 'GOURD', frequency: 6.61e-07, inWordle: true },
  { word: 'GRACE', frequency: 3.63e-05, inWordle: true },
  { word: 'GRADE', frequency: 6.31e-05, inWordle: true },
  { word: 'GRAFT', frequency: 2.95e-06, inWordle: true },
  { word: 'GRAIL', frequency: 2.88e-06, inWordle: true },
  { word: 'GRAIN', frequency: 1.51e-05, inWordle: true },
  { word: 'GRAND', frequency: 8.13e-05, inWordle: true },
  { word: 'GRANT', frequency: 4.68e-05, inWordle: true },
  { word: 'GRAPE', frequency: 5.01e-06, inWordle: true },
  { word: 'GRAPH', frequency: 1.12e-05, inWordle: true },
  { word: 'GRASP', frequency: 9.33e-06, inWordle: true },
  { word: 'GRASS', frequency: 2.4e-05, inWordle: true },
  { word: 'GRATE', frequency: 1.48e-06, inWordle: true },
  { word: 'GRAVE', frequency: 2.04e-05, inWordle: true },
  { word: 'GRAVY', frequency: 3.02e-06, inWordle: true },
  { word: 'GRAZE', frequency: 1.05e-06, inWordle: true },
  { word: 'GREAT', frequency: 0.000759, inWordle: true },
  { word: 'GREED', frequency: 5.37e-06, inWordle: true },
  { word: 'GREEN', frequency: 0.000135, inWordle: true },
  { word: 'GREET', frequency: 5.37e-06, inWordle: true },
  { word: 'GRIEF', frequency: 1.2e-05, inWordle: true },
  { word: 'GRILL', frequency: 6.92e-06, inWordle: true },
  { word: 'GRIME', frequency: 1.23e-06, inWordle: true },
  { word: 'GRIMY', frequency: 5.75e-07, inWordle: true },
  { word: 'GRIND', frequency: 8.71e-06, inWordle: true },
  { word: 'GRIPE', frequency: 6.46e-07, inWordle: true },
  { word: 'GROAN', frequency: 1.32e-06, inWordle: true },
  { word: 'GROIN', frequency: 1.82e-06, inWordle: true },
  { word: 'GROOM', frequency: 4.27e-06, inWordle: true },
  { word: 'GROPE', frequency: 4.79e-07, inWordle: true },
  { word: 'GROSS', frequency: 2.82e-05, inWordle: true },
  { word: 'GROUP', frequency: 0.000372, inWordle: true },
  { word: 'GROUT', frequency: 6.76e-07, inWordle: true },
  { word: 'GROVE', frequency: 8.71e-06, inWordle: true },
  { word: 'GROWL', frequency: 1.38e-06, inWordle: true },
  { word: 'GROWN', frequency: 4.68e-05, inWordle: true },
  { word: 'GRUEL', frequency: 2.75e-07, inWordle: true },
  { word: 'GRUFF', frequency: 6.46e-07, inWordle: true },
  { word: 'GRUNT', frequency: 1.41e-06, inWordle: true },
  { word: 'GUARD', frequency: 5.37e-05, inWordle: true },
  { word: 'GUAVA', frequency: 4.07e-07, inWordle: true },
  { word: 'GUESS', frequency: 0.000148, inWordle: true },
  { word: 'GUEST', frequency: 3.8e-05, inWordle: true },
  { word: 'GUIDE', frequency: 5.62e-05, inWordle: true },
  { word: 'GUILD', frequency: 8.51e-06, inWordle: true },
  { word: 'GUILE', frequency: 5.62e-07, inWordle: true },
  { word: 'GUILT', frequency: 1.35e-05, inWordle: true },
  { word: 'GUISE', frequency: 2.95e-06, inWordle: true },
  { word: 'GULCH', frequency: 6.03e-07, inWordle: true },
  { word: 'GULLY', frequency: 1.29e-06, inWordle: true },
  { word: 'GUMBO', frequency: 5.01e-07, inWordle: true },
  { word: 'GUMMY', frequency: 9.33e-07, inWordle: true },
  { word: 'GUPPY', frequency: 3.09e-07, inWordle: true },
  { word: 'GUSTO', frequency: 1e-06, inWordle: true },
  { word: 'GUSTY', frequency: 3.89e-07, inWordle: true },
  { word: 'HABIT', frequency: 1.74e-05, inWordle: true },
  { word: 'HAIRY', frequency: 6.31e-06, inWordle: true },
  { word: 'HALVE', frequency: 3.98e-07, inWordle: true },
  { word: 'HANDY', frequency: 9.33e-06, inWordle: true },
  { word: 'HAPPY', frequency: 0.000224, inWordle: true },
  { word: 'HARDY', frequency: 7.24e-06, inWordle: true },
  { word: 'HAREM', frequency: 1.35e-06, inWordle: true },
  { word: 'HARPY', frequency: 3.16e-07, inWordle: true },
  { word: 'HARRY', frequency: 5.25e-05, inWordle: true },
  { word: 'HARSH', frequency: 1.38e-05, inWordle: true },
  { word: 'HASTE', frequency: 2.34e-06, inWordle: true },
  { word: 'HASTY', frequency: 1.95e-06, inWordle: true },
  { word: 'HATCH', frequency: 6.61e-06, inWordle: true },
  { word: 'HATER', frequency: 1.38e-06, inWordle: true },
  { word: 'HAUNT', frequency: 3.47e-06, inWordle: true },
  { word: 'HAUTE', frequency: 1.58e-06, inWordle: true },
  { word: 'HAVEN', frequency: 1.35e-05, inWordle: true },
  { word: 'HAVOC', frequency: 3.16e-06, inWordle: true },
  { word: 'HAZEL', frequency: 3.47e-06, inWordle: true },
  { word: 'HEADY', frequency: 8.51e-07, inWordle: true },
  { word: 'HEARD', frequency: 0.000186, inWordle: true },
  { word: 'HEART', frequency: 0.000204, inWordle: true },
  { word: 'HEATH', frequency: 5.75e-06, inWordle: true },
  { word: 'HEAVE', frequency: 7.94e-07, inWordle: true },
  { word: 'HEAVY', frequency: 9.12e-05, inWordle: true },
  { word: 'HEDGE', frequency: 5.5e-06, inWordle: true },
  { word: 'HEFTY', frequency: 2.29e-06, inWordle: true },
  { word: 'HEIST', frequency: 2.45e-06, inWordle: true },
  { word: 'HELIX', frequency: 1.82e-06, inWordle: true },
  { word: 'HELLO', frequency: 5.25e-05, inWordle: true },
  { word: 'HENCE', frequency: 2.4e-05, inWordle: true },
  { word: 'HERON', frequency: 1.23e-06, inWordle: true },
  { word: 'HILLY', frequency: 1.48e-06, inWordle: true },
  { word: 'HINGE', frequency: 2.09e-06, inWordle: true },
  { word: 'HIPPO', frequency: 1.35e-06, inWordle: true },
  { word: 'HIPPY', frequency: 1e-06, inWordle: true },
  { word: 'HITCH', frequency: 2.63e-06, inWordle: true },
  { word: 'HOARD', frequency: 1.7e-06, inWordle: true },
  { word: 'HOBBY', frequency: 8.71e-06, inWordle: true },
  { word: 'HOIST', frequency: 1.32e-06, inWordle: true },
  { word: 'HOLLY', frequency: 7.59e-06, inWordle: true },
  { word: 'HOMER', frequency: 7.76e-06, inWordle: true },
  { word: 'HONEY', frequency: 2.34e-05, inWordle: true },
  { word: 'HONOR', frequency: 4.9e-05, inWordle: true },
  { word: 'HORDE', frequency: 1.7e-06, inWordle: true },
  { word: 'HORNY', frequency: 6.17e-06, inWordle: true },
  { word: 'HORSE', frequency: 5.75e-05, inWordle: true },
  { word: 'HOTEL', frequency: 8.91e-05, inWordle: true },
  { word: 'HOTLY', frequency: 8.51e-07, inWordle: true },
  { word: 'HOUND', frequency: 2.69e-06, inWordle: true },
  { word: 'HOUSE', frequency: 0.000513, inWordle: true },
  { word: 'HOVEL', frequency: 2.04e-07, inWordle: true },
  { word: 'HOVER', frequency: 1.82e-06, inWordle: true },
  { word: 'HOWDY', frequency: 1.2e-06, inWordle: true },
  { word: 'HUMAN', frequency: 0.000224, inWordle: true },
  { word: 'HUMID', frequency: 3.16e-06, inWordle: true },
  { word: 'HUMOR', frequency: 1.55e-05, inWordle: true },
  { word: 'HUMPH', frequency: 1.51e-07, inWordle: true },
  { word: 'HUMUS', frequency: 2.4e-07, inWordle: true },
  { word: 'HUNCH', frequency: 1.17e-06, inWordle: true },
  { word: 'HUNKY', frequency: 5.25e-07, inWordle: true },
  { word: 'HURRY', frequency: 1.38e-05, inWordle: true },
  { word: 'HUSKY', frequency: 1.95e-06, inWordle: true },
  { word: 'HUTCH', frequency: 1.1e-06, inWordle: true },
  { word: 'HYDRO', frequency: 4.27e-06, inWordle: true },
  { word: 'HYENA', frequency: 6.31e-07, inWordle: true },
  { word: 'HYMEN', frequency: 3.72e-07, inWordle: true },
  { word: 'HYPER', frequency: 4.9e-06, inWordle: true },
  { word: 'ICILY', frequency: 4.37e-08, inWordle: true },
  { word: 'ICING', frequency: 3.09e-06, inWordle: true },
  { word: 'IDEAL', frequency: 2.75e-05, inWordle: true },
  { word: 'IDIOM', frequency: 9.33e-07, inWordle: true },
  { word: 'IDIOT', frequency: 2.45e-05, inWordle: true },
  { word: 'IDLER', frequency: 2e-07, inWordle: true },
  { word: 'IDYLL', frequency: 2.75e-07, inWordle: true },
  { word: 'IGLOO', frequency: 4.37e-07, inWordle: true },
  { word: 'ILIAC', frequency: 2.29e-07, inWordle: true },
  { word: 'IMAGE', frequency: 8.71e-05, inWordle: true },
  { word: 'IMBUE', frequency: 2.63e-07, inWordle: true },
  { word: 'IMPEL', frequency: 2.29e-07, inWordle: true },
  { word: 'IMPLY', frequency: 6.76e-06, inWordle: true },
  { word: 'INANE', frequency: 5.01e-07, inWordle: true },
  { word: 'INBOX', frequency: 3.24e-06, inWordle: true },
  { word: 'INCUR', frequency: 2e-06, inWordle: true },
  { word: 'INDEX', frequency: 3.72e-05, inWordle: true },
  { word: 'INEPT', frequency: 1.35e-06, inWordle: true },
  { word: 'INERT', frequency: 1.23e-06, inWordle: true },
  { word: 'INFER', frequency: 1.45e-06, inWordle: true },
  { word: 'INGOT', frequency: 2.4e-07, inWordle: true },
  { word: 'INLAY', frequency: 4.79e-07, inWordle: true },
  { word: 'INLET', frequency: 2.82e-06, inWordle: true },
  { word: 'INNER', frequency: 3.16e-05, inWordle: true },
  { word: 'INPUT', frequency: 2.24e-05, inWordle: true },
  { word: 'INTER', frequency: 1.45e-05, inWordle: true },
  { word: 'INTRO', frequency: 6.46e-06, inWordle: true },
  { word: 'IONIC', frequency: 1.62e-06, inWordle: true },
  { word: 'IRATE', frequency: 6.03e-07, inWordle: true },
  { word: 'IRONY', frequency: 7.24e-06, inWordle: true },
  { word: 'ISLET', frequency: 5.75e-07, inWordle: true },
  { word: 'ISSUE', frequency: 0.00017, inWordle: true },
  { word: 'ITCHY', frequency: 2.19e-06, inWordle: true },
  { word: 'IVORY', frequency: 7.08e-06, inWordle: true },
  { word: 'JAUNT', frequency: 3.98e-07, inWordle: true },
  { word: 'JAZZY', frequency: 1e-06, inWordle: true },
  { word: 'JELLY', frequency: 5.89e-06, inWordle: true },
  { word: 'JERKY', frequency: 1.26e-06, inWordle: true },
  { word: 'JETTY', frequency: 1.1e-06, inWordle: true },
  { word: 'JEWEL', frequency: 4.79e-06, inWordle: true },
  { word: 'JIFFY', frequency: 4.37e-07, inWordle: true },
  { word: 'JOINT', frequency: 5.13e-05, inWordle: true },
  { word: 'JOIST', frequency: 1.78e-07, inWordle: true },
  { word: 'JOKER', frequency: 5.5e-06, inWordle: true },
  { word: 'JOLLY', frequency: 3.72e-06, inWordle: true },
  { word: 'JOUST', frequency: 2.95e-07, inWordle: true },
  { word: 'JUDGE', frequency: 8.91e-05, inWordle: true },
  { word: 'JUICE', frequency: 2.29e-05, inWordle: true },
  { word: 'JUICY', frequency: 5.01e-06, inWordle: true },
  { word: 'JUMBO', frequency: 2.4e-06, inWordle: true },
  { word: 'JUMPY', frequency: 4.68e-07, inWordle: true },
  { word: 'JUROR', frequency: 1.35e-06, inWordle: true },
  { word: 'KAPPA', frequency: 2.88e-06, inWordle: true },
  { word: 'KARMA', frequency: 7.59e-06, inWordle: true },
  { word: 'KAYAK', frequency: 1.74e-06, inWordle: true },
  { word: 'KEBAB', frequency: 1.07e-06, inWordle: true },
  { word: 'KHAKI', frequency: 1.1e-06, inWordle: true },
  { word: 'KINKY', frequency: 2.34e-06, inWordle: true },
  { word: 'KIOSK', frequency: 1e-06, inWordle: true },
  { word: 'KITTY', frequency: 9.55e-06, inWordle: true },
  { word: 'KNACK', frequency: 1.82e-06, inWordle: true },
  { word: 'KNAVE', frequency: 3.16e-07, inWordle: true },
  { word: 'KNEAD', frequency: 3.72e-07, inWordle: true },
  { word: 'KNEED', frequency: 2.75e-07, inWordle: true },
  { word: 'KNEEL', frequency: 1.74e-06, inWordle: true },
  { word: 'KNELT', frequency: 6.31e-07, inWordle: true },
  { word: 'KNIFE', frequency: 2.57e-05, inWordle: true },
  { word: 'KNOCK', frequency: 2.24e-05, inWordle: true },
  { word: 'KNOLL', frequency: 7.94e-07, inWordle: true },
  { word: 'KNOWN', frequency: 0.000245, inWordle: true },
  { word: 'KOALA', frequency: 1.1e-06, inWordle: true },
  { word: 'KRILL', frequency: 4.27e-07, inWordle: true },
  { word: 'LABEL', frequency: 2.69e-05, inWordle: true },
  { word: 'LABOR', frequency: 5.89e-05, inWordle: true },
  { word: 'LADEN', frequency: 5.5e-06, inWordle: true },
  { word: 'LADLE', frequency: 4.57e-07, inWordle: true },
  { word: 'LAGER', frequency: 1.45e-06, inWordle: true },
  { word: 'LANCE', frequency: 8.71e-06, inWordle: true },
  { word: 'LANKY', frequency: 5.37e-07, inWordle: true },
  { word: 'LAPEL', frequency: 5.89e-07, inWordle: true },
  { word: 'LAPSE', frequency: 3.09e-06, inWordle: true },
  { word: 'LARGE', frequency: 0.000245, inWordle: true },
  { word: 'LARVA', frequency: 9.77e-07, inWordle: true },
  { word: 'LASSO', frequency: 5.5e-07, inWordle: true },
  { word: 'LATCH', frequency: 2.19e-06, inWordle: true },
  { word: 'LATER', frequency: 0.000309, inWordle: true },
  { word: 'LATHE', frequency: 8.13e-07, inWordle: true },
  { word: 'LATTE', frequency: 2e-06, inWordle: true },
  { word: 'LAUGH', frequency: 4.57e-05, inWordle: true },
  { word: 'LAYER', frequency: 2.51e-05, inWordle: true },
  { word: 'LEACH', frequency: 1.78e-06, inWordle: true },
  { word: 'LEAFY', frequency: 2e-06, inWordle: true },
  { word: 'LEAKY', frequency: 1.15e-06, inWordle: true },
  { word: 'LEANT', frequency: 2.69e-07, inWordle: true },
  { word: 'LEAPT', frequency: 1.12e-06, inWordle: true },
  { word: 'LEARN', frequency: 0.000148, inWordle: true },
  { word: 'LEASE', frequency: 1.48e-05, inWordle: true },
  { word: 'LEASH', frequency: 2.95e-06, inWordle: true },
  { word: 'LEAST', frequency: 0.000275, inWordle: true },
  { word: 'LEAVE', frequency: 0.000219, inWordle: true },
  { word: 'LEDGE', frequency: 2.57e-06, inWordle: true },
  { word: 'LEECH', frequency: 1.48e-06, inWordle: true },
  { word: 'LEERY', frequency: 3.8e-07, inWordle: true },
  { word: 'LEFTY', frequency: 1.78e-06, inWordle: true },
  { word: 'LEGAL', frequency: 0.00012, inWordle: true },
  { word: 'LEGGY', frequency: 3.02e-07, inWordle: true },
  { word: 'LEMON', frequency: 1.26e-05, inWordle: true },
  { word: 'LEMUR', frequency: 3.72e-07, inWordle: true },
  { word: 'LEPER', frequency: 6.17e-07, inWordle: true },
  { word: 'LEVEL', frequency: 0.000257, inWordle: true },
  { word: 'LEVER', frequency: 4.37e-06, inWordle: true },
  { word: 'LIBEL', frequency: 2.19e-06, inWordle: true },
  { word: 'LIEGE', frequency: 8.91e-07, inWordle: true },
  { word: 'LIGHT', frequency: 0.000214, inWordle: true },
  { word: 'LIKEN', frequency: 3.72e-07, inWordle: true },
  { word: 'LILAC', frequency: 1.29e-06, inWordle: true },
  { word: 'LIMBO', frequency: 2.04e-06, inWordle: true },
  { word: 'LIMIT', frequency: 5.01e-05, inWordle: true },
  { word: 'LINEN', frequency: 4.07e-06, inWordle: true },
  { word: 'LINER', frequency: 5.62e-06, inWordle: true },
  { word: 'LINGO', frequency: 1.02e-06, inWordle: true },
  { word: 'LIPID', frequency: 1.95e-06, inWordle: true },
  { word: 'LITHE', frequency: 3.02e-07, inWordle: true },
  { word: 'LIVER', frequency: 1.51e-05, inWordle: true },
  { word: 'LIVID', frequency: 9.77e-07, inWordle: true },
  { word: 'LLAMA', frequency: 8.91e-07, inWordle: true },
  { word: 'LOAMY', frequency: 1.66e-07, inWordle: true },
  { word: 'LOATH', frequency: 4.68e-07, inWordle: true },
  { word: 'LOBBY', frequency: 1.07e-05, inWordle: true },
  { word: 'LOCAL', frequency: 0.000269, inWordle: true },
  { word: 'LOCUS', frequency: 1.51e-06, inWordle: true },
  { word: 'LODGE', frequency: 1.2e-05, inWordle: true },
  { word: 'LOFTY', frequency: 2.19e-06, inWordle: true },
  { word: 'LOGIC', frequency: 2.29e-05, inWordle: true },
  { word: 'LOGIN', frequency: 3.09e-06, inWordle: true },
  { word: 'LOOPY', frequency: 4.68e-07, inWordle: true },
  { word: 'LOOSE', frequency: 2.88e-05, inWordle: true },
  { word: 'LORRY', frequency: 1.62e-06, inWordle: true },
  { word: 'LOSER', frequency: 1.02e-05, inWordle: true },
  { word: 'LOUSE', frequency: 3.98e-07, inWordle: true },
  { word: 'LOUSY', frequency: 2.04e-06, inWordle: true },
  { word: 'LOVER', frequency: 1.82e-05, inWordle: true },
  { word: 'LOWER', frequency: 0.000129, inWordle: true },
  { word: 'LOWLY', frequency: 1.86e-06, inWordle: true },
  { word: 'LOYAL', frequency: 1.58e-05, inWordle: true },
  { word: 'LUCID', frequency: 1.86e-06, inWordle: true },
  { word: 'LUCKY', frequency: 5.89e-05, inWordle: true },
  { word: 'LUMEN', frequency: 1.23e-06, inWordle: true },
  { word: 'LUMPY', frequency: 6.92e-07, inWordle: true },
  { word: 'LUNAR', frequency: 5.89e-06, inWordle: true },
  { word: 'LUNCH', frequency: 4.57e-05, inWordle: true },
  { word: 'LUNGE', frequency: 7.08e-07, inWordle: true },
  { word: 'LUPUS', frequency: 1.58e-06, inWordle: true },
  { word: 'LURCH', frequency: 6.17e-07, inWordle: true },
  { word: 'LURID', frequency: 5.37e-07, inWordle: true },
  { word: 'LUSTY', frequency: 6.31e-07, inWordle: true },
  { word: 'LYING', frequency: 4.68e-05, inWordle: true },
  { word: 'LYMPH', frequency: 1.58e-06, inWordle: true },
  { word: 'LYNCH', frequency: 8.71e-06, inWordle: false },
  { word: 'LYRIC', frequency: 4.27e-06, inWordle: true },
  { word: 'MACAW', frequency: 2.14e-07, inWordle: true },
  { word: 'MACHO', frequency: 1.82e-06, inWordle: true },
  { word: 'MACRO', frequency: 5.13e-06, inWordle: true },
  { word: 'MADAM', frequency: 3.89e-06, inWordle: true },
  { word: 'MADLY', frequency: 1.48e-06, inWordle: true },
  { word: 'MAFIA', frequency: 6.76e-06, inWordle: true },
  { word: 'MAGIC', frequency: 5.75e-05, inWordle: true },
  { word: 'MAGMA', frequency: 1.55e-06, inWordle: true },
  { word: 'MAIZE', frequency: 2.19e-06, inWordle: true },
  { word: 'MAJOR', frequency: 0.0002, inWordle: true },
  { word: 'MAKER', frequency: 1.7e-05, inWordle: true },
  { word: 'MAMBO', frequency: 6.03e-07, inWordle: true },
  { word: 'MAMMA', frequency: 2.09e-06, inWordle: true },
  { word: 'MANGA', frequency: 9.33e-06, inWordle: true },
  { word: 'MANGE', frequency: 3.16e-07, inWordle: true },
  { word: 'MANGO', frequency: 3.63e-06, inWordle: true },
  { word: 'MANGY', frequency: 1.26e-07, inWordle: true },
  { word: 'MANIA', frequency: 2.75e-06, inWordle: true },
  { word: 'MANIC', frequency: 2.09e-06, inWordle: true },
  { word: 'MANLY', frequency: 4.57e-06, inWordle: true },
  { word: 'MANOR', frequency: 6.46e-06, inWordle: true },
  { word: 'MAPLE', frequency: 7.24e-06, inWordle: true },
  { word: 'MARCH', frequency: 0.000182, inWordle: true },
  { word: 'MARRY', frequency: 2.51e-05, inWordle: true },
  { word: 'MARSH', frequency: 7.41e-06, inWordle: true },
  { word: 'MASON', frequency: 1.38e-05, inWordle: true },
  { word: 'MASSE', frequency: 1.41e-06, inWordle: true },
  { word: 'MATCH', frequency: 0.000135, inWordle: true },
  { word: 'MATEY', frequency: 3.16e-07, inWordle: true },
  { word: 'MAUVE', frequency: 5.13e-07, inWordle: true },
  { word: 'MAXIM', frequency: 2.45e-06, inWordle: true },
  { word: 'MAYBE', frequency: 0.000282, inWordle: true },
  { word: 'MAYOR', frequency: 4.17e-05, inWordle: true },
  { word: 'MEALY', frequency: 2.51e-07, inWordle: true },
  { word: 'MEANT', frequency: 8.71e-05, inWordle: true },
  { word: 'MEATY', frequency: 1.02e-06, inWordle: true },
  { word: 'MECCA', frequency: 2.4e-06, inWordle: true },
  { word: 'MEDAL', frequency: 2.45e-05, inWordle: true },
  { word: 'MEDIA', frequency: 0.0002, inWordle: true },
  { word: 'MEDIC', frequency: 2.63e-06, inWordle: true },
  { word: 'MELEE', frequency: 1.66e-06, inWordle: true },
  { word: 'MELON', frequency: 2.09e-06, inWordle: true },
  { word: 'MERCY', frequency: 1.78e-05, inWordle: true },
  { word: 'MERGE', frequency: 5.62e-06, inWordle: true },
  { word: 'MERIT', frequency: 1.2e-05, inWordle: true },
  { word: 'MERRY', frequency: 6.76e-06, inWordle: true },
  { word: 'METAL', frequency: 6.61e-05, inWordle: true },
  { word: 'METER', frequency: 1.23e-05, inWordle: true },
  { word: 'METRO', frequency: 1.51e-05, inWordle: true },
  { word: 'MICRO', frequency: 1.2e-05, inWordle: true },
  { word: 'MIDGE', frequency: 5.75e-07, inWordle: true },
  { word: 'MIDST', frequency: 7.76e-06, inWordle: true },
  { word: 'MIGHT', frequency: 0.000457, inWordle: true },
  { word: 'MILKY', frequency: 3.16e-06, inWordle: true },
  { word: 'MIMIC', frequency: 3.09e-06, inWordle: true },
  { word: 'MINCE', frequency: 1.05e-06, inWordle: true },
  { word: 'MINER', frequency: 3.8e-06, inWordle: true },
  { word: 'MINIM', frequency: 9.77e-08, inWordle: true },
  { word: 'MINOR', frequency: 4.17e-05, inWordle: true },
  { word: 'MINTY', frequency: 4.9e-07, inWordle: true },
  { word: 'MINUS', frequency: 1e-05, inWordle: true },
  { word: 'MIRTH', frequency: 4.17e-07, inWordle: true },
  { word: 'MISER', frequency: 3.63e-07, inWordle: true },
  { word: 'MISSY', frequency: 1.82e-06, inWordle: true },
  { word: 'MOCHA', frequency: 9.55e-07, inWordle: true },
  { word: 'MODAL', frequency: 1.35e-06, inWordle: true },
  { word: 'MODEL', frequency: 0.000135, inWordle: true },
  { word: 'MODEM', frequency: 2.51e-06, inWordle: true },
  { word: 'MOGUL', frequency: 1.17e-06, inWordle: true },
  { word: 'MOIST', frequency: 4.9e-06, inWordle: true },
  { word: 'MOLAR', frequency: 9.77e-07, inWordle: true },
  { word: 'MOLDY', frequency: 4.9e-07, inWordle: true },
  { word: 'MONEY', frequency: 0.000437, inWordle: true },
  { word: 'MONTH', frequency: 0.000178, inWordle: true },
  { word: 'MOODY', frequency: 5.01e-06, inWordle: true },
  { word: 'MOOSE', frequency: 4.07e-06, inWordle: true },
  { word: 'MORAL', frequency: 2.88e-05, inWordle: true },
  { word: 'MORON', frequency: 5.62e-06, inWordle: true },
  { word: 'MORPH', frequency: 1.17e-06, inWordle: true },
  { word: 'MOSSY', frequency: 4.37e-07, inWordle: true },
  { word: 'MOTEL', frequency: 4.07e-06, inWordle: true },
  { word: 'MOTIF', frequency: 2.51e-06, inWordle: true },
  { word: 'MOTOR', frequency: 3.39e-05, inWordle: true },
  { word: 'MOTTO', frequency: 5.25e-06, inWordle: true },
  { word: 'MOULT', frequency: 1.78e-07, inWordle: true },
  { word: 'MOUND', frequency: 3.98e-06, inWordle: true },
  { word: 'MOUNT', frequency: 2.95e-05, inWordle: true },
  { word: 'MOURN', frequency: 2.69e-06, inWordle: true },
  { word: 'MOUSE', frequency: 2.04e-05, inWordle: true },
  { word: 'MOUTH', frequency: 6.76e-05, inWordle: true },
  { word: 'MOVER', frequency: 1.62e-06, inWordle: true },
  { word: 'MOVIE', frequency: 0.000145, inWordle: true },
  { word: 'MOWER', frequency: 1.26e-06, inWordle: true },
  { word: 'MUCKY', frequency: 1.95e-07, inWordle: true },
  { word: 'MUCUS', frequency: 1.41e-06, inWordle: true },
  { word: 'MUDDY', frequency: 3.98e-06, inWordle: true },
  { word: 'MULCH', frequency: 7.94e-07, inWordle: true },
  { word: 'MUMMY', frequency: 3.72e-06, inWordle: true },
  { word: 'MUNCH', frequency: 1.2e-06, inWordle: true },
  { word: 'MURAL', frequency: 3.09e-06, inWordle: true },
  { word: 'MURKY', frequency: 1.32e-06, inWordle: true },
  { word: 'MUSHY', frequency: 8.71e-07, inWordle: true },
  { word: 'MUSIC', frequency: 0.000331, inWordle: true },
  { word: 'MUSKY', frequency: 2.69e-07, inWordle: true },
  { word: 'MUSTY', frequency: 6.76e-07, inWordle: true },
  { word: 'MYRRH', frequency: 3.63e-07, inWordle: true },
  { word: 'NADIR', frequency: 7.24e-07, inWordle: true },
  { word: 'NAIVE', frequency: 5.62e-06, inWordle: true },
  { word: 'NANNY', frequency: 3.89e-06, inWordle: true },
  { word: 'NASAL', frequency: 3.09e-06, inWordle: true },
  { word: 'NASTY', frequency: 1.66e-05, inWordle: true },
  { word: 'NATAL', frequency: 2.57e-06, inWordle: true },
  { word: 'NAVAL', frequency: 1.74e-05, inWordle: true },
  { word: 'NAVEL', frequency: 8.91e-07, inWordle: true },
  { word: 'NEEDY', frequency: 3.8e-06, inWordle: true },
  { word: 'NEIGH', frequency: 3.09e-07, inWordle: true },
  { word: 'NERDY', frequency: 1.48e-06, inWordle: true },
  { word: 'NERVE', frequency: 1.55e-05, inWordle: true },
  { word: 'NEVER', frequency: 0.000813, inWordle: true },
  { word: 'NEWER', frequency: 8.71e-06, inWordle: true },
  { word: 'NEWLY', frequency: 2.63e-05, inWordle: true },
  { word: 'NICER', frequency: 4.47e-06, inWordle: true },
  { word: 'NICHE', frequency: 7.08e-06, inWordle: true },
  { word: 'NIECE', frequency: 6.61e-06, inWordle: true },
  { word: 'NIGHT', frequency: 0.000407, inWordle: true },
  { word: 'NINJA', frequency: 7.41e-06, inWordle: true },
  { word: 'NINNY', frequency: 8.51e-08, inWordle: true },
  { word: 'NINTH', frequency: 1.17e-05, inWordle: true },
  { word: 'NOBLE', frequency: 1.74e-05, inWordle: true },
  { word: 'NOBLY', frequency: 2.45e-07, inWordle: true },
  { word: 'NOISE', frequency: 3.55e-05, inWordle: true },
  { word: 'NOISY', frequency: 4.68e-06, inWordle: true },
  { word: 'NOMAD', frequency: 1.17e-06, inWordle: true },
  { word: 'NOOSE', frequency: 9.55e-07, inWordle: true },
  { word: 'NORTH', frequency: 0.000219, inWordle: true },
  { word: 'NOSEY', frequency: 3.55e-07, inWordle: true },
  { word: 'NOTCH', frequency: 6.03e-06, inWordle: true },
  { word: 'NOVEL', frequency: 4.27e-05, inWordle: true },
  { word: 'NUDGE', frequency: 1.66e-06, inWordle: true },
  { word: 'NURSE', frequency: 2.51e-05, inWordle: true },
  { word: 'NUTTY', frequency: 1.55e-06, inWordle: true },
  { word: 'NYLON', frequency: 2.63e-06, inWordle: true },
  { word: 'NYMPH', frequency: 7.41e-07, inWordle: true },
  { word: 'OAKEN', frequency: 8.71e-08, inWordle: true },
  { word: 'OBESE', frequency: 4.79e-06, inWordle: true },
  { word: 'OCCUR', frequency: 2.95e-05, inWordle: true },
  { word: 'OCEAN', frequency: 5.01e-05, inWordle: true },
  { word: 'OCTAL', frequency: 1.35e-07, inWordle: true },
  { word: 'OCTET', frequency: 1.74e-07, inWordle: true },
  { word: 'ODDER', frequency: 1.26e-07, inWordle: true },
  { word: 'ODDLY', frequency: 3.63e-06, inWordle: true },
  { word: 'OFFAL', frequency: 3.24e-07, inWordle: true },
  { word: 'OFFER', frequency: 0.000112, inWordle: true },
  { word: 'OFTEN', frequency: 0.000257, inWordle: true },
  { word: 'OLDEN', frequency: 6.92e-07, inWordle: true },
  { word: 'OLDER', frequency: 8.32e-05, inWordle: true },
  { word: 'OLIVE', frequency: 1.23e-05, inWordle: true },
  { word: 'OMBRE', frequency: 3.89e-07, inWordle: true },
  { word: 'OMEGA', frequency: 6.03e-06, inWordle: true },
  { word: 'ONION', frequency: 7.76e-06, inWordle: true },
  { word: 'ONSET', frequency: 5.25e-06, inWordle: true },
  { word: 'OPERA', frequency: 1.86e-05, inWordle: true },
  { word: 'OPINE', frequency: 2e-07, inWordle: true },
  { word: 'OPIUM', frequency: 2.88e-06, inWordle: true },
  { word: 'OPTIC', frequency: 4.47e-06, inWordle: true },
  { word: 'ORBIT', frequency: 1.07e-05, inWordle: true },
  { word: 'ORDER', frequency: 0.000309, inWordle: true },
  { word: 'ORGAN', frequency: 1.38e-05, inWordle: true },
  { word: 'OTHER', frequency: 0.00145, inWordle: true },
  { word: 'OTTER', frequency: 2.34e-06, inWordle: true },
  { word: 'OUGHT', frequency: 2.24e-05, inWordle: true },
  { word: 'OUNCE', frequency: 6.31e-06, inWordle: true },
  { word: 'OUTDO', frequency: 5.25e-07, inWordle: true },
  { word: 'OUTER', frequency: 1.78e-05, inWordle: true },
  { word: 'OUTGO', frequency: 2.19e-08, inWordle: true },
  { word: 'OVARY', frequency: 8.71e-07, inWordle: true },
  { word: 'OVATE', frequency: 3.8e-07, inWordle: true },
  { word: 'OVERT', frequency: 2.04e-06, inWordle: true },
  { word: 'OVINE', frequency: 4.79e-08, inWordle: true },
  { word: 'OVOID', frequency: 2.63e-07, inWordle: true },
  { word: 'OWING', frequency: 5.37e-06, inWordle: true },
  { word: 'OWNER', frequency: 6.76e-05, inWordle: true },
  { word: 'OXIDE', frequency: 4.57e-06, inWordle: true },
  { word: 'OZONE', frequency: 2.63e-06, inWordle: true },
  { word: 'PADDY', frequency: 4.17e-06, inWordle: true },
  { word: 'PAGAN', frequency: 3.63e-06, inWordle: true },
  { word: 'PAINT', frequency: 3.31e-05, inWordle: true },
  { word: 'PALER', frequency: 7.41e-07, inWordle: true },
  { word: 'PALSY', frequency: 1.58e-06, inWordle: true },
  { word: 'PANEL', frequency: 3.55e-05, inWordle: true },
  { word: 'PANIC', frequency: 1.82e-05, inWordle: true },
  { word: 'PANSY', frequency: 5.89e-07, inWordle: true },
  { word: 'PAPAL', frequency: 2.51e-06, inWordle: true },
  { word: 'PAPER', frequency: 0.000117, inWordle: true },
  { word: 'PARER', frequency: 3.55e-08, inWordle: true },
  { word: 'PARKA', frequency: 5.75e-07, inWordle: true },
  { word: 'PARRY', frequency: 2.75e-06, inWordle: true },
  { word: 'PARSE', frequency: 9.55e-07, inWordle: true },
  { word: 'PARTY', frequency: 0.000309, inWordle: true },
  { word: 'PASTA', frequency: 8.32e-06, inWordle: true },
  { word: 'PASTE', frequency: 8.13e-06, inWordle: true },
  { word: 'PASTY', frequency: 7.59e-07, inWordle: true },
  { word: 'PATCH', frequency: 1.58e-05, inWordle: true },
  { word: 'PATIO', frequency: 2.75e-06, inWordle: true },
  { word: 'PATSY', frequency: 1.32e-06, inWordle: true },
  { word: 'PATTY', frequency: 3.8e-06, inWordle: true },
  { word: 'PAUSE', frequency: 1e-05, inWordle: true },
  { word: 'PAYEE', frequency: 1.95e-07, inWordle: true },
  { word: 'PAYER', frequency: 1.66e-06, inWordle: true },
  { word: 'PEACE', frequency: 0.000105, inWordle: true },
  { word: 'PEACH', frequency: 5.89e-06, inWordle: true },
  { word: 'PEARL', frequency: 1.38e-05, inWordle: true },
  { word: 'PECAN', frequency: 8.51e-07, inWordle: true },
  { word: 'PEDAL', frequency: 4.37e-06, inWordle: true },
  { word: 'PENAL', frequency: 2.88e-06, inWordle: true },
  { word: 'PENCE', frequency: 4.57e-06, inWordle: true },
  { word: 'PENNE', frequency: 2.95e-07, inWordle: true },
  { word: 'PENNY', frequency: 1.17e-05, inWordle: true },
  { word: 'PERCH', frequency: 1.95e-06, inWordle: true },
  { word: 'PERIL', frequency: 2.51e-06, inWordle: true },
  { word: 'PERKY', frequency: 8.91e-07, inWordle: true },
  { word: 'PESKY', frequency: 1.26e-06, inWordle: true },
  { word: 'PESTO', frequency: 7.59e-07, inWordle: true },
  { word: 'PETAL', frequency: 1.1e-06, inWordle: true },
  { word: 'PETTY', frequency: 1.17e-05, inWordle: true },
  { word: 'PHASE', frequency: 4.37e-05, inWordle: true },
  { word: 'PHONE', frequency: 0.0002, inWordle: true },
  { word: 'PHONY', frequency: 2.24e-06, inWordle: true },
  { word: 'PHOTO', frequency: 9.33e-05, inWordle: true },
  { word: 'PIANO', frequency: 2.04e-05, inWordle: true },
  { word: 'PICKY', frequency: 2.19e-06, inWordle: true },
  { word: 'PIECE', frequency: 0.00011, inWordle: true },
  { word: 'PIETY', frequency: 1.23e-06, inWordle: true },
  { word: 'PIGGY', frequency: 2e-06, inWordle: true },
  { word: 'PILOT', frequency: 3.31e-05, inWordle: true },
  { word: 'PINCH', frequency: 5.75e-06, inWordle: true },
  { word: 'PINEY', frequency: 3.02e-07, inWordle: true },
  { word: 'PINKY', frequency: 2.45e-06, inWordle: true },
  { word: 'PINTO', frequency: 1.32e-06, inWordle: true },
  { word: 'PIPER', frequency: 4.79e-06, inWordle: true },
  { word: 'PIQUE', frequency: 8.51e-07, inWordle: true },
  { word: 'PITCH', frequency: 2.69e-05, inWordle: true },
  { word: 'PITHY', frequency: 4.07e-07, inWordle: true },
  { word: 'PIVOT', frequency: 3.16e-06, inWordle: true },
  { word: 'PIXEL', frequency: 5.25e-06, inWordle: true },
  { word: 'PIXIE', frequency: 1.41e-06, inWordle: true },
  { word: 'PIZZA', frequency: 2.69e-05, inWordle: true },
  { word: 'PLACE', frequency: 0.000513, inWordle: true },
  { word: 'PLAID', frequency: 2.14e-06, inWordle: true },
  { word: 'PLAIN', frequency: 2.69e-05, inWordle: true },
  { word: 'PLAIT', frequency: 2.63e-07, inWordle: true },
  { word: 'PLANE', frequency: 5.25e-05, inWordle: true },
  { word: 'PLANK', frequency: 2.88e-06, inWordle: true },
  { word: 'PLANT', frequency: 7.76e-05, inWordle: true },
  { word: 'PLATE', frequency: 3.55e-05, inWordle: true },
  { word: 'PLAZA', frequency: 8.13e-06, inWordle: true },
  { word: 'PLEAD', frequency: 4.27e-06, inWordle: true },
  { word: 'PLEAT', frequency: 1.55e-07, inWordle: true },
  { word: 'PLIED', frequency: 3.63e-07, inWordle: true },
  { word: 'PLIER', frequency: 4.57e-08, inWordle: true },
  { word: 'PLUCK', frequency: 1.35e-06, inWordle: true },
  { word: 'PLUMB', frequency: 8.32e-07, inWordle: true },
  { word: 'PLUME', frequency: 1.55e-06, inWordle: true },
  { word: 'PLUMP', frequency: 1.55e-06, inWordle: true },
  { word: 'PLUNK', frequency: 1.29e-07, inWordle: true },
  { word: 'PLUSH', frequency: 2.14e-06, inWordle: true },
  { word: 'POESY', frequency: 4.57e-08, inWordle: true },
  { word: 'POINT', frequency: 0.000347, inWordle: true },
  { word: 'POISE', frequency: 1.1e-06, inWordle: true },
  { word: 'POKER', frequency: 9.33e-06, inWordle: true },
  { word: 'POLAR', frequency: 9.12e-06, inWordle: true },
  { word: 'POLKA', frequency: 1.58e-06, inWordle: true },
  { word: 'POLYP', frequency: 2.45e-07, inWordle: true },
  { word: 'POOCH', frequency: 9.33e-07, inWordle: true },
  { word: 'POPPY', frequency: 3.89e-06, inWordle: true },
  { word: 'PORCH', frequency: 7.08e-06, inWordle: true },
  { word: 'POSER', frequency: 4.68e-07, inWordle: true },
  { word: 'POSIT', frequency: 5.75e-07, inWordle: true },
  { word: 'POSSE', frequency: 1.51e-06, inWordle: true },
  { word: 'POUCH', frequency: 2.69e-06, inWordle: true },
  { word: 'POUND', frequency: 2.09e-05, inWordle: true },
  { word: 'POUTY', frequency: 2.4e-07, inWordle: true },
  { word: 'POWER', frequency: 0.000331, inWordle: true },
  { word: 'PRANK', frequency: 5.01e-06, inWordle: true },
  { word: 'PRAWN', frequency: 7.41e-07, inWordle: true },
  { word: 'PREEN', frequency: 1.45e-07, inWordle: true },
  { word: 'PRESS', frequency: 0.000145, inWordle: true },
  { word: 'PRICE', frequency: 0.00017, inWordle: true },
  { word: 'PRICK', frequency: 3.98e-06, inWordle: true },
  { word: 'PRIDE', frequency: 3.09e-05, inWordle: true },
  { word: 'PRIED', frequency: 2.45e-07, inWordle: true },
  { word: 'PRIME', frequency: 6.46e-05, inWordle: true },
  { word: 'PRIMO', frequency: 9.77e-07, inWordle: true },
  { word: 'PRINT', frequency: 3.47e-05, inWordle: true },
  { word: 'PRIOR', frequency: 7.08e-05, inWordle: true },
  { word: 'PRISM', frequency: 2.75e-06, inWordle: true },
  { word: 'PRIVY', frequency: 2.88e-06, inWordle: true },
  { word: 'PRIZE', frequency: 3.89e-05, inWordle: true },
  { word: 'PROBE', frequency: 9.77e-06, inWordle: true },
  { word: 'PRONE', frequency: 8.51e-06, inWordle: true },
  { word: 'PRONG', frequency: 6.31e-07, inWordle: true },
  { word: 'PROOF', frequency: 5.01e-05, inWordle: true },
  { word: 'PROSE', frequency: 5.25e-06, inWordle: true },
  { word: 'PROUD', frequency: 6.03e-05, inWordle: true },
  { word: 'PROVE', frequency: 5.89e-05, inWordle: true },
  { word: 'PROWL', frequency: 5.62e-07, inWordle: true },
  { word: 'PROXY', frequency: 5.37e-06, inWordle: true },
  { word: 'PRUDE', frequency: 3.8e-07, inWordle: true },
  { word: 'PRUNE', frequency: 9.12e-07, inWordle: true },
  { word: 'PSALM', frequency: 3.63e-06, inWordle: true },
  { word: 'PUBIC', frequency: 1.17e-06, inWordle: true },
  { word: 'PUDGY', frequency: 2.95e-07, inWordle: true },
  { word: 'PUFFY', frequency: 1.35e-06, inWordle: true },
  { word: 'PULPY', frequency: 1.7e-07, inWordle: true },
  { word: 'PULSE', frequency: 1.15e-05, inWordle: true },
  { word: 'PUNCH', frequency: 2.09e-05, inWordle: true },
  { word: 'PUPAL', frequency: 1.41e-07, inWordle: false },
  { word: 'PUPIL', frequency: 6.46e-06, inWordle: true },
  { word: 'PUPPY', frequency: 1e-05, inWordle: true },
  { word: 'PUREE', frequency: 7.41e-07, inWordle: true },
  { word: 'PURER', frequency: 3.39e-07, inWordle: true },
  { word: 'PURGE', frequency: 3.72e-06, inWordle: true },
  { word: 'PURSE', frequency: 8.91e-06, inWordle: true },
  { word: 'PUSHY', frequency: 1e-06, inWordle: true },
  { word: 'PUTTY', frequency: 7.76e-07, inWordle: true },
  { word: 'PYGMY', frequency: 5.25e-07, inWordle: true },
  { word: 'QUACK', frequency: 1.15e-06, inWordle: true },
  { word: 'QUAIL', frequency: 1.35e-06, inWordle: true },
  { word: 'QUAKE', frequency: 2.82e-06, inWordle: true },
  { word: 'QUALM', frequency: 7.76e-08, inWordle: true },
  { word: 'QUARK', frequency: 1.12e-06, inWordle: true },
  { word: 'QUART', frequency: 1.02e-06, inWordle: true },
  { word: 'QUASH', frequency: 5.62e-07, inWordle: true },
  { word: 'QUASI', frequency: 3.09e-06, inWordle: true },
  { word: 'QUEEN', frequency: 7.24e-05, inWordle: true },
  { word: 'QUEER', frequency: 5.75e-06, inWordle: true },
  { word: 'QUELL', frequency: 1e-06, inWordle: true },
  { word: 'QUERY', frequency: 4.37e-06, inWordle: true },
  { word: 'QUEST', frequency: 1.86e-05, inWordle: true },
  { word: 'QUEUE', frequency: 6.03e-06, inWordle: true },
  { word: 'QUICK', frequency: 9.55e-05, inWordle: true },
  { word: 'QUIET', frequency: 4.47e-05, inWordle: true },
  { word: 'QUILL', frequency: 1.29e-06, inWordle: true },
  { word: 'QUILT', frequency: 1.78e-06, inWordle: true },
  { word: 'QUIRK', frequency: 1.35e-06, inWordle: true },
  { word: 'QUITE', frequency: 0.000195, inWordle: true },
  { word: 'QUOTA', frequency: 3.39e-06, inWordle: true },
  { word: 'QUOTE', frequency: 3.24e-05, inWordle: true },
  { word: 'QUOTH', frequency: 1.2e-07, inWordle: true },
  { word: 'RABBI', frequency: 4.9e-06, inWordle: true },
  { word: 'RABID', frequency: 1.35e-06, inWordle: true },
  { word: 'RACER', frequency: 2.82e-06, inWordle: true },
  { word: 'RADAR', frequency: 1.58e-05, inWordle: true },
  { word: 'RADII', frequency: 3.55e-07, inWordle: true },
  { word: 'RADIO', frequency: 0.000102, inWordle: true },
  { word: 'RAINY', frequency: 5.5e-06, inWordle: true },
  { word: 'RAISE', frequency: 5.62e-05, inWordle: true },
  { word: 'RAJAH', frequency: 4.47e-07, inWordle: true },
  { word: 'RALLY', frequency: 2.19e-05, inWordle: true },
  { word: 'RALPH', frequency: 1.26e-05, inWordle: true },
  { word: 'RAMEN', frequency: 2.24e-06, inWordle: true },
  { word: 'RANCH', frequency: 1.07e-05, inWordle: true },
  { word: 'RANDY', frequency: 8.32e-06, inWordle: true },
  { word: 'RANGE', frequency: 0.000132, inWordle: true },
  { word: 'RAPID', frequency: 2.4e-05, inWordle: true },
  { word: 'RARER', frequency: 1.12e-06, inWordle: true },
  { word: 'RASPY', frequency: 4.37e-07, inWordle: true },
  { word: 'RATIO', frequency: 2.34e-05, inWordle: true },
  { word: 'RATTY', frequency: 2.95e-07, inWordle: true },
  { word: 'RAVEN', frequency: 6.17e-06, inWordle: true },
  { word: 'RAYON', frequency: 9.77e-07, inWordle: true },
  { word: 'RAZOR', frequency: 5.25e-06, inWordle: true },
  { word: 'REACH', frequency: 8.71e-05, inWordle: true },
  { word: 'REACT', frequency: 1.45e-05, inWordle: true },
  { word: 'READY', frequency: 0.000191, inWordle: true },
  { word: 'REALM', frequency: 1.15e-05, inWordle: true },
  { word: 'REARM', frequency: 1.38e-07, inWordle: true },
  { word: 'REBAR', frequency: 3.72e-07, inWordle: true },
  { word: 'REBEL', frequency: 1.2e-05, inWordle: true },
  { word: 'REBUS', frequency: 3.39e-07, inWordle: true },
  { word: 'REBUT', frequency: 3.98e-07, inWordle: true },
  { word: 'RECAP', frequency: 2.82e-06, inWordle: true },
  { word: 'RECUR', frequency: 4.47e-07, inWordle: true },
  { word: 'RECUT', frequency: 1.35e-07, inWordle: true },
  { word: 'REEDY', frequency: 3.63e-07, inWordle: true },
  { word: 'REFER', frequency: 2.82e-05, inWordle: true },
  { word: 'REFIT', frequency: 4.68e-07, inWordle: true },
  { word: 'REGAL', frequency: 2.19e-06, inWordle: true },
  { word: 'REHAB', frequency: 6.17e-06, inWordle: true },
  { word: 'REIGN', frequency: 1.17e-05, inWordle: true },
  { word: 'RELAX', frequency: 1.95e-05, inWordle: true },
  { word: 'RELAY', frequency: 7.24e-06, inWordle: true },
  { word: 'RELIC', frequency: 2.34e-06, inWordle: true },
  { word: 'REMIT', frequency: 1.23e-06, inWordle: true },
  { word: 'RENAL', frequency: 2.75e-06, inWordle: true },
  { word: 'RENEW', frequency: 5.37e-06, inWordle: true },
  { word: 'REPAY', frequency: 4.57e-06, inWordle: true },
  { word: 'REPEL', frequency: 1.58e-06, inWordle: true },
  { word: 'REPLY', frequency: 3.16e-05, inWordle: true },
  { word: 'RERUN', frequency: 7.94e-07, inWordle: true },
  { word: 'RESET', frequency: 6.76e-06, inWordle: true },
  { word: 'RESIN', frequency: 4.07e-06, inWordle: true },
  { word: 'RETCH', frequency: 1.1e-07, inWordle: true },
  { word: 'RETRO', frequency: 5.37e-06, inWordle: true },
  { word: 'RETRY', frequency: 3.72e-07, inWordle: true },
  { word: 'REUSE', frequency: 2.34e-06, inWordle: true },
  { word: 'REVEL', frequency: 1.29e-06, inWordle: true },
  { word: 'REVUE', frequency: 1.17e-06, inWordle: true },
  { word: 'RHINO', frequency: 3.72e-06, inWordle: true },
  { word: 'RHYME', frequency: 3.63e-06, inWordle: true },
  { word: 'RIDER', frequency: 1.05e-05, inWordle: true },
  { word: 'RIDGE', frequency: 1.32e-05, inWordle: true },
  { word: 'RIFLE', frequency: 1.51e-05, inWordle: true },
  { word: 'RIGHT', frequency: 0.000912, inWordle: true },
  { word: 'RIGID', frequency: 5.62e-06, inWordle: true },
  { word: 'RIGOR', frequency: 1.17e-06, inWordle: true },
  { word: 'RINSE', frequency: 3.02e-06, inWordle: true },
  { word: 'RIPEN', frequency: 4.37e-07, inWordle: true },
  { word: 'RIPER', frequency: 8.91e-08, inWordle: true },
  { word: 'RISEN', frequency: 7.24e-06, inWordle: true },
  { word: 'RISER', frequency: 7.59e-07, inWordle: true },
  { word: 'RISKY', frequency: 8.71e-06, inWordle: true },
  { word: 'RIVAL', frequency: 1.51e-05, inWordle: true },
  { word: 'RIVER', frequency: 0.000107, inWordle: true },
  { word: 'RIVET', frequency: 4.9e-07, inWordle: true },
  { word: 'ROACH', frequency: 2.75e-06, inWordle: true },
  { word: 'ROAST', frequency: 7.41e-06, inWordle: true },
  { word: 'ROBIN', frequency: 2.14e-05, inWordle: true },
  { word: 'ROBOT', frequency: 1.74e-05, inWordle: true },
  { word: 'ROCKY', frequency: 1.45e-05, inWordle: true },
  { word: 'RODEO', frequency: 2.95e-06, inWordle: true },
  { word: 'ROGER', frequency: 2.45e-05, inWordle: true },
  { word: 'ROGUE', frequency: 7.76e-06, inWordle: true },
  { word: 'ROOMY', frequency: 4.68e-07, inWordle: true },
  { word: 'ROOST', frequency: 1e-06, inWordle: true },
  { word: 'ROTOR', frequency: 2.63e-06, inWordle: true },
  { word: 'ROUGE', frequency: 4.57e-06, inWordle: true },
  { word: 'ROUGH', frequency: 3.09e-05, inWordle: true },
  { word: 'ROUND', frequency: 0.000138, inWordle: true },
  { word: 'ROUSE', frequency: 1.26e-06, inWordle: true },
  { word: 'ROUTE', frequency: 4.68e-05, inWordle: true },
  { word: 'ROVER', frequency: 5.75e-06, inWordle: true },
  { word: 'ROWDY', frequency: 1.62e-06, inWordle: true },
  { word: 'ROWER', frequency: 1.29e-06, inWordle: true },
  { word: 'ROYAL', frequency: 7.08e-05, inWordle: true },
  { word: 'RUDDY', frequency: 1.02e-06, inWordle: true },
  { word: 'RUDER', frequency: 1.35e-07, inWordle: true },
  { word: 'RUGBY', frequency: 2.51e-05, inWordle: true },
  { word: 'RULER', frequency: 6.92e-06, inWordle: true },
  { word: 'RUMBA', frequency: 4.27e-07, inWordle: true },
  { word: 'RUMOR', frequency: 5.37e-06, inWordle: true },
  { word: 'RUPEE', frequency: 1.1e-06, inWordle: true },
  { word: 'RURAL', frequency: 3.89e-05, inWordle: true },
  { word: 'RUSTY', frequency: 4.07e-06, inWordle: true },
  { word: 'SADLY', frequency: 1.51e-05, inWordle: true },
  { word: 'SAFER', frequency: 1.23e-05, inWordle: true },
  { word: 'SAINT', frequency: 2.57e-05, inWordle: true },
  { word: 'SALAD', frequency: 1.41e-05, inWordle: true },
  { word: 'SALLY', frequency: 9.33e-06, inWordle: true },
  { word: 'SALON', frequency: 7.41e-06, inWordle: true },
  { word: 'SALSA', frequency: 3.39e-06, inWordle: true },
  { word: 'SALTY', frequency: 5.5e-06, inWordle: true },
  { word: 'SALVE', frequency: 6.46e-07, inWordle: true },
  { word: 'SALVO', frequency: 7.24e-07, inWordle: true },
  { word: 'SANDY', frequency: 1.55e-05, inWordle: true },
  { word: 'SANER', frequency: 1.78e-07, inWordle: true },
  { word: 'SAPPY', frequency: 4.79e-07, inWordle: true },
  { word: 'SASSY', frequency: 1.62e-06, inWordle: true },
  { word: 'SATIN', frequency: 2.45e-06, inWordle: true },
  { word: 'SATYR', frequency: 2.95e-07, inWordle: true },
  { word: 'SAUCE', frequency: 2e-05, inWordle: true },
  { word: 'SAUCY', frequency: 7.94e-07, inWordle: true },
  { word: 'SAUNA', frequency: 1.78e-06, inWordle: true },
  { word: 'SAUTE', frequency: 2.88e-07, inWordle: true },
  { word: 'SAVOR', frequency: 9.55e-07, inWordle: true },
  { word: 'SAVOY', frequency: 1.23e-06, inWordle: true },
  { word: 'SAVVY', frequency: 3.63e-06, inWordle: true },
  { word: 'SCALD', frequency: 1.48e-07, inWordle: true },
  { word: 'SCALE', frequency: 6.76e-05, inWordle: true },
  { word: 'SCALP', frequency: 3.02e-06, inWordle: true },
  { word: 'SCALY', frequency: 6.46e-07, inWordle: true },
  { word: 'SCAMP', frequency: 2.09e-07, inWordle: true },
  { word: 'SCANT', frequency: 1.26e-06, inWordle: true },
  { word: 'SCARE', frequency: 1.17e-05, inWordle: true },
  { word: 'SCARF', frequency: 4.79e-06, inWordle: true },
  { word: 'SCARY', frequency: 2.34e-05, inWordle: true },
  { word: 'SCENE', frequency: 9.33e-05, inWordle: true },
  { word: 'SCENT', frequency: 6.61e-06, inWordle: true },
  { word: 'SCION', frequency: 1.07e-06, inWordle: true },
  { word: 'SCOFF', frequency: 6.03e-07, inWordle: true },
  { word: 'SCOLD', frequency: 6.46e-07, inWordle: true },
  { word: 'SCONE', frequency: 5.5e-07, inWordle: true },
  { word: 'SCOOP', frequency: 4.9e-06, inWordle: true },
  { word: 'SCOPE', frequency: 1.82e-05, inWordle: true },
  { word: 'SCORE', frequency: 6.76e-05, inWordle: true },
  { word: 'SCORN', frequency: 1.35e-06, inWordle: true },
  { word: 'SCOUR', frequency: 9.33e-07, inWordle: true },
  { word: 'SCOUT', frequency: 9.33e-06, inWordle: true },
  { word: 'SCOWL', frequency: 3.24e-07, inWordle: true },
  { word: 'SCRAM', frequency: 2.24e-07, inWordle: true },
  { word: 'SCRAP', frequency: 7.94e-06, inWordle: true },
  { word: 'SCREE', frequency: 2.04e-07, inWordle: true },
  { word: 'SCREW', frequency: 1.78e-05, inWordle: true },
  { word: 'SCRUB', frequency: 4.9e-06, inWordle: true },
  { word: 'SCRUM', frequency: 1.78e-06, inWordle: true },
  { word: 'SCUBA', frequency: 2.04e-06, inWordle: true },
  { word: 'SEDAN', frequency: 3.55e-06, inWordle: true },
  { word: 'SEEDY', frequency: 6.76e-07, inWordle: true },
  { word: 'SEGUE', frequency: 3.63e-07, inWordle: true },
  { word: 'SEIZE', frequency: 6.31e-06, inWordle: true },
  { word: 'SEMEN', frequency: 2.4e-06, inWordle: true },
  { word: 'SENSE', frequency: 0.000155, inWordle: true },
  { word: 'SEPIA', frequency: 6.03e-07, inWordle: true },
  { word: 'SERIF', frequency: 4.37e-07, inWordle: true },
  { word: 'SERUM', frequency: 5.5e-06, inWordle: true },
  { word: 'SERVE', frequency: 7.08e-05, inWordle: true },
  { word: 'SETUP', frequency: 1.23e-05, inWordle: true },
  { word: 'SEVEN', frequency: 0.00012, inWordle: true },
  { word: 'SEVER', frequency: 1.41e-06, inWordle: true },
  { word: 'SEWER', frequency: 4.37e-06, inWordle: true },
  { word: 'SHACK', frequency: 2.69e-06, inWordle: true },
  { word: 'SHADE', frequency: 1.45e-05, inWordle: true },
  { word: 'SHADY', frequency: 5.13e-06, inWordle: true },
  { word: 'SHAFT', frequency: 7.94e-06, inWordle: true },
  { word: 'SHAKE', frequency: 2.14e-05, inWordle: true },
  { word: 'SHAKY', frequency: 2.82e-06, inWordle: true },
  { word: 'SHALE', frequency: 4.9e-06, inWordle: true },
  { word: 'SHALL', frequency: 0.000107, inWordle: true },
  { word: 'SHALT', frequency: 2.19e-06, inWordle: true },
  { word: 'SHAME', frequency: 3.55e-05, inWordle: true },
  { word: 'SHANK', frequency: 1.17e-06, inWordle: true },
  { word: 'SHAPE', frequency: 5.25e-05, inWordle: true },
  { word: 'SHARD', frequency: 1e-06, inWordle: true },
  { word: 'SHARE', frequency: 0.000158, inWordle: true },
  { word: 'SHARK', frequency: 1.26e-05, inWordle: true },
  { word: 'SHARP', frequency: 3.02e-05, inWordle: true },
  { word: 'SHAVE', frequency: 6.76e-06, inWordle: true },
  { word: 'SHAWL', frequency: 1.48e-06, inWordle: true },
  { word: 'SHEAR', frequency: 2.51e-06, inWordle: true },
  { word: 'SHEEN', frequency: 2.19e-06, inWordle: true },
  { word: 'SHEEP', frequency: 1.55e-05, inWordle: true },
  { word: 'SHEER', frequency: 1.02e-05, inWordle: true },
  { word: 'SHEET', frequency: 2.51e-05, inWordle: true },
  { word: 'SHEIK', frequency: 1.26e-06, inWordle: true },
  { word: 'SHELF', frequency: 1.05e-05, inWordle: true },
  { word: 'SHELL', frequency: 2.45e-05, inWordle: true },
  { word: 'SHIED', frequency: 3.24e-07, inWordle: true },
  { word: 'SHIFT', frequency: 3.72e-05, inWordle: true },
  { word: 'SHINE', frequency: 1.48e-05, inWordle: true },
  { word: 'SHINY', frequency: 7.59e-06, inWordle: true },
  { word: 'SHIRE', frequency: 2.95e-06, inWordle: true },
  { word: 'SHIRK', frequency: 4.57e-07, inWordle: true },
  { word: 'SHIRT', frequency: 4.27e-05, inWordle: true },
  { word: 'SHOAL', frequency: 8.51e-07, inWordle: true },
  { word: 'SHOCK', frequency: 2.88e-05, inWordle: true },
  { word: 'SHONE', frequency: 1.7e-06, inWordle: true },
  { word: 'SHOOK', frequency: 1.12e-05, inWordle: true },
  { word: 'SHOOT', frequency: 5.37e-05, inWordle: true },
  { word: 'SHORE', frequency: 2.14e-05, inWordle: true },
  { word: 'SHORN', frequency: 3.39e-07, inWordle: true },
  { word: 'SHORT', frequency: 0.000214, inWordle: true },
  { word: 'SHOUT', frequency: 1.15e-05, inWordle: true },
  { word: 'SHOVE', frequency: 4.57e-06, inWordle: true },
  { word: 'SHOWN', frequency: 7.94e-05, inWordle: true },
  { word: 'SHOWY', frequency: 6.17e-07, inWordle: true },
  { word: 'SHREW', frequency: 5.62e-07, inWordle: true },
  { word: 'SHRUB', frequency: 1.55e-06, inWordle: true },
  { word: 'SHRUG', frequency: 2e-06, inWordle: true },
  { word: 'SHUCK', frequency: 2.34e-07, inWordle: true },
  { word: 'SHUNT', frequency: 6.61e-07, inWordle: true },
  { word: 'SHUSH', frequency: 5.62e-07, inWordle: true },
  { word: 'SHYLY', frequency: 2.63e-07, inWordle: true },
  { word: 'SIEGE', frequency: 8.51e-06, inWordle: true },
  { word: 'SIEVE', frequency: 1e-06, inWordle: true },
  { word: 'SIGHT', frequency: 3.47e-05, inWordle: true },
  { word: 'SIGMA', frequency: 3.24e-06, inWordle: true },
  { word: 'SILKY', frequency: 1.82e-06, inWordle: true },
  { word: 'SILLY', frequency: 2.45e-05, inWordle: true },
  { word: 'SINCE', frequency: 0.000562, inWordle: true },
  { word: 'SINEW', frequency: 2.14e-07, inWordle: true },
  { word: 'SINGE', frequency: 2.69e-07, inWordle: true },
  { word: 'SIREN', frequency: 2.88e-06, inWordle: true },
  { word: 'SISSY', frequency: 1.7e-06, inWordle: true },
  { word: 'SIXTH', frequency: 2.4e-05, inWordle: true },
  { word: 'SIXTY', frequency: 8.51e-06, inWordle: true },
  { word: 'SKATE', frequency: 5.5e-06, inWordle: true },
  { word: 'SKIER', frequency: 1.58e-06, inWordle: true },
  { word: 'SKIFF', frequency: 4.27e-07, inWordle: true },
  { word: 'SKILL', frequency: 2.63e-05, inWordle: true },
  { word: 'SKIMP', frequency: 3.31e-07, inWordle: true },
  { word: 'SKIRT', frequency: 9.12e-06, inWordle: true },
  { word: 'SKULK', frequency: 7.76e-08, inWordle: true },
  { word: 'SKULL', frequency: 1.23e-05, inWordle: true },
  { word: 'SKUNK', frequency: 1.26e-06, inWordle: true },
  { word: 'SLACK', frequency: 5.13e-06, inWordle: true },
  { word: 'SLAIN', frequency: 3.47e-06, inWordle: true },
  { word: 'SLANG', frequency: 3.55e-06, inWordle: true },
  { word: 'SLANT', frequency: 1.51e-06, inWordle: true },
  { word: 'SLASH', frequency: 4.47e-06, inWordle: true },
  { word: 'SLATE', frequency: 6.61e-06, inWordle: true },
  { word: 'SLEEK', frequency: 2.19e-06, inWordle: true },
  { word: 'SLEEP', frequency: 0.000112, inWordle: true },
  { word: 'SLEET', frequency: 6.76e-07, inWordle: true },
  { word: 'SLEPT', frequency: 1.51e-05, inWordle: true },
  { word: 'SLICE', frequency: 1e-05, inWordle: true },
  { word: 'SLICK', frequency: 5.13e-06, inWordle: true },
  { word: 'SLIDE', frequency: 2e-05, inWordle: true },
  { word: 'SLIME', frequency: 2.4e-06, inWordle: true },
  { word: 'SLIMY', frequency: 1.2e-06, inWordle: true },
  { word: 'SLING', frequency: 2.19e-06, inWordle: true },
  { word: 'SLINK', frequency: 2.4e-07, inWordle: true },
  { word: 'SLOOP', frequency: 6.31e-07, inWordle: true },
  { word: 'SLOPE', frequency: 7.94e-06, inWordle: true },
  { word: 'SLOSH', frequency: 1.26e-07, inWordle: true },
  { word: 'SLOTH', frequency: 1.26e-06, inWordle: true },
  { word: 'SLUMP', frequency: 2.29e-06, inWordle: true },
  { word: 'SLUNG', frequency: 7.08e-07, inWordle: true },
  { word: 'SLUNK', frequency: 9.33e-08, inWordle: true },
  { word: 'SLURP', frequency: 3.63e-07, inWordle: true },
  { word: 'SLUSH', frequency: 9.77e-07, inWordle: true },
  { word: 'SLYLY', frequency: 2.88e-07, inWordle: true },
  { word: 'SMACK', frequency: 4.37e-06, inWordle: true },
  { word: 'SMALL', frequency: 0.000324, inWordle: true },
  { word: 'SMART', frequency: 6.76e-05, inWordle: true },
  { word: 'SMASH', frequency: 1.23e-05, inWordle: true },
  { word: 'SMEAR', frequency: 2.88e-06, inWordle: true },
  { word: 'SMELL', frequency: 3.09e-05, inWordle: true },
  { word: 'SMELT', frequency: 9.77e-07, inWordle: true },
  { word: 'SMILE', frequency: 4.37e-05, inWordle: true },
  { word: 'SMIRK', frequency: 1.1e-06, inWordle: true },
  { word: 'SMITE', frequency: 8.51e-07, inWordle: true },
  { word: 'SMITH', frequency: 7.76e-05, inWordle: true },
  { word: 'SMOCK', frequency: 3.72e-07, inWordle: true },
  { word: 'SMOKE', frequency: 4.68e-05, inWordle: true },
  { word: 'SMOKY', frequency: 2.14e-06, inWordle: true },
  { word: 'SMOTE', frequency: 2e-07, inWordle: true },
  { word: 'SNACK', frequency: 7.94e-06, inWordle: true },
  { word: 'SNAIL', frequency: 4.68e-06, inWordle: true },
  { word: 'SNAKE', frequency: 1.7e-05, inWordle: true },
  { word: 'SNAKY', frequency: 5.25e-08, inWordle: true },
  { word: 'SNARE', frequency: 1.78e-06, inWordle: true },
  { word: 'SNARL', frequency: 4.17e-07, inWordle: true },
  { word: 'SNEAK', frequency: 9.77e-06, inWordle: true },
  { word: 'SNEER', frequency: 5.01e-07, inWordle: true },
  { word: 'SNIDE', frequency: 3.89e-07, inWordle: true },
  { word: 'SNIFF', frequency: 2.75e-06, inWordle: true },
  { word: 'SNIPE', frequency: 1.1e-06, inWordle: true },
  { word: 'SNOOP', frequency: 2.51e-06, inWordle: true },
  { word: 'SNORE', frequency: 5.75e-07, inWordle: true },
  { word: 'SNORT', frequency: 1.02e-06, inWordle: true },
  { word: 'SNOUT', frequency: 1.2e-06, inWordle: true },
  { word: 'SNOWY', frequency: 2.88e-06, inWordle: true },
  { word: 'SNUCK', frequency: 1.86e-06, inWordle: true },
  { word: 'SNUFF', frequency: 1.41e-06, inWordle: true },
  { word: 'SOAPY', frequency: 5.62e-07, inWordle: true },
  { word: 'SOBER', frequency: 8.71e-06, inWordle: true },
  { word: 'SOGGY', frequency: 1.38e-06, inWordle: true },
  { word: 'SOLAR', frequency: 3.39e-05, inWordle: true },
  { word: 'SOLID', frequency: 5.37e-05, inWordle: true },
  { word: 'SOLVE', frequency: 2.63e-05, inWordle: true },
  { word: 'SONAR', frequency: 2e-06, inWordle: true },
  { word: 'SONIC', frequency: 8.51e-06, inWordle: true },
  { word: 'SOOTH', frequency: 2.34e-07, inWordle: true },
  { word: 'SOOTY', frequency: 3.24e-07, inWordle: true },
  { word: 'SORRY', frequency: 0.000151, inWordle: true },
  { word: 'SOUND', frequency: 0.000141, inWordle: true },
  { word: 'SOUTH', frequency: 0.000251, inWordle: true },
  { word: 'SOWER', frequency: 1.48e-07, inWordle: true },
  { word: 'SPACE', frequency: 0.00017, inWordle: true },
  { word: 'SPADE', frequency: 2.14e-06, inWordle: true },
  { word: 'SPANK', frequency: 1.2e-06, inWordle: true },
  { word: 'SPARE', frequency: 1.91e-05, inWordle: true },
  { word: 'SPARK', frequency: 9.77e-06, inWordle: true },
  { word: 'SPASM', frequency: 6.76e-07, inWordle: true },
  { word: 'SPAWN', frequency: 2.4e-06, inWordle: true },
  { word: 'SPEAK', frequency: 0.000107, inWordle: true },
  { word: 'SPEAR', frequency: 5.01e-06, inWordle: true },
  { word: 'SPECK', frequency: 1.05e-06, inWordle: true },
  { word: 'SPEED', frequency: 0.0001, inWordle: true },
  { word: 'SPELL', frequency: 2.34e-05, inWordle: true },
  { word: 'SPELT', frequency: 1.51e-06, inWordle: true },
  { word: 'SPEND', frequency: 9.33e-05, inWordle: true },
  { word: 'SPENT', frequency: 0.000105, inWordle: true },
  { word: 'SPERM', frequency: 6.92e-06, inWordle: true },
  { word: 'SPICE', frequency: 8.71e-06, inWordle: true },
  { word: 'SPICY', frequency: 6.31e-06, inWordle: true },
  { word: 'SPIED', frequency: 1.2e-06, inWordle: true },
  { word: 'SPIEL', frequency: 4.57e-07, inWordle: true },
  { word: 'SPIKE', frequency: 9.12e-06, inWordle: true },
  { word: 'SPIKY', frequency: 5.62e-07, inWordle: true },
  { word: 'SPILL', frequency: 6.92e-06, inWordle: true },
  { word: 'SPILT', frequency: 8.13e-07, inWordle: true },
  { word: 'SPINE', frequency: 8.51e-06, inWordle: true },
  { word: 'SPINY', frequency: 4.37e-07, inWordle: true },
  { word: 'SPIRE', frequency: 1.29e-06, inWordle: true },
  { word: 'SPITE', frequency: 1.1e-05, inWordle: true },
  { word: 'SPLAT', frequency: 5.01e-07, inWordle: true },
  { word: 'SPLIT', frequency: 4.47e-05, inWordle: true },
  { word: 'SPOIL', frequency: 6.46e-06, inWordle: true },
  { word: 'SPOKE', frequency: 4.07e-05, inWordle: true },
  { word: 'SPOOF', frequency: 1.26e-06, inWordle: true },
  { word: 'SPOOK', frequency: 7.59e-07, inWordle: true },
  { word: 'SPOOL', frequency: 6.92e-07, inWordle: true },
  { word: 'SPOON', frequency: 7.59e-06, inWordle: true },
  { word: 'SPORE', frequency: 1e-06, inWordle: true },
  { word: 'SPORT', frequency: 5.37e-05, inWordle: true },
  { word: 'SPOUT', frequency: 1.29e-06, inWordle: true },
  { word: 'SPRAY', frequency: 1.51e-05, inWordle: true },
  { word: 'SPREE', frequency: 3.63e-06, inWordle: true },
  { word: 'SPRIG', frequency: 2.69e-07, inWordle: true },
  { word: 'SPUNK', frequency: 4.57e-07, inWordle: true },
  { word: 'SPURN', frequency: 2.29e-07, inWordle: true },
  { word: 'SPURT', frequency: 6.92e-07, inWordle: true },
  { word: 'SQUAD', frequency: 4.68e-05, inWordle: true },
  { word: 'SQUAT', frequency: 3.02e-06, inWordle: true },
  { word: 'SQUIB', frequency: 1.95e-07, inWordle: true },
  { word: 'STACK', frequency: 1.12e-05, inWordle: true },
  { word: 'STAFF', frequency: 0.00012, inWordle: true },
  { word: 'STAGE', frequency: 0.000126, inWordle: true },
  { word: 'STAID', frequency: 3.8e-07, inWordle: true },
  { word: 'STAIN', frequency: 5.01e-06, inWordle: true },
  { word: 'STAIR', frequency: 1.82e-06, inWordle: true },
  { word: 'STAKE', frequency: 1.41e-05, inWordle: true },
  { word: 'STALE', frequency: 2.69e-06, inWordle: true },
  { word: 'STALK', frequency: 2.88e-06, inWordle: true },
  { word: 'STALL', frequency: 6.17e-06, inWordle: true },
  { word: 'STAMP', frequency: 1.29e-05, inWordle: true },
  { word: 'STAND', frequency: 0.000138, inWordle: true },
  { word: 'STANK', frequency: 5.75e-07, inWordle: true },
  { word: 'STARE', frequency: 8.13e-06, inWordle: true },
  { word: 'STARK', frequency: 1.02e-05, inWordle: true },
  { word: 'START', frequency: 0.000363, inWordle: true },
  { word: 'STASH', frequency: 3.47e-06, inWordle: true },
  { word: 'STATE', frequency: 0.000603, inWordle: true },
  { word: 'STAVE', frequency: 1.1e-06, inWordle: true },
  { word: 'STEAD', frequency: 1.55e-06, inWordle: true },
  { word: 'STEAK', frequency: 9.33e-06, inWordle: true },
  { word: 'STEAL', frequency: 2.57e-05, inWordle: true },
  { word: 'STEAM', frequency: 3.31e-05, inWordle: true },
  { word: 'STEED', frequency: 8.91e-07, inWordle: true },
  { word: 'STEEL', frequency: 5.13e-05, inWordle: true },
  { word: 'STEEP', frequency: 9.77e-06, inWordle: true },
  { word: 'STEER', frequency: 5.25e-06, inWordle: true },
  { word: 'STEIN', frequency: 4.47e-06, inWordle: true },
  { word: 'STERN', frequency: 7.94e-06, inWordle: true },
  { word: 'STICK', frequency: 5.75e-05, inWordle: true },
  { word: 'STIFF', frequency: 7.94e-06, inWordle: true },
  { word: 'STILL', frequency: 0.000832, inWordle: true },
  { word: 'STILT', frequency: 2.34e-07, inWordle: true },
  { word: 'STING', frequency: 6.31e-06, inWordle: true },
  { word: 'STINK', frequency: 2.88e-06, inWordle: true },
  { word: 'STINT', frequency: 4.07e-06, inWordle: true },
  { word: 'STOCK', frequency: 8.51e-05, inWordle: true },
  { word: 'STOIC', frequency: 1.41e-06, inWordle: true },
  { word: 'STOKE', frequency: 5.37e-06, inWordle: true },
  { word: 'STOLE', frequency: 1.62e-05, inWordle: true },
  { word: 'STOMP', frequency: 1.78e-06, inWordle: true },
  { word: 'STONE', frequency: 6.31e-05, inWordle: true },
  { word: 'STONY', frequency: 2e-06, inWordle: true },
  { word: 'STOOD', frequency: 3.72e-05, inWordle: true },
  { word: 'STOOL', frequency: 3.31e-06, inWordle: true },
  { word: 'STOOP', frequency: 1.38e-06, inWordle: true },
  { word: 'STORE', frequency: 0.000105, inWordle: true },
  { word: 'STORK', frequency: 7.59e-07, inWordle: true },
  { word: 'STORM', frequency: 4.57e-05, inWordle: true },
  { word: 'STORY', frequency: 0.000282, inWordle: true },
  { word: 'STOUT', frequency: 2.82e-06, inWordle: true },
  { word: 'STOVE', frequency: 5.13e-06, inWordle: true },
  { word: 'STRAP', frequency: 6.17e-06, inWordle: true },
  { word: 'STRAW', frequency: 9.77e-06, inWordle: true },
  { word: 'STRAY', frequency: 5.5e-06, inWordle: true },
  { word: 'STRIP', frequency: 2.29e-05, inWordle: true },
  { word: 'STRUT', frequency: 1.45e-06, inWordle: true },
  { word: 'STUCK', frequency: 4.79e-05, inWordle: true },
  { word: 'STUDY', frequency: 0.000182, inWordle: true },
  { word: 'STUFF', frequency: 0.000138, inWordle: true },
  { word: 'STUMP', frequency: 2.82e-06, inWordle: true },
  { word: 'STUNG', frequency: 1.91e-06, inWordle: true },
  { word: 'STUNK', frequency: 2.45e-07, inWordle: true },
  { word: 'STUNT', frequency: 7.24e-06, inWordle: true },
  { word: 'STYLE', frequency: 0.000129, inWordle: true },
  { word: 'SUAVE', frequency: 7.94e-07, inWordle: true },
  { word: 'SUGAR', frequency: 4.79e-05, inWordle: true },
  { word: 'SUING', frequency: 3.16e-06, inWordle: true },
  { word: 'SUITE', frequency: 1.51e-05, inWordle: true },
  { word: 'SULKY', frequency: 2.14e-07, inWordle: true },
  { word: 'SULLY', frequency: 1.29e-06, inWordle: true },
  { word: 'SUMAC', frequency: 2.19e-07, inWordle: true },
  { word: 'SUNNY', frequency: 1.17e-05, inWordle: true },
  { word: 'SUPER', frequency: 0.00012, inWordle: true },
  { word: 'SURER', frequency: 1.51e-07, inWordle: true },
  { word: 'SURGE', frequency: 6.61e-06, inWordle: true },
  { word: 'SURLY', frequency: 7.08e-07, inWordle: true },
  { word: 'SUSHI', frequency: 4.79e-06, inWordle: true },
  { word: 'SWAMI', frequency: 1.1e-06, inWordle: true },
  { word: 'SWAMP', frequency: 6.92e-06, inWordle: true },
  { word: 'SWARM', frequency: 2.75e-06, inWordle: true },
  { word: 'SWASH', frequency: 1.62e-07, inWordle: true },
  { word: 'SWATH', frequency: 6.76e-07, inWordle: true },
  { word: 'SWEAR', frequency: 3.24e-05, inWordle: true },
  { word: 'SWEAT', frequency: 1.38e-05, inWordle: true },
  { word: 'SWEEP', frequency: 9.33e-06, inWordle: true },
  { word: 'SWEET', frequency: 8.13e-05, inWordle: true },
  { word: 'SWELL', frequency: 4.37e-06, inWordle: true },
  { word: 'SWEPT', frequency: 8.71e-06, inWordle: true },
  { word: 'SWIFT', frequency: 1.41e-05, inWordle: true },
  { word: 'SWILL', frequency: 2.09e-07, inWordle: true },
  { word: 'SWINE', frequency: 2.88e-06, inWordle: true },
  { word: 'SWING', frequency: 2.19e-05, inWordle: true },
  { word: 'SWIRL', frequency: 1.45e-06, inWordle: true },
  { word: 'SWISH', frequency: 7.76e-07, inWordle: true },
  { word: 'SWOON', frequency: 7.59e-07, inWordle: true },
  { word: 'SWOOP', frequency: 1.58e-06, inWordle: true },
  { word: 'SWORD', frequency: 2.34e-05, inWordle: true },
  { word: 'SWORE', frequency: 3.39e-06, inWordle: true },
  { word: 'SWORN', frequency: 7.94e-06, inWordle: true },
  { word: 'SWUNG', frequency: 2.95e-06, inWordle: true },
  { word: 'SYNOD', frequency: 2.09e-06, inWordle: true },
  { word: 'SYRUP', frequency: 5.75e-06, inWordle: true },
  { word: 'TABBY', frequency: 6.17e-07, inWordle: true },
  { word: 'TABLE', frequency: 0.000112, inWordle: true },
  { word: 'TABOO', frequency: 2.95e-06, inWordle: true },
  { word: 'TACIT', frequency: 8.71e-07, inWordle: true },
  { word: 'TACKY', frequency: 1.51e-06, inWordle: true },
  { word: 'TAFFY', frequency: 5.13e-07, inWordle: true },
  { word: 'TAINT', frequency: 9.55e-07, inWordle: true },
  { word: 'TAKEN', frequency: 0.000214, inWordle: true },
  { word: 'TAKER', frequency: 1.7e-06, inWordle: true },
  { word: 'TALLY', frequency: 4.17e-06, inWordle: true },
  { word: 'TALON', frequency: 9.33e-07, inWordle: true },
  { word: 'TAMER', frequency: 5.5e-07, inWordle: true },
  { word: 'TANGO', frequency: 3.8e-06, inWordle: true },
  { word: 'TANGY', frequency: 4.37e-07, inWordle: true },
  { word: 'TAPER', frequency: 2e-06, inWordle: true },
  { word: 'TAPIR', frequency: 1.95e-07, inWordle: true },
  { word: 'TARDY', frequency: 4.9e-07, inWordle: true },
  { word: 'TAROT', frequency: 1.32e-06, inWordle: true },
  { word: 'TASTE', frequency: 5.37e-05, inWordle: true },
  { word: 'TASTY', frequency: 6.92e-06, inWordle: true },
  { word: 'TATTY', frequency: 1.55e-07, inWordle: true },
  { word: 'TAUNT', frequency: 9.12e-07, inWordle: true },
  { word: 'TAWNY', frequency: 5.89e-07, inWordle: true },
  { word: 'TEACH', frequency: 4.68e-05, inWordle: true },
  { word: 'TEARY', frequency: 6.92e-07, inWordle: true },
  { word: 'TEASE', frequency: 3.89e-06, inWordle: true },
  { word: 'TEDDY', frequency: 7.59e-06, inWordle: true },
  { word: 'TEETH', frequency: 3.8e-05, inWordle: true },
  { word: 'TEMPO', frequency: 5.5e-06, inWordle: true },
  { word: 'TENET', frequency: 1e-06, inWordle: true },
  { word: 'TENOR', frequency: 2.51e-06, inWordle: true },
  { word: 'TENSE', frequency: 8.91e-06, inWordle: true },
  { word: 'TENTH', frequency: 8.32e-06, inWordle: true },
  { word: 'TEPEE', frequency: 1.07e-07, inWordle: true },
  { word: 'TEPID', frequency: 5.13e-07, inWordle: true },
  { word: 'TERRA', frequency: 2.75e-06, inWordle: true },
  { word: 'TERSE', frequency: 4.68e-07, inWordle: true },
  { word: 'TESTY', frequency: 3.47e-07, inWordle: true },
  { word: 'THANK', frequency: 0.000302, inWordle: true },
  { word: 'THEFT', frequency: 1.35e-05, inWordle: true },
  { word: 'THEIR', frequency: 0.00214, inWordle: true },
  { word: 'THEME', frequency: 4.17e-05, inWordle: true },
  { word: 'THERE', frequency: 0.00204, inWordle: true },
  { word: 'THESE', frequency: 0.0011, inWordle: true },
  { word: 'THETA', frequency: 1.45e-06, inWordle: true },
  { word: 'THICK', frequency: 2.88e-05, inWordle: true },
  { word: 'THIEF', frequency: 7.59e-06, inWordle: true },
  { word: 'THIGH', frequency: 5.37e-06, inWordle: true },
  { word: 'THING', frequency: 0.000525, inWordle: true },
  { word: 'THINK', frequency: 0.0012, inWordle: true },
  { word: 'THIRD', frequency: 0.000209, inWordle: true },
  { word: 'THONG', frequency: 1.45e-06, inWordle: true },
  { word: 'THORN', frequency: 3.02e-06, inWordle: true },
  { word: 'THOSE', frequency: 0.000794, inWordle: true },
  { word: 'THREE', frequency: 0.000603, inWordle: true },
  { word: 'THREW', frequency: 2.88e-05, inWordle: true },
  { word: 'THROB', frequency: 4.79e-07, inWordle: true },
  { word: 'THROW', frequency: 6.76e-05, inWordle: true },
  { word: 'THRUM', frequency: 9.33e-08, inWordle: true },
  { word: 'THUMB', frequency: 1.02e-05, inWordle: true },
  { word: 'THUMP', frequency: 9.33e-07, inWordle: true },
  { word: 'THYME', frequency: 1.17e-06, inWordle: true },
  { word: 'TIARA', frequency: 9.55e-07, inWordle: true },
  { word: 'TIBIA', frequency: 7.94e-07, inWordle: true },
  { word: 'TIDAL', frequency: 5.01e-06, inWordle: true },
  { word: 'TIGER', frequency: 2e-05, inWordle: true },
  { word: 'TIGHT', frequency: 3.72e-05, inWordle: true },
  { word: 'TILDE', frequency: 1.55e-07, inWordle: true },
  { word: 'TIMER', frequency: 4.79e-06, inWordle: true },
  { word: 'TIMID', frequency: 1.78e-06, inWordle: true },
  { word: 'TIPSY', frequency: 7.41e-07, inWordle: true },
  { word: 'TITAN', frequency: 4.9e-06, inWordle: true },
  { word: 'TITHE', frequency: 7.59e-07, inWordle: true },
  { word: 'TITLE', frequency: 0.000126, inWordle: true },
  { word: 'TOAST', frequency: 9.12e-06, inWordle: true },
  { word: 'TODAY', frequency: 0.000355, inWordle: true },
  { word: 'TODDY', frequency: 3.55e-07, inWordle: true },
  { word: 'TOKEN', frequency: 6.61e-06, inWordle: true },
  { word: 'TONAL', frequency: 1.23e-06, inWordle: true },
  { word: 'TONGA', frequency: 1.26e-06, inWordle: true },
  { word: 'TONIC', frequency: 2.45e-06, inWordle: true },
  { word: 'TOOTH', frequency: 1.2e-05, inWordle: true },
  { word: 'TOPAZ', frequency: 7.41e-07, inWordle: true },
  { word: 'TOPIC', frequency: 3.09e-05, inWordle: true },
  { word: 'TORCH', frequency: 5.5e-06, inWordle: true },
  { word: 'TORSO', frequency: 2.57e-06, inWordle: true },
  { word: 'TORUS', frequency: 3.72e-07, inWordle: true },
  { word: 'TOTAL', frequency: 0.000162, inWordle: true },
  { word: 'TOTEM', frequency: 1.23e-06, inWordle: true },
  { word: 'TOUCH', frequency: 8.13e-05, inWordle: true },
  { word: 'TOUGH', frequency: 5.89e-05, inWordle: true },
  { word: 'TOWEL', frequency: 8.71e-06, inWordle: true },
  { word: 'TOWER', frequency: 3.16e-05, inWordle: true },
  { word: 'TOXIC', frequency: 1.74e-05, inWordle: true },
  { word: 'TOXIN', frequency: 2e-06, inWordle: true },
  { word: 'TRACE', frequency: 1.55e-05, inWordle: true },
  { word: 'TRACK', frequency: 0.000105, inWordle: true },
  { word: 'TRACT', frequency: 5.13e-06, inWordle: true },
  { word: 'TRADE', frequency: 0.000132, inWordle: true },
  { word: 'TRAIL', frequency: 2.82e-05, inWordle: true },
  { word: 'TRAIN', frequency: 9.12e-05, inWordle: true },
  { word: 'TRAIT', frequency: 4.9e-06, inWordle: true },
  { word: 'TRAMP', frequency: 1.62e-06, inWordle: true },
  { word: 'TRASH', frequency: 2.63e-05, inWordle: true },
  { word: 'TRAWL', frequency: 4.47e-07, inWordle: true },
  { word: 'TREAD', frequency: 3.31e-06, inWordle: true },
  { word: 'TREAT', frequency: 5.62e-05, inWordle: true },
  { word: 'TREND', frequency: 3.24e-05, inWordle: true },
  { word: 'TRIAD', frequency: 1.7e-06, inWordle: true },
  { word: 'TRIAL', frequency: 7.41e-05, inWordle: true },
  { word: 'TRIBE', frequency: 1.32e-05, inWordle: true },
  { word: 'TRICE', frequency: 2.51e-07, inWordle: true },
  { word: 'TRICK', frequency: 3.02e-05, inWordle: true },
  { word: 'TRIED', frequency: 0.000145, inWordle: true },
  { word: 'TRIPE', frequency: 5.13e-07, inWordle: true },
  { word: 'TRITE', frequency: 6.31e-07, inWordle: true },
  { word: 'TROLL', frequency: 5.37e-06, inWordle: true },
  { word: 'TROOP', frequency: 4.9e-06, inWordle: true },
  { word: 'TROPE', frequency: 1.26e-06, inWordle: true },
  { word: 'TROUT', frequency: 6.03e-06, inWordle: true },
  { word: 'TROVE', frequency: 1.1e-06, inWordle: true },
  { word: 'TRUCE', frequency: 3.31e-06, inWordle: true },
  { word: 'TRUCK', frequency: 4.37e-05, inWordle: true },
  { word: 'TRUER', frequency: 9.33e-07, inWordle: true },
  { word: 'TRULY', frequency: 7.41e-05, inWordle: true },
  { word: 'TRUMP', frequency: 8.51e-05, inWordle: true },
  { word: 'TRUNK', frequency: 1.07e-05, inWordle: true },
  { word: 'TRUSS', frequency: 1.95e-06, inWordle: true },
  { word: 'TRUST', frequency: 0.000135, inWordle: true },
  { word: 'TRUTH', frequency: 0.000112, inWordle: true },
  { word: 'TRYST', frequency: 3.63e-07, inWordle: true },
  { word: 'TUBAL', frequency: 3.63e-07, inWordle: true },
  { word: 'TUBER', frequency: 4.37e-07, inWordle: true },
  { word: 'TULIP', frequency: 1.51e-06, inWordle: true },
  { word: 'TULLE', frequency: 4.17e-07, inWordle: true },
  { word: 'TUMOR', frequency: 9.33e-06, inWordle: true },
  { word: 'TUNIC', frequency: 1.2e-06, inWordle: true },
  { word: 'TURBO', frequency: 5.5e-06, inWordle: true },
  { word: 'TUTOR', frequency: 4.68e-06, inWordle: true },
  { word: 'TWANG', frequency: 3.63e-07, inWordle: true },
  { word: 'TWEAK', frequency: 1.86e-06, inWordle: true },
  { word: 'TWEED', frequency: 1.78e-06, inWordle: true },
  { word: 'TWEET', frequency: 1.48e-05, inWordle: true },
  { word: 'TWICE', frequency: 6.92e-05, inWordle: true },
  { word: 'TWINE', frequency: 8.51e-07, inWordle: true },
  { word: 'TWIRL', frequency: 4.9e-07, inWordle: true },
  { word: 'TWIST', frequency: 1.66e-05, inWordle: true },
  { word: 'TWIXT', frequency: 1.2e-07, inWordle: true },
  { word: 'TYING', frequency: 4.79e-06, inWordle: true },
  { word: 'UDDER', frequency: 1.95e-07, inWordle: true },
  { word: 'ULCER', frequency: 1.07e-06, inWordle: true },
  { word: 'ULTRA', frequency: 1.7e-05, inWordle: true },
  { word: 'UMBRA', frequency: 2.45e-07, inWordle: true },
  { word: 'UNCLE', frequency: 2.82e-05, inWordle: true },
  { word: 'UNCUT', frequency: 1.78e-06, inWordle: true },
  { word: 'UNDER', frequency: 0.000537, inWordle: true },
  { word: 'UNDID', frequency: 3.39e-07, inWordle: true },
  { word: 'UNDUE', frequency: 1.95e-06, inWordle: true },
  { word: 'UNFED', frequency: 4.27e-08, inWordle: true },
  { word: 'UNFIT', frequency: 3.31e-06, inWordle: true },
  { word: 'UNIFY', frequency: 1.17e-06, inWordle: true },
  { word: 'UNION', frequency: 0.00012, inWordle: true },
  { word: 'UNITE', frequency: 7.94e-06, inWordle: true },
  { word: 'UNITY', frequency: 1.66e-05, inWordle: true },
  { word: 'UNLIT', frequency: 2.75e-07, inWordle: true },
  { word: 'UNMET', frequency: 5.37e-07, inWordle: true },
  { word: 'UNSET', frequency: 6.61e-08, inWordle: true },
  { word: 'UNTIE', frequency: 3.24e-07, inWordle: true },
  { word: 'UNTIL', frequency: 0.000407, inWordle: true },
  { word: 'UNWED', frequency: 3.31e-07, inWordle: true },
  { word: 'UNZIP', frequency: 3.55e-07, inWordle: true },
  { word: 'UPPER', frequency: 5.25e-05, inWordle: true },
  { word: 'UPSET', frequency: 4.07e-05, inWordle: true },
  { word: 'URBAN', frequency: 4.47e-05, inWordle: true },
  { word: 'URINE', frequency: 6.92e-06, inWordle: true },
  { word: 'USAGE', frequency: 1.7e-05, inWordle: true },
  { word: 'USHER', frequency: 3.24e-06, inWordle: true },
  { word: 'USING', frequency: 0.000295, inWordle: true },
  { word: 'USUAL', frequency: 4.17e-05, inWordle: true },
  { word: 'USURP', frequency: 5.01e-07, inWordle: true },
  { word: 'UTILE', frequency: 4.57e-08, inWordle: true },
  { word: 'UTTER', frequency: 7.08e-06, inWordle: true },
  { word: 'VAGUE', frequency: 7.41e-06, inWordle: true },
  { word: 'VALET', frequency: 1.48e-06, inWordle: true },
  { word: 'VALID', frequency: 2.4e-05, inWordle: true },
  { word: 'VALOR', frequency: 1.7e-06, inWordle: true },
  { word: 'VALUE', frequency: 0.000141, inWordle: true },
  { word: 'VALVE', frequency: 1.35e-05, inWordle: true },
  { word: 'VAPID', frequency: 3.16e-07, inWordle: true },
  { word: 'VAPOR', frequency: 3.63e-06, inWordle: true },
  { word: 'VAULT', frequency: 7.94e-06, inWordle: true },
  { word: 'VAUNT', frequency: 2.45e-08, inWordle: true },
  { word: 'VEGAN', frequency: 8.91e-06, inWordle: true },
  { word: 'VENOM', frequency: 3.72e-06, inWordle: true },
  { word: 'VENUE', frequency: 1.78e-05, inWordle: true },
  { word: 'VERGE', frequency: 4.68e-06, inWordle: true },
  { word: 'VERSE', frequency: 1.51e-05, inWordle: true },
  { word: 'VERSO', frequency: 5.25e-07, inWordle: true },
  { word: 'VERVE', frequency: 7.08e-07, inWordle: true },
  { word: 'VICAR', frequency: 2.34e-06, inWordle: true },
  { word: 'VIDEO', frequency: 0.000269, inWordle: true },
  { word: 'VIGIL', frequency: 1.74e-06, inWordle: true },
  { word: 'VIGOR', frequency: 1.07e-06, inWordle: true },
  { word: 'VILLA', frequency: 1.58e-05, inWordle: true },
  { word: 'VINYL', frequency: 1e-05, inWordle: true },
  { word: 'VIOLA', frequency: 3.47e-06, inWordle: true },
  { word: 'VIPER', frequency: 2.04e-06, inWordle: true },
  { word: 'VIRAL', frequency: 1.2e-05, inWordle: true },
  { word: 'VIRUS', frequency: 2.63e-05, inWordle: true },
  { word: 'VISIT', frequency: 0.00011, inWordle: true },
  { word: 'VISOR', frequency: 9.55e-07, inWordle: true },
  { word: 'VISTA', frequency: 5.13e-06, inWordle: true },
  { word: 'VITAL', frequency: 2.4e-05, inWordle: true },
  { word: 'VIVID', frequency: 5.62e-06, inWordle: true },
  { word: 'VIXEN', frequency: 8.71e-07, inWordle: true },
  { word: 'VOCAL', frequency: 1.45e-05, inWordle: true },
  { word: 'VODKA', frequency: 6.76e-06, inWordle: true },
  { word: 'VOGUE', frequency: 5.13e-06, inWordle: true },
  { word: 'VOICE', frequency: 0.000117, inWordle: true },
  { word: 'VOILA', frequency: 8.51e-07, inWordle: true },
  { word: 'VOMIT', frequency: 3.39e-06, inWordle: true },
  { word: 'VOTER', frequency: 1.29e-05, inWordle: true },
  { word: 'VOUCH', frequency: 1.35e-06, inWordle: true },
  { word: 'VOWEL', frequency: 2.14e-06, inWordle: true },
  { word: 'VYING', frequency: 8.32e-07, inWordle: true },
  { word: 'WACKY', frequency: 1.95e-06, inWordle: true },
  { word: 'WAFER', frequency: 1.35e-06, inWordle: true },
  { word: 'WAGER', frequency: 2.69e-06, inWordle: true },
  { word: 'WAGON', frequency: 7.94e-06, inWordle: true },
  { word: 'WAIST', frequency: 9.12e-06, inWordle: true },
  { word: 'WAIVE', frequency: 1.74e-06, inWordle: true },
  { word: 'WALTZ', frequency: 2.4e-06, inWordle: true },
  { word: 'WARTY', frequency: 1.2e-07, inWordle: true },
  { word: 'WASTE', frequency: 6.46e-05, inWordle: true },
  { word: 'WATCH', frequency: 0.000219, inWordle: true },
  { word: 'WATER', frequency: 0.000331, inWordle: true },
  { word: 'WAVER', frequency: 5.62e-07, inWordle: true },
  { word: 'WAXEN', frequency: 4.9e-08, inWordle: true },
  { word: 'WEARY', frequency: 4.07e-06, inWordle: true },
  { word: 'WEAVE', frequency: 3.39e-06, inWordle: true },
  { word: 'WEDGE', frequency: 4.17e-06, inWordle: true },
  { word: 'WEEDY', frequency: 2.34e-07, inWordle: true },
  { word: 'WEIGH', frequency: 9.77e-06, inWordle: true },
  { word: 'WEIRD', frequency: 6.46e-05, inWordle: true },
  { word: 'WELCH', frequency: 2.34e-06, inWordle: true },
  { word: 'WELSH', frequency: 1.41e-05, inWordle: true },
  { word: 'WENCH', frequency: 4.68e-07, inWordle: false },
  { word: 'WHACK', frequency: 2.69e-06, inWordle: true },
  { word: 'WHALE', frequency: 9.55e-06, inWordle: true },
  { word: 'WHARF', frequency: 3.02e-06, inWordle: true },
  { word: 'WHEAT', frequency: 1.02e-05, inWordle: true },
  { word: 'WHEEL', frequency: 3.16e-05, inWordle: true },
  { word: 'WHELP', frequency: 3.09e-07, inWordle: true },
  { word: 'WHERE', frequency: 0.001, inWordle: true },
  { word: 'WHICH', frequency: 0.002, inWordle: true },
  { word: 'WHIFF', frequency: 1.66e-06, inWordle: true },
  { word: 'WHILE', frequency: 0.000724, inWordle: true },
  { word: 'WHINE', frequency: 1.91e-06, inWordle: true },
  { word: 'WHINY', frequency: 7.76e-07, inWordle: true },
  { word: 'WHIRL', frequency: 9.12e-07, inWordle: true },
  { word: 'WHISK', frequency: 1.29e-06, inWordle: true },
  { word: 'WHITE', frequency: 0.000324, inWordle: true },
  { word: 'WHOLE', frequency: 0.000288, inWordle: true },
  { word: 'WHOOP', frequency: 1.58e-06, inWordle: true },
  { word: 'WHOSE', frequency: 0.000117, inWordle: true },
  { word: 'WIDEN', frequency: 1.78e-06, inWordle: true },
  { word: 'WIDER', frequency: 1.74e-05, inWordle: true },
  { word: 'WIDOW', frequency: 1.2e-05, inWordle: true },
  { word: 'WIDTH', frequency: 1.05e-05, inWordle: true },
  { word: 'WIELD', frequency: 1.62e-06, inWordle: true },
  { word: 'WIGHT', frequency: 1.7e-06, inWordle: true },
  { word: 'WILLY', frequency: 4.07e-06, inWordle: true },
  { word: 'WIMPY', frequency: 5.75e-07, inWordle: true },
  { word: 'WINCE', frequency: 4.07e-07, inWordle: true },
  { word: 'WINCH', frequency: 1.1e-06, inWordle: true },
  { word: 'WINDY', frequency: 3.72e-06, inWordle: true },
  { word: 'WISER', frequency: 3.02e-06, inWordle: true },
  { word: 'WISPY', frequency: 2.63e-07, inWordle: true },
  { word: 'WITCH', frequency: 1.29e-05, inWordle: true },
  { word: 'WITTY', frequency: 3.63e-06, inWordle: true },
  { word: 'WOKEN', frequency: 2.34e-06, inWordle: true },
  { word: 'WOMAN', frequency: 0.000224, inWordle: true },
  { word: 'WOMEN', frequency: 0.000372, inWordle: true },
  { word: 'WOODY', frequency: 6.61e-06, inWordle: true },
  { word: 'WOOER', frequency: 1.51e-08, inWordle: true },
  { word: 'WOOLY', frequency: 3.09e-07, inWordle: true },
  { word: 'WOOZY', frequency: 2.51e-07, inWordle: true },
  { word: 'WORDY', frequency: 3.63e-07, inWordle: true },
  { word: 'WORLD', frequency: 0.000776, inWordle: true },
  { word: 'WORRY', frequency: 6.92e-05, inWordle: true },
  { word: 'WORSE', frequency: 7.76e-05, inWordle: true },
  { word: 'WORST', frequency: 8.51e-05, inWordle: true },
  { word: 'WORTH', frequency: 0.000145, inWordle: true },
  { word: 'WOULD', frequency: 0.00186, inWordle: true },
  { word: 'WOUND', frequency: 1.74e-05, inWordle: true },
  { word: 'WOVEN', frequency: 3.63e-06, inWordle: true },
  { word: 'WRACK', frequency: 1.62e-07, inWordle: true },
  { word: 'WRATH', frequency: 5.01e-06, inWordle: true },
  { word: 'WREAK', frequency: 8.71e-07, inWordle: true },
  { word: 'WRECK', frequency: 9.12e-06, inWordle: true },
  { word: 'WREST', frequency: 4.27e-07, inWordle: true },
  { word: 'WRING', frequency: 5.62e-07, inWordle: true },
  { word: 'WRIST', frequency: 1.02e-05, inWordle: true },
  { word: 'WRITE', frequency: 0.000107, inWordle: true },
  { word: 'WRONG', frequency: 0.000245, inWordle: true },
  { word: 'WROTE', frequency: 0.00011, inWordle: true },
  { word: 'WRUNG', frequency: 2.29e-07, inWordle: true },
  { word: 'WRYLY', frequency: 2.57e-07, inWordle: true },
  { word: 'YACHT', frequency: 6.61e-06, inWordle: true },
  { word: 'YEARN', frequency: 9.33e-07, inWordle: true },
  { word: 'YEAST', frequency: 4.68e-06, inWordle: true },
  { word: 'YIELD', frequency: 1.45e-05, inWordle: true },
  { word: 'YOUNG', frequency: 0.000269, inWordle: true },
  { word: 'YOUTH', frequency: 5.62e-05, inWordle: true },
  { word: 'ZEBRA', frequency: 2.51e-06, inWordle: true },
  { word: 'ZESTY', frequency: 2.57e-07, inWordle: true },
  { word: 'AARGH', frequency: 6.76e-08, inWordle: false },
  { word: 'AARTI', frequency: 1.7e-07, inWordle: false },
  { word: 'ABACA', frequency: 5.89e-08, inWordle: false },
  { word: 'ABACI', frequency: 1.55e-08, inWordle: false },
  { word: 'ABAFT', frequency: 6.31e-08, inWordle: false },
  { word: 'ABAND', frequency: 1.58e-08, inWordle: false },
  { word: 'ABASH', frequency: 1.05e-08, inWordle: false },
  { word: 'ABAYA', frequency: 1.74e-07, inWordle: false },
  { word: 'ABBAS', frequency: 2.57e-06, inWordle: false },
  { word: 'ABBES', frequency: 1.62e-08, inWordle: false },
  { word: 'ABEAM', frequency: 5.62e-08, inWordle: false },
  { word: 'ABELE', frequency: 5.89e-08, inWordle: false },
  { word: 'ABERS', frequency: 1.23e-08, inWordle: false },
  { word: 'ABETS', frequency: 4.17e-08, inWordle: false },
  { word: 'ABIES', frequency: 1.7e-07, inWordle: false },
  { word: 'ABLER', frequency: 1.95e-08, inWordle: false },
  { word: 'ABLES', frequency: 5.37e-08, inWordle: false },
  { word: 'ABLOW', frequency: 3.63e-08, inWordle: false },
  { word: 'ABORD', frequency: 3.16e-08, inWordle: false },
  { word: 'ABRAM', frequency: 7.94e-07, inWordle: false },
  { word: 'ABRIN', frequency: 1.32e-08, inWordle: false },
  { word: 'ABUNA', frequency: 1.29e-08, inWordle: false },
  { word: 'ABUNE', frequency: 1.51e-08, inWordle: false },
  { word: 'ABUTS', frequency: 1.86e-07, inWordle: false },
  { word: 'ABUZZ', frequency: 2e-07, inWordle: false },
  { word: 'ACARI', frequency: 6.17e-08, inWordle: false },
  { word: 'ACERS', frequency: 2.88e-08, inWordle: false },
  { word: 'ACHAR', frequency: 3.09e-08, inWordle: false },
  { word: 'ACHED', frequency: 2.57e-07, inWordle: false },
  { word: 'ACHES', frequency: 1.91e-06, inWordle: false },
  { word: 'ACHOO', frequency: 5.01e-08, inWordle: false },
  { word: 'ACIDS', frequency: 7.08e-06, inWordle: false },
  { word: 'ACING', frequency: 1.05e-07, inWordle: false },
  { word: 'ACINI', frequency: 1.32e-08, inWordle: false },
  { word: 'ACKEE', frequency: 3.98e-08, inWordle: false },
  { word: 'ACKER', frequency: 3.02e-07, inWordle: false },
  { word: 'ACNES', frequency: 4.57e-08, inWordle: false },
  { word: 'ACOCK', frequency: 1.2e-08, inWordle: false },
  { word: 'ACRES', frequency: 1.48e-05, inWordle: false },
  { word: 'ACROS', frequency: 4.37e-08, inWordle: false },
  { word: 'ACTED', frequency: 1.91e-05, inWordle: false },
  { word: 'ACTIN', frequency: 1.38e-06, inWordle: false },
  { word: 'ACTON', frequency: 9.33e-07, inWordle: false },
  { word: 'ADAYS', frequency: 4.07e-08, inWordle: false },
  { word: 'ADDAX', frequency: 2.14e-08, inWordle: false },
  { word: 'ADDED', frequency: 0.000145, inWordle: false },
  { word: 'ADDER', frequency: 4.9e-07, inWordle: false },
  { word: 'ADDIO', frequency: 3.98e-08, inWordle: false },
  { word: 'ADDLE', frequency: 4.9e-08, inWordle: false },
  { word: 'ADHAN', frequency: 4.79e-08, inWordle: false },
  { word: 'ADIEU', frequency: 6.76e-07, inWordle: false },
  { word: 'ADIOS', frequency: 4.79e-07, inWordle: false },
  { word: 'ADITS', frequency: 2.51e-08, inWordle: false },
  { word: 'ADMAN', frequency: 3.24e-08, inWordle: false },
  { word: 'ADMEN', frequency: 1.29e-08, inWordle: false },
  { word: 'ADOBO', frequency: 1.38e-07, inWordle: false },
  { word: 'ADOWN', frequency: 3.89e-08, inWordle: false },
  { word: 'ADZES', frequency: 2.88e-08, inWordle: false },
  { word: 'AEDES', frequency: 2.95e-07, inWordle: false },
  { word: 'AEGIS', frequency: 1.15e-06, inWordle: false },
  { word: 'AEONS', frequency: 1.74e-07, inWordle: false },
  { word: 'AERIE', frequency: 1.48e-07, inWordle: false },
  { word: 'AEROS', frequency: 4.27e-08, inWordle: false },
  { word: 'AESIR', frequency: 5.89e-08, inWordle: false },
  { word: 'AFARS', frequency: 1.1e-08, inWordle: false },
  { word: 'AFORE', frequency: 2.63e-07, inWordle: false },
  { word: 'AFROS', frequency: 6.17e-08, inWordle: false },
  { word: 'AGAMA', frequency: 9.55e-08, inWordle: false },
  { word: 'AGAMI', frequency: 1.26e-08, inWordle: false },
  { word: 'AGAVE', frequency: 5.5e-07, inWordle: false },
  { word: 'AGERS', frequency: 1.62e-07, inWordle: false },
  { word: 'AGGER', frequency: 1.95e-07, inWordle: false },
  { word: 'AGGIE', frequency: 7.08e-07, inWordle: false },
  { word: 'AGGRO', frequency: 2.88e-07, inWordle: false },
  { word: 'AGILA', frequency: 2.14e-08, inWordle: false },
  { word: 'AGIOS', frequency: 9.77e-08, inWordle: false },
  { word: 'AGITA', frequency: 2.45e-08, inWordle: false },
  { word: 'AGLET', frequency: 2.09e-08, inWordle: false },
  { word: 'AGOGE', frequency: 1.17e-08, inWordle: false },
  { word: 'AGONE', frequency: 3.63e-08, inWordle: false },
  { word: 'AGOOD', frequency: 4.9e-08, inWordle: false },
  { word: 'AGRIA', frequency: 1.38e-08, inWordle: false },
  { word: 'AGRIN', frequency: 1.38e-08, inWordle: false },
  { word: 'AGROS', frequency: 1.66e-08, inWordle: false },
  { word: 'AHIGH', frequency: 1.15e-08, inWordle: false },
  { word: 'AHOLD', frequency: 7.24e-07, inWordle: false },
  { word: 'AIDED', frequency: 5.5e-06, inWordle: false },
  { word: 'AIDES', frequency: 2.57e-06, inWordle: false },
  { word: 'AIGHT', frequency: 4.37e-07, inWordle: false },
  { word: 'AILED', frequency: 4.37e-08, inWordle: false },
  { word: 'AIMED', frequency: 1.78e-05, inWordle: false },
  { word: 'AIMER', frequency: 1.15e-07, inWordle: false },
  { word: 'AIOLI', frequency: 2.04e-07, inWordle: false },
  { word: 'AIRED', frequency: 7.08e-06, inWordle: false },
  { word: 'AIRER', frequency: 1.02e-08, inWordle: false },
  { word: 'AIRTH', frequency: 2.29e-08, inWordle: false },
  { word: 'AITCH', frequency: 4.37e-08, inWordle: false },
  { word: 'AJUGA', frequency: 1.41e-08, inWordle: false },
  { word: 'AKELA', frequency: 7.24e-08, inWordle: false },
  { word: 'AKING', frequency: 8.91e-08, inWordle: false },
  { word: 'AKITA', frequency: 3.09e-07, inWordle: false },
  { word: 'ALACK', frequency: 6.03e-08, inWordle: false },
  { word: 'ALAMO', frequency: 1.2e-06, inWordle: false },
  { word: 'ALAND', frequency: 1.05e-07, inWordle: false },
  { word: 'ALANE', frequency: 2.57e-08, inWordle: false },
  { word: 'ALANG', frequency: 6.17e-08, inWordle: false },
  { word: 'ALANS', frequency: 1.38e-07, inWordle: false },
  { word: 'ALARY', frequency: 2.63e-08, inWordle: false },
  { word: 'ALATE', frequency: 1.55e-08, inWordle: false },
  { word: 'ALBAS', frequency: 1.51e-08, inWordle: false },
  { word: 'ALBEE', frequency: 2.88e-07, inWordle: false },
  { word: 'ALDEA', frequency: 5.62e-08, inWordle: false },
  { word: 'ALDER', frequency: 9.33e-07, inWordle: false },
  { word: 'ALDOL', frequency: 5.01e-08, inWordle: false },
  { word: 'ALECK', frequency: 1.48e-07, inWordle: false },
  { word: 'ALECS', frequency: 1.41e-08, inWordle: false },
  { word: 'ALEPH', frequency: 2.45e-07, inWordle: false },
  { word: 'ALFAS', frequency: 2.04e-08, inWordle: false },
  { word: 'ALGAL', frequency: 4.9e-07, inWordle: false },
  { word: 'ALGOR', frequency: 1.32e-08, inWordle: false },
  { word: 'ALIAS', frequency: 2.88e-06, inWordle: false },
  { word: 'ALINE', frequency: 3.8e-07, inWordle: false },
  { word: 'ALIST', frequency: 3.31e-08, inWordle: false },
  { word: 'ALIYA', frequency: 1.7e-07, inWordle: false },
  { word: 'ALKYD', frequency: 5.89e-08, inWordle: false },
  { word: 'ALKYL', frequency: 6.46e-07, inWordle: false },
  { word: 'ALLEE', frequency: 1.23e-07, inWordle: false },
  { word: 'ALLIS', frequency: 2.82e-07, inWordle: false },
  { word: 'ALLYL', frequency: 1.23e-07, inWordle: false },
  { word: 'ALMAH', frequency: 1.41e-08, inWordle: false },
  { word: 'ALMAS', frequency: 1.1e-07, inWordle: false },
  { word: 'ALOES', frequency: 7.94e-08, inWordle: false },
  { word: 'ALOHA', frequency: 1.23e-06, inWordle: false },
  { word: 'ALTHO', frequency: 4.47e-07, inWordle: false },
  { word: 'ALTOS', frequency: 3.47e-07, inWordle: false },
  { word: 'ALULA', frequency: 2.69e-08, inWordle: false },
  { word: 'ALUMS', frequency: 2.63e-07, inWordle: false },
  { word: 'ALVAR', frequency: 1.02e-07, inWordle: false },
  { word: 'ALWAY', frequency: 3.89e-07, inWordle: false },
  { word: 'AMAIN', frequency: 2.34e-08, inWordle: false },
  { word: 'AMATE', frequency: 2.63e-08, inWordle: false },
  { word: 'AMBIT', frequency: 2.82e-07, inWordle: false },
  { word: 'AMBOS', frequency: 7.94e-08, inWordle: false },
  { word: 'AMBRY', frequency: 1.35e-08, inWordle: false },
  { word: 'AMEBA', frequency: 3.8e-08, inWordle: false },
  { word: 'AMEER', frequency: 3.02e-07, inWordle: false },
  { word: 'AMENS', frequency: 2.14e-08, inWordle: false },
  { word: 'AMENT', frequency: 6.17e-08, inWordle: false },
  { word: 'AMIAS', frequency: 1.41e-08, inWordle: false },
  { word: 'AMICE', frequency: 3.16e-08, inWordle: false },
  { word: 'AMICI', frequency: 1.78e-07, inWordle: false },
  { word: 'AMIDE', frequency: 2.75e-07, inWordle: false },
  { word: 'AMIDO', frequency: 5.89e-08, inWordle: false },
  { word: 'AMIES', frequency: 5.62e-08, inWordle: false },
  { word: 'AMIGA', frequency: 5.37e-07, inWordle: false },
  { word: 'AMIGO', frequency: 7.24e-07, inWordle: false },
  { word: 'AMINE', frequency: 6.17e-07, inWordle: false },
  { word: 'AMINO', frequency: 5.25e-06, inWordle: false },
  { word: 'AMIRS', frequency: 3.8e-08, inWordle: false },
  { word: 'AMMAN', frequency: 1.2e-06, inWordle: false },
  { word: 'AMMON', frequency: 2.88e-07, inWordle: false },
  { word: 'AMMOS', frequency: 3.55e-08, inWordle: false },
  { word: 'AMNIO', frequency: 3.09e-08, inWordle: false },
  { word: 'AMOLE', frequency: 1.55e-08, inWordle: false },
  { word: 'AMOUR', frequency: 1.07e-06, inWordle: false },
  { word: 'AMPED', frequency: 6.31e-07, inWordle: false },
  { word: 'AMRIT', frequency: 1.48e-07, inWordle: false },
  { word: 'AMUCK', frequency: 1.12e-07, inWordle: false },
  { word: 'ANANA', frequency: 5.62e-08, inWordle: false },
  { word: 'ANATA', frequency: 1.12e-07, inWordle: false },
  { word: 'ANCHO', frequency: 6.46e-08, inWordle: false },
  { word: 'ANCON', frequency: 5.25e-08, inWordle: false },
  { word: 'ANDRO', frequency: 1.66e-07, inWordle: false },
  { word: 'ANELE', frequency: 3.09e-08, inWordle: false },
  { word: 'ANENT', frequency: 1.66e-07, inWordle: false },
  { word: 'ANGAS', frequency: 7.94e-08, inWordle: false },
  { word: 'ANGLO', frequency: 6.46e-06, inWordle: false },
  { word: 'ANILE', frequency: 1.23e-08, inWordle: false },
  { word: 'ANIMA', frequency: 5.75e-07, inWordle: false },
  { word: 'ANIMI', frequency: 1.86e-08, inWordle: false },
  { word: 'ANION', frequency: 5.01e-07, inWordle: false },
  { word: 'ANISE', frequency: 4.47e-07, inWordle: false },
  { word: 'ANKER', frequency: 3.47e-07, inWordle: false },
  { word: 'ANNAL', frequency: 4.37e-08, inWordle: false },
  { word: 'ANNAS', frequency: 1.55e-07, inWordle: false },
  { word: 'ANOLE', frequency: 3.55e-08, inWordle: false },
  { word: 'ANTAR', frequency: 1.48e-07, inWordle: false },
  { word: 'ANTED', frequency: 3.39e-08, inWordle: false },
  { word: 'ANTES', frequency: 1.41e-07, inWordle: false },
  { word: 'ANTIS', frequency: 1.86e-07, inWordle: false },
  { word: 'ANTRA', frequency: 1.55e-08, inWordle: false },
  { word: 'ANTSY', frequency: 3.31e-07, inWordle: false },
  { word: 'ANURA', frequency: 3.63e-08, inWordle: false },
  { word: 'ANYON', frequency: 4.68e-08, inWordle: false },
  { word: 'APACE', frequency: 2.88e-07, inWordle: false },
  { word: 'APERT', frequency: 1.82e-08, inWordle: false },
  { word: 'APGAR', frequency: 1.1e-07, inWordle: false },
  { word: 'APHIS', frequency: 1.62e-07, inWordle: false },
  { word: 'APIAN', frequency: 1.78e-08, inWordle: false },
  { word: 'APISH', frequency: 1.35e-08, inWordle: false },
  { word: 'APORT', frequency: 1.45e-08, inWordle: false },
  { word: 'APPAL', frequency: 4.27e-08, inWordle: false },
  { word: 'APPEL', frequency: 3.39e-07, inWordle: false },
  { word: 'APPRO', frequency: 7.24e-08, inWordle: false },
  { word: 'APPUI', frequency: 1.55e-08, inWordle: false },
  { word: 'APRES', frequency: 1.17e-07, inWordle: false },
  { word: 'APSES', frequency: 3.39e-08, inWordle: false },
  { word: 'APSIS', frequency: 1.12e-08, inWordle: false },
  { word: 'APTED', frequency: 3.55e-08, inWordle: false },
  { word: 'APTER', frequency: 6.17e-08, inWordle: false },
  { word: 'AQUAE', frequency: 4.79e-08, inWordle: false },
  { word: 'AQUAS', frequency: 3.16e-08, inWordle: false },
  { word: 'ARABA', frequency: 5.25e-08, inWordle: false },
  { word: 'ARCED', frequency: 8.13e-08, inWordle: false },
  { word: 'ARCHI', frequency: 1.26e-07, inWordle: false },
  { word: 'ARCOS', frequency: 1.17e-07, inWordle: false },
  { word: 'ARCUS', frequency: 7.41e-08, inWordle: false },
  { word: 'AREAL', frequency: 2.45e-07, inWordle: false },
  { word: 'AREAS', frequency: 0.000141, inWordle: false },
  { word: 'ARECA', frequency: 8.51e-08, inWordle: false },
  { word: 'ARENE', frequency: 4.57e-08, inWordle: false },
  { word: 'AREPA', frequency: 3.39e-08, inWordle: false },
  { word: 'ARETE', frequency: 8.32e-08, inWordle: false },
  { word: 'ARGAL', frequency: 1.26e-08, inWordle: false },
  { word: 'ARGAN', frequency: 2.57e-07, inWordle: false },
  { word: 'ARGOL', frequency: 1.02e-08, inWordle: false },
  { word: 'ARGON', frequency: 7.24e-07, inWordle: false },
  { word: 'ARGOT', frequency: 8.71e-08, inWordle: false },
  { word: 'ARGUS', frequency: 1.12e-06, inWordle: false },
  { word: 'ARHAT', frequency: 3.47e-08, inWordle: false },
  { word: 'ARIAS', frequency: 1.26e-06, inWordle: false },
  { word: 'ARIEL', frequency: 3.47e-06, inWordle: false },
  { word: 'ARIKI', frequency: 3.72e-08, inWordle: false },
  { word: 'ARILS', frequency: 1.7e-08, inWordle: false },
  { word: 'ARISH', frequency: 1.1e-07, inWordle: false },
  { word: 'ARLES', frequency: 2.88e-07, inWordle: false },
  { word: 'ARMED', frequency: 3.89e-05, inWordle: false },
  { word: 'ARMER', frequency: 6.76e-08, inWordle: false },
  { word: 'AROHA', frequency: 7.94e-08, inWordle: false },
  { word: 'AROID', frequency: 1.62e-08, inWordle: false },
  { word: 'ARRAH', frequency: 3.16e-08, inWordle: false },
  { word: 'ARRAS', frequency: 3.55e-07, inWordle: false },
  { word: 'ARRET', frequency: 1.23e-08, inWordle: false },
  { word: 'ARRIS', frequency: 1.17e-07, inWordle: false },
  { word: 'ARROZ', frequency: 1.2e-07, inWordle: false },
  { word: 'ARSED', frequency: 5.13e-07, inWordle: false },
  { word: 'ARSES', frequency: 2.95e-07, inWordle: false },
  { word: 'ARSEY', frequency: 2.95e-08, inWordle: false },
  { word: 'ARSIS', frequency: 2.19e-08, inWordle: false },
  { word: 'ARTEL', frequency: 2.51e-08, inWordle: false },
  { word: 'ARTIC', frequency: 2.63e-07, inWordle: false },
  { word: 'ARTIS', frequency: 3.63e-07, inWordle: false },
  { word: 'ARVAL', frequency: 1.12e-08, inWordle: false },
  { word: 'ASANA', frequency: 1.7e-07, inWordle: false },
  { word: 'ASCON', frequency: 1.17e-08, inWordle: false },
  { word: 'ASCUS', frequency: 3.24e-08, inWordle: false },
  { word: 'ASDIC', frequency: 1.82e-08, inWordle: false },
  { word: 'ASHED', frequency: 3.02e-08, inWordle: false },
  { word: 'ASHES', frequency: 8.51e-06, inWordle: false },
  { word: 'ASKED', frequency: 0.0002, inWordle: false },
  { word: 'ASKER', frequency: 1.2e-07, inWordle: false },
  { word: 'ASPEN', frequency: 2.69e-06, inWordle: false },
  { word: 'ASPER', frequency: 7.59e-08, inWordle: false },
  { word: 'ASPIC', frequency: 1.23e-07, inWordle: false },
  { word: 'ASPIE', frequency: 5.5e-08, inWordle: false },
  { word: 'ASPIS', frequency: 1.48e-08, inWordle: false },
  { word: 'ASPRO', frequency: 1.55e-08, inWordle: false },
  { word: 'ASSAI', frequency: 4.37e-08, inWordle: false },
  { word: 'ASSAM', frequency: 1.95e-06, inWordle: false },
  { word: 'ASSES', frequency: 6.17e-06, inWordle: false },
  { word: 'ASSEZ', frequency: 2.75e-08, inWordle: false },
  { word: 'ASTER', frequency: 6.46e-07, inWordle: false },
  { word: 'ASTIR', frequency: 3.98e-08, inWordle: false },
  { word: 'ASURA', frequency: 2.34e-07, inWordle: false },
  { word: 'ATLAS', frequency: 6.31e-06, inWordle: false },
  { word: 'ATMAN', frequency: 1.7e-07, inWordle: false },
  { word: 'ATMOS', frequency: 4.37e-07, inWordle: false },
  { word: 'ATOMS', frequency: 5.62e-06, inWordle: false },
  { word: 'ATOMY', frequency: 1.26e-08, inWordle: false },
  { word: 'ATONY', frequency: 1.15e-08, inWordle: false },
  { word: 'ATOPY', frequency: 3.72e-08, inWordle: false },
  { word: 'ATRIA', frequency: 2.4e-07, inWordle: false },
  { word: 'ATTAR', frequency: 1.7e-07, inWordle: false },
  { word: 'AUGER', frequency: 5.89e-07, inWordle: false },
  { word: 'AUGHT', frequency: 2.69e-07, inWordle: false },
  { word: 'AULAS', frequency: 3.02e-08, inWordle: false },
  { word: 'AULIC', frequency: 1.41e-08, inWordle: false },
  { word: 'AULOS', frequency: 1.2e-08, inWordle: false },
  { word: 'AUNTS', frequency: 1.62e-06, inWordle: false },
  { word: 'AURAL', frequency: 6.03e-07, inWordle: false },
  { word: 'AURAS', frequency: 2.34e-07, inWordle: false },
  { word: 'AURES', frequency: 2.19e-08, inWordle: false },
  { word: 'AURIC', frequency: 1.17e-07, inWordle: false },
  { word: 'AURIS', frequency: 6.61e-08, inWordle: false },
  { word: 'AURUM', frequency: 1.74e-07, inWordle: false },
  { word: 'AUTOS', frequency: 1.32e-06, inWordle: false },
  { word: 'AUXIN', frequency: 1.51e-07, inWordle: false },
  { word: 'AVANT', frequency: 2.29e-06, inWordle: false },
  { word: 'AVAST', frequency: 2.82e-07, inWordle: false },
  { word: 'AVENS', frequency: 2.09e-08, inWordle: false },
  { word: 'AVERS', frequency: 7.41e-08, inWordle: false },
  { word: 'AVGAS', frequency: 3.39e-08, inWordle: false },
  { word: 'AVION', frequency: 8.51e-08, inWordle: false },
  { word: 'AVISO', frequency: 2.95e-08, inWordle: false },
  { word: 'AVOWS', frequency: 1.51e-08, inWordle: false },
  { word: 'AWAYS', frequency: 4.07e-07, inWordle: false },
  { word: 'AWING', frequency: 2.34e-08, inWordle: false },
  { word: 'AXELS', frequency: 4.68e-08, inWordle: false },
  { word: 'AXILS', frequency: 1.2e-07, inWordle: false },
  { word: 'AXING', frequency: 1.58e-07, inWordle: false },
  { word: 'AXLES', frequency: 9.55e-07, inWordle: false },
  { word: 'AXMAN', frequency: 1.7e-08, inWordle: false },
  { word: 'AXONS', frequency: 3.89e-07, inWordle: false },
  { word: 'AYAHS', frequency: 1.7e-08, inWordle: false },
  { word: 'AYAYA', frequency: 2e-08, inWordle: false },
  { word: 'AYRES', frequency: 7.94e-07, inWordle: false },
  { word: 'AZIDE', frequency: 1.15e-07, inWordle: false },
  { word: 'AZIDO', frequency: 1.74e-08, inWordle: false },
  { word: 'AZOIC', frequency: 1.17e-08, inWordle: false },
  { word: 'AZOLE', frequency: 2.29e-08, inWordle: false },
  { word: 'AZOTE', frequency: 1.55e-08, inWordle: false },
  { word: 'AZOTH', frequency: 1.95e-08, inWordle: false },
  { word: 'AZUKI', frequency: 3.39e-08, inWordle: false },
  { word: 'BAALS', frequency: 1.66e-08, inWordle: false },
  { word: 'BABAS', frequency: 4.9e-08, inWordle: false },
  { word: 'BABEL', frequency: 8.13e-07, inWordle: false },
  { word: 'BABES', frequency: 2.45e-06, inWordle: false },
  { word: 'BABKA', frequency: 5.5e-08, inWordle: false },
  { word: 'BABOO', frequency: 5.13e-08, inWordle: false },
  { word: 'BABUL', frequency: 3.89e-08, inWordle: false },
  { word: 'BABUS', frequency: 3.39e-08, inWordle: false },
  { word: 'BACCA', frequency: 1e-07, inWordle: false },
  { word: 'BACCO', frequency: 3.8e-08, inWordle: false },
  { word: 'BACCY', frequency: 4.37e-08, inWordle: false },
  { word: 'BACHA', frequency: 1.26e-07, inWordle: false },
  { word: 'BACHS', frequency: 2.88e-08, inWordle: false },
  { word: 'BACKS', frequency: 1.26e-05, inWordle: false },
  { word: 'BADDY', frequency: 5.25e-08, inWordle: false },
  { word: 'BAHTS', frequency: 1.48e-08, inWordle: false },
  { word: 'BAHUT', frequency: 3.63e-08, inWordle: false },
  { word: 'BAILS', frequency: 3.63e-07, inWordle: false },
  { word: 'BAIRN', frequency: 1.1e-07, inWordle: false },
  { word: 'BAITH', frequency: 2.19e-08, inWordle: false },
  { word: 'BAITS', frequency: 4.47e-07, inWordle: false },
  { word: 'BAIZE', frequency: 6.76e-08, inWordle: false },
  { word: 'BAJAN', frequency: 1.15e-07, inWordle: false },
  { word: 'BAJRA', frequency: 3.63e-08, inWordle: false },
  { word: 'BAKED', frequency: 8.32e-06, inWordle: false },
  { word: 'BAKEN', frequency: 1.32e-08, inWordle: false },
  { word: 'BAKES', frequency: 5.37e-07, inWordle: false },
  { word: 'BAKRA', frequency: 2e-08, inWordle: false },
  { word: 'BALAS', frequency: 4.79e-08, inWordle: false },
  { word: 'BALDS', frequency: 2.04e-08, inWordle: false },
  { word: 'BALDY', frequency: 3.8e-07, inWordle: false },
  { word: 'BALED', frequency: 6.17e-08, inWordle: false },
  { word: 'BALES', frequency: 9.33e-07, inWordle: false },
  { word: 'BALKS', frequency: 1.23e-07, inWordle: false },
  { word: 'BALKY', frequency: 3.72e-08, inWordle: false },
  { word: 'BALLS', frequency: 3.31e-05, inWordle: false },
  { word: 'BALLY', frequency: 5.37e-07, inWordle: false },
  { word: 'BALMS', frequency: 1.74e-07, inWordle: false },
  { word: 'BALOO', frequency: 2.19e-07, inWordle: false },
  { word: 'BALSA', frequency: 3.02e-07, inWordle: false },
  { word: 'BALTI', frequency: 1.26e-07, inWordle: false },
  { word: 'BALUN', frequency: 3.89e-08, inWordle: false },
  { word: 'BAMBI', frequency: 9.12e-07, inWordle: false },
  { word: 'BANCO', frequency: 1.07e-06, inWordle: false },
  { word: 'BANCS', frequency: 1.1e-08, inWordle: false },
  { word: 'BANDA', frequency: 1e-06, inWordle: false },
  { word: 'BANDH', frequency: 1.02e-07, inWordle: false },
  { word: 'BANDS', frequency: 2.34e-05, inWordle: false },
  { word: 'BANDY', frequency: 3.55e-07, inWordle: false },
  { word: 'BANES', frequency: 1.32e-07, inWordle: false },
  { word: 'BANGS', frequency: 2.82e-06, inWordle: false },
  { word: 'BANIA', frequency: 4.68e-08, inWordle: false },
  { word: 'BANKS', frequency: 4.9e-05, inWordle: false },
  { word: 'BANNS', frequency: 1.05e-07, inWordle: false },
  { word: 'BANTS', frequency: 5.62e-08, inWordle: false },
  { word: 'BANTU', frequency: 1.07e-06, inWordle: false },
  { word: 'BANTY', frequency: 1.86e-08, inWordle: false },
  { word: 'BANYA', frequency: 6.03e-08, inWordle: false },
  { word: 'BARBE', frequency: 1.23e-07, inWordle: false },
  { word: 'BARBS', frequency: 6.46e-07, inWordle: false },
  { word: 'BARBY', frequency: 8.32e-08, inWordle: false },
  { word: 'BARCA', frequency: 2.57e-06, inWordle: false },
  { word: 'BARDE', frequency: 2.75e-08, inWordle: false },
  { word: 'BARDO', frequency: 2.09e-07, inWordle: false },
  { word: 'BARDS', frequency: 5.01e-07, inWordle: false },
  { word: 'BARDY', frequency: 2e-08, inWordle: false },
  { word: 'BARED', frequency: 4.37e-07, inWordle: false },
  { word: 'BARER', frequency: 4.27e-08, inWordle: false },
  { word: 'BARES', frequency: 3.16e-07, inWordle: false },
  { word: 'BARFI', frequency: 1.02e-07, inWordle: false },
  { word: 'BARFS', frequency: 3.8e-08, inWordle: false },
  { word: 'BARIC', frequency: 2.14e-08, inWordle: false },
  { word: 'BARKS', frequency: 1.02e-06, inWordle: false },
  { word: 'BARKY', frequency: 3.89e-08, inWordle: false },
  { word: 'BARMY', frequency: 2.09e-07, inWordle: false },
  { word: 'BARNS', frequency: 1.38e-06, inWordle: false },
  { word: 'BARNY', frequency: 4.9e-08, inWordle: false },
  { word: 'BARRA', frequency: 7.76e-07, inWordle: false },
  { word: 'BARRE', frequency: 1.2e-06, inWordle: false },
  { word: 'BARRO', frequency: 1.35e-07, inWordle: false },
  { word: 'BARRY', frequency: 1.82e-05, inWordle: false },
  { word: 'BARYE', frequency: 1.66e-08, inWordle: false },
  { word: 'BASAN', frequency: 1.45e-08, inWordle: false },
  { word: 'BASED', frequency: 0.000324, inWordle: false },
  { word: 'BASEN', frequency: 1.02e-08, inWordle: false },
  { word: 'BASER', frequency: 1.38e-07, inWordle: false },
  { word: 'BASES', frequency: 1.51e-05, inWordle: false },
  { word: 'BASHO', frequency: 1.35e-07, inWordle: false },
  { word: 'BASIJ', frequency: 9.77e-08, inWordle: false },
  { word: 'BASKS', frequency: 7.59e-08, inWordle: false },
  { word: 'BASON', frequency: 4.17e-08, inWordle: false },
  { word: 'BASSE', frequency: 1.38e-07, inWordle: false },
  { word: 'BASSI', frequency: 1.07e-07, inWordle: false },
  { word: 'BASSO', frequency: 2.75e-07, inWordle: false },
  { word: 'BASSY', frequency: 8.32e-08, inWordle: false },
  { word: 'BASTA', frequency: 2.82e-07, inWordle: false },
  { word: 'BASTI', frequency: 1.95e-07, inWordle: false },
  { word: 'BASTO', frequency: 2.51e-08, inWordle: false },
  { word: 'BASTS', frequency: 1.02e-08, inWordle: false },
  { word: 'BATED', frequency: 2.14e-07, inWordle: false },
  { word: 'BATES', frequency: 4.37e-06, inWordle: false },
  { word: 'BATHS', frequency: 4.68e-06, inWordle: false },
  { word: 'BATIK', frequency: 3.47e-07, inWordle: false },
  { word: 'BATTA', frequency: 5.01e-08, inWordle: false },
  { word: 'BATTS', frequency: 2.19e-07, inWordle: false },
  { word: 'BAULK', frequency: 1.26e-07, inWordle: false },
  { word: 'BAVIN', frequency: 1.48e-08, inWordle: false },
  { word: 'BAWDS', frequency: 1.35e-08, inWordle: false },
  { word: 'BAWLS', frequency: 4.37e-08, inWordle: false },
  { word: 'BAYED', frequency: 3.98e-08, inWordle: false },
  { word: 'BAYER', frequency: 1.82e-06, inWordle: false },
  { word: 'BAYES', frequency: 3.24e-07, inWordle: false },
  { word: 'BAYLE', frequency: 9.33e-08, inWordle: false },
  { word: 'BAZAR', frequency: 3.72e-07, inWordle: false },
  { word: 'BAZOO', frequency: 1.1e-08, inWordle: false },
  { word: 'BEADS', frequency: 4.9e-06, inWordle: false },
  { word: 'BEAKS', frequency: 5.5e-07, inWordle: false },
  { word: 'BEAKY', frequency: 6.17e-08, inWordle: false },
  { word: 'BEALS', frequency: 2.04e-07, inWordle: false },
  { word: 'BEAMS', frequency: 5.75e-06, inWordle: false },
  { word: 'BEAMY', frequency: 1.66e-08, inWordle: false },
  { word: 'BEANO', frequency: 2.04e-07, inWordle: false },
  { word: 'BEANS', frequency: 1.38e-05, inWordle: false },
  { word: 'BEANY', frequency: 5.75e-08, inWordle: false },
  { word: 'BEARE', frequency: 8.51e-08, inWordle: false },
  { word: 'BEARS', frequency: 2.19e-05, inWordle: false },
  { word: 'BEATH', frequency: 4.47e-08, inWordle: false },
  { word: 'BEATS', frequency: 1.66e-05, inWordle: false },
  { word: 'BEATY', frequency: 2e-07, inWordle: false },
  { word: 'BEAUS', frequency: 5.37e-08, inWordle: false },
  { word: 'BEAUT', frequency: 3.63e-07, inWordle: false },
  { word: 'BEAUX', frequency: 5.37e-07, inWordle: false },
  { word: 'BEBOP', frequency: 6.76e-07, inWordle: false },
  { word: 'BECKE', frequency: 2.69e-08, inWordle: false },
  { word: 'BECKS', frequency: 2.88e-07, inWordle: false },
  { word: 'BEDEL', frequency: 3.8e-08, inWordle: false },
  { word: 'BEDES', frequency: 1.58e-08, inWordle: false },
  { word: 'BEEDI', frequency: 4.57e-08, inWordle: false },
  { word: 'BEEFS', frequency: 2.34e-07, inWordle: false },
  { word: 'BEEPS', frequency: 5.37e-07, inWordle: false },
  { word: 'BEERS', frequency: 7.94e-06, inWordle: false },
  { word: 'BEERY', frequency: 1.41e-07, inWordle: false },
  { word: 'BEETS', frequency: 1.17e-06, inWordle: false },
  { word: 'BEGOT', frequency: 9.33e-08, inWordle: false },
  { word: 'BEGUM', frequency: 3.63e-07, inWordle: false },
  { word: 'BEIGE', frequency: 2e-06, inWordle: false },
  { word: 'BEKAH', frequency: 7.59e-08, inWordle: false },
  { word: 'BELAH', frequency: 1.07e-08, inWordle: false },
  { word: 'BELAR', frequency: 1.38e-08, inWordle: false },
  { word: 'BELAY', frequency: 2.69e-07, inWordle: false },
  { word: 'BELGA', frequency: 1.95e-08, inWordle: false },
  { word: 'BELLS', frequency: 7.94e-06, inWordle: false },
  { word: 'BELON', frequency: 4.9e-08, inWordle: false },
  { word: 'BELTS', frequency: 5.5e-06, inWordle: false },
  { word: 'BENDS', frequency: 2.19e-06, inWordle: false },
  { word: 'BENDY', frequency: 3.55e-07, inWordle: false },
  { word: 'BENES', frequency: 1.55e-07, inWordle: false },
  { word: 'BENET', frequency: 1.95e-07, inWordle: false },
  { word: 'BENGA', frequency: 5.01e-08, inWordle: false },
  { word: 'BENIS', frequency: 1.58e-08, inWordle: false },
  { word: 'BENNE', frequency: 3.72e-08, inWordle: false },
  { word: 'BENNI', frequency: 5.89e-08, inWordle: false },
  { word: 'BENNY', frequency: 3.98e-06, inWordle: false },
  { word: 'BENTO', frequency: 5.01e-07, inWordle: false },
  { word: 'BENTS', frequency: 5.13e-08, inWordle: false },
  { word: 'BERES', frequency: 5.89e-08, inWordle: false },
  { word: 'BERGS', frequency: 7.08e-08, inWordle: false },
  { word: 'BERKO', frequency: 3.63e-08, inWordle: false },
  { word: 'BERKS', frequency: 5.5e-07, inWordle: false },
  { word: 'BERMS', frequency: 1.07e-07, inWordle: false },
  { word: 'BERYL', frequency: 8.13e-07, inWordle: false },
  { word: 'BESOM', frequency: 3.16e-08, inWordle: false },
  { word: 'BESTS', frequency: 3.89e-07, inWordle: false },
  { word: 'BETAS', frequency: 3.02e-07, inWordle: false },
  { word: 'BETHS', frequency: 1.86e-08, inWordle: false },
  { word: 'BETON', frequency: 6.46e-08, inWordle: false },
  { word: 'BETTA', frequency: 6.17e-07, inWordle: false },
  { word: 'BETTY', frequency: 8.32e-06, inWordle: false },
  { word: 'BEVER', frequency: 8.32e-08, inWordle: false },
  { word: 'BEVOR', frequency: 1.62e-08, inWordle: false },
  { word: 'BEVVY', frequency: 3.89e-08, inWordle: false },
  { word: 'BHAJI', frequency: 7.08e-08, inWordle: false },
  { word: 'BHANG', frequency: 5.89e-08, inWordle: false },
  { word: 'BHOOT', frequency: 2.75e-08, inWordle: false },
  { word: 'BHUNA', frequency: 1.78e-08, inWordle: false },
  { word: 'BIALY', frequency: 2.51e-08, inWordle: false },
  { word: 'BIBBS', frequency: 5.25e-08, inWordle: false },
  { word: 'BIDED', frequency: 6.03e-08, inWordle: false },
  { word: 'BIDES', frequency: 4.47e-08, inWordle: false },
  { word: 'BIDET', frequency: 3.8e-07, inWordle: false },
  { word: 'BIDIS', frequency: 1.48e-08, inWordle: false },
  { word: 'BIDON', frequency: 1.17e-08, inWordle: false },
  { word: 'BIELD', frequency: 1.29e-08, inWordle: false },
  { word: 'BIERS', frequency: 2.57e-08, inWordle: false },
  { word: 'BIFFO', frequency: 2.63e-08, inWordle: false },
  { word: 'BIFFS', frequency: 2.04e-08, inWordle: false },
  { word: 'BIFFY', frequency: 1.55e-07, inWordle: false },
  { word: 'BIFID', frequency: 3.47e-08, inWordle: false },
  { word: 'BIGGS', frequency: 1.12e-06, inWordle: false },
  { word: 'BIGGY', frequency: 1e-07, inWordle: false },
  { word: 'BIGHA', frequency: 2.09e-08, inWordle: false },
  { word: 'BIGHT', frequency: 4.68e-07, inWordle: false },
  { word: 'BIGLY', frequency: 2.34e-07, inWordle: false },
  { word: 'BIGOS', frequency: 1.95e-08, inWordle: false },
  { word: 'BIJOU', frequency: 3.09e-07, inWordle: false },
  { word: 'BIKED', frequency: 2.04e-07, inWordle: false },
  { word: 'BIKER', frequency: 2.34e-06, inWordle: false },
  { word: 'BIKES', frequency: 7.76e-06, inWordle: false },
  { word: 'BIKIE', frequency: 4.17e-08, inWordle: false },
  { word: 'BILBO', frequency: 6.76e-07, inWordle: false },
  { word: 'BILBY', frequency: 8.91e-08, inWordle: false },
  { word: 'BILES', frequency: 2.09e-07, inWordle: false },
  { word: 'BILLS', frequency: 3.31e-05, inWordle: false },
  { word: 'BIMAH', frequency: 1.32e-08, inWordle: false },
  { word: 'BIMBO', frequency: 7.41e-07, inWordle: false },
  { word: 'BINDI', frequency: 2.34e-07, inWordle: false },
  { word: 'BINDS', frequency: 2.4e-06, inWordle: false },
  { word: 'BINER', frequency: 1.55e-08, inWordle: false },
  { word: 'BINES', frequency: 4.9e-08, inWordle: false },
  { word: 'BINGS', frequency: 3.72e-08, inWordle: false },
  { word: 'BINKS', frequency: 2.45e-07, inWordle: false },
  { word: 'BIOTA', frequency: 3.09e-07, inWordle: false },
  { word: 'BIPED', frequency: 1.02e-07, inWordle: false },
  { word: 'BIPOD', frequency: 1.17e-07, inWordle: false },
  { word: 'BIRDS', frequency: 3.98e-05, inWordle: false },
  { word: 'BIRKS', frequency: 1.86e-07, inWordle: false },
  { word: 'BIROS', frequency: 2.29e-08, inWordle: false },
  { word: 'BIRSE', frequency: 1.45e-08, inWordle: false },
  { word: 'BITCH', frequency: 5.75e-05, inWordle: false },
  { word: 'BITER', frequency: 3.98e-07, inWordle: false },
  { word: 'BITES', frequency: 6.17e-06, inWordle: false },
  { word: 'BITOU', frequency: 2.29e-08, inWordle: false },
  { word: 'BITSY', frequency: 1.91e-07, inWordle: false },
  { word: 'BITTE', frequency: 1.12e-07, inWordle: false },
  { word: 'BITTS', frequency: 2.34e-08, inWordle: false },
  { word: 'BIVVY', frequency: 2.69e-08, inWordle: false },
  { word: 'BIZZY', frequency: 9.55e-08, inWordle: false },
  { word: 'BLABS', frequency: 3.02e-08, inWordle: false },
  { word: 'BLADY', frequency: 1.38e-08, inWordle: false },
  { word: 'BLAHS', frequency: 4.47e-08, inWordle: false },
  { word: 'BLAIN', frequency: 2.04e-07, inWordle: false },
  { word: 'BLART', frequency: 1.32e-07, inWordle: false },
  { word: 'BLASE', frequency: 1.45e-07, inWordle: false },
  { word: 'BLASH', frequency: 1.7e-08, inWordle: false },
  { word: 'BLATT', frequency: 4.07e-07, inWordle: false },
  { word: 'BLEBS', frequency: 2.75e-08, inWordle: false },
  { word: 'BLECH', frequency: 1.7e-07, inWordle: false },
  { word: 'BLEES', frequency: 1.32e-08, inWordle: false },
  { word: 'BLENT', frequency: 1.91e-08, inWordle: false },
  { word: 'BLEST', frequency: 1.45e-07, inWordle: false },
  { word: 'BLING', frequency: 1.62e-06, inWordle: false },
  { word: 'BLINI', frequency: 3.31e-08, inWordle: false },
  { word: 'BLIPS', frequency: 2.4e-07, inWordle: false },
  { word: 'BLIVE', frequency: 1.07e-08, inWordle: false },
  { word: 'BLOBS', frequency: 3.8e-07, inWordle: false },
  { word: 'BLOCS', frequency: 4.79e-07, inWordle: false },
  { word: 'BLOGS', frequency: 8.91e-06, inWordle: false },
  { word: 'BLOOK', frequency: 1.23e-08, inWordle: false },
  { word: 'BLOOP', frequency: 2.69e-07, inWordle: false },
  { word: 'BLORE', frequency: 9.33e-08, inWordle: false },
  { word: 'BLOTS', frequency: 2e-07, inWordle: false },
  { word: 'BLOWS', frequency: 1.1e-05, inWordle: false },
  { word: 'BLOWY', frequency: 4.47e-08, inWordle: false },
  { word: 'BLUBS', frequency: 1.12e-08, inWordle: false },
  { word: 'BLUED', frequency: 1.41e-07, inWordle: false },
  { word: 'BLUES', frequency: 2.19e-05, inWordle: false },
  { word: 'BLUET', frequency: 1.66e-08, inWordle: false },
  { word: 'BLUEY', frequency: 1.62e-07, inWordle: false },
  { word: 'BLUME', frequency: 3.39e-07, inWordle: false },
  { word: 'BLURS', frequency: 4.17e-07, inWordle: false },
  { word: 'BOARS', frequency: 5.5e-07, inWordle: false },
  { word: 'BOART', frequency: 1.78e-08, inWordle: false },
  { word: 'BOATS', frequency: 1.78e-05, inWordle: false },
  { word: 'BOBAK', frequency: 2.57e-08, inWordle: false },
  { word: 'BOBOS', frequency: 2.63e-08, inWordle: false },
  { word: 'BOCCA', frequency: 6.92e-08, inWordle: false },
  { word: 'BOCCE', frequency: 1.82e-07, inWordle: false },
  { word: 'BOCCI', frequency: 2.19e-08, inWordle: false },
  { word: 'BOCHE', frequency: 7.08e-08, inWordle: false },
  { word: 'BOCKS', frequency: 3.02e-08, inWordle: false },
  { word: 'BODED', frequency: 3.8e-08, inWordle: false },
  { word: 'BODES', frequency: 3.8e-07, inWordle: false },
  { word: 'BODGE', frequency: 3.98e-08, inWordle: false },
  { word: 'BODHI', frequency: 4.07e-07, inWordle: false },
  { word: 'BODLE', frequency: 1.7e-08, inWordle: false },
  { word: 'BOEUF', frequency: 1.51e-07, inWordle: false },
  { word: 'BOFFO', frequency: 3.72e-08, inWordle: false },
  { word: 'BOGAN', frequency: 3.55e-07, inWordle: false },
  { word: 'BOGEY', frequency: 8.32e-07, inWordle: false },
  { word: 'BOGGY', frequency: 2.63e-07, inWordle: false },
  { word: 'BOGIE', frequency: 2.88e-07, inWordle: false },
  { word: 'BOGLE', frequency: 1.95e-07, inWordle: false },
  { word: 'BOGUE', frequency: 1.62e-07, inWordle: false },
  { word: 'BOGUS', frequency: 2.69e-06, inWordle: false },
  { word: 'BOILS', frequency: 1.95e-06, inWordle: false },
  { word: 'BOING', frequency: 5.5e-07, inWordle: false },
  { word: 'BOINK', frequency: 5.13e-08, inWordle: false },
  { word: 'BOITE', frequency: 6.76e-08, inWordle: false },
  { word: 'BOKEH', frequency: 1.7e-07, inWordle: false },
  { word: 'BOLAR', frequency: 3.72e-08, inWordle: false },
  { word: 'BOLAS', frequency: 1.29e-07, inWordle: false },
  { word: 'BOLDS', frequency: 2.19e-08, inWordle: false },
  { word: 'BOLES', frequency: 2.95e-07, inWordle: false },
  { word: 'BOLLS', frequency: 2.51e-08, inWordle: false },
  { word: 'BOLOS', frequency: 4.68e-08, inWordle: false },
  { word: 'BOLTS', frequency: 4.17e-06, inWordle: false },
  { word: 'BOLUS', frequency: 3.98e-07, inWordle: false },
  { word: 'BOMAS', frequency: 1.66e-08, inWordle: false },
  { word: 'BOMBE', frequency: 8.51e-08, inWordle: false },
  { word: 'BOMBO', frequency: 3.72e-08, inWordle: false },
  { word: 'BOMBS', frequency: 1.41e-05, inWordle: false },
  { word: 'BONCE', frequency: 3.63e-08, inWordle: false },
  { word: 'BONDS', frequency: 1.86e-05, inWordle: false },
  { word: 'BONED', frequency: 7.59e-07, inWordle: false },
  { word: 'BONER', frequency: 1.62e-06, inWordle: false },
  { word: 'BONES', frequency: 2.09e-05, inWordle: false },
  { word: 'BONGS', frequency: 3.02e-07, inWordle: false },
  { word: 'BONKS', frequency: 4.9e-08, inWordle: false },
  { word: 'BONNE', frequency: 4.68e-07, inWordle: false },
  { word: 'BONNY', frequency: 6.92e-07, inWordle: false },
  { word: 'BONZA', frequency: 2.45e-08, inWordle: false },
  { word: 'BONZE', frequency: 1.91e-08, inWordle: false },
  { word: 'BOOBS', frequency: 7.94e-06, inWordle: false },
  { word: 'BOODY', frequency: 3.31e-08, inWordle: false },
  { word: 'BOOED', frequency: 1.23e-06, inWordle: false },
  { word: 'BOOGY', frequency: 2.63e-08, inWordle: false },
  { word: 'BOOKS', frequency: 0.000141, inWordle: false },
  { word: 'BOOKY', frequency: 5.01e-08, inWordle: false },
  { word: 'BOOMS', frequency: 1e-06, inWordle: false },
  { word: 'BOOMY', frequency: 3.39e-08, inWordle: false },
  { word: 'BOONG', frequency: 2.24e-08, inWordle: false },
  { word: 'BOONS', frequency: 1.58e-07, inWordle: false },
  { word: 'BOORD', frequency: 2.24e-08, inWordle: false },
  { word: 'BOORS', frequency: 3.8e-08, inWordle: false },
  { word: 'BOOSE', frequency: 3.24e-08, inWordle: false },
  { word: 'BOOTS', frequency: 2.14e-05, inWordle: false },
  { word: 'BOPPY', frequency: 5.13e-08, inWordle: false },
  { word: 'BORAK', frequency: 3.02e-08, inWordle: false },
  { word: 'BORAL', frequency: 5.37e-08, inWordle: false },
  { word: 'BORAS', frequency: 1.74e-07, inWordle: false },
  { word: 'BORDE', frequency: 9.12e-08, inWordle: false },
  { word: 'BORDS', frequency: 2.14e-08, inWordle: false },
  { word: 'BORED', frequency: 1.58e-05, inWordle: false },
  { word: 'BOREE', frequency: 1.95e-08, inWordle: false },
  { word: 'BOREL', frequency: 1.91e-07, inWordle: false },
  { word: 'BORER', frequency: 3.39e-07, inWordle: false },
  { word: 'BORES', frequency: 6.92e-07, inWordle: false },
  { word: 'BORGO', frequency: 1.55e-07, inWordle: false },
  { word: 'BORIC', frequency: 2.04e-07, inWordle: false },
  { word: 'BORNA', frequency: 6.03e-08, inWordle: false },
  { word: 'BORON', frequency: 8.32e-07, inWordle: false },
  { word: 'BORTS', frequency: 1.15e-08, inWordle: false },
  { word: 'BORTZ', frequency: 3.31e-08, inWordle: false },
  { word: 'BOSIE', frequency: 4.17e-08, inWordle: false },
  { word: 'BOSKY', frequency: 2.4e-08, inWordle: false },
  { word: 'BOSON', frequency: 5.75e-07, inWordle: false },
  { word: 'BOSUN', frequency: 7.76e-08, inWordle: false },
  { word: 'BOTAS', frequency: 3.63e-08, inWordle: false },
  { word: 'BOTES', frequency: 3.55e-08, inWordle: false },
  { word: 'BOTHY', frequency: 1.15e-07, inWordle: false },
  { word: 'BOTTE', frequency: 2.63e-08, inWordle: false },
  { word: 'BOTTS', frequency: 9.77e-08, inWordle: false },
  { word: 'BOTTY', frequency: 3.16e-08, inWordle: false },
  { word: 'BOUGE', frequency: 2e-08, inWordle: false },
  { word: 'BOULT', frequency: 1.95e-07, inWordle: false },
  { word: 'BOURG', frequency: 1.82e-07, inWordle: false },
  { word: 'BOURN', frequency: 1.45e-07, inWordle: false },
  { word: 'BOUSE', frequency: 2.88e-08, inWordle: false },
  { word: 'BOUTS', frequency: 1.62e-06, inWordle: false },
  { word: 'BOVID', frequency: 1.55e-08, inWordle: false },
  { word: 'BOWED', frequency: 2.14e-06, inWordle: false },
  { word: 'BOWER', frequency: 1e-06, inWordle: false },
  { word: 'BOWES', frequency: 5.01e-07, inWordle: false },
  { word: 'BOWIE', frequency: 3.47e-06, inWordle: false },
  { word: 'BOWLS', frequency: 5.62e-06, inWordle: false },
  { word: 'BOWNE', frequency: 8.32e-08, inWordle: false },
  { word: 'BOXED', frequency: 2.19e-06, inWordle: false },
  { word: 'BOXEN', frequency: 2.63e-08, inWordle: false },
  { word: 'BOXES', frequency: 2.19e-05, inWordle: false },
  { word: 'BOXTY', frequency: 1.23e-08, inWordle: false },
  { word: 'BOYAR', frequency: 8.13e-08, inWordle: false },
  { word: 'BOYOS', frequency: 3.39e-08, inWordle: false },
  { word: 'BOZOS', frequency: 1.32e-07, inWordle: false },
  { word: 'BRAAI', frequency: 1.17e-07, inWordle: false },
  { word: 'BRACH', frequency: 1.12e-07, inWordle: false },
  { word: 'BRACK', frequency: 2.14e-07, inWordle: false },
  { word: 'BRACT', frequency: 6.76e-08, inWordle: false },
  { word: 'BRADS', frequency: 9.77e-08, inWordle: false },
  { word: 'BRAES', frequency: 1.02e-07, inWordle: false },
  { word: 'BRAGS', frequency: 4.57e-07, inWordle: false },
  { word: 'BRAIL', frequency: 2.75e-08, inWordle: false },
  { word: 'BRAME', frequency: 3.47e-08, inWordle: false },
  { word: 'BRANE', frequency: 1.2e-07, inWordle: false },
  { word: 'BRANK', frequency: 1.12e-08, inWordle: false },
  { word: 'BRANS', frequency: 3.89e-08, inWordle: false },
  { word: 'BRANT', frequency: 7.94e-07, inWordle: false },
  { word: 'BRATS', frequency: 8.13e-07, inWordle: false },
  { word: 'BRAVA', frequency: 4.07e-07, inWordle: false },
  { word: 'BRAVI', frequency: 2.95e-08, inWordle: false },
  { word: 'BRAYS', frequency: 6.17e-08, inWordle: false },
  { word: 'BRAZE', frequency: 6.92e-08, inWordle: false },
  { word: 'BREAM', frequency: 4.9e-07, inWordle: false },
  { word: 'BREDE', frequency: 9.33e-08, inWordle: false },
  { word: 'BREDS', frequency: 1.15e-07, inWordle: false },
  { word: 'BREER', frequency: 2.09e-08, inWordle: false },
  { word: 'BREES', frequency: 9.55e-07, inWordle: false },
  { word: 'BRENS', frequency: 1.45e-08, inWordle: false },
  { word: 'BRENT', frequency: 4.9e-06, inWordle: false },
  { word: 'BREVE', frequency: 1.29e-07, inWordle: false },
  { word: 'BREWS', frequency: 9.77e-07, inWordle: false },
  { word: 'BRIER', frequency: 2.24e-07, inWordle: false },
  { word: 'BRIGS', frequency: 8.91e-08, inWordle: false },
  { word: 'BRILL', frequency: 1.15e-06, inWordle: false },
  { word: 'BRIMS', frequency: 1.45e-07, inWordle: false },
  { word: 'BRISE', frequency: 3.98e-08, inWordle: false },
  { word: 'BRISS', frequency: 1.62e-08, inWordle: false },
  { word: 'BRITH', frequency: 6.61e-08, inWordle: false },
  { word: 'BRITS', frequency: 3.47e-06, inWordle: false },
  { word: 'BRITT', frequency: 1.51e-06, inWordle: false },
  { word: 'BRIZE', frequency: 7.08e-08, inWordle: false },
  { word: 'BROCH', frequency: 1.05e-07, inWordle: false },
  { word: 'BROCK', frequency: 5.13e-06, inWordle: false },
  { word: 'BROME', frequency: 1.35e-07, inWordle: false },
  { word: 'BROMO', frequency: 2.04e-07, inWordle: false },
  { word: 'BRONC', frequency: 1.1e-07, inWordle: false },
  { word: 'BROOS', frequency: 1.15e-08, inWordle: false },
  { word: 'BROSE', frequency: 6.03e-08, inWordle: false },
  { word: 'BROWS', frequency: 2.19e-06, inWordle: false },
  { word: 'BRUGH', frequency: 2.57e-08, inWordle: false },
  { word: 'BRUIN', frequency: 3.31e-07, inWordle: false },
  { word: 'BRUIT', frequency: 5.5e-08, inWordle: false },
  { word: 'BRULE', frequency: 1.62e-07, inWordle: false },
  { word: 'BRUME', frequency: 3.39e-08, inWordle: false },
  { word: 'BRUNG', frequency: 1.2e-07, inWordle: false },
  { word: 'BRUST', frequency: 8.71e-08, inWordle: false },
  { word: 'BUBBA', frequency: 2e-06, inWordle: false },
  { word: 'BUBBE', frequency: 2.29e-08, inWordle: false },
  { word: 'BUBBY', frequency: 1.35e-07, inWordle: false },
  { word: 'BUCHU', frequency: 1.45e-08, inWordle: false },
  { word: 'BUCKO', frequency: 1.48e-07, inWordle: false },
  { word: 'BUCKS', frequency: 1.55e-05, inWordle: false },
  { word: 'BUFFA', frequency: 5.01e-08, inWordle: false },
  { word: 'BUFFO', frequency: 2.29e-08, inWordle: false },
  { word: 'BUFFS', frequency: 1.05e-06, inWordle: false },
  { word: 'BUFFY', frequency: 2.63e-06, inWordle: false },
  { word: 'BUIST', frequency: 4.07e-08, inWordle: false },
  { word: 'BULBS', frequency: 3.55e-06, inWordle: false },
  { word: 'BULGY', frequency: 3.63e-08, inWordle: false },
  { word: 'BULKS', frequency: 9.77e-08, inWordle: false },
  { word: 'BULLA', frequency: 1.74e-07, inWordle: false },
  { word: 'BULLS', frequency: 9.33e-06, inWordle: false },
  { word: 'BUMBO', frequency: 4.47e-08, inWordle: false },
  { word: 'BUMPS', frequency: 3.98e-06, inWordle: false },
  { word: 'BUMPY', frequency: 1.51e-06, inWordle: false },
  { word: 'BUNCE', frequency: 1.82e-07, inWordle: false },
  { word: 'BUNCO', frequency: 5.75e-08, inWordle: false },
  { word: 'BUNDE', frequency: 1.07e-08, inWordle: false },
  { word: 'BUNDS', frequency: 8.51e-08, inWordle: false },
  { word: 'BUNDT', frequency: 1.41e-07, inWordle: false },
  { word: 'BUNDU', frequency: 3.55e-08, inWordle: false },
  { word: 'BUNDY', frequency: 1.58e-06, inWordle: false },
  { word: 'BUNGS', frequency: 3.8e-08, inWordle: false },
  { word: 'BUNGY', frequency: 4.17e-08, inWordle: false },
  { word: 'BUNIA', frequency: 1.2e-08, inWordle: false },
  { word: 'BUNKO', frequency: 5.75e-08, inWordle: false },
  { word: 'BUNKS', frequency: 4.27e-07, inWordle: false },
  { word: 'BUNTS', frequency: 8.32e-08, inWordle: false },
  { word: 'BUNTY', frequency: 1.41e-07, inWordle: false },
  { word: 'BUNYA', frequency: 2.34e-08, inWordle: false },
  { word: 'BUOYS', frequency: 5.89e-07, inWordle: false },
  { word: 'BURAN', frequency: 4.47e-08, inWordle: false },
  { word: 'BURAS', frequency: 2.4e-08, inWordle: false },
  { word: 'BURBS', frequency: 2.57e-07, inWordle: false },
  { word: 'BURDS', frequency: 1.12e-08, inWordle: false },
  { word: 'BURET', frequency: 1.41e-08, inWordle: false },
  { word: 'BURGH', frequency: 7.24e-07, inWordle: false },
  { word: 'BURGS', frequency: 3.63e-08, inWordle: false },
  { word: 'BURIN', frequency: 7.24e-08, inWordle: false },
  { word: 'BURKA', frequency: 3.89e-07, inWordle: false },
  { word: 'BURKE', frequency: 7.41e-06, inWordle: false },
  { word: 'BURKS', frequency: 2.34e-07, inWordle: false },
  { word: 'BURLS', frequency: 4.07e-08, inWordle: false },
  { word: 'BURNS', frequency: 1.74e-05, inWordle: false },
  { word: 'BURPS', frequency: 1.82e-07, inWordle: false },
  { word: 'BURQA', frequency: 3.8e-07, inWordle: false },
  { word: 'BURRO', frequency: 2.24e-07, inWordle: false },
  { word: 'BURRS', frequency: 1.66e-07, inWordle: false },
  { word: 'BURRY', frequency: 2e-07, inWordle: false },
  { word: 'BURSA', frequency: 3.98e-07, inWordle: false },
  { word: 'BURSE', frequency: 4.27e-08, inWordle: false },
  { word: 'BUSBY', frequency: 4.79e-07, inWordle: false },
  { word: 'BUSES', frequency: 1.05e-05, inWordle: false },
  { word: 'BUSKS', frequency: 1.62e-08, inWordle: false },
  { word: 'BUSTI', frequency: 1.55e-08, inWordle: false },
  { word: 'BUSTS', frequency: 1.48e-06, inWordle: false },
  { word: 'BUSTY', frequency: 1.17e-06, inWordle: false },
  { word: 'BUTEO', frequency: 4.27e-08, inWordle: false },
  { word: 'BUTES', frequency: 1.1e-08, inWordle: false },
  { word: 'BUTOH', frequency: 4.37e-08, inWordle: false },
  { word: 'BUTTS', frequency: 3.39e-06, inWordle: false },
  { word: 'BUTTY', frequency: 9.77e-08, inWordle: false },
  { word: 'BUTYL', frequency: 3.16e-07, inWordle: false },
  { word: 'BUZZY', frequency: 2.88e-07, inWordle: false },
  { word: 'BWANA', frequency: 9.33e-08, inWordle: false },
  { word: 'BYRES', frequency: 6.46e-08, inWordle: false },
  { word: 'BYTES', frequency: 1.82e-06, inWordle: false },
  { word: 'BYWAY', frequency: 1.7e-07, inWordle: false },
  { word: 'CABAS', frequency: 1.55e-08, inWordle: false },
  { word: 'CABER', frequency: 8.13e-08, inWordle: false },
  { word: 'CADEE', frequency: 1.12e-08, inWordle: false },
  { word: 'CADES', frequency: 6.31e-08, inWordle: false },
  { word: 'CADGE', frequency: 2.57e-08, inWordle: false },
  { word: 'CADIE', frequency: 1.62e-08, inWordle: false },
  { word: 'CADRE', frequency: 1.1e-06, inWordle: false },
  { word: 'CAECA', frequency: 2.24e-08, inWordle: false },
  { word: 'CAFES', frequency: 2.14e-06, inWordle: false },
  { word: 'CAGED', frequency: 1.15e-06, inWordle: false },
  { word: 'CAGER', frequency: 3.47e-08, inWordle: false },
  { word: 'CAGES', frequency: 2.69e-06, inWordle: false },
  { word: 'CAHOW', frequency: 1.32e-08, inWordle: false },
  { word: 'CAINS', frequency: 4.57e-08, inWordle: false },
  { word: 'CAIRD', frequency: 1.51e-07, inWordle: false },
  { word: 'CAJON', frequency: 2.82e-07, inWordle: false },
  { word: 'CAJUN', frequency: 9.77e-07, inWordle: false },
  { word: 'CAKED', frequency: 5.01e-07, inWordle: false },
  { word: 'CAKES', frequency: 7.08e-06, inWordle: false },
  { word: 'CAKEY', frequency: 1.32e-07, inWordle: false },
  { word: 'CALFS', frequency: 3.89e-08, inWordle: false },
  { word: 'CALIF', frequency: 6.76e-06, inWordle: false },
  { word: 'CALIX', frequency: 3.98e-08, inWordle: false },
  { word: 'CALKS', frequency: 1.62e-08, inWordle: false },
  { word: 'CALLA', frequency: 2.29e-07, inWordle: false },
  { word: 'CALLS', frequency: 8.13e-05, inWordle: false },
  { word: 'CALMS', frequency: 9.55e-07, inWordle: false },
  { word: 'CALMY', frequency: 2.24e-08, inWordle: false },
  { word: 'CALVE', frequency: 9.12e-08, inWordle: false },
  { word: 'CALYX', frequency: 2.82e-07, inWordle: false },
  { word: 'CAMAS', frequency: 1.38e-07, inWordle: false },
  { word: 'CAMES', frequency: 3.24e-08, inWordle: false },
  { word: 'CAMIS', frequency: 2.34e-08, inWordle: false },
  { word: 'CAMOS', frequency: 5.01e-08, inWordle: false },
  { word: 'CAMPI', frequency: 7.59e-08, inWordle: false },
  { word: 'CAMPO', frequency: 7.41e-07, inWordle: false },
  { word: 'CAMPS', frequency: 1.55e-05, inWordle: false },
  { word: 'CAMPY', frequency: 3.24e-07, inWordle: false },
  { word: 'CAMUS', frequency: 7.59e-07, inWordle: false },
  { word: 'CANED', frequency: 1.51e-07, inWordle: false },
  { word: 'CANER', frequency: 6.31e-08, inWordle: false },
  { word: 'CANES', frequency: 1.29e-06, inWordle: false },
  { word: 'CANID', frequency: 5.5e-08, inWordle: false },
  { word: 'CANNA', frequency: 3.09e-07, inWordle: false },
  { word: 'CANSO', frequency: 6.92e-08, inWordle: false },
  { word: 'CANST', frequency: 2.19e-07, inWordle: false },
  { word: 'CANTO', frequency: 6.46e-07, inWordle: false },
  { word: 'CANTS', frequency: 4.79e-08, inWordle: false },
  { word: 'CANTY', frequency: 8.91e-08, inWordle: false },
  { word: 'CAPAS', frequency: 2.51e-08, inWordle: false },
  { word: 'CAPED', frequency: 2.29e-07, inWordle: false },
  { word: 'CAPES', frequency: 1e-06, inWordle: false },
  { word: 'CAPEX', frequency: 2.09e-07, inWordle: false },
  { word: 'CAPIZ', frequency: 7.08e-08, inWordle: false },
  { word: 'CAPLE', frequency: 2.63e-08, inWordle: false },
  { word: 'CAPON', frequency: 1.55e-07, inWordle: false },
  { word: 'CAPOS', frequency: 7.41e-08, inWordle: false },
  { word: 'CAPRI', frequency: 1.15e-06, inWordle: false },
  { word: 'CARBO', frequency: 2.04e-07, inWordle: false },
  { word: 'CARBS', frequency: 2.29e-06, inWordle: false },
  { word: 'CARBY', frequency: 5.01e-08, inWordle: false },
  { word: 'CARDI', frequency: 5.89e-07, inWordle: false },
  { word: 'CARDS', frequency: 5.75e-05, inWordle: false },
  { word: 'CARDY', frequency: 9.55e-08, inWordle: false },
  { word: 'CARED', frequency: 1.29e-05, inWordle: false },
  { word: 'CARER', frequency: 7.24e-07, inWordle: false },
  { word: 'CARES', frequency: 2.51e-05, inWordle: false },
  { word: 'CARET', frequency: 8.13e-08, inWordle: false },
  { word: 'CAREX', frequency: 1.48e-07, inWordle: false },
  { word: 'CARLE', frequency: 3.39e-07, inWordle: false },
  { word: 'CARLS', frequency: 8.51e-08, inWordle: false },
  { word: 'CARNS', frequency: 2.29e-08, inWordle: false },
  { word: 'CARNY', frequency: 9.33e-08, inWordle: false },
  { word: 'CAROB', frequency: 1.29e-07, inWordle: false },
  { word: 'CAROM', frequency: 9.33e-08, inWordle: false },
  { word: 'CARON', frequency: 4.47e-07, inWordle: false },
  { word: 'CARPI', frequency: 1.05e-07, inWordle: false },
  { word: 'CARPS', frequency: 7.08e-08, inWordle: false },
  { word: 'CARRS', frequency: 5.01e-08, inWordle: false },
  { word: 'CARSE', frequency: 5.01e-08, inWordle: false },
  { word: 'CARTA', frequency: 8.13e-07, inWordle: false },
  { word: 'CARTE', frequency: 1.45e-06, inWordle: false },
  { word: 'CARTS', frequency: 2.82e-06, inWordle: false },
  { word: 'CASAS', frequency: 4.57e-07, inWordle: false },
  { word: 'CASCO', frequency: 1.7e-07, inWordle: false },
  { word: 'CASED', frequency: 3.8e-07, inWordle: false },
  { word: 'CASES', frequency: 0.00011, inWordle: false },
  { word: 'CASKS', frequency: 5.13e-07, inWordle: false },
  { word: 'CASTS', frequency: 3.8e-06, inWordle: false },
  { word: 'CASUS', frequency: 1.58e-07, inWordle: false },
  { word: 'CATES', frequency: 3.8e-07, inWordle: false },
  { word: 'CAUDA', frequency: 8.51e-08, inWordle: false },
  { word: 'CAULD', frequency: 1.95e-08, inWordle: false },
  { word: 'CAUSA', frequency: 3.55e-07, inWordle: false },
  { word: 'CAVAS', frequency: 1.29e-08, inWordle: false },
  { word: 'CAVED', frequency: 9.55e-07, inWordle: false },
  { word: 'CAVER', frequency: 5.89e-08, inWordle: false },
  { word: 'CAVES', frequency: 4.9e-06, inWordle: false },
  { word: 'CECAL', frequency: 3.16e-08, inWordle: false },
  { word: 'CECUM', frequency: 6.46e-08, inWordle: false },
  { word: 'CEDED', frequency: 1.07e-06, inWordle: false },
  { word: 'CEDER', frequency: 2.24e-08, inWordle: false },
  { word: 'CEDES', frequency: 1.23e-07, inWordle: false },
  { word: 'CEDIS', frequency: 5.25e-08, inWordle: false },
  { word: 'CEIBA', frequency: 7.59e-08, inWordle: false },
  { word: 'CEILI', frequency: 2.63e-08, inWordle: false },
  { word: 'CELEB', frequency: 1e-06, inWordle: false },
  { word: 'CELLA', frequency: 1.26e-07, inWordle: false },
  { word: 'CELLI', frequency: 5.5e-08, inWordle: false },
  { word: 'CELLS', frequency: 5.62e-05, inWordle: false },
  { word: 'CELTS', frequency: 6.61e-07, inWordle: false },
  { word: 'CENSE', frequency: 2.29e-08, inWordle: false },
  { word: 'CENTO', frequency: 1.86e-07, inWordle: false },
  { word: 'CENTS', frequency: 2.29e-05, inWordle: false },
  { word: 'CENTU', frequency: 1.62e-08, inWordle: false },
  { word: 'CEPES', frequency: 1.02e-08, inWordle: false },
  { word: 'CERCI', frequency: 9.12e-08, inWordle: false },
  { word: 'CERES', frequency: 7.24e-07, inWordle: false },
  { word: 'CERIA', frequency: 4.9e-08, inWordle: false },
  { word: 'CERIC', frequency: 1.91e-08, inWordle: false },
  { word: 'CERNE', frequency: 3.47e-08, inWordle: false },
  { word: 'CEROS', frequency: 1.07e-08, inWordle: false },
  { word: 'CERTS', frequency: 1.66e-07, inWordle: false },
  { word: 'CESTA', frequency: 2.88e-08, inWordle: false },
  { word: 'CETYL', frequency: 2.95e-08, inWordle: false },
  { word: 'CHACE', frequency: 2.04e-07, inWordle: false },
  { word: 'CHACK', frequency: 1.82e-08, inWordle: false },
  { word: 'CHACO', frequency: 3.09e-07, inWordle: false },
  { word: 'CHADS', frequency: 9.55e-08, inWordle: false },
  { word: 'CHAIS', frequency: 2.57e-08, inWordle: false },
  { word: 'CHAMS', frequency: 2.69e-08, inWordle: false },
  { word: 'CHANA', frequency: 2.09e-07, inWordle: false },
  { word: 'CHANG', frequency: 5.37e-06, inWordle: false },
  { word: 'CHANK', frequency: 2.24e-08, inWordle: false },
  { word: 'CHAPE', frequency: 2.57e-08, inWordle: false },
  { word: 'CHAPS', frequency: 1.32e-06, inWordle: false },
  { word: 'CHAPT', frequency: 2.95e-08, inWordle: false },
  { word: 'CHARA', frequency: 6.61e-07, inWordle: false },
  { word: 'CHARE', frequency: 2.4e-08, inWordle: false },
  { word: 'CHARK', frequency: 2.4e-08, inWordle: false },
  { word: 'CHARR', frequency: 8.13e-08, inWordle: false },
  { word: 'CHARS', frequency: 3.16e-07, inWordle: false },
  { word: 'CHARY', frequency: 4.37e-08, inWordle: false },
  { word: 'CHATS', frequency: 2.34e-06, inWordle: false },
  { word: 'CHAVE', frequency: 2.57e-08, inWordle: false },
  { word: 'CHAVS', frequency: 1.29e-07, inWordle: false },
  { word: 'CHAWK', frequency: 1.12e-08, inWordle: false },
  { word: 'CHAYA', frequency: 1.45e-07, inWordle: false },
  { word: 'CHEEP', frequency: 2.95e-07, inWordle: false },
  { word: 'CHEFS', frequency: 4.37e-06, inWordle: false },
  { word: 'CHEKA', frequency: 7.08e-08, inWordle: false },
  { word: 'CHELA', frequency: 9.55e-08, inWordle: false },
  { word: 'CHEMO', frequency: 1.78e-06, inWordle: false },
  { word: 'CHEMS', frequency: 6.46e-08, inWordle: false },
  { word: 'CHERE', frequency: 7.08e-08, inWordle: false },
  { word: 'CHERT', frequency: 1.82e-07, inWordle: false },
  { word: 'CHEVY', frequency: 3.39e-06, inWordle: false },
  { word: 'CHEWS', frequency: 6.03e-07, inWordle: false },
  { word: 'CHEWY', frequency: 8.71e-07, inWordle: false },
  { word: 'CHIAO', frequency: 1.41e-07, inWordle: false },
  { word: 'CHIBS', frequency: 4.57e-08, inWordle: false },
  { word: 'CHICA', frequency: 5.89e-07, inWordle: false },
  { word: 'CHICH', frequency: 2.57e-08, inWordle: false },
  { word: 'CHICO', frequency: 1.62e-06, inWordle: false },
  { word: 'CHICS', frequency: 3.72e-08, inWordle: false },
  { word: 'CHIEL', frequency: 1.32e-08, inWordle: false },
  { word: 'CHILE', frequency: 1.15e-05, inWordle: false },
  { word: 'CHIMO', frequency: 3.02e-08, inWordle: false },
  { word: 'CHIMP', frequency: 8.91e-07, inWordle: false },
  { word: 'CHINE', frequency: 3.31e-07, inWordle: false },
  { word: 'CHING', frequency: 2.34e-06, inWordle: false },
  { word: 'CHINK', frequency: 4.07e-07, inWordle: false },
  { word: 'CHINO', frequency: 1.05e-06, inWordle: false },
  { word: 'CHINS', frequency: 4.9e-07, inWordle: false },
  { word: 'CHIPS', frequency: 1.62e-05, inWordle: false },
  { word: 'CHIRK', frequency: 6.46e-08, inWordle: false },
  { word: 'CHIRO', frequency: 1.07e-07, inWordle: false },
  { word: 'CHIRU', frequency: 4.57e-08, inWordle: false },
  { word: 'CHITS', frequency: 7.24e-08, inWordle: false },
  { word: 'CHIVE', frequency: 1.62e-07, inWordle: false },
  { word: 'CHOCO', frequency: 4.37e-07, inWordle: false },
  { word: 'CHOCS', frequency: 3.8e-08, inWordle: false },
  { word: 'CHODE', frequency: 1.26e-07, inWordle: false },
  { word: 'CHOKO', frequency: 2.75e-08, inWordle: false },
  { word: 'CHOKY', frequency: 1.45e-08, inWordle: false },
  { word: 'CHOLA', frequency: 2.14e-07, inWordle: false },
  { word: 'CHOLI', frequency: 5.25e-08, inWordle: false },
  { word: 'CHOLO', frequency: 2.24e-07, inWordle: false },
  { word: 'CHOMP', frequency: 3.39e-07, inWordle: false },
  { word: 'CHOOK', frequency: 1.45e-07, inWordle: false },
  { word: 'CHOOM', frequency: 2.4e-08, inWordle: false },
  { word: 'CHOON', frequency: 1.7e-07, inWordle: false },
  { word: 'CHOPS', frequency: 2.4e-06, inWordle: false },
  { word: 'CHOTA', frequency: 1.38e-07, inWordle: false },
  { word: 'CHOUT', frequency: 1.07e-08, inWordle: false },
  { word: 'CHOUX', frequency: 1.12e-07, inWordle: false },
  { word: 'CHOWK', frequency: 2.75e-07, inWordle: false },
  { word: 'CHOWS', frequency: 7.41e-08, inWordle: false },
  { word: 'CHUBS', frequency: 1e-07, inWordle: false },
  { word: 'CHUFF', frequency: 5.13e-08, inWordle: false },
  { word: 'CHUGS', frequency: 1.62e-07, inWordle: false },
  { word: 'CHUMS', frequency: 3.98e-07, inWordle: false },
  { word: 'CHURL', frequency: 3.24e-08, inWordle: false },
  { word: 'CHUSE', frequency: 2.14e-08, inWordle: false },
  { word: 'CHYLE', frequency: 2.51e-08, inWordle: false },
  { word: 'CHYME', frequency: 2.19e-08, inWordle: false },
  { word: 'CIGGY', frequency: 3.16e-08, inWordle: false },
  { word: 'CILIA', frequency: 4.47e-07, inWordle: false },
  { word: 'CIMEX', frequency: 2.88e-08, inWordle: false },
  { word: 'CINES', frequency: 2.09e-08, inWordle: false },
  { word: 'CIRCS', frequency: 3.31e-08, inWordle: false },
  { word: 'CIRES', frequency: 1.41e-08, inWordle: false },
  { word: 'CIRRI', frequency: 4.37e-08, inWordle: false },
  { word: 'CISCO', frequency: 3.09e-06, inWordle: false },
  { word: 'CISSY', frequency: 2.14e-07, inWordle: false },
  { word: 'CISTS', frequency: 2.4e-08, inWordle: false },
  { word: 'CITED', frequency: 1.95e-05, inWordle: false },
  { word: 'CITES', frequency: 4.07e-06, inWordle: false },
  { word: 'CIVES', frequency: 1.29e-08, inWordle: false },
  { word: 'CIVET', frequency: 1.32e-07, inWordle: false },
  { word: 'CIVVY', frequency: 3.72e-08, inWordle: false },
  { word: 'CLACH', frequency: 1.05e-08, inWordle: false },
  { word: 'CLADE', frequency: 2.34e-07, inWordle: false },
  { word: 'CLADS', frequency: 2.19e-08, inWordle: false },
  { word: 'CLAES', frequency: 1.82e-07, inWordle: false },
  { word: 'CLAMS', frequency: 1.35e-06, inWordle: false },
  { word: 'CLANS', frequency: 2.82e-06, inWordle: false },
  { word: 'CLAPS', frequency: 7.76e-07, inWordle: false },
  { word: 'CLARO', frequency: 2.75e-07, inWordle: false },
  { word: 'CLARY', frequency: 6.03e-07, inWordle: false },
  { word: 'CLAST', frequency: 3.55e-08, inWordle: false },
  { word: 'CLAVE', frequency: 1.78e-07, inWordle: false },
  { word: 'CLAWS', frequency: 3.63e-06, inWordle: false },
  { word: 'CLAYS', frequency: 6.17e-07, inWordle: false },
  { word: 'CLEEK', frequency: 2.04e-08, inWordle: false },
  { word: 'CLEFS', frequency: 4.27e-08, inWordle: false },
  { word: 'CLEMS', frequency: 1.74e-08, inWordle: false },
  { word: 'CLEVE', frequency: 3.89e-07, inWordle: false },
  { word: 'CLEWS', frequency: 6.61e-08, inWordle: false },
  { word: 'CLIFT', frequency: 2.57e-07, inWordle: false },
  { word: 'CLIME', frequency: 8.71e-08, inWordle: false },
  { word: 'CLINE', frequency: 6.92e-07, inWordle: false },
  { word: 'CLINT', frequency: 3.39e-06, inWordle: false },
  { word: 'CLIPS', frequency: 1.1e-05, inWordle: false },
  { word: 'CLITS', frequency: 7.24e-08, inWordle: false },
  { word: 'CLODS', frequency: 1e-07, inWordle: false },
  { word: 'CLOGS', frequency: 6.17e-07, inWordle: false },
  { word: 'CLOKE', frequency: 1e-07, inWordle: false },
  { word: 'CLOMP', frequency: 3.02e-08, inWordle: false },
  { word: 'CLONK', frequency: 2.4e-08, inWordle: false },
  { word: 'CLOPS', frequency: 2.19e-08, inWordle: false },
  { word: 'CLOTS', frequency: 9.33e-07, inWordle: false },
  { word: 'CLOZE', frequency: 3.55e-08, inWordle: false },
  { word: 'CLUBS', frequency: 3.24e-05, inWordle: false },
  { word: 'CLUES', frequency: 6.61e-06, inWordle: false },
  { word: 'CLUNK', frequency: 1.7e-07, inWordle: false },
  { word: 'COADY', frequency: 1.55e-07, inWordle: false },
  { word: 'COALS', frequency: 9.55e-07, inWordle: false },
  { word: 'COATE', frequency: 4.9e-08, inWordle: false },
  { word: 'COATI', frequency: 3.8e-08, inWordle: false },
  { word: 'COATS', frequency: 5.5e-06, inWordle: false },
  { word: 'COBBS', frequency: 1.51e-07, inWordle: false },
  { word: 'COBBY', frequency: 9.77e-08, inWordle: false },
  { word: 'COBIA', frequency: 4.37e-08, inWordle: false },
  { word: 'COBLE', frequency: 1e-07, inWordle: false },
  { word: 'COCCI', frequency: 5.89e-08, inWordle: false },
  { word: 'COCCO', frequency: 5.25e-08, inWordle: false },
  { word: 'COCKS', frequency: 2.88e-06, inWordle: false },
  { word: 'COCKY', frequency: 2.45e-06, inWordle: false },
  { word: 'COCOS', frequency: 3.8e-07, inWordle: false },
  { word: 'CODAS', frequency: 3.16e-08, inWordle: false },
  { word: 'CODEC', frequency: 4.68e-07, inWordle: false },
  { word: 'CODED', frequency: 3.8e-06, inWordle: false },
  { word: 'CODEN', frequency: 2.45e-08, inWordle: false },
  { word: 'CODER', frequency: 4.9e-07, inWordle: false },
  { word: 'CODES', frequency: 1.51e-05, inWordle: false },
  { word: 'CODEX', frequency: 1.51e-06, inWordle: false },
  { word: 'CODON', frequency: 2.82e-07, inWordle: false },
  { word: 'COEDS', frequency: 9.12e-08, inWordle: false },
  { word: 'COFFS', frequency: 1.95e-07, inWordle: false },
  { word: 'COGON', frequency: 1.23e-08, inWordle: false },
  { word: 'COHEN', frequency: 9.55e-06, inWordle: false },
  { word: 'COIFS', frequency: 1.86e-08, inWordle: false },
  { word: 'COILS', frequency: 2.29e-06, inWordle: false },
  { word: 'COINS', frequency: 1.82e-05, inWordle: false },
  { word: 'COKED', frequency: 2e-07, inWordle: false },
  { word: 'COKES', frequency: 3.02e-07, inWordle: false },
  { word: 'COLAS', frequency: 2.95e-07, inWordle: false },
  { word: 'COLBY', frequency: 1.78e-06, inWordle: false },
  { word: 'COLDS', frequency: 9.33e-07, inWordle: false },
  { word: 'COLES', frequency: 1.41e-06, inWordle: false },
  { word: 'COLEY', frequency: 2.51e-07, inWordle: false },
  { word: 'COLIC', frequency: 4.47e-07, inWordle: false },
  { word: 'COLIN', frequency: 1.23e-05, inWordle: false },
  { word: 'COLLS', frequency: 4.79e-08, inWordle: false },
  { word: 'COLLY', frequency: 6.17e-08, inWordle: false },
  { word: 'COLTS', frequency: 4.07e-06, inWordle: false },
  { word: 'COLZA', frequency: 1.17e-08, inWordle: false },
  { word: 'COMAL', frequency: 7.94e-08, inWordle: false },
  { word: 'COMAS', frequency: 2.24e-07, inWordle: false },
  { word: 'COMBE', frequency: 2.88e-07, inWordle: false },
  { word: 'COMBI', frequency: 2.34e-07, inWordle: false },
  { word: 'COMBO', frequency: 6.31e-06, inWordle: false },
  { word: 'COMBS', frequency: 1.48e-06, inWordle: false },
  { word: 'COMER', frequency: 7.24e-07, inWordle: false },
  { word: 'COMES', frequency: 0.000229, inWordle: false },
  { word: 'COMIX', frequency: 1.2e-07, inWordle: false },
  { word: 'COMMO', frequency: 7.24e-08, inWordle: false },
  { word: 'COMMS', frequency: 1.2e-06, inWordle: false },
  { word: 'COMMY', frequency: 2.04e-08, inWordle: false },
  { word: 'COMPO', frequency: 2.14e-07, inWordle: false },
  { word: 'COMPS', frequency: 5.62e-07, inWordle: false },
  { word: 'COMPT', frequency: 1.2e-08, inWordle: false },
  { word: 'COMTE', frequency: 8.13e-07, inWordle: false },
  { word: 'COMUS', frequency: 7.76e-08, inWordle: false },
  { word: 'CONED', frequency: 6.17e-08, inWordle: false },
  { word: 'CONES', frequency: 2.45e-06, inWordle: false },
  { word: 'CONEY', frequency: 1.15e-06, inWordle: false },
  { word: 'CONFS', frequency: 1.12e-08, inWordle: false },
  { word: 'CONGA', frequency: 4.68e-07, inWordle: false },
  { word: 'CONGO', frequency: 5.62e-06, inWordle: false },
  { word: 'CONKS', frequency: 2.88e-08, inWordle: false },
  { word: 'CONKY', frequency: 3.16e-08, inWordle: false },
  { word: 'CONNE', frequency: 4.68e-08, inWordle: false },
  { word: 'CONNS', frequency: 1.41e-08, inWordle: false },
  { word: 'CONTE', frequency: 1.51e-06, inWordle: false },
  { word: 'CONTO', frequency: 4.07e-08, inWordle: false },
  { word: 'CONUS', frequency: 2.14e-07, inWordle: false },
  { word: 'CONVO', frequency: 9.77e-07, inWordle: false },
  { word: 'COOCH', frequency: 2.24e-07, inWordle: false },
  { word: 'COOED', frequency: 1.07e-07, inWordle: false },
  { word: 'COOEE', frequency: 5.62e-08, inWordle: false },
  { word: 'COOEY', frequency: 1.26e-08, inWordle: false },
  { word: 'COOKS', frequency: 4.47e-06, inWordle: false },
  { word: 'COOKY', frequency: 8.51e-08, inWordle: false },
  { word: 'COOLS', frequency: 1.12e-06, inWordle: false },
  { word: 'COOLY', frequency: 9.12e-08, inWordle: false },
  { word: 'COOMB', frequency: 1.23e-08, inWordle: false },
  { word: 'COONS', frequency: 3.31e-07, inWordle: false },
  { word: 'COOPS', frequency: 2.88e-07, inWordle: false },
  { word: 'COOPT', frequency: 3.02e-08, inWordle: false },
  { word: 'COOTS', frequency: 2.51e-07, inWordle: false },
  { word: 'COOZE', frequency: 2.24e-08, inWordle: false },
  { word: 'COPAL', frequency: 5.75e-08, inWordle: false },
  { word: 'COPAY', frequency: 1e-07, inWordle: false },
  { word: 'COPED', frequency: 4.27e-07, inWordle: false },
  { word: 'COPEN', frequency: 2.82e-08, inWordle: false },
  { word: 'COPER', frequency: 2.45e-08, inWordle: false },
  { word: 'COPES', frequency: 2.88e-07, inWordle: false },
  { word: 'COPPY', frequency: 2.51e-08, inWordle: false },
  { word: 'COPRA', frequency: 1.41e-07, inWordle: false },
  { word: 'COQUI', frequency: 3.8e-08, inWordle: false },
  { word: 'CORAM', frequency: 1.95e-07, inWordle: false },
  { word: 'CORBY', frequency: 5.62e-07, inWordle: false },
  { word: 'CORDS', frequency: 2.24e-06, inWordle: false },
  { word: 'CORED', frequency: 1.95e-07, inWordle: false },
  { word: 'CORES', frequency: 3.31e-06, inWordle: false },
  { word: 'COREY', frequency: 5.01e-06, inWordle: false },
  { word: 'CORGI', frequency: 6.76e-07, inWordle: false },
  { word: 'CORIA', frequency: 2.75e-08, inWordle: false },
  { word: 'CORKS', frequency: 3.72e-07, inWordle: false },
  { word: 'CORKY', frequency: 3.8e-07, inWordle: false },
  { word: 'CORMS', frequency: 6.76e-08, inWordle: false },
  { word: 'CORNO', frequency: 3.24e-08, inWordle: false },
  { word: 'CORNS', frequency: 2.82e-07, inWordle: false },
  { word: 'CORNU', frequency: 8.91e-08, inWordle: false },
  { word: 'CORPS', frequency: 1.86e-05, inWordle: false },
  { word: 'CORSE', frequency: 2.45e-07, inWordle: false },
  { word: 'CORSO', frequency: 5.25e-07, inWordle: false },
  { word: 'COSET', frequency: 3.16e-08, inWordle: false },
  { word: 'COSEY', frequency: 3.63e-08, inWordle: false },
  { word: 'COSTA', frequency: 1.41e-05, inWordle: false },
  { word: 'COSTE', frequency: 1.02e-07, inWordle: false },
  { word: 'COSTS', frequency: 9.12e-05, inWordle: false },
  { word: 'COTES', frequency: 1.41e-07, inWordle: false },
  { word: 'COTTA', frequency: 7.08e-07, inWordle: false },
  { word: 'COTTS', frequency: 3.47e-08, inWordle: false },
  { word: 'COUPS', frequency: 7.41e-07, inWordle: false },
  { word: 'COURE', frequency: 1.29e-08, inWordle: false },
  { word: 'COURS', frequency: 3.89e-07, inWordle: false },
  { word: 'COUTH', frequency: 2.88e-08, inWordle: false },
  { word: 'COVED', frequency: 4.9e-08, inWordle: false },
  { word: 'COVES', frequency: 3.09e-07, inWordle: false },
  { word: 'COVIN', frequency: 1.26e-08, inWordle: false },
  { word: 'COWAL', frequency: 2.88e-08, inWordle: false },
  { word: 'COWAN', frequency: 1.51e-06, inWordle: false },
  { word: 'COWED', frequency: 2.51e-07, inWordle: false },
  { word: 'COWLS', frequency: 6.61e-08, inWordle: false },
  { word: 'COWRY', frequency: 2.75e-08, inWordle: false },
  { word: 'COXAE', frequency: 2.57e-08, inWordle: false },
  { word: 'COXAL', frequency: 1.32e-08, inWordle: false },
  { word: 'COXED', frequency: 3.8e-08, inWordle: false },
  { word: 'COXES', frequency: 3.16e-08, inWordle: false },
  { word: 'COYER', frequency: 1.26e-08, inWordle: false },
  { word: 'COYPU', frequency: 1.23e-08, inWordle: false },
  { word: 'COZEN', frequency: 3.31e-08, inWordle: false },
  { word: 'CRABS', frequency: 2.51e-06, inWordle: false },
  { word: 'CRAGS', frequency: 3.31e-07, inWordle: false },
  { word: 'CRAIC', frequency: 1.95e-07, inWordle: false },
  { word: 'CRAIG', frequency: 1.51e-05, inWordle: false },
  { word: 'CRAKE', frequency: 9.12e-08, inWordle: false },
  { word: 'CRAME', frequency: 2.14e-08, inWordle: false },
  { word: 'CRAMS', frequency: 6.92e-08, inWordle: false },
  { word: 'CRANS', frequency: 4.68e-08, inWordle: false },
  { word: 'CRAPE', frequency: 6.76e-08, inWordle: false },
  { word: 'CRAPS', frequency: 6.31e-07, inWordle: false },
  { word: 'CRAPY', frequency: 1.32e-08, inWordle: false },
  { word: 'CRAWS', frequency: 1.51e-08, inWordle: false },
  { word: 'CRAYS', frequency: 1.7e-08, inWordle: false },
  { word: 'CREDS', frequency: 1.26e-07, inWordle: false },
  { word: 'CREEL', frequency: 2.45e-07, inWordle: false },
  { word: 'CREES', frequency: 7.59e-08, inWordle: false },
  { word: 'CREPS', frequency: 1.62e-08, inWordle: false },
  { word: 'CREWE', frequency: 9.12e-07, inWordle: false },
  { word: 'CREWS', frequency: 7.76e-06, inWordle: false },
  { word: 'CRIBS', frequency: 5.13e-07, inWordle: false },
  { word: 'CRIES', frequency: 8.51e-06, inWordle: false },
  { word: 'CRIMS', frequency: 6.92e-08, inWordle: false },
  { word: 'CRINE', frequency: 1.32e-08, inWordle: false },
  { word: 'CRIPE', frequency: 1.62e-08, inWordle: false },
  { word: 'CRIPS', frequency: 3.02e-07, inWordle: false },
  { word: 'CRISE', frequency: 6.61e-08, inWordle: false },
  { word: 'CRITS', frequency: 6.46e-08, inWordle: false },
  { word: 'CROCI', frequency: 1.58e-08, inWordle: false },
  { word: 'CROCS', frequency: 7.41e-07, inWordle: false },
  { word: 'CROFT', frequency: 1.48e-06, inWordle: false },
  { word: 'CROME', frequency: 5.75e-08, inWordle: false },
  { word: 'CRONK', frequency: 1.78e-07, inWordle: false },
  { word: 'CROON', frequency: 1.58e-07, inWordle: false },
  { word: 'CROPS', frequency: 1.12e-05, inWordle: false },
  { word: 'CRORE', frequency: 2.34e-06, inWordle: false },
  { word: 'CROUT', frequency: 1.55e-08, inWordle: false },
  { word: 'CROWS', frequency: 2.95e-06, inWordle: false },
  { word: 'CROZE', frequency: 1.55e-08, inWordle: false },
  { word: 'CRUCK', frequency: 1.55e-08, inWordle: false },
  { word: 'CRUDO', frequency: 5.01e-08, inWordle: false },
  { word: 'CRUES', frequency: 1.58e-08, inWordle: false },
  { word: 'CRUET', frequency: 5.13e-08, inWordle: false },
  { word: 'CRUFT', frequency: 4.9e-08, inWordle: false },
  { word: 'CRUNK', frequency: 1.7e-07, inWordle: false },
  { word: 'CRURA', frequency: 1.45e-08, inWordle: false },
  { word: 'CRUSE', frequency: 1.51e-07, inWordle: false },
  { word: 'CRYER', frequency: 2.19e-07, inWordle: false },
  { word: 'CUBBY', frequency: 3.55e-07, inWordle: false },
  { word: 'CUBEB', frequency: 1.26e-08, inWordle: false },
  { word: 'CUBED', frequency: 3.39e-07, inWordle: false },
  { word: 'CUBER', frequency: 2.69e-08, inWordle: false },
  { word: 'CUBES', frequency: 2.69e-06, inWordle: false },
  { word: 'CUBIT', frequency: 1.17e-07, inWordle: false },
  { word: 'CUDDY', frequency: 3.39e-07, inWordle: false },
  { word: 'CUFFS', frequency: 1.74e-06, inWordle: false },
  { word: 'CUING', frequency: 4.68e-08, inWordle: false },
  { word: 'CUKES', frequency: 2.51e-08, inWordle: false },
  { word: 'CULET', frequency: 1.17e-08, inWordle: false },
  { word: 'CULEX', frequency: 1.23e-07, inWordle: false },
  { word: 'CULLS', frequency: 1.58e-07, inWordle: false },
  { word: 'CULLY', frequency: 1.17e-07, inWordle: false },
  { word: 'CULMS', frequency: 4.57e-08, inWordle: false },
  { word: 'CULPA', frequency: 3.39e-07, inWordle: false },
  { word: 'CULTI', frequency: 1.82e-08, inWordle: false },
  { word: 'CULTS', frequency: 1.41e-06, inWordle: false },
  { word: 'CULTY', frequency: 7.08e-08, inWordle: false },
  { word: 'CUNDY', frequency: 5.37e-08, inWordle: false },
  { word: 'CUNTS', frequency: 2.14e-06, inWordle: false },
  { word: 'CUPID', frequency: 1.58e-06, inWordle: false },
  { word: 'CUPPA', frequency: 5.01e-07, inWordle: false },
  { word: 'CUPPY', frequency: 5.25e-08, inWordle: false },
  { word: 'CURBS', frequency: 6.03e-07, inWordle: false },
  { word: 'CURDS', frequency: 3.02e-07, inWordle: false },
  { word: 'CURDY', frequency: 1.15e-08, inWordle: false },
  { word: 'CURED', frequency: 5.5e-06, inWordle: false },
  { word: 'CURER', frequency: 1.32e-08, inWordle: false },
  { word: 'CURES', frequency: 2.19e-06, inWordle: false },
  { word: 'CURET', frequency: 1.29e-08, inWordle: false },
  { word: 'CURIA', frequency: 3.63e-07, inWordle: false },
  { word: 'CURIE', frequency: 7.59e-07, inWordle: false },
  { word: 'CURLS', frequency: 2.63e-06, inWordle: false },
  { word: 'CURSI', frequency: 1.38e-08, inWordle: false },
  { word: 'CURST', frequency: 2.51e-08, inWordle: false },
  { word: 'CUSHY', frequency: 4.57e-07, inWordle: false },
  { word: 'CUSPS', frequency: 1.58e-07, inWordle: false },
  { word: 'CUTCH', frequency: 1.38e-07, inWordle: false },
  { word: 'CUTER', frequency: 8.51e-07, inWordle: false },
  { word: 'CUTES', frequency: 2.69e-08, inWordle: false },
  { word: 'CUTEY', frequency: 4.57e-08, inWordle: false },
  { word: 'CUTIS', frequency: 4.47e-08, inWordle: false },
  { word: 'CUTTY', frequency: 2.57e-07, inWordle: false },
  { word: 'CUTUP', frequency: 1.62e-08, inWordle: false },
  { word: 'CUVEE', frequency: 7.94e-08, inWordle: false },
  { word: 'CWTCH', frequency: 1.62e-08, inWordle: false },
  { word: 'CYANO', frequency: 5.89e-08, inWordle: false },
  { word: 'CYCAD', frequency: 3.47e-08, inWordle: false },
  { word: 'CYCAS', frequency: 2.51e-08, inWordle: false },
  { word: 'CYCLO', frequency: 1.62e-07, inWordle: false },
  { word: 'CYDER', frequency: 2.4e-08, inWordle: false },
  { word: 'CYMES', frequency: 3.39e-08, inWordle: false },
  { word: 'CYSTS', frequency: 8.13e-07, inWordle: false },
  { word: 'CZARS', frequency: 1.26e-07, inWordle: false },
  { word: 'DABBA', frequency: 7.76e-08, inWordle: false },
  { word: 'DACHA', frequency: 1.41e-07, inWordle: false },
  { word: 'DACKS', frequency: 2.34e-08, inWordle: false },
  { word: 'DADAS', frequency: 1.17e-08, inWordle: false },
  { word: 'DADOS', frequency: 3.39e-08, inWordle: false },
  { word: 'DAFFS', frequency: 2.69e-08, inWordle: false },
  { word: 'DAFFY', frequency: 4.68e-07, inWordle: false },
  { word: 'DAGGA', frequency: 4.68e-08, inWordle: false },
  { word: 'DAGGY', frequency: 2.88e-08, inWordle: false },
  { word: 'DAGOS', frequency: 1.15e-08, inWordle: false },
  { word: 'DAHLS', frequency: 1.07e-08, inWordle: false },
  { word: 'DAINE', frequency: 2.4e-08, inWordle: false },
  { word: 'DALES', frequency: 6.61e-07, inWordle: false },
  { word: 'DALIS', frequency: 2.24e-08, inWordle: false },
  { word: 'DALLE', frequency: 8.32e-08, inWordle: false },
  { word: 'DAMAN', frequency: 1.41e-07, inWordle: false },
  { word: 'DAMAR', frequency: 9.55e-08, inWordle: false },
  { word: 'DAMES', frequency: 9.33e-07, inWordle: false },
  { word: 'DAMME', frequency: 3.09e-07, inWordle: false },
  { word: 'DAMNS', frequency: 1e-07, inWordle: false },
  { word: 'DAMPS', frequency: 5.13e-08, inWordle: false },
  { word: 'DANCY', frequency: 1.58e-07, inWordle: false },
  { word: 'DANGS', frequency: 1.48e-08, inWordle: false },
  { word: 'DANIO', frequency: 2.4e-08, inWordle: false },
  { word: 'DANKS', frequency: 1.2e-07, inWordle: false },
  { word: 'DANNY', frequency: 1.78e-05, inWordle: false },
  { word: 'DARCY', frequency: 2.09e-06, inWordle: false },
  { word: 'DARED', frequency: 3.31e-06, inWordle: false },
  { word: 'DARES', frequency: 1.66e-06, inWordle: false },
  { word: 'DARGA', frequency: 1.35e-08, inWordle: false },
  { word: 'DARIC', frequency: 2.45e-08, inWordle: false },
  { word: 'DARIS', frequency: 2.04e-08, inWordle: false },
  { word: 'DARKS', frequency: 1.15e-07, inWordle: false },
  { word: 'DARKY', frequency: 5.37e-08, inWordle: false },
  { word: 'DARNS', frequency: 1.07e-08, inWordle: false },
  { word: 'DARRE', frequency: 1.45e-08, inWordle: false },
  { word: 'DARTS', frequency: 2.57e-06, inWordle: false },
  { word: 'DARZI', frequency: 3.31e-08, inWordle: false },
  { word: 'DASHI', frequency: 1.1e-07, inWordle: false },
  { word: 'DASHY', frequency: 1.62e-08, inWordle: false },
  { word: 'DATED', frequency: 1.95e-05, inWordle: false },
  { word: 'DATER', frequency: 9.55e-08, inWordle: false },
  { word: 'DATES', frequency: 3.47e-05, inWordle: false },
  { word: 'DATOS', frequency: 4.68e-08, inWordle: false },
  { word: 'DATTO', frequency: 4.79e-08, inWordle: false },
  { word: 'DAUBE', frequency: 3.8e-08, inWordle: false },
  { word: 'DAUBS', frequency: 3.55e-08, inWordle: false },
  { word: 'DAVEN', frequency: 4.07e-08, inWordle: false },
  { word: 'DAVIT', frequency: 7.76e-08, inWordle: false },
  { word: 'DAWAH', frequency: 1.1e-07, inWordle: false },
  { word: 'DAWNS', frequency: 4.37e-07, inWordle: false },
  { word: 'DAYAN', frequency: 2.82e-07, inWordle: false },
  { word: 'DAZED', frequency: 1.35e-06, inWordle: false },
  { word: 'DEADS', frequency: 1.07e-07, inWordle: false },
  { word: 'DEALS', frequency: 3.89e-05, inWordle: false },
  { word: 'DEANS', frequency: 1.15e-06, inWordle: false },
  { word: 'DEARE', frequency: 4.07e-08, inWordle: false },
  { word: 'DEARS', frequency: 2.75e-07, inWordle: false },
  { word: 'DEARY', frequency: 1.38e-07, inWordle: false },
  { word: 'DEBBY', frequency: 4.07e-07, inWordle: false },
  { word: 'DEBES', frequency: 1.86e-08, inWordle: false },
  { word: 'DEBTS', frequency: 9.77e-06, inWordle: false },
  { word: 'DEBUS', frequency: 2.88e-08, inWordle: false },
  { word: 'DEBYE', frequency: 1.02e-07, inWordle: false },
  { word: 'DECAD', frequency: 2.04e-08, inWordle: false },
  { word: 'DECAF', frequency: 4.27e-07, inWordle: false },
  { word: 'DECAN', frequency: 1.86e-08, inWordle: false },
  { word: 'DECKS', frequency: 4.07e-06, inWordle: false },
  { word: 'DECOS', frequency: 1.17e-08, inWordle: false },
  { word: 'DEEDS', frequency: 6.17e-06, inWordle: false },
  { word: 'DEEDY', frequency: 2.24e-08, inWordle: false },
  { word: 'DEELY', frequency: 1.91e-08, inWordle: false },
  { word: 'DEEMS', frequency: 1.26e-06, inWordle: false },
  { word: 'DEEPS', frequency: 1.41e-07, inWordle: false },
  { word: 'DEERE', frequency: 8.13e-07, inWordle: false },
  { word: 'DEERS', frequency: 1.45e-07, inWordle: false },
  { word: 'DEETS', frequency: 2.45e-07, inWordle: false },
  { word: 'DEFFO', frequency: 1.23e-07, inWordle: false },
  { word: 'DEFOG', frequency: 1.07e-08, inWordle: false },
  { word: 'DEGAS', frequency: 4.9e-07, inWordle: false },
  { word: 'DEGUS', frequency: 1.17e-08, inWordle: false },
  { word: 'DEIFY', frequency: 6.61e-08, inWordle: false },
  { word: 'DEISM', frequency: 1.74e-07, inWordle: false },
  { word: 'DEIST', frequency: 1.32e-07, inWordle: false },
  { word: 'DEKED', frequency: 1.02e-08, inWordle: false },
  { word: 'DEKES', frequency: 1.23e-08, inWordle: false },
  { word: 'DEKKO', frequency: 1.23e-08, inWordle: false },
  { word: 'DELES', frequency: 2.45e-08, inWordle: false },
  { word: 'DELFT', frequency: 5.25e-07, inWordle: false },
  { word: 'DELIS', frequency: 1.29e-07, inWordle: false },
  { word: 'DELLS', frequency: 2.34e-07, inWordle: false },
  { word: 'DELLY', frequency: 1.17e-07, inWordle: false },
  { word: 'DELOS', frequency: 3.31e-07, inWordle: false },
  { word: 'DELPH', frequency: 2.45e-07, inWordle: false },
  { word: 'DELTS', frequency: 6.31e-08, inWordle: false },
  { word: 'DEMAN', frequency: 8.91e-08, inWordle: false },
  { word: 'DEMES', frequency: 1.91e-08, inWordle: false },
  { word: 'DEMIC', frequency: 2.4e-08, inWordle: false },
  { word: 'DEMIT', frequency: 1.41e-08, inWordle: false },
  { word: 'DEMOB', frequency: 2.88e-08, inWordle: false },
  { word: 'DEMOS', frequency: 2.51e-06, inWordle: false },
  { word: 'DENAR', frequency: 1.62e-08, inWordle: false },
  { word: 'DENCH', frequency: 3.16e-07, inWordle: false },
  { word: 'DENES', frequency: 4.37e-08, inWordle: false },
  { word: 'DENIS', frequency: 4.17e-06, inWordle: false },
  { word: 'DENTS', frequency: 6.76e-07, inWordle: false },
  { word: 'DEOXY', frequency: 1.02e-07, inWordle: false },
  { word: 'DERAY', frequency: 5.5e-08, inWordle: false },
  { word: 'DERES', frequency: 2.75e-08, inWordle: false },
  { word: 'DERMA', frequency: 1.2e-07, inWordle: false },
  { word: 'DERNY', frequency: 2.19e-08, inWordle: false },
  { word: 'DEROS', frequency: 1.26e-08, inWordle: false },
  { word: 'DERRY', frequency: 1.55e-06, inWordle: false },
  { word: 'DESHI', frequency: 3.89e-08, inWordle: false },
  { word: 'DESIS', frequency: 4.79e-08, inWordle: false },
  { word: 'DESKS', frequency: 2.45e-06, inWordle: false },
  { word: 'DESSE', frequency: 1.38e-08, inWordle: false },
  { word: 'DEVAS', frequency: 1.66e-07, inWordle: false },
  { word: 'DEVEL', frequency: 4.47e-07, inWordle: false },
  { word: 'DEVIS', frequency: 4.07e-08, inWordle: false },
  { word: 'DEVON', frequency: 6.92e-06, inWordle: false },
  { word: 'DEVOS', frequency: 5.5e-07, inWordle: false },
  { word: 'DEWAN', frequency: 3.16e-07, inWordle: false },
  { word: 'DEWAR', frequency: 5.13e-07, inWordle: false },
  { word: 'DHABA', frequency: 5.01e-08, inWordle: false },
  { word: 'DHIKR', frequency: 6.76e-08, inWordle: false },
  { word: 'DHOBI', frequency: 4.68e-08, inWordle: false },
  { word: 'DHOLE', frequency: 3.8e-08, inWordle: false },
  { word: 'DHOTI', frequency: 1e-07, inWordle: false },
  { word: 'DHOWS', frequency: 5.01e-08, inWordle: false },
  { word: 'DIALS', frequency: 1e-06, inWordle: false },
  { word: 'DIANE', frequency: 6.76e-06, inWordle: false },
  { word: 'DIAZO', frequency: 5.13e-08, inWordle: false },
  { word: 'DIBBS', frequency: 4.47e-08, inWordle: false },
  { word: 'DICED', frequency: 1.1e-06, inWordle: false },
  { word: 'DICER', frequency: 6.31e-08, inWordle: false },
  { word: 'DICES', frequency: 1.05e-07, inWordle: false },
  { word: 'DICHT', frequency: 1.05e-08, inWordle: false },
  { word: 'DICKS', frequency: 4.27e-06, inWordle: false },
  { word: 'DICKY', frequency: 5.37e-07, inWordle: false },
  { word: 'DICOT', frequency: 2.57e-08, inWordle: false },
  { word: 'DICTA', frequency: 1.15e-07, inWordle: false },
  { word: 'DIDDY', frequency: 9.33e-07, inWordle: false },
  { word: 'DIDST', frequency: 2.75e-07, inWordle: false },
  { word: 'DIELS', frequency: 9.55e-08, inWordle: false },
  { word: 'DIENE', frequency: 1.23e-07, inWordle: false },
  { word: 'DIETS', frequency: 4.57e-06, inWordle: false },
  { word: 'DIFFS', frequency: 5.37e-08, inWordle: false },
  { word: 'DIGHT', frequency: 2.95e-08, inWordle: false },
  { word: 'DIKED', frequency: 1.2e-08, inWordle: false },
  { word: 'DIKER', frequency: 1.26e-08, inWordle: false },
  { word: 'DIKES', frequency: 3.55e-07, inWordle: false },
  { word: 'DILDO', frequency: 2.51e-06, inWordle: false },
  { word: 'DILLI', frequency: 9.12e-08, inWordle: false },
  { word: 'DILLS', frequency: 3.55e-08, inWordle: false },
  { word: 'DIMER', frequency: 3.55e-07, inWordle: false },
  { word: 'DIMES', frequency: 8.51e-07, inWordle: false },
  { word: 'DIMPS', frequency: 1.91e-08, inWordle: false },
  { word: 'DINAR', frequency: 3.8e-07, inWordle: false },
  { word: 'DINED', frequency: 9.55e-07, inWordle: false },
  { word: 'DINES', frequency: 2.63e-07, inWordle: false },
  { word: 'DINGE', frequency: 4.27e-08, inWordle: false },
  { word: 'DINGS', frequency: 4.37e-07, inWordle: false },
  { word: 'DINKS', frequency: 1.2e-07, inWordle: false },
  { word: 'DINKY', frequency: 4.27e-07, inWordle: false },
  { word: 'DINNA', frequency: 1.02e-07, inWordle: false },
  { word: 'DINOS', frequency: 3.31e-07, inWordle: false },
  { word: 'DIOLS', frequency: 4.17e-08, inWordle: false },
  { word: 'DIPPY', frequency: 1.7e-07, inWordle: false },
  { word: 'DIRER', frequency: 1.12e-08, inWordle: false },
  { word: 'DIRKS', frequency: 1.48e-07, inWordle: false },
  { word: 'DIRTS', frequency: 1.91e-08, inWordle: false },
  { word: 'DISAS', frequency: 1.32e-08, inWordle: false },
  { word: 'DISCI', frequency: 1.2e-08, inWordle: false },
  { word: 'DISCS', frequency: 3.98e-06, inWordle: false },
  { word: 'DISHY', frequency: 6.03e-08, inWordle: false },
  { word: 'DISKS', frequency: 2.45e-06, inWordle: false },
  { word: 'DITES', frequency: 3.89e-08, inWordle: false },
  { word: 'DITSY', frequency: 6.46e-08, inWordle: false },
  { word: 'DITZY', frequency: 1.74e-07, inWordle: false },
  { word: 'DIVAN', frequency: 3.39e-07, inWordle: false },
  { word: 'DIVAS', frequency: 1.12e-06, inWordle: false },
  { word: 'DIVED', frequency: 9.33e-07, inWordle: false },
  { word: 'DIVES', frequency: 2e-06, inWordle: false },
  { word: 'DIVIS', frequency: 7.24e-08, inWordle: false },
  { word: 'DIVOT', frequency: 1.32e-07, inWordle: false },
  { word: 'DIVVY', frequency: 1.66e-07, inWordle: false },
  { word: 'DIWAN', frequency: 1.95e-07, inWordle: false },
  { word: 'DIXIE', frequency: 2.34e-06, inWordle: false },
  { word: 'DIXIT', frequency: 3.39e-07, inWordle: false },
  { word: 'DIYAS', frequency: 5.37e-08, inWordle: false },
  { word: 'DJINN', frequency: 2.95e-07, inWordle: false },
  { word: 'DOATS', frequency: 1.55e-08, inWordle: false },
  { word: 'DOBBY', frequency: 4.27e-07, inWordle: false },
  { word: 'DOBES', frequency: 1.62e-08, inWordle: false },
  { word: 'DOBIE', frequency: 2e-07, inWordle: false },
  { word: 'DOBRA', frequency: 2.45e-08, inWordle: false },
  { word: 'DOBRO', frequency: 1.05e-07, inWordle: false },
  { word: 'DOCKS', frequency: 3.63e-06, inWordle: false },
  { word: 'DODDY', frequency: 2.04e-08, inWordle: false },
  { word: 'DODOS', frequency: 6.31e-08, inWordle: false },
  { word: 'DOERS', frequency: 4.17e-07, inWordle: false },
  { word: 'DOEST', frequency: 1.2e-07, inWordle: false },
  { word: 'DOETH', frequency: 1.05e-07, inWordle: false },
  { word: 'DOFFS', frequency: 2.14e-08, inWordle: false },
  { word: 'DOGAN', frequency: 8.51e-08, inWordle: false },
  { word: 'DOGES', frequency: 8.51e-08, inWordle: false },
  { word: 'DOGGO', frequency: 7.76e-07, inWordle: false },
  { word: 'DOGGY', frequency: 2.14e-06, inWordle: false },
  { word: 'DOGIE', frequency: 1.32e-08, inWordle: false },
  { word: 'DOILY', frequency: 1.29e-07, inWordle: false },
  { word: 'DOJOS', frequency: 6.17e-08, inWordle: false },
  { word: 'DOLCE', frequency: 1.17e-06, inWordle: false },
  { word: 'DOLCI', frequency: 4.37e-08, inWordle: false },
  { word: 'DOLED', frequency: 1.86e-07, inWordle: false },
  { word: 'DOLES', frequency: 1.26e-07, inWordle: false },
  { word: 'DOLLS', frequency: 6.46e-06, inWordle: false },
  { word: 'DOLMA', frequency: 3.55e-08, inWordle: false },
  { word: 'DOLOR', frequency: 1.78e-07, inWordle: false },
  { word: 'DOLTS', frequency: 7.76e-08, inWordle: false },
  { word: 'DOMED', frequency: 7.08e-07, inWordle: false },
  { word: 'DOMES', frequency: 1e-06, inWordle: false },
  { word: 'DONAS', frequency: 2.63e-08, inWordle: false },
  { word: 'DONEE', frequency: 8.91e-08, inWordle: false },
  { word: 'DONER', frequency: 1.38e-07, inWordle: false },
  { word: 'DONGA', frequency: 6.46e-08, inWordle: false },
  { word: 'DONGS', frequency: 2.04e-07, inWordle: false },
  { word: 'DONNA', frequency: 6.92e-06, inWordle: false },
  { word: 'DONNE', frequency: 5.62e-07, inWordle: false },
  { word: 'DONNY', frequency: 1.78e-06, inWordle: false },
  { word: 'DOODY', frequency: 2.04e-07, inWordle: false },
  { word: 'DOOKS', frequency: 1.48e-08, inWordle: false },
  { word: 'DOOLE', frequency: 1.12e-08, inWordle: false },
  { word: 'DOOLY', frequency: 3.89e-08, inWordle: false },
  { word: 'DOOMS', frequency: 1.45e-07, inWordle: false },
  { word: 'DOOMY', frequency: 5.13e-08, inWordle: false },
  { word: 'DOONA', frequency: 7.59e-08, inWordle: false },
  { word: 'DOORN', frequency: 6.61e-08, inWordle: false },
  { word: 'DOORS', frequency: 3.47e-05, inWordle: false },
  { word: 'DOOZY', frequency: 3.02e-07, inWordle: false },
  { word: 'DOPED', frequency: 8.71e-07, inWordle: false },
  { word: 'DOPER', frequency: 7.08e-08, inWordle: false },
  { word: 'DOPES', frequency: 1.26e-07, inWordle: false },
  { word: 'DOREE', frequency: 1.95e-08, inWordle: false },
  { word: 'DORES', frequency: 6.46e-08, inWordle: false },
  { word: 'DORIC', frequency: 3.31e-07, inWordle: false },
  { word: 'DORIS', frequency: 3.8e-06, inWordle: false },
  { word: 'DORKS', frequency: 3.89e-07, inWordle: false },
  { word: 'DORKY', frequency: 5.25e-07, inWordle: false },
  { word: 'DORMS', frequency: 9.77e-07, inWordle: false },
  { word: 'DORMY', frequency: 1.62e-08, inWordle: false },
  { word: 'DORSA', frequency: 4.07e-08, inWordle: false },
  { word: 'DOSAS', frequency: 3.31e-08, inWordle: false },
  { word: 'DOSED', frequency: 4.17e-07, inWordle: false },
  { word: 'DOSER', frequency: 1.62e-08, inWordle: false },
  { word: 'DOSES', frequency: 6.03e-06, inWordle: false },
  { word: 'DOSHA', frequency: 3.39e-08, inWordle: false },
  { word: 'DOTED', frequency: 1.48e-07, inWordle: false },
  { word: 'DOTES', frequency: 1.07e-07, inWordle: false },
  { word: 'DOTTY', frequency: 3.16e-07, inWordle: false },
  { word: 'DOUCE', frequency: 1.45e-07, inWordle: false },
  { word: 'DOULA', frequency: 1.82e-07, inWordle: false },
  { word: 'DOUMA', frequency: 1.74e-07, inWordle: false },
  { word: 'DOURA', frequency: 1.78e-08, inWordle: false },
  { word: 'DOUSE', frequency: 3.89e-07, inWordle: false },
  { word: 'DOVER', frequency: 3.72e-06, inWordle: false },
  { word: 'DOVES', frequency: 1.26e-06, inWordle: false },
  { word: 'DOVIE', frequency: 1.82e-08, inWordle: false },
  { word: 'DOWDS', frequency: 1.35e-08, inWordle: false },
  { word: 'DOWER', frequency: 2.63e-07, inWordle: false },
  { word: 'DOWIE', frequency: 1.15e-07, inWordle: false },
  { word: 'DOWNS', frequency: 8.51e-06, inWordle: false },
  { word: 'DOWSE', frequency: 7.59e-08, inWordle: false },
  { word: 'DOXED', frequency: 3.8e-08, inWordle: false },
  { word: 'DOXIE', frequency: 4.68e-08, inWordle: false },
  { word: 'DOYEN', frequency: 1.78e-07, inWordle: false },
  { word: 'DOZED', frequency: 3.39e-07, inWordle: false },
  { word: 'DOZER', frequency: 2.4e-07, inWordle: false },
  { word: 'DOZES', frequency: 4.68e-08, inWordle: false },
  { word: 'DRABS', frequency: 5.75e-08, inWordle: false },
  { word: 'DRACK', frequency: 1.45e-08, inWordle: false },
  { word: 'DRACO', frequency: 1.1e-06, inWordle: false },
  { word: 'DRAGS', frequency: 1.74e-06, inWordle: false },
  { word: 'DRAMS', frequency: 1.17e-07, inWordle: false },
  { word: 'DRATS', frequency: 2e-08, inWordle: false },
  { word: 'DRAVE', frequency: 1.29e-08, inWordle: false },
  { word: 'DRAWS', frequency: 1.26e-05, inWordle: false },
  { word: 'DRAYS', frequency: 2.95e-08, inWordle: false },
  { word: 'DREAR', frequency: 2.95e-08, inWordle: false },
  { word: 'DRECK', frequency: 7.94e-08, inWordle: false },
  { word: 'DREES', frequency: 4.57e-08, inWordle: false },
  { word: 'DREGS', frequency: 4.17e-07, inWordle: false },
  { word: 'DRENT', frequency: 1.2e-08, inWordle: false },
  { word: 'DREST', frequency: 2.04e-08, inWordle: false },
  { word: 'DRIBS', frequency: 3.47e-08, inWordle: false },
  { word: 'DRIES', frequency: 1.58e-06, inWordle: false },
  { word: 'DRILY', frequency: 9.33e-08, inWordle: false },
  { word: 'DRIPS', frequency: 7.08e-07, inWordle: false },
  { word: 'DROID', frequency: 1.7e-06, inWordle: false },
  { word: 'DROLE', frequency: 1.32e-08, inWordle: false },
  { word: 'DROME', frequency: 5.89e-08, inWordle: false },
  { word: 'DROOG', frequency: 4.07e-08, inWordle: false },
  { word: 'DROPS', frequency: 2.14e-05, inWordle: false },
  { word: 'DROPT', frequency: 1.86e-08, inWordle: false },
  { word: 'DRUGS', frequency: 5.89e-05, inWordle: false },
  { word: 'DRUMS', frequency: 8.51e-06, inWordle: false },
  { word: 'DRUPE', frequency: 4.9e-08, inWordle: false },
  { word: 'DRUSE', frequency: 6.76e-08, inWordle: false },
  { word: 'DRUSY', frequency: 1.95e-08, inWordle: false },
  { word: 'DRYAD', frequency: 1.32e-07, inWordle: false },
  { word: 'DRYAS', frequency: 7.59e-08, inWordle: false },
  { word: 'DUALS', frequency: 1.58e-07, inWordle: false },
  { word: 'DUBBO', frequency: 2.24e-07, inWordle: false },
  { word: 'DUCAL', frequency: 2.45e-07, inWordle: false },
  { word: 'DUCAT', frequency: 9.12e-08, inWordle: false },
  { word: 'DUCES', frequency: 5.89e-08, inWordle: false },
  { word: 'DUCKS', frequency: 7.94e-06, inWordle: false },
  { word: 'DUCKY', frequency: 4.79e-07, inWordle: false },
  { word: 'DUCTS', frequency: 1.29e-06, inWordle: false },
  { word: 'DUDDY', frequency: 1.58e-07, inWordle: false },
  { word: 'DUDES', frequency: 8.91e-06, inWordle: false },
  { word: 'DUELS', frequency: 7.41e-07, inWordle: false },
  { word: 'DUETS', frequency: 6.17e-07, inWordle: false },
  { word: 'DUETT', frequency: 1.17e-08, inWordle: false },
  { word: 'DUFFS', frequency: 4.37e-08, inWordle: false },
  { word: 'DUFUS', frequency: 3.89e-08, inWordle: false },
  { word: 'DUING', frequency: 1.95e-08, inWordle: false },
  { word: 'DUKAS', frequency: 2.88e-08, inWordle: false },
  { word: 'DUKED', frequency: 2.75e-08, inWordle: false },
  { word: 'DUKES', frequency: 1.7e-06, inWordle: false },
  { word: 'DULCE', frequency: 4.68e-07, inWordle: false },
  { word: 'DULIA', frequency: 1.1e-08, inWordle: false },
  { word: 'DULLS', frequency: 1.32e-07, inWordle: false },
  { word: 'DULSE', frequency: 2.82e-08, inWordle: false },
  { word: 'DUMAS', frequency: 7.76e-07, inWordle: false },
  { word: 'DUMBO', frequency: 5.37e-07, inWordle: false },
  { word: 'DUMBS', frequency: 6.17e-08, inWordle: false },
  { word: 'DUMKA', frequency: 3.72e-08, inWordle: false },
  { word: 'DUMPS', frequency: 2.24e-06, inWordle: false },
  { word: 'DUNAM', frequency: 1.17e-08, inWordle: false },
  { word: 'DUNCH', frequency: 1.05e-08, inWordle: false },
  { word: 'DUNES', frequency: 2.34e-06, inWordle: false },
  { word: 'DUNGS', frequency: 1.15e-08, inWordle: false },
  { word: 'DUNGY', frequency: 1.29e-07, inWordle: false },
  { word: 'DUNKS', frequency: 6.31e-07, inWordle: false },
  { word: 'DUNNO', frequency: 5.75e-06, inWordle: false },
  { word: 'DUNNY', frequency: 7.08e-08, inWordle: false },
  { word: 'DUOMO', frequency: 2.75e-07, inWordle: false },
  { word: 'DUPED', frequency: 1.2e-06, inWordle: false },
  { word: 'DUPER', frequency: 7.59e-07, inWordle: false },
  { word: 'DUPES', frequency: 3.02e-07, inWordle: false },
  { word: 'DUPLE', frequency: 4.9e-08, inWordle: false },
  { word: 'DUPPY', frequency: 4.27e-08, inWordle: false },
  { word: 'DURAL', frequency: 1.38e-07, inWordle: false },
  { word: 'DURAS', frequency: 1.48e-07, inWordle: false },
  { word: 'DURES', frequency: 1.1e-08, inWordle: false },
  { word: 'DUROC', frequency: 5.75e-08, inWordle: false },
  { word: 'DUROS', frequency: 2.29e-08, inWordle: false },
  { word: 'DUROY', frequency: 2.29e-08, inWordle: false },
  { word: 'DURRA', frequency: 1.51e-08, inWordle: false },
  { word: 'DURRY', frequency: 1.17e-08, inWordle: false },
  { word: 'DURST', frequency: 5.01e-07, inWordle: false },
  { word: 'DURUM', frequency: 1.2e-07, inWordle: false },
  { word: 'DUSKS', frequency: 1.12e-08, inWordle: false },
  { word: 'DUSTS', frequency: 1.91e-07, inWordle: false },
  { word: 'DWEEB', frequency: 2.34e-07, inWordle: false },
  { word: 'DYADS', frequency: 6.31e-08, inWordle: false },
  { word: 'DYERS', frequency: 1.12e-07, inWordle: false },
  { word: 'DYKES', frequency: 7.76e-07, inWordle: false },
  { word: 'DYNES', frequency: 4.68e-08, inWordle: false },
  { word: 'EALES', frequency: 7.59e-08, inWordle: false },
  { word: 'EARED', frequency: 6.92e-07, inWordle: false },
  { word: 'EARLS', frequency: 7.41e-07, inWordle: false },
  { word: 'EARNS', frequency: 3.63e-06, inWordle: false },
  { word: 'EARNT', frequency: 1.35e-07, inWordle: false },
  { word: 'EASED', frequency: 1.78e-06, inWordle: false },
  { word: 'EASER', frequency: 2.45e-08, inWordle: false },
  { word: 'EASES', frequency: 8.51e-07, inWordle: false },
  { word: 'EASTS', frequency: 1.23e-07, inWordle: false },
  { word: 'EAVES', frequency: 7.08e-07, inWordle: false },
  { word: 'EBBED', frequency: 1.7e-07, inWordle: false },
  { word: 'EBOOK', frequency: 5.13e-06, inWordle: false },
  { word: 'ECHOS', frequency: 2.45e-07, inWordle: false },
  { word: 'EDEMA', frequency: 8.91e-07, inWordle: false },
  { word: 'EDGED', frequency: 3.55e-06, inWordle: false },
  { word: 'EDGER', frequency: 8.13e-08, inWordle: false },
  { word: 'EDGES', frequency: 1.23e-05, inWordle: false },
  { word: 'EDITS', frequency: 2.75e-06, inWordle: false },
  { word: 'EDUCE', frequency: 1.02e-08, inWordle: false },
  { word: 'EEJIT', frequency: 5.89e-08, inWordle: false },
  { word: 'EFFED', frequency: 1.2e-07, inWordle: false },
  { word: 'EGADS', frequency: 3.63e-08, inWordle: false },
  { word: 'EGGAR', frequency: 3.55e-08, inWordle: false },
  { word: 'EGGED', frequency: 3.09e-07, inWordle: false },
  { word: 'EGGER', frequency: 1.1e-07, inWordle: false },
  { word: 'EIDER', frequency: 1.29e-07, inWordle: false },
  { word: 'EIDOS', frequency: 8.91e-08, inWordle: false },
  { word: 'EIKON', frequency: 6.31e-08, inWordle: false },
  { word: 'EISEL', frequency: 2.29e-08, inWordle: false },
  { word: 'EJIDO', frequency: 5.25e-08, inWordle: false },
  { word: 'ELAIN', frequency: 2e-08, inWordle: false },
  { word: 'ELAND', frequency: 1.41e-07, inWordle: false },
  { word: 'ELDIN', frequency: 7.41e-08, inWordle: false },
  { word: 'ELEMI', frequency: 1.15e-08, inWordle: false },
  { word: 'ELFED', frequency: 1.07e-08, inWordle: false },
  { word: 'ELINT', frequency: 2.24e-08, inWordle: false },
  { word: 'ELUTE', frequency: 2.82e-08, inWordle: false },
  { word: 'ELVAN', frequency: 4.79e-08, inWordle: false },
  { word: 'ELVEN', frequency: 4.27e-07, inWordle: false },
  { word: 'ELVER', frequency: 2.4e-08, inWordle: false },
  { word: 'ELVES', frequency: 2.51e-06, inWordle: false },
  { word: 'EMACS', frequency: 2.95e-07, inWordle: false },
  { word: 'EMBAR', frequency: 2.69e-08, inWordle: false },
  { word: 'EMEND', frequency: 6.17e-08, inWordle: false },
  { word: 'EMERG', frequency: 1.48e-07, inWordle: false },
  { word: 'EMERY', frequency: 2e-06, inWordle: false },
  { word: 'EMIRS', frequency: 8.51e-08, inWordle: false },
  { word: 'EMITS', frequency: 1.05e-06, inWordle: false },
  { word: 'EMMAS', frequency: 1.95e-08, inWordle: false },
  { word: 'EMMER', frequency: 1e-07, inWordle: false },
  { word: 'EMMET', frequency: 7.41e-07, inWordle: false },
  { word: 'EMMYS', frequency: 9.33e-07, inWordle: false },
  { word: 'EMOJI', frequency: 1.7e-06, inWordle: false },
  { word: 'EMONG', frequency: 1.05e-08, inWordle: false },
  { word: 'EMOTE', frequency: 2.88e-07, inWordle: false },
  { word: 'EMPTS', frequency: 3.02e-08, inWordle: false },
  { word: 'EMULE', frequency: 1.82e-08, inWordle: false },
  { word: 'ENDED', frequency: 8.32e-05, inWordle: false },
  { word: 'ENDER', frequency: 6.03e-07, inWordle: false },
  { word: 'ENDUE', frequency: 1.26e-08, inWordle: false },
  { word: 'ENEWS', frequency: 8.32e-08, inWordle: false },
  { word: 'ENIAC', frequency: 6.03e-08, inWordle: false },
  { word: 'ENOKI', frequency: 4.79e-08, inWordle: false },
  { word: 'ENROL', frequency: 4.68e-07, inWordle: false },
  { word: 'ENTIA', frequency: 1.12e-08, inWordle: false },
  { word: 'ENURE', frequency: 1.07e-08, inWordle: false },
  { word: 'ENVOI', frequency: 3.02e-08, inWordle: false },
  { word: 'EOSIN', frequency: 7.24e-08, inWordle: false },
  { word: 'EPACT', frequency: 2.34e-08, inWordle: false },
  { word: 'EPHAH', frequency: 2.75e-08, inWordle: false },
  { word: 'EPHOD', frequency: 3.89e-08, inWordle: false },
  { word: 'EPICS', frequency: 8.13e-07, inWordle: false },
  { word: 'EPODE', frequency: 1.51e-08, inWordle: false },
  { word: 'EQUES', frequency: 1.7e-08, inWordle: false },
  { word: 'EQUID', frequency: 1.62e-08, inWordle: false },
  { word: 'ERGON', frequency: 6.46e-08, inWordle: false },
  { word: 'ERGOT', frequency: 1.23e-07, inWordle: false },
  { word: 'ERICA', frequency: 3.63e-06, inWordle: false },
  { word: 'ERICK', frequency: 7.76e-07, inWordle: false },
  { word: 'ERICS', frequency: 2.45e-08, inWordle: false },
  { word: 'ERING', frequency: 2.69e-08, inWordle: false },
  { word: 'ERRED', frequency: 6.46e-07, inWordle: false },
  { word: 'ERVEN', frequency: 2.14e-08, inWordle: false },
  { word: 'ESKER', frequency: 5.37e-08, inWordle: false },
  { word: 'ESSES', frequency: 8.32e-08, inWordle: false },
  { word: 'ESTOP', frequency: 1.78e-08, inWordle: false },
  { word: 'ESTRO', frequency: 3.16e-08, inWordle: false },
  { word: 'ETAGE', frequency: 1.82e-08, inWordle: false },
  { word: 'ETAPE', frequency: 2.04e-08, inWordle: false },
  { word: 'ETATS', frequency: 4.9e-08, inWordle: false },
  { word: 'ETHNE', frequency: 1.95e-08, inWordle: false },
  { word: 'ETHYL', frequency: 8.51e-07, inWordle: false },
  { word: 'ETTIN', frequency: 1.23e-08, inWordle: false },
  { word: 'EUROS', frequency: 6.03e-06, inWordle: false },
  { word: 'EVENS', frequency: 5.13e-07, inWordle: false },
  { word: 'EVERT', frequency: 3.47e-07, inWordle: false },
  { word: 'EVILS', frequency: 2.24e-06, inWordle: false },
  { word: 'EVITE', frequency: 3.55e-08, inWordle: false },
  { word: 'EWERS', frequency: 9.55e-08, inWordle: false },
  { word: 'EXAMS', frequency: 1e-05, inWordle: false },
  { word: 'EXEAT', frequency: 1.15e-08, inWordle: false },
  { word: 'EXECS', frequency: 1.02e-06, inWordle: false },
  { word: 'EXFIL', frequency: 1.62e-08, inWordle: false },
  { word: 'EXITS', frequency: 3.39e-06, inWordle: false },
  { word: 'EXOME', frequency: 8.71e-08, inWordle: false },
  { word: 'EXONS', frequency: 1.74e-07, inWordle: false },
  { word: 'EXPAT', frequency: 1.02e-06, inWordle: false },
  { word: 'EXPOS', frequency: 4.17e-07, inWordle: false },
  { word: 'EXUDE', frequency: 3.31e-07, inWordle: false },
  { word: 'EXURB', frequency: 1.35e-08, inWordle: false },
  { word: 'EYERS', frequency: 1.95e-08, inWordle: false },
  { word: 'EYRES', frequency: 4.07e-08, inWordle: false },
  { word: 'EYRIE', frequency: 1.78e-07, inWordle: false },
  { word: 'EZINE', frequency: 1.1e-07, inWordle: false },
  { word: 'FABBY', frequency: 3.39e-08, inWordle: false },
  { word: 'FACED', frequency: 3.09e-05, inWordle: false },
  { word: 'FACER', frequency: 4.57e-08, inWordle: false },
  { word: 'FACES', frequency: 3.89e-05, inWordle: false },
  { word: 'FACIA', frequency: 5.5e-08, inWordle: false },
  { word: 'FACTA', frequency: 4.68e-08, inWordle: false },
  { word: 'FACTS', frequency: 5.25e-05, inWordle: false },
  { word: 'FADDY', frequency: 2.45e-08, inWordle: false },
  { word: 'FADED', frequency: 5.37e-06, inWordle: false },
  { word: 'FADER', frequency: 3.8e-07, inWordle: false },
  { word: 'FADES', frequency: 2.57e-06, inWordle: false },
  { word: 'FAENA', frequency: 2.88e-08, inWordle: false },
  { word: 'FAERY', frequency: 1.07e-07, inWordle: false },
  { word: 'FAGGY', frequency: 8.71e-08, inWordle: false },
  { word: 'FAGIN', frequency: 1.95e-07, inWordle: false },
  { word: 'FAGOT', frequency: 9.55e-08, inWordle: false },
  { word: 'FAILS', frequency: 1.82e-05, inWordle: false },
  { word: 'FAINE', frequency: 4.47e-08, inWordle: false },
  { word: 'FAIRS', frequency: 2.45e-06, inWordle: false },
  { word: 'FAKED', frequency: 2.24e-06, inWordle: false },
  { word: 'FAKER', frequency: 6.46e-07, inWordle: false },
  { word: 'FAKES', frequency: 1.7e-06, inWordle: false },
  { word: 'FAKEY', frequency: 2.69e-08, inWordle: false },
  { word: 'FAKIE', frequency: 4.17e-08, inWordle: false },
  { word: 'FAKIR', frequency: 1.48e-07, inWordle: false },
  { word: 'FALLS', frequency: 4.27e-05, inWordle: false },
  { word: 'FAMED', frequency: 3.98e-06, inWordle: false },
  { word: 'FAMES', frequency: 4.9e-08, inWordle: false },
  { word: 'FANES', frequency: 1.82e-08, inWordle: false },
  { word: 'FANGO', frequency: 1.55e-08, inWordle: false },
  { word: 'FANGS', frequency: 1.05e-06, inWordle: false },
  { word: 'FANON', frequency: 2.29e-07, inWordle: false },
  { word: 'FAQIR', frequency: 2.51e-08, inWordle: false },
  { word: 'FARAD', frequency: 5.01e-08, inWordle: false },
  { word: 'FARCY', frequency: 1.23e-08, inWordle: false },
  { word: 'FARED', frequency: 1.2e-06, inWordle: false },
  { word: 'FARER', frequency: 1.62e-08, inWordle: false },
  { word: 'FARES', frequency: 4.07e-06, inWordle: false },
  { word: 'FARMS', frequency: 1.38e-05, inWordle: false },
  { word: 'FAROS', frequency: 2.09e-08, inWordle: false },
  { word: 'FARRO', frequency: 1.07e-07, inWordle: false },
  { word: 'FARSE', frequency: 1.32e-08, inWordle: false },
  { word: 'FARTS', frequency: 1.55e-06, inWordle: false },
  { word: 'FASCI', frequency: 3.31e-08, inWordle: false },
  { word: 'FASTI', frequency: 1.15e-07, inWordle: false },
  { word: 'FASTS', frequency: 3.39e-07, inWordle: false },
  { word: 'FATED', frequency: 1.55e-06, inWordle: false },
  { word: 'FATES', frequency: 1.51e-06, inWordle: false },
  { word: 'FATSO', frequency: 1.38e-07, inWordle: false },
  { word: 'FATWA', frequency: 5.01e-07, inWordle: false },
  { word: 'FAUGH', frequency: 1.58e-08, inWordle: false },
  { word: 'FAUNS', frequency: 4.57e-08, inWordle: false },
  { word: 'FAUVE', frequency: 3.8e-08, inWordle: false },
  { word: 'FAVEL', frequency: 1.51e-08, inWordle: false },
  { word: 'FAVER', frequency: 1.55e-08, inWordle: false },
  { word: 'FAVES', frequency: 7.24e-07, inWordle: false },
  { word: 'FAWNS', frequency: 1.51e-07, inWordle: false },
  { word: 'FAXED', frequency: 2.95e-07, inWordle: false },
  { word: 'FAXES', frequency: 2.82e-07, inWordle: false },
  { word: 'FAYED', frequency: 1.78e-07, inWordle: false },
  { word: 'FAYER', frequency: 1.55e-08, inWordle: false },
  { word: 'FAYNE', frequency: 3.8e-08, inWordle: false },
  { word: 'FAYRE', frequency: 2.04e-07, inWordle: false },
  { word: 'FAZED', frequency: 1.82e-07, inWordle: false },
  { word: 'FAZES', frequency: 3.8e-08, inWordle: false },
  { word: 'FEARE', frequency: 2.29e-08, inWordle: false },
  { word: 'FEARS', frequency: 1.48e-05, inWordle: false },
  { word: 'FEART', frequency: 1.29e-08, inWordle: false },
  { word: 'FEATS', frequency: 1.7e-06, inWordle: false },
  { word: 'FECES', frequency: 1.66e-06, inWordle: false },
  { word: 'FECHT', frequency: 1.82e-08, inWordle: false },
  { word: 'FECIT', frequency: 4.9e-08, inWordle: false },
  { word: 'FEDEX', frequency: 2.57e-06, inWordle: false },
  { word: 'FEEDS', frequency: 7.76e-06, inWordle: false },
  { word: 'FEELS', frequency: 7.94e-05, inWordle: false },
  { word: 'FEINT', frequency: 3.31e-07, inWordle: false },
  { word: 'FEIST', frequency: 1.66e-07, inWordle: false },
  { word: 'FELCH', frequency: 3.8e-08, inWordle: false },
  { word: 'FELID', frequency: 2.19e-08, inWordle: false },
  { word: 'FELLS', frequency: 4.17e-07, inWordle: false },
  { word: 'FELLY', frequency: 3.89e-08, inWordle: false },
  { word: 'FELTS', frequency: 1.2e-07, inWordle: false },
  { word: 'FELTY', frequency: 4.47e-08, inWordle: false },
  { word: 'FEMAL', frequency: 2.09e-08, inWordle: false },
  { word: 'FEMMY', frequency: 1.02e-08, inWordle: false },
  { word: 'FENDS', frequency: 1e-07, inWordle: false },
  { word: 'FENNY', frequency: 5.37e-08, inWordle: false },
  { word: 'FERES', frequency: 2.57e-08, inWordle: false },
  { word: 'FERIA', frequency: 1.58e-07, inWordle: false },
  { word: 'FERMI', frequency: 6.76e-07, inWordle: false },
  { word: 'FERNS', frequency: 1.32e-06, inWordle: false },
  { word: 'FERNY', frequency: 7.41e-08, inWordle: false },
  { word: 'FESSE', frequency: 1.86e-08, inWordle: false },
  { word: 'FESTA', frequency: 2.63e-07, inWordle: false },
  { word: 'FESTS', frequency: 2.09e-07, inWordle: false },
  { word: 'FESTY', frequency: 1.23e-08, inWordle: false },
  { word: 'FETED', frequency: 1.58e-07, inWordle: false },
  { word: 'FETES', frequency: 1.2e-07, inWordle: false },
  { word: 'FETTA', frequency: 1.78e-08, inWordle: false },
  { word: 'FEUDS', frequency: 7.76e-07, inWordle: false },
  { word: 'FEYER', frequency: 1.48e-08, inWordle: false },
  { word: 'FIATS', frequency: 5.13e-08, inWordle: false },
  { word: 'FIBRO', frequency: 2.34e-07, inWordle: false },
  { word: 'FICHE', frequency: 5.13e-08, inWordle: false },
  { word: 'FIDES', frequency: 3.63e-07, inWordle: false },
  { word: 'FIEFS', frequency: 1.55e-07, inWordle: false },
  { word: 'FIERE', frequency: 1.62e-08, inWordle: false },
  { word: 'FIERS', frequency: 1.05e-07, inWordle: false },
  { word: 'FIEST', frequency: 1.82e-08, inWordle: false },
  { word: 'FIFER', frequency: 9.77e-08, inWordle: false },
  { word: 'FIFES', frequency: 4.27e-08, inWordle: false },
  { word: 'FIGGY', frequency: 6.76e-08, inWordle: false },
  { word: 'FIKES', frequency: 1.48e-08, inWordle: false },
  { word: 'FILAR', frequency: 1.55e-08, inWordle: false },
  { word: 'FILCH', frequency: 9.33e-08, inWordle: false },
  { word: 'FILED', frequency: 3.09e-05, inWordle: false },
  { word: 'FILES', frequency: 2.88e-05, inWordle: false },
  { word: 'FILII', frequency: 6.31e-08, inWordle: false },
  { word: 'FILLE', frequency: 2.34e-07, inWordle: false },
  { word: 'FILLO', frequency: 1.07e-08, inWordle: false },
  { word: 'FILLS', frequency: 5.13e-06, inWordle: false },
  { word: 'FILMI', frequency: 3.63e-08, inWordle: false },
  { word: 'FILMS', frequency: 4.37e-05, inWordle: false },
  { word: 'FILOS', frequency: 1.29e-08, inWordle: false },
  { word: 'FILUM', frequency: 1.66e-08, inWordle: false },
  { word: 'FINCA', frequency: 1.32e-07, inWordle: false },
  { word: 'FINDS', frequency: 4.07e-05, inWordle: false },
  { word: 'FINED', frequency: 5.01e-06, inWordle: false },
  { word: 'FINES', frequency: 6.03e-06, inWordle: false },
  { word: 'FINIS', frequency: 1.91e-07, inWordle: false },
  { word: 'FINKS', frequency: 1e-07, inWordle: false },
  { word: 'FINNY', frequency: 9.33e-08, inWordle: false },
  { word: 'FINOS', frequency: 1.51e-08, inWordle: false },
  { word: 'FIORD', frequency: 7.41e-08, inWordle: false },
  { word: 'FIRED', frequency: 4.27e-05, inWordle: false },
  { word: 'FIRER', frequency: 3.63e-08, inWordle: false },
  { word: 'FIRES', frequency: 1.48e-05, inWordle: false },
  { word: 'FIRMS', frequency: 2.4e-05, inWordle: false },
  { word: 'FIRTH', frequency: 1.51e-06, inWordle: false },
  { word: 'FISTS', frequency: 2.69e-06, inWordle: false },
  { word: 'FISTY', frequency: 1.74e-08, inWordle: false },
  { word: 'FITCH', frequency: 1.82e-06, inWordle: false },
  { word: 'FITLY', frequency: 2.88e-08, inWordle: false },
  { word: 'FITNA', frequency: 6.03e-08, inWordle: false },
  { word: 'FITTE', frequency: 1.74e-08, inWordle: false },
  { word: 'FITTS', frequency: 1.02e-07, inWordle: false },
  { word: 'FIVER', frequency: 5.13e-07, inWordle: false },
  { word: 'FIVES', frequency: 1.29e-06, inWordle: false },
  { word: 'FIXED', frequency: 5.01e-05, inWordle: false },
  { word: 'FIXES', frequency: 3.89e-06, inWordle: false },
  { word: 'FIXIT', frequency: 9.55e-08, inWordle: false },
  { word: 'FJELD', frequency: 1.29e-08, inWordle: false },
  { word: 'FLAGS', frequency: 1.23e-05, inWordle: false },
  { word: 'FLAKS', frequency: 1.26e-08, inWordle: false },
  { word: 'FLAMM', frequency: 2.63e-08, inWordle: false },
  { word: 'FLAMS', frequency: 1.38e-08, inWordle: false },
  { word: 'FLANS', frequency: 3.31e-08, inWordle: false },
  { word: 'FLAPS', frequency: 1.58e-06, inWordle: false },
  { word: 'FLATS', frequency: 5.89e-06, inWordle: false },
  { word: 'FLAVA', frequency: 2.29e-07, inWordle: false },
  { word: 'FLAWS', frequency: 7.08e-06, inWordle: false },
  { word: 'FLAYS', frequency: 4.57e-08, inWordle: false },
  { word: 'FLEAS', frequency: 1.29e-06, inWordle: false },
  { word: 'FLEEK', frequency: 1.07e-07, inWordle: false },
  { word: 'FLEER', frequency: 7.94e-08, inWordle: false },
  { word: 'FLEES', frequency: 7.59e-07, inWordle: false },
  { word: 'FLEUR', frequency: 9.12e-07, inWordle: false },
  { word: 'FLEXI', frequency: 2.45e-07, inWordle: false },
  { word: 'FLEXO', frequency: 5.62e-08, inWordle: false },
  { word: 'FLICS', frequency: 2.45e-08, inWordle: false },
  { word: 'FLIED', frequency: 1e-07, inWordle: false },
  { word: 'FLIES', frequency: 1.23e-05, inWordle: false },
  { word: 'FLIMS', frequency: 2.24e-08, inWordle: false },
  { word: 'FLIPS', frequency: 1.95e-06, inWordle: false },
  { word: 'FLITE', frequency: 6.76e-08, inWordle: false },
  { word: 'FLITS', frequency: 1.02e-07, inWordle: false },
  { word: 'FLOCS', frequency: 1.82e-08, inWordle: false },
  { word: 'FLOES', frequency: 1.48e-07, inWordle: false },
  { word: 'FLOGS', frequency: 4.07e-08, inWordle: false },
  { word: 'FLOPS', frequency: 2e-06, inWordle: false },
  { word: 'FLORY', frequency: 1.29e-07, inWordle: false },
  { word: 'FLOTA', frequency: 2.4e-08, inWordle: false },
  { word: 'FLOWS', frequency: 1.38e-05, inWordle: false },
  { word: 'FLUBS', frequency: 6.46e-08, inWordle: false },
  { word: 'FLUES', frequency: 7.59e-08, inWordle: false },
  { word: 'FLUKY', frequency: 3.98e-08, inWordle: false },
  { word: 'FLUMP', frequency: 1.29e-08, inWordle: false },
  { word: 'FLUOR', frequency: 1.55e-07, inWordle: false },
  { word: 'FLYBY', frequency: 3.09e-07, inWordle: false },
  { word: 'FLYTE', frequency: 6.03e-08, inWordle: false },
  { word: 'FOALS', frequency: 4.27e-07, inWordle: false },
  { word: 'FOAMS', frequency: 5.75e-07, inWordle: false },
  { word: 'FOEHN', frequency: 3.02e-08, inWordle: false },
  { word: 'FOGEY', frequency: 4.57e-08, inWordle: false },
  { word: 'FOGLE', frequency: 1.35e-07, inWordle: false },
  { word: 'FOILS', frequency: 6.46e-07, inWordle: false },
  { word: 'FOLDS', frequency: 2.69e-06, inWordle: false },
  { word: 'FOLEY', frequency: 3.16e-06, inWordle: false },
  { word: 'FOLIA', frequency: 7.24e-08, inWordle: false },
  { word: 'FOLIC', frequency: 5.13e-07, inWordle: false },
  { word: 'FOLIE', frequency: 1.2e-07, inWordle: false },
  { word: 'FOLKS', frequency: 3.89e-05, inWordle: false },
  { word: 'FOLKY', frequency: 8.91e-08, inWordle: false },
  { word: 'FOMES', frequency: 1.7e-08, inWordle: false },
  { word: 'FONDA', frequency: 9.55e-07, inWordle: false },
  { word: 'FONDS', frequency: 1.58e-07, inWordle: false },
  { word: 'FONDU', frequency: 1.95e-08, inWordle: false },
  { word: 'FONES', frequency: 3.39e-08, inWordle: false },
  { word: 'FONTS', frequency: 1.74e-06, inWordle: false },
  { word: 'FOODS', frequency: 2.57e-05, inWordle: false },
  { word: 'FOODY', frequency: 4.37e-08, inWordle: false },
  { word: 'FOOLS', frequency: 7.59e-06, inWordle: false },
  { word: 'FOOTS', frequency: 1.62e-07, inWordle: false },
  { word: 'FOOTY', frequency: 1.41e-06, inWordle: false },
  { word: 'FORAM', frequency: 2.4e-08, inWordle: false },
  { word: 'FORBS', frequency: 5.89e-08, inWordle: false },
  { word: 'FORBY', frequency: 1.45e-08, inWordle: false },
  { word: 'FORDO', frequency: 1.78e-08, inWordle: false },
  { word: 'FORDS', frequency: 5.5e-07, inWordle: false },
  { word: 'FOREL', frequency: 7.76e-08, inWordle: false },
  { word: 'FORES', frequency: 4.9e-08, inWordle: false },
  { word: 'FOREX', frequency: 4.37e-06, inWordle: false },
  { word: 'FORKS', frequency: 2.82e-06, inWordle: false },
  { word: 'FORKY', frequency: 1.91e-08, inWordle: false },
  { word: 'FORME', frequency: 2.75e-07, inWordle: false },
  { word: 'FORMS', frequency: 5.37e-05, inWordle: false },
  { word: 'FORTS', frequency: 1.7e-06, inWordle: false },
  { word: 'FORZA', frequency: 1.26e-06, inWordle: false },
  { word: 'FORZE', frequency: 1.78e-08, inWordle: false },
  { word: 'FOSSA', frequency: 3.72e-07, inWordle: false },
  { word: 'FOSSE', frequency: 2.69e-07, inWordle: false },
  { word: 'FOULE', frequency: 1.48e-08, inWordle: false },
  { word: 'FOULS', frequency: 1.41e-06, inWordle: false },
  { word: 'FOUNT', frequency: 1.91e-07, inWordle: false },
  { word: 'FOURS', frequency: 1.74e-06, inWordle: false },
  { word: 'FOUTH', frequency: 1.78e-08, inWordle: false },
  { word: 'FOVEA', frequency: 1.05e-07, inWordle: false },
  { word: 'FOWLS', frequency: 1.51e-07, inWordle: false },
  { word: 'FOXED', frequency: 6.61e-08, inWordle: false },
  { word: 'FOXES', frequency: 2.63e-06, inWordle: false },
  { word: 'FOXIE', frequency: 1.23e-08, inWordle: false },
  { word: 'FOYLE', frequency: 4.07e-07, inWordle: false },
  { word: 'FRACK', frequency: 2.75e-07, inWordle: false },
  { word: 'FRAGS', frequency: 8.32e-08, inWordle: false },
  { word: 'FRANC', frequency: 1.29e-06, inWordle: false },
  { word: 'FRAPS', frequency: 5.89e-08, inWordle: false },
  { word: 'FRASS', frequency: 5.62e-08, inWordle: false },
  { word: 'FRATE', frequency: 2.63e-08, inWordle: false },
  { word: 'FRATI', frequency: 2.4e-08, inWordle: false },
  { word: 'FRATS', frequency: 8.13e-08, inWordle: false },
  { word: 'FRAYS', frequency: 5.01e-08, inWordle: false },
  { word: 'FREES', frequency: 1.51e-06, inWordle: false },
  { word: 'FREMD', frequency: 2.04e-08, inWordle: false },
  { word: 'FRENA', frequency: 1.12e-08, inWordle: false },
  { word: 'FREON', frequency: 1.66e-07, inWordle: false },
  { word: 'FRERE', frequency: 2.75e-07, inWordle: false },
  { word: 'FRETS', frequency: 4.47e-07, inWordle: false },
  { word: 'FRIER', frequency: 5.75e-08, inWordle: false },
  { word: 'FRIES', frequency: 6.46e-06, inWordle: false },
  { word: 'FRISE', frequency: 8.91e-08, inWordle: false },
  { word: 'FRIST', frequency: 2.4e-07, inWordle: false },
  { word: 'FRITH', frequency: 3.98e-07, inWordle: false },
  { word: 'FRITS', frequency: 9.77e-08, inWordle: false },
  { word: 'FRIZE', frequency: 1.66e-08, inWordle: false },
  { word: 'FRIZZ', frequency: 2.51e-07, inWordle: false },
  { word: 'FROGS', frequency: 3.63e-06, inWordle: false },
  { word: 'FRONS', frequency: 6.17e-08, inWordle: false },
  { word: 'FROSH', frequency: 1.95e-07, inWordle: false },
  { word: 'FRUMP', frequency: 5.25e-08, inWordle: false },
  { word: 'FRUSH', frequency: 1.1e-08, inWordle: false },
  { word: 'FRYER', frequency: 9.77e-07, inWordle: false },
  { word: 'FUBAR', frequency: 2.09e-07, inWordle: false },
  { word: 'FUCKS', frequency: 7.94e-06, inWordle: false },
  { word: 'FUCUS', frequency: 3.72e-08, inWordle: false },
  { word: 'FUDDY', frequency: 1.15e-07, inWordle: false },
  { word: 'FUDGY', frequency: 5.37e-08, inWordle: false },
  { word: 'FUELS', frequency: 6.61e-06, inWordle: false },
  { word: 'FUERO', frequency: 1.51e-08, inWordle: false },
  { word: 'FUGAL', frequency: 4.57e-08, inWordle: false },
  { word: 'FUGLY', frequency: 2.34e-07, inWordle: false },
  { word: 'FULLS', frequency: 6.46e-08, inWordle: false },
  { word: 'FUMED', frequency: 1.78e-07, inWordle: false },
  { word: 'FUMES', frequency: 2.19e-06, inWordle: false },
  { word: 'FUNDI', frequency: 3.98e-08, inWordle: false },
  { word: 'FUNDS', frequency: 5.5e-05, inWordle: false },
  { word: 'FUNDY', frequency: 2.4e-07, inWordle: false },
  { word: 'FUNGO', frequency: 2.04e-08, inWordle: false },
  { word: 'FUNKS', frequency: 3.89e-08, inWordle: false },
  { word: 'FURAN', frequency: 5.75e-08, inWordle: false },
  { word: 'FURCA', frequency: 1.48e-08, inWordle: false },
  { word: 'FURTH', frequency: 1.26e-07, inWordle: false },
  { word: 'FURZE', frequency: 1e-07, inWordle: false },
  { word: 'FUSED', frequency: 2.51e-06, inWordle: false },
  { word: 'FUSEE', frequency: 3.02e-08, inWordle: false },
  { word: 'FUSEL', frequency: 2.14e-08, inWordle: false },
  { word: 'FUSES', frequency: 1.17e-06, inWordle: false },
  { word: 'FUSIL', frequency: 3.63e-08, inWordle: false },
  { word: 'FUSTY', frequency: 4.57e-08, inWordle: false },
  { word: 'FUTON', frequency: 3.63e-07, inWordle: false },
  { word: 'FUZED', frequency: 1.35e-08, inWordle: false },
  { word: 'FUZES', frequency: 5.62e-08, inWordle: false },
  { word: 'FYLES', frequency: 1.2e-08, inWordle: false },
  { word: 'GABBA', frequency: 3.02e-07, inWordle: false },
  { word: 'GABBY', frequency: 1.45e-06, inWordle: false },
  { word: 'GABLE', frequency: 1.2e-06, inWordle: false },
  { word: 'GADDI', frequency: 3.63e-08, inWordle: false },
  { word: 'GADES', frequency: 3.24e-08, inWordle: false },
  { word: 'GADGE', frequency: 2.34e-08, inWordle: false },
  { word: 'GADIS', frequency: 3.16e-08, inWordle: false },
  { word: 'GAFFS', frequency: 5.13e-08, inWordle: false },
  { word: 'GAGED', frequency: 2.24e-08, inWordle: false },
  { word: 'GAGER', frequency: 1.82e-08, inWordle: false },
  { word: 'GAGES', frequency: 1.15e-07, inWordle: false },
  { word: 'GAINS', frequency: 1.78e-05, inWordle: false },
  { word: 'GAITA', frequency: 2.04e-08, inWordle: false },
  { word: 'GAITS', frequency: 7.59e-08, inWordle: false },
  { word: 'GALAH', frequency: 3.63e-08, inWordle: false },
  { word: 'GALAS', frequency: 1.82e-07, inWordle: false },
  { word: 'GALAX', frequency: 7.94e-08, inWordle: false },
  { word: 'GALEA', frequency: 1.07e-07, inWordle: false },
  { word: 'GALES', frequency: 6.46e-07, inWordle: false },
  { word: 'GALLS', frequency: 2.19e-07, inWordle: false },
  { word: 'GALLY', frequency: 1.55e-07, inWordle: false },
  { word: 'GALOP', frequency: 2.88e-08, inWordle: false },
  { word: 'GALUT', frequency: 1.02e-08, inWordle: false },
  { word: 'GAMAY', frequency: 5.89e-08, inWordle: false },
  { word: 'GAMBA', frequency: 1.91e-07, inWordle: false },
  { word: 'GAMBO', frequency: 2.88e-08, inWordle: false },
  { word: 'GAMED', frequency: 1.78e-07, inWordle: false },
  { word: 'GAMES', frequency: 0.000275, inWordle: false },
  { word: 'GAMEY', frequency: 1.23e-07, inWordle: false },
  { word: 'GAMIN', frequency: 5.01e-08, inWordle: false },
  { word: 'GAMME', frequency: 1.7e-08, inWordle: false },
  { word: 'GAMMY', frequency: 1.38e-07, inWordle: false },
  { word: 'GANDY', frequency: 3.02e-07, inWordle: false },
  { word: 'GANEV', frequency: 1.62e-08, inWordle: false },
  { word: 'GANGS', frequency: 5.37e-06, inWordle: false },
  { word: 'GANJA', frequency: 5.25e-07, inWordle: false },
  { word: 'GANTS', frequency: 2.95e-08, inWordle: false },
  { word: 'GAOLS', frequency: 3.98e-08, inWordle: false },
  { word: 'GAPED', frequency: 1.07e-07, inWordle: false },
  { word: 'GAPER', frequency: 1.62e-08, inWordle: false },
  { word: 'GAPES', frequency: 1.2e-07, inWordle: false },
  { word: 'GAPPY', frequency: 4.17e-08, inWordle: false },
  { word: 'GARBE', frequency: 3.16e-08, inWordle: false },
  { word: 'GARBO', frequency: 3.55e-07, inWordle: false },
  { word: 'GARBS', frequency: 3.16e-08, inWordle: false },
  { word: 'GARDA', frequency: 7.24e-07, inWordle: false },
  { word: 'GARES', frequency: 1.02e-08, inWordle: false },
  { word: 'GARIS', frequency: 6.76e-08, inWordle: false },
  { word: 'GARMS', frequency: 2.95e-08, inWordle: false },
  { word: 'GARNI', frequency: 7.94e-08, inWordle: false },
  { word: 'GARRE', frequency: 1.29e-08, inWordle: false },
  { word: 'GARTH', frequency: 2.04e-06, inWordle: false },
  { word: 'GARUM', frequency: 2.09e-08, inWordle: false },
  { word: 'GASES', frequency: 5.37e-06, inWordle: false },
  { word: 'GASPS', frequency: 8.32e-07, inWordle: false },
  { word: 'GATCH', frequency: 2.75e-08, inWordle: false },
  { word: 'GATED', frequency: 1.7e-06, inWordle: false },
  { word: 'GATER', frequency: 3.09e-08, inWordle: false },
  { word: 'GATES', frequency: 2e-05, inWordle: false },
  { word: 'GATOR', frequency: 1.55e-06, inWordle: false },
  { word: 'GAULT', frequency: 2.88e-07, inWordle: false },
  { word: 'GAUSS', frequency: 6.76e-07, inWordle: false },
  { word: 'GAUZY', frequency: 1.45e-07, inWordle: false },
  { word: 'GAWDS', frequency: 1.35e-08, inWordle: false },
  { word: 'GAWKS', frequency: 1.1e-08, inWordle: false },
  { word: 'GAZAL', frequency: 3.63e-08, inWordle: false },
  { word: 'GAZED', frequency: 6.76e-07, inWordle: false },
  { word: 'GAZES', frequency: 4.07e-07, inWordle: false },
  { word: 'GAZOO', frequency: 5.75e-08, inWordle: false },
  { word: 'GEARS', frequency: 4.68e-06, inWordle: false },
  { word: 'GEATS', frequency: 2.88e-08, inWordle: false },
  { word: 'GEEKS', frequency: 1.86e-06, inWordle: false },
  { word: 'GEEST', frequency: 3.63e-08, inWordle: false },
  { word: 'GEIST', frequency: 3.72e-07, inWordle: false },
  { word: 'GELEE', frequency: 1.66e-08, inWordle: false },
  { word: 'GELID', frequency: 2.04e-08, inWordle: false },
  { word: 'GELLY', frequency: 3.72e-08, inWordle: false },
  { word: 'GEMMA', frequency: 2.14e-06, inWordle: false },
  { word: 'GEMMY', frequency: 1.86e-08, inWordle: false },
  { word: 'GENAL', frequency: 2.75e-08, inWordle: false },
  { word: 'GENES', frequency: 1.38e-05, inWordle: false },
  { word: 'GENET', frequency: 2.63e-07, inWordle: false },
  { word: 'GENIC', frequency: 4.17e-08, inWordle: false },
  { word: 'GENII', frequency: 1.74e-07, inWordle: false },
  { word: 'GENNY', frequency: 1.48e-07, inWordle: false },
  { word: 'GENOA', frequency: 1.51e-06, inWordle: false },
  { word: 'GENOM', frequency: 3.16e-08, inWordle: false },
  { word: 'GENRO', frequency: 1.7e-08, inWordle: false },
  { word: 'GENTS', frequency: 1.41e-06, inWordle: false },
  { word: 'GENUA', frequency: 2.09e-08, inWordle: false },
  { word: 'GENUS', frequency: 5.37e-06, inWordle: false },
  { word: 'GEODE', frequency: 1.15e-07, inWordle: false },
  { word: 'GEOID', frequency: 6.03e-08, inWordle: false },
  { word: 'GERBE', frequency: 3.47e-08, inWordle: false },
  { word: 'GERMS', frequency: 2.45e-06, inWordle: false },
  { word: 'GERMY', frequency: 4.27e-08, inWordle: false },
  { word: 'GERNE', frequency: 1.91e-08, inWordle: false },
  { word: 'GESSO', frequency: 9.55e-08, inWordle: false },
  { word: 'GESTE', frequency: 1.12e-07, inWordle: false },
  { word: 'GETUP', frequency: 3.16e-07, inWordle: false },
  { word: 'GEYER', frequency: 2.75e-07, inWordle: false },
  { word: 'GHAST', frequency: 3.31e-08, inWordle: false },
  { word: 'GHATS', frequency: 2.63e-07, inWordle: false },
  { word: 'GHAUT', frequency: 2.24e-08, inWordle: false },
  { word: 'GHAZI', frequency: 4.9e-07, inWordle: false },
  { word: 'GHYLL', frequency: 2.09e-08, inWordle: false },
  { word: 'GIBES', frequency: 3.63e-08, inWordle: false },
  { word: 'GIBUS', frequency: 1.95e-08, inWordle: false },
  { word: 'GIFTS', frequency: 2.4e-05, inWordle: false },
  { word: 'GIGAS', frequency: 1.32e-07, inWordle: false },
  { word: 'GIGOT', frequency: 2.57e-08, inWordle: false },
  { word: 'GIGUE', frequency: 2.45e-08, inWordle: false },
  { word: 'GILAS', frequency: 6.17e-08, inWordle: false },
  { word: 'GILDS', frequency: 3.8e-08, inWordle: false },
  { word: 'GILET', frequency: 7.94e-08, inWordle: false },
  { word: 'GILLS', frequency: 1.15e-06, inWordle: false },
  { word: 'GILLY', frequency: 4.07e-07, inWordle: false },
  { word: 'GILTS', frequency: 2.04e-07, inWordle: false },
  { word: 'GIMEL', frequency: 2.14e-08, inWordle: false },
  { word: 'GIMME', frequency: 3.72e-06, inWordle: false },
  { word: 'GIMPS', frequency: 5.89e-08, inWordle: false },
  { word: 'GIMPY', frequency: 7.76e-08, inWordle: false },
  { word: 'GINGE', frequency: 5.62e-08, inWordle: false },
  { word: 'GINNY', frequency: 9.55e-07, inWordle: false },
  { word: 'GIPPY', frequency: 1.48e-08, inWordle: false },
  { word: 'GIRDS', frequency: 2.75e-08, inWordle: false },
  { word: 'GIRLS', frequency: 0.000148, inWordle: false },
  { word: 'GIRON', frequency: 8.71e-08, inWordle: false },
  { word: 'GIROS', frequency: 1.55e-08, inWordle: false },
  { word: 'GIRTS', frequency: 1.23e-08, inWordle: false },
  { word: 'GISMO', frequency: 1.95e-08, inWordle: false },
  { word: 'GISTS', frequency: 6.76e-08, inWordle: false },
  { word: 'GITES', frequency: 1.1e-08, inWordle: false },
  { word: 'GIVED', frequency: 2e-08, inWordle: false },
  { word: 'GIVES', frequency: 0.000107, inWordle: false },
  { word: 'GIZMO', frequency: 4.07e-07, inWordle: false },
  { word: 'GLACE', frequency: 1.86e-07, inWordle: false },
  { word: 'GLADS', frequency: 3.31e-08, inWordle: false },
  { word: 'GLADY', frequency: 4.17e-08, inWordle: false },
  { word: 'GLAMS', frequency: 1.41e-08, inWordle: false },
  { word: 'GLANS', frequency: 2.63e-07, inWordle: false },
  { word: 'GLARY', frequency: 1.26e-08, inWordle: false },
  { word: 'GLEBA', frequency: 1.82e-08, inWordle: false },
  { word: 'GLEBE', frequency: 4.27e-07, inWordle: false },
  { word: 'GLEED', frequency: 1.82e-08, inWordle: false },
  { word: 'GLEEK', frequency: 2.95e-08, inWordle: false },
  { word: 'GLEES', frequency: 4.17e-08, inWordle: false },
  { word: 'GLEIS', frequency: 1.02e-08, inWordle: false },
  { word: 'GLENS', frequency: 4.57e-07, inWordle: false },
  { word: 'GLIAL', frequency: 2.88e-07, inWordle: false },
  { word: 'GLITZ', frequency: 4.57e-07, inWordle: false },
  { word: 'GLOBS', frequency: 8.13e-08, inWordle: false },
  { word: 'GLOOP', frequency: 8.13e-08, inWordle: false },
  { word: 'GLOWS', frequency: 8.51e-07, inWordle: false },
  { word: 'GLUED', frequency: 2.57e-06, inWordle: false },
  { word: 'GLUER', frequency: 1.32e-08, inWordle: false },
  { word: 'GLUES', frequency: 2.63e-07, inWordle: false },
  { word: 'GLUEY', frequency: 4.79e-08, inWordle: false },
  { word: 'GLUGS', frequency: 1.41e-08, inWordle: false },
  { word: 'GLUME', frequency: 2.45e-08, inWordle: false },
  { word: 'GLUON', frequency: 1.45e-07, inWordle: false },
  { word: 'GLUTE', frequency: 1.2e-07, inWordle: false },
  { word: 'GLUTS', frequency: 4.27e-08, inWordle: false },
  { word: 'GNARL', frequency: 1.7e-08, inWordle: false },
  { word: 'GNARR', frequency: 1.38e-08, inWordle: false },
  { word: 'GNATS', frequency: 2.88e-07, inWordle: false },
  { word: 'GNAWS', frequency: 8.91e-08, inWordle: false },
  { word: 'GOADS', frequency: 8.13e-08, inWordle: false },
  { word: 'GOALS', frequency: 8.91e-05, inWordle: false },
  { word: 'GOATS', frequency: 5.25e-06, inWordle: false },
  { word: 'GOATY', frequency: 1.91e-08, inWordle: false },
  { word: 'GOBAR', frequency: 2.95e-08, inWordle: false },
  { word: 'GOBBI', frequency: 5.75e-08, inWordle: false },
  { word: 'GOBBO', frequency: 3.24e-08, inWordle: false },
  { word: 'GOBBY', frequency: 6.31e-08, inWordle: false },
  { word: 'GOBOS', frequency: 1.74e-08, inWordle: false },
  { word: 'GODET', frequency: 3.31e-08, inWordle: false },
  { word: 'GOERS', frequency: 1.23e-06, inWordle: false },
  { word: 'GOEST', frequency: 5.62e-08, inWordle: false },
  { word: 'GOETH', frequency: 1.7e-07, inWordle: false },
  { word: 'GOFER', frequency: 4.9e-08, inWordle: false },
  { word: 'GOFFS', frequency: 2.63e-08, inWordle: false },
  { word: 'GOGOS', frequency: 2e-08, inWordle: false },
  { word: 'GOLDS', frequency: 1.35e-06, inWordle: false },
  { word: 'GOLDY', frequency: 2.24e-07, inWordle: false },
  { word: 'GOLES', frequency: 1.45e-08, inWordle: false },
  { word: 'GOLFS', frequency: 9.33e-08, inWordle: false },
  { word: 'GOLPE', frequency: 2.34e-08, inWordle: false },
  { word: 'GOMBO', frequency: 1.15e-08, inWordle: false },
  { word: 'GOMER', frequency: 2.14e-07, inWordle: false },
  { word: 'GOMPA', frequency: 4.47e-08, inWordle: false },
  { word: 'GONGS', frequency: 2.82e-07, inWordle: false },
  { word: 'GONNA', frequency: 0.000195, inWordle: false },
  { word: 'GONZO', frequency: 6.31e-07, inWordle: false },
  { word: 'GOOBY', frequency: 3.55e-08, inWordle: false },
  { word: 'GOODS', frequency: 3.98e-05, inWordle: false },
  { word: 'GOOFS', frequency: 1.55e-07, inWordle: false },
  { word: 'GOOKS', frequency: 4.57e-08, inWordle: false },
  { word: 'GOOLD', frequency: 1.12e-07, inWordle: false },
  { word: 'GOONS', frequency: 1.62e-06, inWordle: false },
  { word: 'GOONY', frequency: 2.57e-08, inWordle: false },
  { word: 'GOOPY', frequency: 7.59e-08, inWordle: false },
  { word: 'GOOSY', frequency: 1.02e-08, inWordle: false },
  { word: 'GORAL', frequency: 2.63e-08, inWordle: false },
  { word: 'GORAS', frequency: 1.32e-08, inWordle: false },
  { word: 'GORED', frequency: 1.7e-07, inWordle: false },
  { word: 'GORES', frequency: 1.26e-07, inWordle: false },
  { word: 'GORIS', frequency: 1.86e-08, inWordle: false },
  { word: 'GORSE', frequency: 2.24e-07, inWordle: false },
  { word: 'GOSHT', frequency: 1.66e-08, inWordle: false },
  { word: 'GOSSE', frequency: 1.26e-07, inWordle: false },
  { word: 'GOTCH', frequency: 1.45e-07, inWordle: false },
  { word: 'GOTHS', frequency: 5.75e-07, inWordle: false },
  { word: 'GOTHY', frequency: 1.95e-08, inWordle: false },
  { word: 'GOTTA', frequency: 8.91e-05, inWordle: false },
  { word: 'GOUTS', frequency: 1.95e-08, inWordle: false },
  { word: 'GOUTY', frequency: 5.89e-08, inWordle: false },
  { word: 'GOWAN', frequency: 1.74e-07, inWordle: false },
  { word: 'GOWNS', frequency: 1.78e-06, inWordle: false },
  { word: 'GOYIM', frequency: 1.17e-07, inWordle: false },
  { word: 'GOYLE', frequency: 4.27e-08, inWordle: false },
  { word: 'GRAAL', frequency: 6.61e-08, inWordle: false },
  { word: 'GRABS', frequency: 5.37e-06, inWordle: false },
  { word: 'GRADS', frequency: 8.51e-07, inWordle: false },
  { word: 'GRAFF', frequency: 6.31e-07, inWordle: false },
  { word: 'GRAMA', frequency: 1.74e-07, inWordle: false },
  { word: 'GRAMP', frequency: 2.57e-08, inWordle: false },
  { word: 'GRAMS', frequency: 6.61e-06, inWordle: false },
  { word: 'GRANA', frequency: 9.77e-08, inWordle: false },
  { word: 'GRANS', frequency: 4.79e-08, inWordle: false },
  { word: 'GRAYS', frequency: 6.76e-07, inWordle: false },
  { word: 'GREBE', frequency: 1.62e-07, inWordle: false },
  { word: 'GREBO', frequency: 1.41e-08, inWordle: false },
  { word: 'GRECE', frequency: 2.69e-08, inWordle: false },
  { word: 'GREEK', frequency: 3.16e-05, inWordle: false },
  { word: 'GREES', frequency: 1.2e-08, inWordle: false },
  { word: 'GREGO', frequency: 3.55e-08, inWordle: false },
  { word: 'GREIN', frequency: 2.19e-08, inWordle: false },
  { word: 'GRENS', frequency: 1.7e-08, inWordle: false },
  { word: 'GRESE', frequency: 2e-08, inWordle: false },
  { word: 'GREVE', frequency: 1.26e-07, inWordle: false },
  { word: 'GREYS', frequency: 7.08e-07, inWordle: false },
  { word: 'GRICE', frequency: 2.19e-07, inWordle: false },
  { word: 'GRIDS', frequency: 1.35e-06, inWordle: false },
  { word: 'GRIFF', frequency: 4.68e-07, inWordle: false },
  { word: 'GRIFT', frequency: 1.91e-07, inWordle: false },
  { word: 'GRINS', frequency: 6.61e-07, inWordle: false },
  { word: 'GRIOT', frequency: 5.62e-08, inWordle: false },
  { word: 'GRIPS', frequency: 2.95e-06, inWordle: false },
  { word: 'GRISE', frequency: 7.24e-08, inWordle: false },
  { word: 'GRIST', frequency: 4.79e-07, inWordle: false },
  { word: 'GRITS', frequency: 8.51e-07, inWordle: false },
  { word: 'GROAT', frequency: 1.29e-07, inWordle: false },
  { word: 'GRODY', frequency: 5.25e-08, inWordle: false },
  { word: 'GROGS', frequency: 1.38e-08, inWordle: false },
  { word: 'GROSZ', frequency: 1.17e-07, inWordle: false },
  { word: 'GROTS', frequency: 1.62e-08, inWordle: false },
  { word: 'GROWS', frequency: 1.51e-05, inWordle: false },
  { word: 'GRRRL', frequency: 9.33e-08, inWordle: false },
  { word: 'GRUBS', frequency: 3.02e-07, inWordle: false },
  { word: 'GRUMP', frequency: 1.95e-07, inWordle: false },
  { word: 'GRUND', frequency: 7.08e-08, inWordle: false },
  { word: 'GRYCE', frequency: 3.72e-08, inWordle: false },
  { word: 'GUANA', frequency: 3.31e-08, inWordle: false },
  { word: 'GUANO', frequency: 4.07e-07, inWordle: false },
  { word: 'GUIDS', frequency: 1.51e-08, inWordle: false },
  { word: 'GULAG', frequency: 7.08e-07, inWordle: false },
  { word: 'GULAR', frequency: 5.37e-08, inWordle: false },
  { word: 'GULES', frequency: 1.62e-07, inWordle: false },
  { word: 'GULET', frequency: 1.82e-08, inWordle: false },
  { word: 'GULFS', frequency: 9.55e-08, inWordle: false },
  { word: 'GULLS', frequency: 1e-06, inWordle: false },
  { word: 'GULPH', frequency: 1.7e-08, inWordle: false },
  { word: 'GULPS', frequency: 2.19e-07, inWordle: false },
  { word: 'GUMMA', frequency: 2.19e-08, inWordle: false },
  { word: 'GUMMI', frequency: 2e-07, inWordle: false },
  { word: 'GUMPS', frequency: 2.34e-08, inWordle: false },
  { word: 'GUNDY', frequency: 3.02e-07, inWordle: false },
  { word: 'GUNGE', frequency: 7.59e-08, inWordle: false },
  { word: 'GUNKY', frequency: 2.63e-08, inWordle: false },
  { word: 'GUNNY', frequency: 2e-07, inWordle: false },
  { word: 'GUQIN', frequency: 1.2e-08, inWordle: false },
  { word: 'GURDY', frequency: 1.1e-07, inWordle: false },
  { word: 'GURLS', frequency: 9.33e-08, inWordle: false },
  { word: 'GURRY', frequency: 2.95e-08, inWordle: false },
  { word: 'GURUS', frequency: 9.77e-07, inWordle: false },
  { word: 'GUSHY', frequency: 9.12e-08, inWordle: false },
  { word: 'GUSSY', frequency: 5.25e-08, inWordle: false },
  { word: 'GUSTS', frequency: 1.41e-06, inWordle: false },
  { word: 'GUTSY', frequency: 5.37e-07, inWordle: false },
  { word: 'GUTTA', frequency: 2.34e-07, inWordle: false },
  { word: 'GUTTY', frequency: 2.69e-08, inWordle: false },
  { word: 'GUYED', frequency: 3.31e-08, inWordle: false },
  { word: 'GUYOT', frequency: 1.12e-07, inWordle: false },
  { word: 'GUYSE', frequency: 1.12e-08, inWordle: false },
  { word: 'GWINE', frequency: 2.34e-08, inWordle: false },
  { word: 'GYNAE', frequency: 2.82e-08, inWordle: false },
  { word: 'GYOZA', frequency: 8.32e-08, inWordle: false },
  { word: 'GYRES', frequency: 5.89e-08, inWordle: false },
  { word: 'GYROS', frequency: 1.95e-07, inWordle: false },
  { word: 'GYRUS', frequency: 3.47e-07, inWordle: false },
  { word: 'HABLE', frequency: 1.78e-08, inWordle: false },
  { word: 'HACKS', frequency: 2.82e-06, inWordle: false },
  { word: 'HADAL', frequency: 1.7e-08, inWordle: false },
  { word: 'HADES', frequency: 1.58e-06, inWordle: false },
  { word: 'HADJI', frequency: 1.7e-07, inWordle: false },
  { word: 'HADST', frequency: 6.92e-08, inWordle: false },
  { word: 'HAFIZ', frequency: 5.37e-07, inWordle: false },
  { word: 'HAFTS', frequency: 1.05e-08, inWordle: false },
  { word: 'HAGGS', frequency: 1.29e-08, inWordle: false },
  { word: 'HAIKU', frequency: 1.2e-06, inWordle: false },
  { word: 'HAILS', frequency: 1.35e-06, inWordle: false },
  { word: 'HAILY', frequency: 1.07e-08, inWordle: false },
  { word: 'HAINS', frequency: 4.57e-08, inWordle: false },
  { word: 'HAINT', frequency: 1.95e-08, inWordle: false },
  { word: 'HAIRS', frequency: 5.89e-06, inWordle: false },
  { word: 'HAITH', frequency: 2.57e-08, inWordle: false },
  { word: 'HAJIS', frequency: 1.62e-08, inWordle: false },
  { word: 'HAJJI', frequency: 1.45e-07, inWordle: false },
  { word: 'HAKAM', frequency: 6.46e-08, inWordle: false },
  { word: 'HAKEA', frequency: 4.37e-08, inWordle: false },
  { word: 'HAKES', frequency: 1.58e-08, inWordle: false },
  { word: 'HAKIM', frequency: 6.92e-07, inWordle: false },
  { word: 'HALAL', frequency: 1.41e-06, inWordle: false },
  { word: 'HALED', frequency: 2.09e-08, inWordle: false },
  { word: 'HALER', frequency: 1.58e-08, inWordle: false },
  { word: 'HALES', frequency: 7.76e-07, inWordle: false },
  { word: 'HALFA', frequency: 7.41e-08, inWordle: false },
  { word: 'HALFS', frequency: 6.76e-08, inWordle: false },
  { word: 'HALLO', frequency: 5.62e-07, inWordle: false },
  { word: 'HALLS', frequency: 7.08e-06, inWordle: false },
  { word: 'HALMA', frequency: 1.95e-08, inWordle: false },
  { word: 'HALON', frequency: 8.13e-08, inWordle: false },
  { word: 'HALOS', frequency: 4.47e-07, inWordle: false },
  { word: 'HALSE', frequency: 5.62e-08, inWordle: false },
  { word: 'HALTS', frequency: 7.24e-07, inWordle: false },
  { word: 'HALVA', frequency: 3.63e-08, inWordle: false },
  { word: 'HALWA', frequency: 8.91e-08, inWordle: false },
  { word: 'HAMAL', frequency: 3.24e-08, inWordle: false },
  { word: 'HAMBA', frequency: 1.95e-08, inWordle: false },
  { word: 'HAMED', frequency: 2.51e-07, inWordle: false },
  { word: 'HAMES', frequency: 1.15e-07, inWordle: false },
  { word: 'HAMMY', frequency: 3.55e-07, inWordle: false },
  { word: 'HAMZA', frequency: 7.76e-07, inWordle: false },
  { word: 'HANCE', frequency: 1.1e-07, inWordle: false },
  { word: 'HANDS', frequency: 0.000145, inWordle: false },
  { word: 'HANGI', frequency: 2.29e-08, inWordle: false },
  { word: 'HANGS', frequency: 5.01e-06, inWordle: false },
  { word: 'HANKS', frequency: 1.66e-06, inWordle: false },
  { word: 'HANKY', frequency: 2.34e-07, inWordle: false },
  { word: 'HANSA', frequency: 1.7e-07, inWordle: false },
  { word: 'HANSE', frequency: 1.2e-07, inWordle: false },
  { word: 'HANTS', frequency: 2.57e-07, inWordle: false },
  { word: 'HAOLE', frequency: 6.92e-08, inWordle: false },
  { word: 'HAOMA', frequency: 1.07e-08, inWordle: false },
  { word: 'HAPAX', frequency: 1.95e-08, inWordle: false },
  { word: 'HAPLY', frequency: 6.92e-08, inWordle: false },
  { word: 'HAPPI', frequency: 4.9e-08, inWordle: false },
  { word: 'HARAM', frequency: 2.69e-06, inWordle: false },
  { word: 'HARDS', frequency: 1.82e-07, inWordle: false },
  { word: 'HARED', frequency: 1.82e-08, inWordle: false },
  { word: 'HARES', frequency: 6.17e-07, inWordle: false },
  { word: 'HARIM', frequency: 3.16e-08, inWordle: false },
  { word: 'HARKS', frequency: 1.17e-07, inWordle: false },
  { word: 'HARMS', frequency: 1.95e-06, inWordle: false },
  { word: 'HARPS', frequency: 3.8e-07, inWordle: false },
  { word: 'HARTS', frequency: 1.86e-07, inWordle: false },
  { word: 'HASTA', frequency: 3.63e-07, inWordle: false },
  { word: 'HATED', frequency: 1.58e-05, inWordle: false },
  { word: 'HATES', frequency: 1.41e-05, inWordle: false },
  { word: 'HATHA', frequency: 1.58e-07, inWordle: false },
  { word: 'HAUGH', frequency: 1.35e-07, inWordle: false },
  { word: 'HAULS', frequency: 6.92e-07, inWordle: false },
  { word: 'HAULT', frequency: 1.95e-08, inWordle: false },
  { word: 'HAUSE', frequency: 7.41e-08, inWordle: false },
  { word: 'HAVER', frequency: 1.62e-07, inWordle: false },
  { word: 'HAVES', frequency: 8.91e-07, inWordle: false },
  { word: 'HAWED', frequency: 3.24e-08, inWordle: false },
  { word: 'HAWKS', frequency: 7.76e-06, inWordle: false },
  { word: 'HAWSE', frequency: 2.29e-08, inWordle: false },
  { word: 'HAYER', frequency: 2e-08, inWordle: false },
  { word: 'HAYLE', frequency: 9.77e-08, inWordle: false },
  { word: 'HAZAN', frequency: 9.12e-08, inWordle: false },
  { word: 'HAZED', frequency: 1.15e-07, inWordle: false },
  { word: 'HAZER', frequency: 1.35e-08, inWordle: false },
  { word: 'HAZES', frequency: 3.47e-08, inWordle: false },
  { word: 'HEADS', frequency: 4.68e-05, inWordle: false },
  { word: 'HEALD', frequency: 2.19e-07, inWordle: false },
  { word: 'HEALS', frequency: 2.09e-06, inWordle: false },
  { word: 'HEAPS', frequency: 2.04e-06, inWordle: false },
  { word: 'HEARE', frequency: 2.63e-08, inWordle: false },
  { word: 'HEARS', frequency: 6.03e-06, inWordle: false },
  { word: 'HEATS', frequency: 2.57e-06, inWordle: false },
  { word: 'HEBEN', frequency: 1.7e-08, inWordle: false },
  { word: 'HEBES', frequency: 2.4e-08, inWordle: false },
  { word: 'HECHT', frequency: 3.98e-07, inWordle: false },
  { word: 'HECKS', frequency: 2.95e-08, inWordle: false },
  { word: 'HEDER', frequency: 3.89e-08, inWordle: false },
  { word: 'HEEDS', frequency: 9.12e-08, inWordle: false },
  { word: 'HEELS', frequency: 1.15e-05, inWordle: false },
  { word: 'HEEZE', frequency: 1.05e-08, inWordle: false },
  { word: 'HEFTE', frequency: 1.74e-08, inWordle: false },
  { word: 'HEIGH', frequency: 1.07e-07, inWordle: false },
  { word: 'HEIRS', frequency: 3.24e-06, inWordle: false },
  { word: 'HELIO', frequency: 2.24e-07, inWordle: false },
  { word: 'HELLS', frequency: 1.17e-06, inWordle: false },
  { word: 'HELMS', frequency: 7.76e-07, inWordle: false },
  { word: 'HELOS', frequency: 6.03e-08, inWordle: false },
  { word: 'HELOT', frequency: 2e-08, inWordle: false },
  { word: 'HELPS', frequency: 5.5e-05, inWordle: false },
  { word: 'HELVE', frequency: 1.51e-08, inWordle: false },
  { word: 'HEMAL', frequency: 1.45e-08, inWordle: false },
  { word: 'HEMES', frequency: 1.15e-08, inWordle: false },
  { word: 'HEMIN', frequency: 2.4e-08, inWordle: false },
  { word: 'HENCH', frequency: 1.12e-07, inWordle: false },
  { word: 'HENGE', frequency: 9.77e-08, inWordle: false },
  { word: 'HENNA', frequency: 6.92e-07, inWordle: false },
  { word: 'HENNY', frequency: 3.63e-07, inWordle: false },
  { word: 'HENRY', frequency: 5.5e-05, inWordle: false },
  { word: 'HERBS', frequency: 4.47e-06, inWordle: false },
  { word: 'HERBY', frequency: 1.29e-07, inWordle: false },
  { word: 'HERDS', frequency: 1.62e-06, inWordle: false },
  { word: 'HERES', frequency: 1.51e-06, inWordle: false },
  { word: 'HERMA', frequency: 3.02e-08, inWordle: false },
  { word: 'HERMS', frequency: 4.47e-08, inWordle: false },
  { word: 'HEROS', frequency: 6.76e-07, inWordle: false },
  { word: 'HERRY', frequency: 5.25e-08, inWordle: false },
  { word: 'HERSE', frequency: 3.02e-08, inWordle: false },
  { word: 'HERTZ', frequency: 1.15e-06, inWordle: false },
  { word: 'HEUGH', frequency: 1.55e-08, inWordle: false },
  { word: 'HEVEA', frequency: 3.09e-08, inWordle: false },
  { word: 'HEWED', frequency: 7.94e-08, inWordle: false },
  { word: 'HEWER', frequency: 8.13e-08, inWordle: false },
  { word: 'HEXED', frequency: 7.41e-08, inWordle: false },
  { word: 'HEXER', frequency: 2.04e-08, inWordle: false },
  { word: 'HEXES', frequency: 1.48e-07, inWordle: false },
  { word: 'HEXYL', frequency: 2.82e-08, inWordle: false },
  { word: 'HICKS', frequency: 3.72e-06, inWordle: false },
  { word: 'HIDED', frequency: 2.09e-08, inWordle: false },
  { word: 'HIDER', frequency: 1.26e-07, inWordle: false },
  { word: 'HIDES', frequency: 4.9e-06, inWordle: false },
  { word: 'HIGHS', frequency: 3.89e-06, inWordle: false },
  { word: 'HIGHT', frequency: 3.16e-07, inWordle: false },
  { word: 'HIJAB', frequency: 1.41e-06, inWordle: false },
  { word: 'HIJRA', frequency: 1.17e-07, inWordle: false },
  { word: 'HIKED', frequency: 8.91e-07, inWordle: false },
  { word: 'HIKER', frequency: 6.03e-07, inWordle: false },
  { word: 'HIKES', frequency: 2.19e-06, inWordle: false },
  { word: 'HILAR', frequency: 8.13e-08, inWordle: false },
  { word: 'HILLO', frequency: 1.12e-08, inWordle: false },
  { word: 'HILLS', frequency: 2.88e-05, inWordle: false },
  { word: 'HILTS', frequency: 1.12e-07, inWordle: false },
  { word: 'HILUM', frequency: 4.57e-08, inWordle: false },
  { word: 'HIMBO', frequency: 1.48e-08, inWordle: false },
  { word: 'HINDS', frequency: 6.92e-07, inWordle: false },
  { word: 'HINGS', frequency: 2.88e-08, inWordle: false },
  { word: 'HINKY', frequency: 6.03e-08, inWordle: false },
  { word: 'HINNY', frequency: 2.69e-08, inWordle: false },
  { word: 'HINTS', frequency: 7.08e-06, inWordle: false },
  { word: 'HIRED', frequency: 2.57e-05, inWordle: false },
  { word: 'HIRER', frequency: 7.94e-08, inWordle: false },
  { word: 'HIRES', frequency: 3.02e-06, inWordle: false },
  { word: 'HISSY', frequency: 2.57e-07, inWordle: false },
  { word: 'HIVED', frequency: 3.98e-08, inWordle: false },
  { word: 'HIVER', frequency: 8.51e-08, inWordle: false },
  { word: 'HIVES', frequency: 1.32e-06, inWordle: false },
  { word: 'HIZEN', frequency: 1.23e-08, inWordle: false },
  { word: 'HOAGY', frequency: 4.17e-08, inWordle: false },
  { word: 'HOARY', frequency: 1.95e-07, inWordle: false },
  { word: 'HOBOS', frequency: 2.14e-07, inWordle: false },
  { word: 'HOCKS', frequency: 1.26e-07, inWordle: false },
  { word: 'HOCUS', frequency: 3.72e-07, inWordle: false },
  { word: 'HODJA', frequency: 2.57e-08, inWordle: false },
  { word: 'HOGAN', frequency: 4.27e-06, inWordle: false },
  { word: 'HOGEN', frequency: 1.74e-08, inWordle: false },
  { word: 'HOGGS', frequency: 2.95e-08, inWordle: false },
  { word: 'HOICK', frequency: 1.41e-08, inWordle: false },
  { word: 'HOING', frequency: 1.23e-08, inWordle: false },
  { word: 'HOISE', frequency: 1.07e-08, inWordle: false },
  { word: 'HOKES', frequency: 1.48e-08, inWordle: false },
  { word: 'HOKEY', frequency: 4.17e-07, inWordle: false },
  { word: 'HOKKU', frequency: 1.07e-08, inWordle: false },
  { word: 'HOKUM', frequency: 1.07e-07, inWordle: false },
  { word: 'HOLDS', frequency: 3.98e-05, inWordle: false },
  { word: 'HOLED', frequency: 1.1e-06, inWordle: false },
  { word: 'HOLES', frequency: 2.24e-05, inWordle: false },
  { word: 'HOLEY', frequency: 1.35e-07, inWordle: false },
  { word: 'HOLLA', frequency: 3.63e-07, inWordle: false },
  { word: 'HOLLO', frequency: 5.01e-08, inWordle: false },
  { word: 'HOLME', frequency: 2.45e-07, inWordle: false },
  { word: 'HOLMS', frequency: 3.39e-08, inWordle: false },
  { word: 'HOLON', frequency: 5.5e-08, inWordle: false },
  { word: 'HOLOS', frequency: 6.76e-08, inWordle: false },
  { word: 'HOLTS', frequency: 8.13e-08, inWordle: false },
  { word: 'HOMED', frequency: 1.66e-07, inWordle: false },
  { word: 'HOMES', frequency: 4.9e-05, inWordle: false },
  { word: 'HOMEY', frequency: 5.62e-07, inWordle: false },
  { word: 'HOMIE', frequency: 1.82e-06, inWordle: false },
  { word: 'HOMME', frequency: 8.51e-07, inWordle: false },
  { word: 'HOMOS', frequency: 1.95e-07, inWordle: false },
  { word: 'HONAN', frequency: 1.48e-07, inWordle: false },
  { word: 'HONDA', frequency: 8.32e-06, inWordle: false },
  { word: 'HONED', frequency: 1.1e-06, inWordle: false },
  { word: 'HONER', frequency: 2.69e-08, inWordle: false },
  { word: 'HONES', frequency: 1.82e-07, inWordle: false },
  { word: 'HONGI', frequency: 3.72e-08, inWordle: false },
  { word: 'HONGS', frequency: 1.58e-08, inWordle: false },
  { word: 'HONKS', frequency: 1.7e-07, inWordle: false },
  { word: 'HONKY', frequency: 6.17e-07, inWordle: false },
  { word: 'HOOCH', frequency: 3.8e-07, inWordle: false },
  { word: 'HOODS', frequency: 1.26e-06, inWordle: false },
  { word: 'HOODY', frequency: 1.95e-07, inWordle: false },
  { word: 'HOOEY', frequency: 6.61e-08, inWordle: false },
  { word: 'HOOFS', frequency: 1.55e-07, inWordle: false },
  { word: 'HOOKA', frequency: 2.04e-08, inWordle: false },
  { word: 'HOOKS', frequency: 4.47e-06, inWordle: false },
  { word: 'HOOKY', frequency: 1.74e-07, inWordle: false },
  { word: 'HOOLY', frequency: 2.4e-08, inWordle: false },
  { word: 'HOONS', frequency: 1.15e-08, inWordle: false },
  { word: 'HOOPS', frequency: 2.82e-06, inWordle: false },
  { word: 'HOORS', frequency: 1.51e-08, inWordle: false },
  { word: 'HOOTS', frequency: 2.82e-07, inWordle: false },
  { word: 'HOOTY', frequency: 2.88e-08, inWordle: false },
  { word: 'HOPED', frequency: 1.91e-05, inWordle: false },
  { word: 'HOPER', frequency: 3.24e-08, inWordle: false },
  { word: 'HOPES', frequency: 2.51e-05, inWordle: false },
  { word: 'HOPPY', frequency: 4.57e-07, inWordle: false },
  { word: 'HORAS', frequency: 1.15e-07, inWordle: false },
  { word: 'HORIS', frequency: 1.41e-08, inWordle: false },
  { word: 'HORNS', frequency: 6.31e-06, inWordle: false },
  { word: 'HORST', frequency: 7.08e-07, inWordle: false },
  { word: 'HORSY', frequency: 1.32e-08, inWordle: false },
  { word: 'HOSED', frequency: 3.39e-07, inWordle: false },
  { word: 'HOSEL', frequency: 1.26e-08, inWordle: false },
  { word: 'HOSEN', frequency: 3.39e-08, inWordle: false },
  { word: 'HOSER', frequency: 6.17e-08, inWordle: false },
  { word: 'HOSES', frequency: 9.77e-07, inWordle: false },
  { word: 'HOSEY', frequency: 2.09e-08, inWordle: false },
  { word: 'HOSTA', frequency: 5.5e-08, inWordle: false },
  { word: 'HOSTS', frequency: 1.7e-05, inWordle: false },
  { word: 'HOTCH', frequency: 1.66e-07, inWordle: false },
  { word: 'HOTTY', frequency: 8.13e-08, inWordle: false },
  { word: 'HOUGH', frequency: 9.55e-07, inWordle: false },
  { word: 'HOURI', frequency: 1.62e-08, inWordle: false },
  { word: 'HOURS', frequency: 0.000251, inWordle: false },
  { word: 'HOUTS', frequency: 1.41e-08, inWordle: false },
  { word: 'HOVEA', frequency: 1.32e-08, inWordle: false },
  { word: 'HOVEN', frequency: 6.03e-08, inWordle: false },
  { word: 'HOWES', frequency: 5.25e-07, inWordle: false },
  { word: 'HOWLS', frequency: 6.03e-07, inWordle: false },
  { word: 'HOYAS', frequency: 1.1e-07, inWordle: false },
  { word: 'HOYLE', frequency: 4.07e-07, inWordle: false },
  { word: 'HUBBY', frequency: 2.57e-06, inWordle: false },
  { word: 'HUCKS', frequency: 2.82e-08, inWordle: false },
  { word: 'HUDUD', frequency: 5.01e-08, inWordle: false },
  { word: 'HUFFS', frequency: 1.45e-07, inWordle: false },
  { word: 'HUFFY', frequency: 1.62e-07, inWordle: false },
  { word: 'HUGER', frequency: 9.77e-08, inWordle: false },
  { word: 'HUGGY', frequency: 1.02e-07, inWordle: false },
  { word: 'HULAS', frequency: 1.1e-08, inWordle: false },
  { word: 'HULKS', frequency: 2.29e-07, inWordle: false },
  { word: 'HULLO', frequency: 1.12e-07, inWordle: false },
  { word: 'HULLS', frequency: 7.76e-07, inWordle: false },
  { word: 'HULLY', frequency: 1.7e-08, inWordle: false },
  { word: 'HUMIC', frequency: 2.34e-07, inWordle: false },
  { word: 'HUMPS', frequency: 3.63e-07, inWordle: false },
  { word: 'HUMPY', frequency: 6.46e-08, inWordle: false },
  { word: 'HUNKS', frequency: 3.47e-07, inWordle: false },
  { word: 'HUNTS', frequency: 2.24e-06, inWordle: false },
  { word: 'HURLS', frequency: 2.4e-07, inWordle: false },
  { word: 'HURLY', frequency: 9.77e-08, inWordle: false },
  { word: 'HURRA', frequency: 4.17e-08, inWordle: false },
  { word: 'HURST', frequency: 1.26e-06, inWordle: false },
  { word: 'HURTS', frequency: 2e-05, inWordle: false },
  { word: 'HUSKS', frequency: 4.07e-07, inWordle: false },
  { word: 'HYDRA', frequency: 2.04e-06, inWordle: false },
  { word: 'HYGGE', frequency: 7.08e-08, inWordle: false },
  { word: 'HYLAS', frequency: 5.01e-08, inWordle: false },
  { word: 'HYLES', frequency: 1.78e-08, inWordle: false },
  { word: 'HYMNS', frequency: 2.19e-06, inWordle: false },
  { word: 'HYNDE', frequency: 1.2e-07, inWordle: false },
  { word: 'HYOID', frequency: 1.78e-07, inWordle: false },
  { word: 'HYPED', frequency: 3.47e-06, inWordle: false },
  { word: 'HYPES', frequency: 1.23e-07, inWordle: false },
  { word: 'HYPHA', frequency: 1.74e-08, inWordle: false },
  { word: 'HYPHY', frequency: 3.8e-08, inWordle: false },
  { word: 'HYPOS', frequency: 3.47e-08, inWordle: false },
  { word: 'HYRAX', frequency: 3.63e-08, inWordle: false },
  { word: 'HYSON', frequency: 3.39e-08, inWordle: false },
  { word: 'HYTHE', frequency: 1.41e-07, inWordle: false },
  { word: 'IAMBS', frequency: 1.7e-08, inWordle: false },
  { word: 'ICERS', frequency: 3.39e-08, inWordle: false },
  { word: 'ICHOR', frequency: 5.01e-08, inWordle: false },
  { word: 'ICIER', frequency: 1.41e-08, inWordle: false },
  { word: 'ICKLE', frequency: 2.57e-08, inWordle: false },
  { word: 'ICONS', frequency: 5.5e-06, inWordle: false },
  { word: 'ICTAL', frequency: 2.82e-08, inWordle: false },
  { word: 'ICTUS', frequency: 2.95e-08, inWordle: false },
  { word: 'IDEAS', frequency: 6.92e-05, inWordle: false },
  { word: 'IDEES', frequency: 1.91e-08, inWordle: false },
  { word: 'IDENT', frequency: 2.75e-07, inWordle: false },
  { word: 'IDLED', frequency: 1.23e-07, inWordle: false },
  { word: 'IDLES', frequency: 1.02e-07, inWordle: false },
  { word: 'IDOLA', frequency: 2.34e-08, inWordle: false },
  { word: 'IDOLS', frequency: 3.09e-06, inWordle: false },
  { word: 'IFTAR', frequency: 1.58e-07, inWordle: false },
  { word: 'IHRAM', frequency: 3.16e-08, inWordle: false },
  { word: 'IKONS', frequency: 2.04e-08, inWordle: false },
  { word: 'ILEAL', frequency: 4.37e-08, inWordle: false },
  { word: 'ILEUM', frequency: 9.12e-08, inWordle: false },
  { word: 'ILEUS', frequency: 3.98e-08, inWordle: false },
  { word: 'ILIAD', frequency: 8.13e-07, inWordle: false },
  { word: 'ILIUM', frequency: 1.7e-07, inWordle: false },
  { word: 'ILLER', frequency: 4.17e-08, inWordle: false },
  { word: 'IMAGO', frequency: 2.14e-07, inWordle: false },
  { word: 'IMAMS', frequency: 6.46e-07, inWordle: false },
  { word: 'IMARI', frequency: 6.17e-08, inWordle: false },
  { word: 'IMBED', frequency: 2.75e-08, inWordle: false },
  { word: 'IMIDE', frequency: 2.29e-08, inWordle: false },
  { word: 'IMINE', frequency: 5.5e-08, inWordle: false },
  { word: 'IMINO', frequency: 1.82e-08, inWordle: false },
  { word: 'IMPIS', frequency: 1.51e-08, inWordle: false },
  { word: 'IMPRO', frequency: 5.5e-08, inWordle: false },
  { word: 'INAPT', frequency: 3.8e-08, inWordle: false },
  { word: 'INCEL', frequency: 9.77e-08, inWordle: false },
  { word: 'INCOG', frequency: 2.19e-08, inWordle: false },
  { word: 'INCUS', frequency: 4.68e-08, inWordle: false },
  { word: 'INDIA', frequency: 0.00011, inWordle: false },
  { word: 'INDIE', frequency: 1e-05, inWordle: false },
  { word: 'INDOL', frequency: 2.14e-08, inWordle: false },
  { word: 'INDRI', frequency: 4.79e-08, inWordle: false },
  { word: 'INDUE', frequency: 1.07e-08, inWordle: false },
  { word: 'INFIX', frequency: 5.75e-08, inWordle: false },
  { word: 'INFOS', frequency: 3.39e-07, inWordle: false },
  { word: 'INFRA', frequency: 7.94e-07, inWordle: false },
  { word: 'INGAN', frequency: 2.45e-08, inWordle: false },
  { word: 'INGLE', frequency: 2.51e-07, inWordle: false },
  { word: 'INION', frequency: 1.32e-08, inWordle: false },
  { word: 'INKED', frequency: 1.2e-06, inWordle: false },
  { word: 'INKER', frequency: 5.01e-08, inWordle: false },
  { word: 'INKLE', frequency: 2.4e-08, inWordle: false },
  { word: 'INNIT', frequency: 5.5e-07, inWordle: false },
  { word: 'INSET', frequency: 7.08e-07, inWordle: false },
  { word: 'INSPO', frequency: 1.51e-07, inWordle: false },
  { word: 'INTEL', frequency: 1.17e-05, inWordle: false },
  { word: 'INTIL', frequency: 1.2e-08, inWordle: false },
  { word: 'INTRA', frequency: 2.09e-06, inWordle: false },
  { word: 'INULA', frequency: 1.51e-08, inWordle: false },
  { word: 'INURE', frequency: 7.94e-08, inWordle: false },
  { word: 'INVAR', frequency: 1.91e-08, inWordle: false },
  { word: 'IOTAS', frequency: 1.86e-08, inWordle: false },
  { word: 'IPPON', frequency: 3.89e-08, inWordle: false },
  { word: 'IRING', frequency: 1.7e-08, inWordle: false },
  { word: 'IRKED', frequency: 5.62e-07, inWordle: false },
  { word: 'IROKO', frequency: 3.55e-08, inWordle: false },
  { word: 'IRONS', frequency: 2.09e-06, inWordle: false },
  { word: 'ISLES', frequency: 3.8e-06, inWordle: false },
  { word: 'ISNAE', frequency: 1.07e-08, inWordle: false },
  { word: 'ISSEI', frequency: 1.86e-07, inWordle: false },
  { word: 'ITEMS', frequency: 6.03e-05, inWordle: false },
  { word: 'ITHER', frequency: 3.89e-08, inWordle: false },
  { word: 'IVIES', frequency: 7.24e-08, inWordle: false },
  { word: 'IXNAY', frequency: 1.82e-08, inWordle: false },
  { word: 'IXORA', frequency: 1.51e-08, inWordle: false },
  { word: 'IZARD', frequency: 8.71e-08, inWordle: false },
  { word: 'IZZAT', frequency: 1e-07, inWordle: false },
  { word: 'JABOT', frequency: 2.09e-08, inWordle: false },
  { word: 'JACKS', frequency: 2.57e-06, inWordle: false },
  { word: 'JACKY', frequency: 6.61e-07, inWordle: false },
  { word: 'JADED', frequency: 9.33e-07, inWordle: false },
  { word: 'JADES', frequency: 1.12e-07, inWordle: false },
  { word: 'JAFFA', frequency: 9.55e-07, inWordle: false },
  { word: 'JAGER', frequency: 3.24e-07, inWordle: false },
  { word: 'JAGGY', frequency: 2.19e-08, inWordle: false },
  { word: 'JAGIR', frequency: 3.39e-08, inWordle: false },
  { word: 'JAILS', frequency: 1.58e-06, inWordle: false },
  { word: 'JAKES', frequency: 3.24e-07, inWordle: false },
  { word: 'JAKEY', frequency: 9.55e-08, inWordle: false },
  { word: 'JAMBE', frequency: 2.51e-08, inWordle: false },
  { word: 'JAMBO', frequency: 1.2e-07, inWordle: false },
  { word: 'JAMBS', frequency: 8.51e-08, inWordle: false },
  { word: 'JAMBU', frequency: 3.72e-08, inWordle: false },
  { word: 'JAMES', frequency: 0.000129, inWordle: false },
  { word: 'JAMMY', frequency: 2.4e-07, inWordle: false },
  { word: 'JAMON', frequency: 8.13e-08, inWordle: false },
  { word: 'JANES', frequency: 3.55e-07, inWordle: false },
  { word: 'JANNY', frequency: 5.37e-08, inWordle: false },
  { word: 'JAPAN', frequency: 7.76e-05, inWordle: false },
  { word: 'JAPES', frequency: 4.68e-08, inWordle: false },
  { word: 'JARLS', frequency: 2.75e-08, inWordle: false },
  { word: 'JAVAS', frequency: 1.55e-08, inWordle: false },
  { word: 'JAVEL', frequency: 1.23e-08, inWordle: false },
  { word: 'JAWAN', frequency: 7.76e-08, inWordle: false },
  { word: 'JAWED', frequency: 3.55e-07, inWordle: false },
  { word: 'JEANS', frequency: 1.23e-05, inWordle: false },
  { word: 'JEBEL', frequency: 2.19e-07, inWordle: false },
  { word: 'JEDIS', frequency: 5.75e-08, inWordle: false },
  { word: 'JEEPS', frequency: 6.17e-07, inWordle: false },
  { word: 'JEERS', frequency: 2.09e-07, inWordle: false },
  { word: 'JEEZE', frequency: 1e-07, inWordle: false },
  { word: 'JEFES', frequency: 1.15e-08, inWordle: false },
  { word: 'JEFFS', frequency: 1.78e-07, inWordle: false },
  { word: 'JEHAD', frequency: 3.89e-08, inWordle: false },
  { word: 'JELLO', frequency: 6.61e-07, inWordle: false },
  { word: 'JELLS', frequency: 1.32e-08, inWordle: false },
  { word: 'JEMMY', frequency: 8.71e-08, inWordle: false },
  { word: 'JENNY', frequency: 7.76e-06, inWordle: false },
  { word: 'JERKS', frequency: 1.91e-06, inWordle: false },
  { word: 'JERRY', frequency: 1.82e-05, inWordle: false },
  { word: 'JESSE', frequency: 1.1e-05, inWordle: false },
  { word: 'JESTS', frequency: 7.41e-08, inWordle: false },
  { word: 'JESUS', frequency: 9.77e-05, inWordle: false },
  { word: 'JETON', frequency: 1.15e-08, inWordle: false },
  { word: 'JEUNE', frequency: 2.4e-07, inWordle: false },
  { word: 'JEWED', frequency: 1.15e-08, inWordle: false },
  { word: 'JHALA', frequency: 1.95e-08, inWordle: false },
  { word: 'JIBED', frequency: 2.34e-08, inWordle: false },
  { word: 'JIBES', frequency: 1.38e-07, inWordle: false },
  { word: 'JIGGY', frequency: 1.66e-07, inWordle: false },
  { word: 'JIHAD', frequency: 3.09e-06, inWordle: false },
  { word: 'JILLS', frequency: 4.57e-08, inWordle: false },
  { word: 'JILTS', frequency: 1.15e-08, inWordle: false },
  { word: 'JIMMY', frequency: 2.75e-05, inWordle: false },
  { word: 'JINGO', frequency: 9.55e-08, inWordle: false },
  { word: 'JINKS', frequency: 2.63e-07, inWordle: false },
  { word: 'JINNI', frequency: 4.57e-08, inWordle: false },
  { word: 'JINNS', frequency: 6.31e-08, inWordle: false },
  { word: 'JIRGA', frequency: 1.29e-07, inWordle: false },
  { word: 'JIVED', frequency: 2.19e-08, inWordle: false },
  { word: 'JIVES', frequency: 4.79e-08, inWordle: false },
  { word: 'JNANA', frequency: 6.46e-08, inWordle: false },
  { word: 'JOBES', frequency: 1.66e-08, inWordle: false },
  { word: 'JOCKO', frequency: 1.29e-07, inWordle: false },
  { word: 'JOCKS', frequency: 5.89e-07, inWordle: false },
  { word: 'JOCKY', frequency: 4.07e-08, inWordle: false },
  { word: 'JODEL', frequency: 1.2e-08, inWordle: false },
  { word: 'JOEYS', frequency: 9.77e-08, inWordle: false },
  { word: 'JOHNS', frequency: 6.92e-06, inWordle: false },
  { word: 'JOINS', frequency: 1.1e-05, inWordle: false },
  { word: 'JOKED', frequency: 1.91e-06, inWordle: false },
  { word: 'JOKES', frequency: 2.14e-05, inWordle: false },
  { word: 'JOKEY', frequency: 2.69e-07, inWordle: false },
  { word: 'JOLLS', frequency: 1.07e-08, inWordle: false },
  { word: 'JOLTS', frequency: 1.95e-07, inWordle: false },
  { word: 'JOMON', frequency: 3.63e-08, inWordle: false },
  { word: 'JONES', frequency: 5.37e-05, inWordle: false },
  { word: 'JONTY', frequency: 1.23e-07, inWordle: false },
  { word: 'JORAM', frequency: 6.46e-08, inWordle: false },
  { word: 'JOTUN', frequency: 4.9e-08, inWordle: false },
  { word: 'JOULE', frequency: 2.75e-07, inWordle: false },
  { word: 'JOURS', frequency: 1.55e-07, inWordle: false },
  { word: 'JOWAR', frequency: 3.55e-08, inWordle: false },
  { word: 'JOWLS', frequency: 1.23e-07, inWordle: false },
  { word: 'JOWLY', frequency: 2.88e-08, inWordle: false },
  { word: 'JOYED', frequency: 3.8e-08, inWordle: false },
  { word: 'JUDAS', frequency: 2.34e-06, inWordle: false },
  { word: 'JUDGY', frequency: 1.38e-07, inWordle: false },
  { word: 'JUGAL', frequency: 4.47e-08, inWordle: false },
  { word: 'JUJUS', frequency: 1.35e-08, inWordle: false },
  { word: 'JUKED', frequency: 4.79e-08, inWordle: false },
  { word: 'JUKES', frequency: 2.09e-07, inWordle: false },
  { word: 'JULEP', frequency: 1.62e-07, inWordle: false },
  { word: 'JUMPS', frequency: 7.24e-06, inWordle: false },
  { word: 'JUNCO', frequency: 7.59e-08, inWordle: false },
  { word: 'JUNKS', frequency: 1.55e-07, inWordle: false },
  { word: 'JUNKY', frequency: 2.63e-07, inWordle: false },
  { word: 'JURAL', frequency: 1.29e-08, inWordle: false },
  { word: 'JURAT', frequency: 3.98e-08, inWordle: false },
  { word: 'JUSTS', frequency: 4.07e-08, inWordle: false },
  { word: 'JUTES', frequency: 4.17e-08, inWordle: false },
  { word: 'JUVIE', frequency: 1.26e-07, inWordle: false },
  { word: 'KABAB', frequency: 5.62e-08, inWordle: false },
  { word: 'KABAR', frequency: 3.55e-08, inWordle: false },
  { word: 'KABOB', frequency: 7.59e-08, inWordle: false },
  { word: 'KACHA', frequency: 2.51e-08, inWordle: false },
  { word: 'KADAI', frequency: 3.89e-08, inWordle: false },
  { word: 'KADIS', frequency: 1.45e-08, inWordle: false },
  { word: 'KAFIR', frequency: 1.91e-07, inWordle: false },
  { word: 'KAHAL', frequency: 1.29e-08, inWordle: false },
  { word: 'KAINS', frequency: 1.07e-08, inWordle: false },
  { word: 'KAKAS', frequency: 1.41e-08, inWordle: false },
  { word: 'KALAM', frequency: 3.02e-07, inWordle: false },
  { word: 'KALES', frequency: 3.39e-08, inWordle: false },
  { word: 'KALIF', frequency: 2.69e-08, inWordle: false },
  { word: 'KALIS', frequency: 3.24e-08, inWordle: false },
  { word: 'KALPA', frequency: 8.32e-08, inWordle: false },
  { word: 'KAMAS', frequency: 3.8e-08, inWordle: false },
  { word: 'KAMES', frequency: 5.5e-08, inWordle: false },
  { word: 'KAMIK', frequency: 1.05e-08, inWordle: false },
  { word: 'KAMIS', frequency: 2.04e-08, inWordle: false },
  { word: 'KANAE', frequency: 6.61e-08, inWordle: false },
  { word: 'KANAS', frequency: 2.95e-08, inWordle: false },
  { word: 'KANDY', frequency: 3.72e-07, inWordle: false },
  { word: 'KANES', frequency: 5.37e-08, inWordle: false },
  { word: 'KANGA', frequency: 1.45e-07, inWordle: false },
  { word: 'KANGS', frequency: 1.95e-08, inWordle: false },
  { word: 'KANJI', frequency: 1.02e-06, inWordle: false },
  { word: 'KANTS', frequency: 1.95e-08, inWordle: false },
  { word: 'KAONS', frequency: 1.91e-08, inWordle: false },
  { word: 'KAPAS', frequency: 1.45e-08, inWordle: false },
  { word: 'KAPOK', frequency: 5.25e-08, inWordle: false },
  { word: 'KAPOW', frequency: 5.75e-08, inWordle: false },
  { word: 'CAPUT', frequency: 1.2e-07, inWordle: true },
  { word: 'KARAS', frequency: 1.23e-07, inWordle: false },
  { word: 'KARAT', frequency: 4.27e-07, inWordle: false },
  { word: 'KARNS', frequency: 5.62e-08, inWordle: false },
  { word: 'KAROO', frequency: 1.91e-07, inWordle: false },
  { word: 'KAROS', frequency: 1.12e-08, inWordle: false },
  { word: 'KARRI', frequency: 8.91e-08, inWordle: false },
  { word: 'KARST', frequency: 3.31e-07, inWordle: false },
  { word: 'KARTS', frequency: 4.17e-07, inWordle: false },
  { word: 'KASHA', frequency: 1.05e-07, inWordle: false },
  { word: 'KATAS', frequency: 4.07e-08, inWordle: false },
  { word: 'KATIS', frequency: 1.26e-08, inWordle: false },
  { word: 'KATTI', frequency: 3.89e-08, inWordle: false },
  { word: 'KAURI', frequency: 8.71e-08, inWordle: false },
  { word: 'KAVAL', frequency: 1.86e-08, inWordle: false },
  { word: 'KAWAS', frequency: 1.55e-08, inWordle: false },
  { word: 'KAYLE', frequency: 3.8e-08, inWordle: false },
  { word: 'KAZIS', frequency: 1.1e-08, inWordle: false },
  { word: 'KAZOO', frequency: 2.24e-07, inWordle: false },
  { word: 'KECKS', frequency: 1.48e-08, inWordle: false },
  { word: 'KEDGE', frequency: 3.09e-08, inWordle: false },
  { word: 'KEECH', frequency: 5.25e-08, inWordle: false },
  { word: 'KEEKS', frequency: 1.48e-08, inWordle: false },
  { word: 'KEELS', frequency: 2e-07, inWordle: false },
  { word: 'KEEMA', frequency: 3.24e-08, inWordle: false },
  { word: 'KEENO', frequency: 1.2e-08, inWordle: false },
  { word: 'KEENS', frequency: 3.72e-08, inWordle: false },
  { word: 'KEEPS', frequency: 4.68e-05, inWordle: false },
  { word: 'KEFIR', frequency: 1.35e-07, inWordle: false },
  { word: 'KELLS', frequency: 2.19e-07, inWordle: false },
  { word: 'KELLY', frequency: 2.75e-05, inWordle: false },
  { word: 'KELPS', frequency: 1.35e-08, inWordle: false },
  { word: 'KELTY', frequency: 1.35e-07, inWordle: false },
  { word: 'KEMPS', frequency: 5.75e-08, inWordle: false },
  { word: 'KEMPT', frequency: 5.5e-08, inWordle: false },
  { word: 'KENAF', frequency: 2.04e-08, inWordle: false },
  { word: 'KENCH', frequency: 2.88e-08, inWordle: false },
  { word: 'KENDO', frequency: 3.09e-07, inWordle: false },
  { word: 'KENTE', frequency: 5.89e-08, inWordle: false },
  { word: 'KENTS', frequency: 1.17e-07, inWordle: false },
  { word: 'KERBS', frequency: 9.77e-08, inWordle: false },
  { word: 'KERMA', frequency: 6.31e-08, inWordle: false },
  { word: 'KERNE', frequency: 1.66e-08, inWordle: false },
  { word: 'KERNS', frequency: 1.7e-07, inWordle: false },
  { word: 'KEROS', frequency: 1.02e-08, inWordle: false },
  { word: 'KERRY', frequency: 7.08e-06, inWordle: false },
  { word: 'KESAR', frequency: 4.07e-08, inWordle: false },
  { word: 'KETCH', frequency: 2.24e-07, inWordle: false },
  { word: 'KEYED', frequency: 7.76e-07, inWordle: false },
  { word: 'KEYER', frequency: 2.29e-08, inWordle: false },
  { word: 'KHADI', frequency: 1.62e-07, inWordle: false },
  { word: 'KHANS', frequency: 3.98e-07, inWordle: false },
  { word: 'KHAYA', frequency: 5.13e-08, inWordle: false },
  { word: 'KHEDA', frequency: 2.45e-08, inWordle: false },
  { word: 'KHOJA', frequency: 3.89e-08, inWordle: false },
  { word: 'KIANG', frequency: 9.77e-08, inWordle: false },
  { word: 'KIBBE', frequency: 4.68e-08, inWordle: false },
  { word: 'KICKS', frequency: 1.17e-05, inWordle: false },
  { word: 'KICKY', frequency: 4.27e-08, inWordle: false },
  { word: 'KIDDO', frequency: 1.66e-06, inWordle: false },
  { word: 'KIDDY', frequency: 2.82e-07, inWordle: false },
  { word: 'KIERS', frequency: 1.15e-08, inWordle: false },
  { word: 'KIGHT', frequency: 3.31e-08, inWordle: false },
  { word: 'KIKES', frequency: 5.89e-08, inWordle: false },
  { word: 'KILEY', frequency: 2.29e-07, inWordle: false },
  { word: 'KILIM', frequency: 6.61e-08, inWordle: false },
  { word: 'KILLS', frequency: 2.19e-05, inWordle: false },
  { word: 'KILNS', frequency: 5.13e-07, inWordle: false },
  { word: 'KILOS', frequency: 1.78e-06, inWordle: false },
  { word: 'KILTS', frequency: 2.63e-07, inWordle: false },
  { word: 'KILTY', frequency: 5.25e-08, inWordle: false },
  { word: 'KIMBO', frequency: 8.51e-08, inWordle: false },
  { word: 'KINDA', frequency: 3.89e-05, inWordle: false },
  { word: 'KINDS', frequency: 3.24e-05, inWordle: false },
  { word: 'KINDY', frequency: 6.92e-08, inWordle: false },
  { word: 'KINES', frequency: 2.4e-08, inWordle: false },
  { word: 'KINGS', frequency: 2.57e-05, inWordle: false },
  { word: 'KININ', frequency: 1.05e-08, inWordle: false },
  { word: 'KINKS', frequency: 1.51e-06, inWordle: false },
  { word: 'KINOS', frequency: 1.45e-08, inWordle: false },
  { word: 'KIPPA', frequency: 3.39e-08, inWordle: false },
  { word: 'KIPPS', frequency: 9.12e-08, inWordle: false },
  { word: 'KIRBY', frequency: 4.47e-06, inWordle: false },
  { word: 'KIRKS', frequency: 6.92e-08, inWordle: false },
  { word: 'KISAN', frequency: 1.74e-07, inWordle: false },
  { word: 'KISSY', frequency: 2.75e-07, inWordle: false },
  { word: 'KITED', frequency: 1.7e-08, inWordle: false },
  { word: 'KITER', frequency: 1.48e-08, inWordle: false },
  { word: 'KITES', frequency: 9.12e-07, inWordle: false },
  { word: 'KIVAS', frequency: 3.63e-08, inWordle: false },
  { word: 'KIWIS', frequency: 7.41e-07, inWordle: false },
  { word: 'KLANG', frequency: 1.78e-07, inWordle: false },
  { word: 'KLETT', frequency: 4.47e-08, inWordle: false },
  { word: 'KLICK', frequency: 7.76e-08, inWordle: false },
  { word: 'KLIEG', frequency: 2.69e-08, inWordle: false },
  { word: 'KLONG', frequency: 6.76e-08, inWordle: false },
  { word: 'KLOOF', frequency: 6.46e-08, inWordle: false },
  { word: 'KLUGE', frequency: 1.1e-07, inWordle: false },
  { word: 'KLUTZ', frequency: 1.32e-07, inWordle: false },
  { word: 'KNEES', frequency: 1.51e-05, inWordle: false },
  { word: 'KNELL', frequency: 3.89e-07, inWordle: false },
  { word: 'KNISH', frequency: 4.27e-08, inWordle: false },
  { word: 'KNITS', frequency: 3.98e-07, inWordle: false },
  { word: 'KNIVE', frequency: 1.91e-08, inWordle: false },
  { word: 'KNOBS', frequency: 1.05e-06, inWordle: false },
  { word: 'KNOPS', frequency: 2e-08, inWordle: false },
  { word: 'KNOTS', frequency: 4.27e-06, inWordle: false },
  { word: 'KNOUT', frequency: 1.32e-08, inWordle: false },
  { word: 'KNOWE', frequency: 4.79e-08, inWordle: false },
  { word: 'KNOWS', frequency: 0.000117, inWordle: false },
  { word: 'KNURL', frequency: 1.62e-08, inWordle: false },
  { word: 'KNUTS', frequency: 1.15e-08, inWordle: false },
  { word: 'KOANS', frequency: 4.17e-08, inWordle: false },
  { word: 'KOBAN', frequency: 2.45e-08, inWordle: false },
  { word: 'KOFTA', frequency: 4.79e-08, inWordle: false },
  { word: 'KOHEN', frequency: 6.17e-08, inWordle: false },
  { word: 'KOHLS', frequency: 1.78e-07, inWordle: false },
  { word: 'KOINE', frequency: 7.94e-08, inWordle: false },
  { word: 'KOKER', frequency: 3.89e-08, inWordle: false },
  { word: 'KOKUM', frequency: 1.35e-08, inWordle: false },
  { word: 'KOLAS', frequency: 1.26e-08, inWordle: false },
  { word: 'KOLOS', frequency: 1.62e-08, inWordle: false },
  { word: 'KOMBU', frequency: 5.37e-08, inWordle: false },
  { word: 'KONBU', frequency: 1.07e-08, inWordle: false },
  { word: 'KONDO', frequency: 4.07e-07, inWordle: false },
  { word: 'KOOKS', frequency: 2.19e-07, inWordle: false },
  { word: 'KOOKY', frequency: 3.8e-07, inWordle: false },
  { word: 'KOORI', frequency: 3.72e-08, inWordle: false },
  { word: 'KOPEK', frequency: 2.57e-08, inWordle: false },
  { word: 'KOPJE', frequency: 3.31e-08, inWordle: false },
  { word: 'KOPPA', frequency: 1.2e-08, inWordle: false },
  { word: 'KORAI', frequency: 1.17e-08, inWordle: false },
  { word: 'KORAT', frequency: 3.24e-08, inWordle: false },
  { word: 'KORES', frequency: 1.95e-08, inWordle: false },
  { word: 'KORMA', frequency: 8.13e-08, inWordle: false },
  { word: 'KOROS', frequency: 1.62e-08, inWordle: false },
  { word: 'KORUS', frequency: 1.35e-08, inWordle: false },
  { word: 'KOTCH', frequency: 2.45e-08, inWordle: false },
  { word: 'KOURA', frequency: 1.66e-08, inWordle: false },
  { word: 'KRAAL', frequency: 8.51e-08, inWordle: false },
  { word: 'KRABS', frequency: 2.82e-07, inWordle: false },
  { word: 'KRAFT', frequency: 2.4e-06, inWordle: false },
  { word: 'KRAIT', frequency: 7.08e-08, inWordle: false },
  { word: 'KRANG', frequency: 8.51e-08, inWordle: false },
  { word: 'KRANS', frequency: 2.4e-08, inWordle: false },
  { word: 'KRANZ', frequency: 1.51e-07, inWordle: false },
  { word: 'KRAUT', frequency: 2.4e-07, inWordle: false },
  { word: 'KRAYS', frequency: 8.51e-08, inWordle: false },
  { word: 'KREEP', frequency: 2.09e-08, inWordle: false },
  { word: 'KREWE', frequency: 8.32e-08, inWordle: false },
  { word: 'KRONA', frequency: 1.66e-07, inWordle: false },
  { word: 'KRONE', frequency: 2.69e-07, inWordle: false },
  { word: 'KROON', frequency: 6.92e-08, inWordle: false },
  { word: 'KRUNK', frequency: 3.89e-08, inWordle: false },
  { word: 'KUBIE', frequency: 1.62e-08, inWordle: false },
  { word: 'KUDOS', frequency: 2.82e-06, inWordle: false },
  { word: 'KUDUS', frequency: 3.89e-08, inWordle: false },
  { word: 'KUDZU', frequency: 1.35e-07, inWordle: false },
  { word: 'KUGEL', frequency: 1.12e-07, inWordle: false },
  { word: 'KUKRI', frequency: 5.89e-08, inWordle: false },
  { word: 'KULAK', frequency: 8.51e-08, inWordle: false },
  { word: 'KULAN', frequency: 1.07e-08, inWordle: false },
  { word: 'KULAS', frequency: 1.66e-08, inWordle: false },
  { word: 'KULFI', frequency: 4.37e-08, inWordle: false },
  { word: 'KUMIS', frequency: 1.07e-08, inWordle: false },
  { word: 'KURTA', frequency: 1.62e-07, inWordle: false },
  { word: 'KURUS', frequency: 4.07e-08, inWordle: false },
  { word: 'KUTCH', frequency: 1.55e-07, inWordle: false },
  { word: 'KVASS', frequency: 4.17e-08, inWordle: false },
  { word: 'KYATS', frequency: 3.09e-08, inWordle: false },
  { word: 'KYLES', frequency: 1.29e-07, inWordle: false },
  { word: 'KYLIE', frequency: 3.47e-06, inWordle: false },
  { word: 'KYLIN', frequency: 3.98e-08, inWordle: false },
  { word: 'KYLIX', frequency: 1.95e-08, inWordle: false },
  { word: 'KYRIE', frequency: 2.04e-06, inWordle: false },
  { word: 'LABIA', frequency: 5.01e-07, inWordle: false },
  { word: 'LABRA', frequency: 1.41e-08, inWordle: false },
  { word: 'LACED', frequency: 1.95e-06, inWordle: false },
  { word: 'LACER', frequency: 1.32e-08, inWordle: false },
  { word: 'LACES', frequency: 1.32e-06, inWordle: false },
  { word: 'LACEY', frequency: 1.86e-06, inWordle: false },
  { word: 'LACKS', frequency: 7.76e-06, inWordle: false },
  { word: 'LADDY', frequency: 4.27e-08, inWordle: false },
  { word: 'LADER', frequency: 3.47e-08, inWordle: false },
  { word: 'LADES', frequency: 2.4e-08, inWordle: false },
  { word: 'LAGAN', frequency: 1.38e-07, inWordle: false },
  { word: 'LAHAR', frequency: 3.8e-08, inWordle: false },
  { word: 'LAICH', frequency: 5.13e-08, inWordle: false },
  { word: 'LAIGH', frequency: 2.69e-08, inWordle: false },
  { word: 'LAIKA', frequency: 1.62e-07, inWordle: false },
  { word: 'LAIRD', frequency: 1.45e-06, inWordle: false },
  { word: 'LAIRS', frequency: 1.41e-07, inWordle: false },
  { word: 'LAIRY', frequency: 2.82e-08, inWordle: false },
  { word: 'LAITH', frequency: 9.12e-08, inWordle: false },
  { word: 'LAITY', frequency: 5.75e-07, inWordle: false },
  { word: 'LAKER', frequency: 6.92e-07, inWordle: false },
  { word: 'LAKES', frequency: 1.38e-05, inWordle: false },
  { word: 'LAKHS', frequency: 1.2e-06, inWordle: false },
  { word: 'LAKIN', frequency: 1.32e-07, inWordle: false },
  { word: 'LAKSA', frequency: 9.33e-08, inWordle: false },
  { word: 'LAMAS', frequency: 3.24e-07, inWordle: false },
  { word: 'LAMBS', frequency: 1.7e-06, inWordle: false },
  { word: 'LAMBY', frequency: 2.82e-08, inWordle: false },
  { word: 'LAMED', frequency: 5.01e-08, inWordle: false },
  { word: 'LAMER', frequency: 1.48e-07, inWordle: false },
  { word: 'LAMES', frequency: 1.23e-07, inWordle: false },
  { word: 'LAMIA', frequency: 2.34e-07, inWordle: false },
  { word: 'LAMMY', frequency: 9.33e-08, inWordle: false },
  { word: 'LAMPS', frequency: 5.37e-06, inWordle: false },
  { word: 'LANAI', frequency: 2e-07, inWordle: false },
  { word: 'LANAS', frequency: 1.26e-08, inWordle: false },
  { word: 'LANDE', frequency: 1.45e-07, inWordle: false },
  { word: 'LANDS', frequency: 2.34e-05, inWordle: false },
  { word: 'LANES', frequency: 9.33e-06, inWordle: false },
  { word: 'LAPIN', frequency: 1e-07, inWordle: false },
  { word: 'LAPIS', frequency: 6.03e-07, inWordle: false },
  { word: 'LARCH', frequency: 3.55e-07, inWordle: false },
  { word: 'LARDS', frequency: 1.23e-08, inWordle: false },
  { word: 'LARDY', frequency: 6.92e-08, inWordle: false },
  { word: 'LAREE', frequency: 1.55e-08, inWordle: false },
  { word: 'LARES', frequency: 8.51e-08, inWordle: false },
  { word: 'LARGO', frequency: 9.77e-07, inWordle: false },
  { word: 'LARIS', frequency: 2.82e-08, inWordle: false },
  { word: 'LARKS', frequency: 2.75e-07, inWordle: false },
  { word: 'LARKY', frequency: 1.32e-08, inWordle: false },
  { word: 'LARUM', frequency: 1.12e-08, inWordle: false },
  { word: 'LASER', frequency: 1.58e-05, inWordle: false },
  { word: 'LASSI', frequency: 1e-07, inWordle: false },
  { word: 'LASSY', frequency: 2.29e-08, inWordle: false },
  { word: 'LASTS', frequency: 7.94e-06, inWordle: false },
  { word: 'LATAH', frequency: 3.98e-08, inWordle: false },
  { word: 'LATED', frequency: 4.17e-08, inWordle: false },
  { word: 'LATEN', frequency: 1.82e-08, inWordle: false },
  { word: 'LATEX', frequency: 2.51e-06, inWordle: false },
  { word: 'LATHI', frequency: 6.61e-08, inWordle: false },
  { word: 'LATHS', frequency: 2.09e-08, inWordle: false },
  { word: 'LATKE', frequency: 2.75e-08, inWordle: false },
  { word: 'LATUS', frequency: 4.79e-08, inWordle: false },
  { word: 'LAUAN', frequency: 1.2e-08, inWordle: false },
  { word: 'LAUCH', frequency: 3.72e-08, inWordle: false },
  { word: 'LAUDS', frequency: 3.16e-07, inWordle: false },
  { word: 'LAUND', frequency: 1.48e-08, inWordle: false },
  { word: 'LAURA', frequency: 1.74e-05, inWordle: false },
  { word: 'LAVAL', frequency: 6.31e-07, inWordle: false },
  { word: 'LAVAS', frequency: 1.82e-07, inWordle: false },
  { word: 'LAVER', frequency: 3.63e-07, inWordle: false },
  { word: 'LAVES', frequency: 2.63e-08, inWordle: false },
  { word: 'LAVRA', frequency: 4.07e-08, inWordle: false },
  { word: 'LAWER', frequency: 2.51e-08, inWordle: false },
  { word: 'LAWNS', frequency: 1.62e-06, inWordle: false },
  { word: 'LAXED', frequency: 1.51e-08, inWordle: false },
  { word: 'LAXER', frequency: 4.79e-08, inWordle: false },
  { word: 'LAXLY', frequency: 1.78e-08, inWordle: false },
  { word: 'LAYED', frequency: 2.88e-07, inWordle: false },
  { word: 'LAYIN', frequency: 2e-07, inWordle: false },
  { word: 'LAYUP', frequency: 8.51e-07, inWordle: false },
  { word: 'LAZAR', frequency: 6.31e-07, inWordle: false },
  { word: 'LAZED', frequency: 2.09e-08, inWordle: false },
  { word: 'LAZES', frequency: 1.05e-08, inWordle: false },
  { word: 'LAZZO', frequency: 1.1e-08, inWordle: false },
  { word: 'LEADS', frequency: 4.47e-05, inWordle: false },
  { word: 'LEAFS', frequency: 3.63e-06, inWordle: false },
  { word: 'LEAKS', frequency: 7.59e-06, inWordle: false },
  { word: 'LEANS', frequency: 1.86e-06, inWordle: false },
  { word: 'LEAPS', frequency: 2.29e-06, inWordle: false },
  { word: 'LEARS', frequency: 2.75e-08, inWordle: false },
  { word: 'LEARY', frequency: 7.24e-07, inWordle: false },
  { word: 'LEATS', frequency: 1.55e-08, inWordle: false },
  { word: 'LEAVY', frequency: 8.91e-08, inWordle: false },
  { word: 'LEBEN', frequency: 2.88e-07, inWordle: false },
  { word: 'LECCY', frequency: 1.48e-08, inWordle: false },
  { word: 'LEDES', frequency: 1.17e-08, inWordle: false },
  { word: 'LEDUM', frequency: 1.48e-08, inWordle: false },
  { word: 'LEEKS', frequency: 5.01e-07, inWordle: false },
  { word: 'LEERS', frequency: 5.01e-08, inWordle: false },
  { word: 'LEESE', frequency: 9.77e-08, inWordle: false },
  { word: 'LEETS', frequency: 1.05e-08, inWordle: false },
  { word: 'LEEZE', frequency: 1.32e-08, inWordle: false },
  { word: 'LEFTS', frequency: 2.51e-07, inWordle: false },
  { word: 'LEGER', frequency: 4.9e-07, inWordle: false },
  { word: 'LEGES', frequency: 6.03e-08, inWordle: false },
  { word: 'LEGGE', frequency: 2.34e-07, inWordle: false },
  { word: 'LEGGO', frequency: 7.41e-08, inWordle: false },
  { word: 'LEGIT', frequency: 1.02e-05, inWordle: false },
  { word: 'LEHUA', frequency: 2.88e-08, inWordle: false },
  { word: 'LEMAN', frequency: 2.04e-07, inWordle: false },
  { word: 'LEMEL', frequency: 1.29e-08, inWordle: false },
  { word: 'LEMMA', frequency: 5.5e-07, inWordle: false },
  { word: 'LEMME', frequency: 1.55e-06, inWordle: false },
  { word: 'LENDS', frequency: 2.29e-06, inWordle: false },
  { word: 'LENIS', frequency: 2.82e-08, inWordle: false },
  { word: 'LENSE', frequency: 1.91e-07, inWordle: false },
  { word: 'LENTI', frequency: 2.69e-08, inWordle: false },
  { word: 'LENTO', frequency: 1.32e-07, inWordle: false },
  { word: 'LEONE', frequency: 4.37e-06, inWordle: false },
  { word: 'LEPRA', frequency: 2.34e-08, inWordle: false },
  { word: 'LESBO', frequency: 1.74e-07, inWordle: false },
  { word: 'LETCH', frequency: 4.27e-08, inWordle: false },
  { word: 'LETHE', frequency: 1.07e-07, inWordle: false },
  { word: 'LETUP', frequency: 3.09e-08, inWordle: false },
  { word: 'LEUCO', frequency: 3.72e-08, inWordle: false },
  { word: 'LEVEE', frequency: 6.17e-07, inWordle: false },
  { word: 'LEVES', frequency: 2.69e-08, inWordle: false },
  { word: 'LEVIN', frequency: 2.57e-06, inWordle: false },
  { word: 'LEVIS', frequency: 3.98e-07, inWordle: false },
  { word: 'LEWIS', frequency: 3.02e-05, inWordle: false },
  { word: 'LEXIS', frequency: 2.82e-07, inWordle: false },
  { word: 'LEZZY', frequency: 1.12e-08, inWordle: false },
  { word: 'LIANA', frequency: 3.39e-07, inWordle: false },
  { word: 'LIANE', frequency: 1.74e-07, inWordle: false },
  { word: 'LIANG', frequency: 1.35e-06, inWordle: false },
  { word: 'LIARD', frequency: 4.27e-08, inWordle: false },
  { word: 'LIARS', frequency: 2.88e-06, inWordle: false },
  { word: 'LIBER', frequency: 6.61e-07, inWordle: false },
  { word: 'LIBRA', frequency: 8.51e-07, inWordle: false },
  { word: 'LIBRI', frequency: 2.19e-07, inWordle: false },
  { word: 'LICHT', frequency: 2.09e-07, inWordle: false },
  { word: 'LICIT', frequency: 8.71e-08, inWordle: false },
  { word: 'LICKS', frequency: 1.26e-06, inWordle: false },
  { word: 'LIDAR', frequency: 4.47e-07, inWordle: false },
  { word: 'LIDOS', frequency: 2.34e-08, inWordle: false },
  { word: 'LIENS', frequency: 4.68e-07, inWordle: false },
  { word: 'LIERS', frequency: 4.27e-08, inWordle: false },
  { word: 'LIEVE', frequency: 1.12e-07, inWordle: false },
  { word: 'LIFER', frequency: 2.88e-07, inWordle: false },
  { word: 'LIFES', frequency: 8.51e-07, inWordle: false },
  { word: 'LIFTS', frequency: 5.75e-06, inWordle: false },
  { word: 'LIGER', frequency: 1.7e-07, inWordle: false },
  { word: 'LIGNE', frequency: 2.45e-07, inWordle: false },
  { word: 'LIKED', frequency: 5.75e-05, inWordle: false },
  { word: 'LIKER', frequency: 5.89e-08, inWordle: false },
  { word: 'LIKES', frequency: 5.37e-05, inWordle: false },
  { word: 'LIKIN', frequency: 6.76e-08, inWordle: false },
  { word: 'LILTS', frequency: 1.12e-08, inWordle: false },
  { word: 'LIMAN', frequency: 1.41e-07, inWordle: false },
  { word: 'LIMAS', frequency: 2.75e-08, inWordle: false },
  { word: 'LIMAX', frequency: 1.7e-08, inWordle: false },
  { word: 'LIMBA', frequency: 2.88e-08, inWordle: false },
  { word: 'LIMBS', frequency: 5.5e-06, inWordle: false },
  { word: 'LIMED', frequency: 2.88e-08, inWordle: false },
  { word: 'LIMEN', frequency: 1.78e-08, inWordle: false },
  { word: 'LIMES', frequency: 7.08e-07, inWordle: false },
  { word: 'LIMEY', frequency: 1.35e-07, inWordle: false },
  { word: 'LIMOS', frequency: 2.75e-07, inWordle: false },
  { word: 'LIMPA', frequency: 1.32e-08, inWordle: false },
  { word: 'LIMPS', frequency: 1.66e-07, inWordle: false },
  { word: 'LINAC', frequency: 6.76e-08, inWordle: false },
  { word: 'LINCH', frequency: 2.57e-08, inWordle: false },
  { word: 'LINDS', frequency: 8.71e-08, inWordle: false },
  { word: 'LINDY', frequency: 6.92e-07, inWordle: false },
  { word: 'LINED', frequency: 1.2e-05, inWordle: false },
  { word: 'LINES', frequency: 8.91e-05, inWordle: false },
  { word: 'LINEY', frequency: 1.38e-08, inWordle: false },
  { word: 'LINGA', frequency: 1.35e-07, inWordle: false },
  { word: 'LINGS', frequency: 1.15e-07, inWordle: false },
  { word: 'LININ', frequency: 1.55e-08, inWordle: false },
  { word: 'LINKS', frequency: 5.25e-05, inWordle: false },
  { word: 'LINKY', frequency: 2.88e-07, inWordle: false },
  { word: 'LINNY', frequency: 3.98e-08, inWordle: false },
  { word: 'LINOS', frequency: 2.4e-08, inWordle: false },
  { word: 'LINTS', frequency: 1.12e-08, inWordle: false },
  { word: 'LINTY', frequency: 1.35e-08, inWordle: false },
  { word: 'LINUM', frequency: 4.57e-08, inWordle: false },
  { word: 'LINUX', frequency: 9.77e-06, inWordle: false },
  { word: 'LIONS', frequency: 1.51e-05, inWordle: false },
  { word: 'LIPIN', frequency: 2.51e-08, inWordle: false },
  { word: 'LIPOS', frequency: 1.38e-08, inWordle: false },
  { word: 'LIPPY', frequency: 1.58e-07, inWordle: false },
  { word: 'LIRAS', frequency: 6.76e-08, inWordle: false },
  { word: 'LISLE', frequency: 4.17e-07, inWordle: false },
  { word: 'LISPS', frequency: 4.07e-08, inWordle: false },
  { word: 'LISTS', frequency: 2.4e-05, inWordle: false },
  { word: 'LITAS', frequency: 2.75e-08, inWordle: false },
  { word: 'LITER', frequency: 2.88e-06, inWordle: false },
  { word: 'LITES', frequency: 1.78e-07, inWordle: false },
  { word: 'LITHO', frequency: 1.35e-07, inWordle: false },
  { word: 'LITRE', frequency: 3.16e-06, inWordle: false },
  { word: 'LIVED', frequency: 7.59e-05, inWordle: false },
  { word: 'LIVEN', frequency: 4.27e-07, inWordle: false },
  { word: 'LIVES', frequency: 0.000138, inWordle: false },
  { word: 'LIVOR', frequency: 1.35e-08, inWordle: false },
  { word: 'LIVRE', frequency: 2.69e-07, inWordle: false },
  { word: 'LLANO', frequency: 1.58e-07, inWordle: false },
  { word: 'LOACH', frequency: 2.75e-07, inWordle: false },
  { word: 'LOADS', frequency: 1.66e-05, inWordle: false },
  { word: 'LOAFS', frequency: 5.5e-08, inWordle: false },
  { word: 'LOAMS', frequency: 4.17e-08, inWordle: false },
  { word: 'LOANS', frequency: 3.24e-05, inWordle: false },
  { word: 'LOBAR', frequency: 3.89e-08, inWordle: false },
  { word: 'LOBED', frequency: 3.8e-07, inWordle: false },
  { word: 'LOBES', frequency: 1.38e-06, inWordle: false },
  { word: 'LOBOS', frequency: 5.62e-07, inWordle: false },
  { word: 'LOCHE', frequency: 1.95e-08, inWordle: false },
  { word: 'LOCHS', frequency: 2e-07, inWordle: false },
  { word: 'LOCIS', frequency: 3.47e-08, inWordle: false },
  { word: 'LOCKS', frequency: 8.71e-06, inWordle: false },
  { word: 'LOCOS', frequency: 2.82e-07, inWordle: false },
  { word: 'LOCUM', frequency: 3.89e-07, inWordle: false },
  { word: 'LODEN', frequency: 4.37e-08, inWordle: false },
  { word: 'LODES', frequency: 4.68e-08, inWordle: false },
  { word: 'LOESS', frequency: 2e-07, inWordle: false },
  { word: 'LOFTS', frequency: 4.37e-07, inWordle: false },
  { word: 'LOGAN', frequency: 1.1e-05, inWordle: false },
  { word: 'LOGES', frequency: 1.86e-08, inWordle: false },
  { word: 'LOGIA', frequency: 6.92e-08, inWordle: false },
  { word: 'LOGIE', frequency: 3.89e-07, inWordle: false },
  { word: 'LOGOI', frequency: 1.51e-08, inWordle: false },
  { word: 'LOGON', frequency: 2.34e-07, inWordle: false },
  { word: 'LOGOS', frequency: 3.39e-06, inWordle: false },
  { word: 'LOHAN', frequency: 1.02e-06, inWordle: false },
  { word: 'LOINS', frequency: 5.13e-07, inWordle: false },
  { word: 'LOLLS', frequency: 2.34e-08, inWordle: false },
  { word: 'LOLLY', frequency: 6.46e-07, inWordle: false },
  { word: 'LOMAS', frequency: 2.63e-07, inWordle: false },
  { word: 'LONER', frequency: 1.17e-06, inWordle: false },
  { word: 'LONGA', frequency: 1.35e-07, inWordle: false },
  { word: 'LONGE', frequency: 1.12e-07, inWordle: false },
  { word: 'LONGS', frequency: 1.05e-06, inWordle: false },
  { word: 'LOOBY', frequency: 4.68e-08, inWordle: false },
  { word: 'LOOEY', frequency: 1.17e-08, inWordle: false },
  { word: 'LOOFA', frequency: 2.95e-08, inWordle: false },
  { word: 'LOOKS', frequency: 0.000229, inWordle: false },
  { word: 'LOOKY', frequency: 1.7e-07, inWordle: false },
  { word: 'LOOMS', frequency: 1.7e-06, inWordle: false },
  { word: 'LOONS', frequency: 3.72e-07, inWordle: false },
  { word: 'LOONY', frequency: 6.03e-07, inWordle: false },
  { word: 'LOOPS', frequency: 4.47e-06, inWordle: false },
  { word: 'LOOTS', frequency: 1.2e-07, inWordle: false },
  { word: 'LOPED', frequency: 2.95e-08, inWordle: false },
  { word: 'LOPER', frequency: 6.17e-08, inWordle: false },
  { word: 'LOPES', frequency: 4.47e-07, inWordle: false },
  { word: 'LORAL', frequency: 9.12e-08, inWordle: false },
  { word: 'LORAN', frequency: 1.74e-07, inWordle: false },
  { word: 'LORDS', frequency: 1.2e-05, inWordle: false },
  { word: 'LORDY', frequency: 3.31e-07, inWordle: false },
  { word: 'LORES', frequency: 1.17e-07, inWordle: false },
  { word: 'LORIS', frequency: 2.14e-07, inWordle: false },
  { word: 'LOSED', frequency: 1.7e-08, inWordle: false },
  { word: 'LOSEN', frequency: 2.63e-08, inWordle: false },
  { word: 'LOSES', frequency: 1.29e-05, inWordle: false },
  { word: 'LOSSY', frequency: 2.24e-07, inWordle: false },
  { word: 'LOTIC', frequency: 1.78e-08, inWordle: false },
  { word: 'LOTOS', frequency: 5.13e-08, inWordle: false },
  { word: 'LOTSA', frequency: 1.82e-07, inWordle: false },
  { word: 'LOTTA', frequency: 1.58e-06, inWordle: false },
  { word: 'LOTTE', frequency: 9.77e-07, inWordle: false },
  { word: 'LOTTO', frequency: 1.7e-06, inWordle: false },
  { word: 'LOTUS', frequency: 4.17e-06, inWordle: false },
  { word: 'LOUGH', frequency: 6.92e-07, inWordle: false },
  { word: 'LOUIE', frequency: 2.4e-06, inWordle: false },
  { word: 'LOUIS', frequency: 6.61e-05, inWordle: false },
  { word: 'LOUND', frequency: 2.45e-08, inWordle: false },
  { word: 'LOUPE', frequency: 1.12e-07, inWordle: false },
  { word: 'LOUPS', frequency: 1.7e-08, inWordle: false },
  { word: 'LOURY', frequency: 2.82e-08, inWordle: false },
  { word: 'LOUTS', frequency: 1.15e-07, inWordle: false },
  { word: 'LOVAT', frequency: 1.45e-07, inWordle: false },
  { word: 'LOVED', frequency: 0.0001, inWordle: false },
  { word: 'LOVES', frequency: 4.57e-05, inWordle: false },
  { word: 'LOVEY', frequency: 5.62e-07, inWordle: false },
  { word: 'LOVIE', frequency: 1.86e-07, inWordle: false },
  { word: 'LOWAN', frequency: 2.82e-08, inWordle: false },
  { word: 'LOWED', frequency: 3.09e-08, inWordle: false },
  { word: 'LOWES', frequency: 4.9e-07, inWordle: false },
  { word: 'LOWNE', frequency: 1.02e-08, inWordle: false },
  { word: 'LOWRY', frequency: 2.24e-06, inWordle: false },
  { word: 'LUAUS', frequency: 1.74e-08, inWordle: false },
  { word: 'LUBED', frequency: 1.17e-07, inWordle: false },
  { word: 'LUBES', frequency: 9.33e-08, inWordle: false },
  { word: 'LUCES', frequency: 2.75e-08, inWordle: false },
  { word: 'LUCKS', frequency: 8.71e-08, inWordle: false },
  { word: 'LUCRE', frequency: 1.05e-07, inWordle: false },
  { word: 'LUDES', frequency: 3.47e-08, inWordle: false },
  { word: 'LUDIC', frequency: 4.17e-08, inWordle: false },
  { word: 'LUFFA', frequency: 2.63e-08, inWordle: false },
  { word: 'LUGER', frequency: 4.17e-07, inWordle: false },
  { word: 'LULLS', frequency: 1.86e-07, inWordle: false },
  { word: 'LULUS', frequency: 3.24e-08, inWordle: false },
  { word: 'LUMAS', frequency: 1.23e-08, inWordle: false },
  { word: 'LUMME', frequency: 1.7e-08, inWordle: false },
  { word: 'LUMPS', frequency: 1.55e-06, inWordle: false },
  { word: 'LUNAS', frequency: 8.51e-08, inWordle: false },
  { word: 'LUNES', frequency: 4.79e-08, inWordle: false },
  { word: 'LUNGI', frequency: 8.51e-08, inWordle: false },
  { word: 'LUNGS', frequency: 9.33e-06, inWordle: false },
  { word: 'LUNTS', frequency: 1.78e-08, inWordle: false },
  { word: 'LUPIN', frequency: 7.24e-07, inWordle: false },
  { word: 'LURED', frequency: 1.82e-06, inWordle: false },
  { word: 'LURES', frequency: 8.71e-07, inWordle: false },
  { word: 'LUREX', frequency: 4.17e-08, inWordle: false },
  { word: 'LURGY', frequency: 2e-08, inWordle: false },
  { word: 'LURKS', frequency: 6.61e-07, inWordle: false },
  { word: 'LURVE', frequency: 3.63e-08, inWordle: false },
  { word: 'LUSTS', frequency: 3.09e-07, inWordle: false },
  { word: 'LUSUS', frequency: 1.95e-08, inWordle: false },
  { word: 'LUTEA', frequency: 1.15e-07, inWordle: false },
  { word: 'LUTER', frequency: 1.1e-08, inWordle: false },
  { word: 'LUTES', frequency: 1.02e-07, inWordle: false },
  { word: 'LYASE', frequency: 8.71e-08, inWordle: false },
  { word: 'LYCEE', frequency: 7.08e-08, inWordle: false },
  { word: 'LYCRA', frequency: 4.47e-07, inWordle: false },
  { word: 'LYMES', frequency: 1.66e-08, inWordle: false },
  { word: 'LYNES', frequency: 4.07e-08, inWordle: false },
  { word: 'LYRES', frequency: 3.72e-08, inWordle: false },
  { word: 'LYSED', frequency: 6.61e-08, inWordle: false },
  { word: 'LYSES', frequency: 1.38e-08, inWordle: false },
  { word: 'LYSIN', frequency: 1.02e-08, inWordle: false },
  { word: 'LYSIS', frequency: 2.69e-07, inWordle: false },
  { word: 'LYSOL', frequency: 1.7e-07, inWordle: false },
  { word: 'LYSSA', frequency: 8.51e-08, inWordle: false },
  { word: 'LYTES', frequency: 1.7e-08, inWordle: false },
  { word: 'LYTHE', frequency: 2.04e-08, inWordle: false },
  { word: 'LYTIC', frequency: 1.1e-07, inWordle: false },
  { word: 'MACED', frequency: 7.24e-08, inWordle: false },
  { word: 'MACER', frequency: 6.31e-08, inWordle: false },
  { word: 'MACES', frequency: 1.02e-07, inWordle: false },
  { word: 'MACHE', frequency: 2.51e-07, inWordle: false },
  { word: 'MACHI', frequency: 3.24e-07, inWordle: false },
  { word: 'MACHS', frequency: 1.51e-08, inWordle: false },
  { word: 'MACKS', frequency: 5.5e-08, inWordle: false },
  { word: 'MACON', frequency: 1.35e-06, inWordle: false },
  { word: 'MADGE', frequency: 7.41e-07, inWordle: false },
  { word: 'MADRE', frequency: 7.59e-07, inWordle: false },
  { word: 'MAFIC', frequency: 1.55e-07, inWordle: false },
  { word: 'MAGES', frequency: 4.27e-07, inWordle: false },
  { word: 'MAGGS', frequency: 1.12e-07, inWordle: false },
  { word: 'MAGUS', frequency: 4.07e-07, inWordle: false },
  { word: 'MAHUA', frequency: 2.75e-08, inWordle: false },
  { word: 'MAIDS', frequency: 1.78e-06, inWordle: false },
  { word: 'MAIKO', frequency: 1.17e-07, inWordle: false },
  { word: 'MAILE', frequency: 8.13e-08, inWordle: false },
  { word: 'MAILS', frequency: 4.17e-06, inWordle: false },
  { word: 'MAIMS', frequency: 3.55e-08, inWordle: false },
  { word: 'MAINS', frequency: 2.82e-06, inWordle: false },
  { word: 'MAIRE', frequency: 1.91e-07, inWordle: false },
  { word: 'MAIRS', frequency: 2.45e-08, inWordle: false },
  { word: 'MAISE', frequency: 1.91e-08, inWordle: false },
  { word: 'MAKAR', frequency: 1.2e-07, inWordle: false },
  { word: 'MAKES', frequency: 0.000288, inWordle: false },
  { word: 'MAKIS', frequency: 4.37e-08, inWordle: false },
  { word: 'MAKOS', frequency: 3.8e-08, inWordle: false },
  { word: 'MALAM', frequency: 1.45e-07, inWordle: false },
  { word: 'MALAR', frequency: 1.17e-07, inWordle: false },
  { word: 'MALAS', frequency: 7.76e-08, inWordle: false },
  { word: 'MALES', frequency: 1.62e-05, inWordle: false },
  { word: 'MALIC', frequency: 1.38e-07, inWordle: false },
  { word: 'MALIK', frequency: 4.17e-06, inWordle: false },
  { word: 'MALIS', frequency: 3.72e-08, inWordle: false },
  { word: 'MALLS', frequency: 2.75e-06, inWordle: false },
  { word: 'MALTS', frequency: 2.29e-07, inWordle: false },
  { word: 'MALTY', frequency: 1.2e-07, inWordle: false },
  { word: 'MALUS', frequency: 1.55e-07, inWordle: false },
  { word: 'MALVA', frequency: 5.13e-08, inWordle: false },
  { word: 'MALWA', frequency: 1.02e-07, inWordle: false },
  { word: 'MAMAS', frequency: 6.17e-07, inWordle: false },
  { word: 'MAMBA', frequency: 4.37e-07, inWordle: false },
  { word: 'MAMEY', frequency: 1.58e-08, inWordle: false },
  { word: 'MAMIE', frequency: 4.47e-07, inWordle: false },
  { word: 'MANAS', frequency: 2.14e-07, inWordle: false },
  { word: 'MANAT', frequency: 2.63e-08, inWordle: false },
  { word: 'MANDI', frequency: 4.79e-07, inWordle: false },
  { word: 'MANEB', frequency: 1.05e-08, inWordle: false },
  { word: 'MANED', frequency: 8.71e-08, inWordle: false },
  { word: 'MANEH', frequency: 1.55e-08, inWordle: false },
  { word: 'MANES', frequency: 2.69e-07, inWordle: false },
  { word: 'MANET', frequency: 3.39e-07, inWordle: false },
  { word: 'MANGS', frequency: 1.55e-08, inWordle: false },
  { word: 'MANIS', frequency: 1.7e-07, inWordle: false },
  { word: 'MANKY', frequency: 7.76e-08, inWordle: false },
  { word: 'MANNA', frequency: 6.31e-07, inWordle: false },
  { word: 'MANOS', frequency: 2.14e-07, inWordle: false },
  { word: 'MANSE', frequency: 2.88e-07, inWordle: false },
  { word: 'MANTA', frequency: 6.61e-07, inWordle: false },
  { word: 'MANTO', frequency: 9.77e-08, inWordle: false },
  { word: 'MANTY', frequency: 1.02e-08, inWordle: false },
  { word: 'MANUS', frequency: 7.59e-07, inWordle: false },
  { word: 'MAQUI', frequency: 1.38e-08, inWordle: false },
  { word: 'MARAE', frequency: 7.08e-08, inWordle: false },
  { word: 'MARAH', frequency: 1.15e-07, inWordle: false },
  { word: 'MARAS', frequency: 8.51e-08, inWordle: false },
  { word: 'MARCS', frequency: 2.4e-08, inWordle: false },
  { word: 'MARDY', frequency: 1.26e-07, inWordle: false },
  { word: 'MARES', frequency: 9.77e-07, inWordle: false },
  { word: 'MARGE', frequency: 1.2e-06, inWordle: false },
  { word: 'MARGS', frequency: 2.69e-08, inWordle: false },
  { word: 'MARIA', frequency: 2.19e-05, inWordle: false },
  { word: 'MARID', frequency: 1.95e-08, inWordle: false },
  { word: 'MARKA', frequency: 4.37e-08, inWordle: false },
  { word: 'MARKS', frequency: 3.09e-05, inWordle: false },
  { word: 'MARLE', frequency: 4.79e-08, inWordle: false },
  { word: 'MARLS', frequency: 7.41e-08, inWordle: false },
  { word: 'MARLY', frequency: 1.95e-07, inWordle: false },
  { word: 'MARON', frequency: 2.19e-07, inWordle: false },
  { word: 'MARRA', frequency: 1.74e-07, inWordle: false },
  { word: 'MARRI', frequency: 1.2e-07, inWordle: false },
  { word: 'MARSE', frequency: 2.88e-08, inWordle: false },
  { word: 'MARTS', frequency: 1.86e-07, inWordle: false },
  { word: 'MARVY', frequency: 2.04e-08, inWordle: false },
  { word: 'MASER', frequency: 1.32e-07, inWordle: false },
  { word: 'MASHY', frequency: 1.32e-08, inWordle: false },
  { word: 'MASKS', frequency: 7.59e-06, inWordle: false },
  { word: 'MASSA', frequency: 1.32e-06, inWordle: false },
  { word: 'MASSY', frequency: 1.78e-07, inWordle: false },
  { word: 'MASTS', frequency: 7.76e-07, inWordle: false },
  { word: 'MATAI', frequency: 1.05e-07, inWordle: false },
  { word: 'MATED', frequency: 8.32e-07, inWordle: false },
  { word: 'MATER', frequency: 2.95e-06, inWordle: false },
  { word: 'MATES', frequency: 9.77e-06, inWordle: false },
  { word: 'MATHS', frequency: 5.62e-06, inWordle: false },
  { word: 'MATIN', frequency: 1.95e-07, inWordle: false },
  { word: 'MATTE', frequency: 3.31e-06, inWordle: false },
  { word: 'MATTS', frequency: 1.07e-07, inWordle: false },
  { word: 'MATZA', frequency: 2.88e-08, inWordle: false },
  { word: 'MATZO', frequency: 1.58e-07, inWordle: false },
  { word: 'MAULS', frequency: 1.07e-07, inWordle: false },
  { word: 'MAUND', frequency: 4.37e-08, inWordle: false },
  { word: 'MAURI', frequency: 9.77e-08, inWordle: false },
  { word: 'MAUZY', frequency: 1.74e-08, inWordle: false },
  { word: 'MAVEN', frequency: 7.59e-07, inWordle: false },
  { word: 'MAVIN', frequency: 4.57e-08, inWordle: false },
  { word: 'MAVIS', frequency: 7.41e-07, inWordle: false },
  { word: 'MAXED', frequency: 5.89e-07, inWordle: false },
  { word: 'MAXES', frequency: 8.91e-08, inWordle: false },
  { word: 'MAXIS', frequency: 2.45e-07, inWordle: false },
  { word: 'MAYAN', frequency: 1.29e-06, inWordle: false },
  { word: 'MAYAS', frequency: 9.77e-08, inWordle: false },
  { word: 'MAYOS', frequency: 3.98e-08, inWordle: false },
  { word: 'MAYST', frequency: 4.07e-08, inWordle: false },
  { word: 'MAZED', frequency: 1.2e-08, inWordle: false },
  { word: 'MAZER', frequency: 9.12e-08, inWordle: false },
  { word: 'MAZES', frequency: 4.9e-07, inWordle: false },
  { word: 'MAZEY', frequency: 1.35e-08, inWordle: false },
  { word: 'MBIRA', frequency: 3.16e-08, inWordle: false },
  { word: 'MEADS', frequency: 2.09e-07, inWordle: false },
  { word: 'MEALS', frequency: 1.55e-05, inWordle: false },
  { word: 'MEANS', frequency: 0.000275, inWordle: false },
  { word: 'MEANY', frequency: 2.04e-07, inWordle: false },
  { word: 'MEARE', frequency: 1.41e-08, inWordle: false },
  { word: 'MEASE', frequency: 2.4e-08, inWordle: false },
  { word: 'MEATH', frequency: 3.72e-07, inWordle: false },
  { word: 'MEATS', frequency: 3.02e-06, inWordle: false },
  { word: 'MECHS', frequency: 2.24e-07, inWordle: false },
  { word: 'MEDII', frequency: 2.57e-08, inWordle: false },
  { word: 'MEEDS', frequency: 1.35e-08, inWordle: false },
  { word: 'MEERS', frequency: 5.25e-08, inWordle: false },
  { word: 'MEETS', frequency: 2.29e-05, inWordle: false },
  { word: 'MEINS', frequency: 1.58e-08, inWordle: false },
  { word: 'MEKKA', frequency: 3.89e-08, inWordle: false },
  { word: 'MELAS', frequency: 8.71e-08, inWordle: false },
  { word: 'MELBA', frequency: 2.88e-07, inWordle: false },
  { word: 'MELDS', frequency: 1.51e-07, inWordle: false },
  { word: 'MELIC', frequency: 1.07e-08, inWordle: false },
  { word: 'MELIK', frequency: 4.27e-08, inWordle: false },
  { word: 'MELLS', frequency: 2.69e-08, inWordle: false },
  { word: 'MELTS', frequency: 2.57e-06, inWordle: false },
  { word: 'MELTY', frequency: 1.66e-07, inWordle: false },
  { word: 'MEMES', frequency: 5.62e-06, inWordle: false },
  { word: 'MEMOS', frequency: 9.55e-07, inWordle: false },
  { word: 'MENDS', frequency: 1.26e-07, inWordle: false },
  { word: 'MENES', frequency: 5.01e-08, inWordle: false },
  { word: 'MENGE', frequency: 4.79e-08, inWordle: false },
  { word: 'MENGS', frequency: 1.86e-08, inWordle: false },
  { word: 'MENSA', frequency: 4.57e-07, inWordle: false },
  { word: 'MENSE', frequency: 3.39e-08, inWordle: false },
  { word: 'MENTA', frequency: 6.61e-08, inWordle: false },
  { word: 'MENTO', frequency: 6.61e-08, inWordle: false },
  { word: 'MENUS', frequency: 2.75e-06, inWordle: false },
  { word: 'MEOWS', frequency: 2.34e-07, inWordle: false },
  { word: 'MERCH', frequency: 1.66e-06, inWordle: false },
  { word: 'MERCS', frequency: 1.82e-07, inWordle: false },
  { word: 'MERDE', frequency: 8.71e-08, inWordle: false },
  { word: 'MERED', frequency: 1.45e-08, inWordle: false },
  { word: 'MEREL', frequency: 3.63e-08, inWordle: false },
  { word: 'MERES', frequency: 5.89e-08, inWordle: false },
  { word: 'MERIL', frequency: 2.4e-08, inWordle: false },
  { word: 'MERIS', frequency: 2.69e-08, inWordle: false },
  { word: 'MERKS', frequency: 3.72e-08, inWordle: false },
  { word: 'MERLE', frequency: 1.1e-06, inWordle: false },
  { word: 'MERSE', frequency: 2.82e-08, inWordle: false },
  { word: 'MESAS', frequency: 1.7e-07, inWordle: false },
  { word: 'MESES', frequency: 3.24e-08, inWordle: false },
  { word: 'MESIC', frequency: 9.12e-08, inWordle: false },
  { word: 'MESNE', frequency: 3.02e-08, inWordle: false },
  { word: 'MESON', frequency: 1.38e-07, inWordle: false },
  { word: 'MESSY', frequency: 7.41e-06, inWordle: false },
  { word: 'MESTO', frequency: 3.55e-08, inWordle: false },
  { word: 'METED', frequency: 3.63e-07, inWordle: false },
  { word: 'METES', frequency: 5.37e-08, inWordle: false },
  { word: 'METHO', frequency: 2.04e-08, inWordle: false },
  { word: 'METHS', frequency: 2.69e-08, inWordle: false },
  { word: 'METIC', frequency: 1.41e-08, inWordle: false },
  { word: 'METIS', frequency: 2.14e-07, inWordle: false },
  { word: 'METRE', frequency: 5.75e-06, inWordle: false },
  { word: 'MEUSE', frequency: 2.57e-07, inWordle: false },
  { word: 'MEWED', frequency: 1.45e-08, inWordle: false },
  { word: 'MEZES', frequency: 1.23e-08, inWordle: false },
  { word: 'MEZZE', frequency: 4.17e-08, inWordle: false },
  { word: 'MEZZO', frequency: 3.98e-07, inWordle: false },
  { word: 'MIAOU', frequency: 1.2e-08, inWordle: false },
  { word: 'MIAOW', frequency: 6.76e-08, inWordle: false },
  { word: 'MICAS', frequency: 3.24e-08, inWordle: false },
  { word: 'MICHE', frequency: 6.17e-08, inWordle: false },
  { word: 'MICKS', frequency: 4.57e-08, inWordle: false },
  { word: 'MICKY', frequency: 8.13e-07, inWordle: false },
  { word: 'MICRA', frequency: 1.35e-07, inWordle: false },
  { word: 'MIDDY', frequency: 4.27e-08, inWordle: false },
  { word: 'MIDIS', frequency: 2.29e-08, inWordle: false },
  { word: 'MIFFY', frequency: 3.98e-08, inWordle: false },
  { word: 'MIGGS', frequency: 2.88e-08, inWordle: false },
  { word: 'MIKED', frequency: 5.89e-08, inWordle: false },
  { word: 'MIKES', frequency: 4.07e-07, inWordle: false },
  { word: 'MIKVA', frequency: 3.16e-08, inWordle: false },
  { word: 'MILCH', frequency: 1.45e-07, inWordle: false },
  { word: 'MILDS', frequency: 2.75e-08, inWordle: false },
  { word: 'MILER', frequency: 3.47e-07, inWordle: false },
  { word: 'MILES', frequency: 0.0001, inWordle: false },
  { word: 'MILFS', frequency: 6.03e-07, inWordle: false },
  { word: 'MILIA', frequency: 6.31e-08, inWordle: false },
  { word: 'MILKO', frequency: 2.95e-08, inWordle: false },
  { word: 'MILKS', frequency: 3.55e-07, inWordle: false },
  { word: 'MILLE', frequency: 6.31e-07, inWordle: false },
  { word: 'MILLS', frequency: 1.66e-05, inWordle: false },
  { word: 'MILOS', frequency: 6.31e-07, inWordle: false },
  { word: 'MILPA', frequency: 2.95e-08, inWordle: false },
  { word: 'MILTY', frequency: 1.23e-08, inWordle: false },
  { word: 'MIMED', frequency: 9.55e-08, inWordle: false },
  { word: 'MIMEO', frequency: 3.09e-08, inWordle: false },
  { word: 'MIMER', frequency: 1.26e-08, inWordle: false },
  { word: 'MIMES', frequency: 2.04e-07, inWordle: false },
  { word: 'MIMSY', frequency: 4.07e-08, inWordle: false },
  { word: 'MINAE', frequency: 2.4e-08, inWordle: false },
  { word: 'MINAR', frequency: 9.33e-08, inWordle: false },
  { word: 'MINAS', frequency: 6.92e-07, inWordle: false },
  { word: 'MINCY', frequency: 1.74e-08, inWordle: false },
  { word: 'MINDS', frequency: 2.82e-05, inWordle: false },
  { word: 'MINED', frequency: 2.57e-06, inWordle: false },
  { word: 'MINES', frequency: 1.51e-05, inWordle: false },
  { word: 'MINGE', frequency: 9.12e-08, inWordle: false },
  { word: 'MINGS', frequency: 6.31e-08, inWordle: false },
  { word: 'MINGY', frequency: 1.26e-08, inWordle: false },
  { word: 'MINIS', frequency: 6.76e-07, inWordle: false },
  { word: 'MINKE', frequency: 1.86e-07, inWordle: false },
  { word: 'MINKS', frequency: 1.35e-07, inWordle: false },
  { word: 'MINNY', frequency: 1.66e-07, inWordle: false },
  { word: 'MINOS', frequency: 2.45e-07, inWordle: false },
  { word: 'MINTS', frequency: 1.05e-06, inWordle: false },
  { word: 'MIRED', frequency: 6.46e-07, inWordle: false },
  { word: 'MIRES', frequency: 6.31e-08, inWordle: false },
  { word: 'MIREX', frequency: 1.29e-08, inWordle: false },
  { word: 'MIRIN', frequency: 9.55e-08, inWordle: false },
  { word: 'MIROS', frequency: 1.02e-08, inWordle: false },
  { word: 'MIRVS', frequency: 1.95e-08, inWordle: false },
  { word: 'MIRZA', frequency: 7.76e-07, inWordle: false },
  { word: 'MISCH', frequency: 5.75e-08, inWordle: false },
  { word: 'MISES', frequency: 3.63e-07, inWordle: false },
  { word: 'MISSA', frequency: 3.72e-07, inWordle: false },
  { word: 'MISTS', frequency: 6.76e-07, inWordle: false },
  { word: 'MISTY', frequency: 2.45e-06, inWordle: false },
  { word: 'MITCH', frequency: 8.13e-06, inWordle: false },
  { word: 'MITER', frequency: 2.45e-07, inWordle: false },
  { word: 'MITES', frequency: 1.15e-06, inWordle: false },
  { word: 'MITIS', frequency: 3.98e-08, inWordle: false },
  { word: 'MITRE', frequency: 4.27e-07, inWordle: false },
  { word: 'MITTS', frequency: 5.13e-07, inWordle: false },
  { word: 'MIXED', frequency: 4.37e-05, inWordle: false },
  { word: 'MIXER', frequency: 3.16e-06, inWordle: false },
  { word: 'MIXES', frequency: 3.31e-06, inWordle: false },
  { word: 'MIXTE', frequency: 2.51e-08, inWordle: false },
  { word: 'MIXUP', frequency: 1.45e-07, inWordle: false },
  { word: 'MIZEN', frequency: 6.03e-08, inWordle: false },
  { word: 'MIZZY', frequency: 1.66e-08, inWordle: false },
  { word: 'MOANS', frequency: 1.35e-06, inWordle: false },
  { word: 'MOATS', frequency: 1.78e-07, inWordle: false },
  { word: 'MOBLE', frequency: 1.17e-08, inWordle: false },
  { word: 'MOCHI', frequency: 2.63e-07, inWordle: false },
  { word: 'MOCKS', frequency: 1.1e-06, inWordle: false },
  { word: 'MODER', frequency: 8.51e-08, inWordle: false },
  { word: 'MODES', frequency: 9.12e-06, inWordle: false },
  { word: 'MODUS', frequency: 8.51e-07, inWordle: false },
  { word: 'MOERS', frequency: 4.07e-08, inWordle: false },
  { word: 'MOFOS', frequency: 1.26e-07, inWordle: false },
  { word: 'MOGGY', frequency: 5.01e-08, inWordle: false },
  { word: 'MOHEL', frequency: 4.27e-08, inWordle: false },
  { word: 'MOIRA', frequency: 1.35e-06, inWordle: false },
  { word: 'MOIRE', frequency: 9.77e-08, inWordle: false },
  { word: 'MOJOS', frequency: 3.89e-08, inWordle: false },
  { word: 'MOKES', frequency: 1.23e-08, inWordle: false },
  { word: 'MOLAS', frequency: 3.02e-08, inWordle: false },
  { word: 'MOLDS', frequency: 1.32e-06, inWordle: false },
  { word: 'MOLES', frequency: 1.17e-06, inWordle: false },
  { word: 'MOLLA', frequency: 7.76e-08, inWordle: false },
  { word: 'MOLLS', frequency: 4.68e-08, inWordle: false },
  { word: 'MOLLY', frequency: 7.41e-06, inWordle: false },
  { word: 'MOLTO', frequency: 2.04e-07, inWordle: false },
  { word: 'MOLTS', frequency: 5.01e-08, inWordle: false },
  { word: 'MOMMA', frequency: 2.57e-06, inWordle: false },
  { word: 'MOMMY', frequency: 7.76e-06, inWordle: false },
  { word: 'MOMUS', frequency: 3.89e-08, inWordle: false },
  { word: 'MONAD', frequency: 2.24e-07, inWordle: false },
  { word: 'MONAL', frequency: 1.86e-08, inWordle: false },
  { word: 'MONAS', frequency: 4.37e-08, inWordle: false },
  { word: 'MONDE', frequency: 1.1e-06, inWordle: false },
  { word: 'MONDO', frequency: 6.17e-07, inWordle: false },
  { word: 'MONER', frequency: 3.72e-08, inWordle: false },
  { word: 'MONGO', frequency: 3.31e-07, inWordle: false },
  { word: 'MONGS', frequency: 2e-08, inWordle: false },
  { word: 'MONIC', frequency: 3.47e-08, inWordle: false },
  { word: 'MONIE', frequency: 6.46e-08, inWordle: false },
  { word: 'MONKS', frequency: 5.25e-06, inWordle: false },
  { word: 'MONOS', frequency: 4.79e-08, inWordle: false },
  { word: 'MONTE', frequency: 4.9e-06, inWordle: false },
  { word: 'MONTY', frequency: 3.55e-06, inWordle: false },
  { word: 'MOOBS', frequency: 6.17e-08, inWordle: false },
  { word: 'MOOCH', frequency: 2.69e-07, inWordle: false },
  { word: 'MOODS', frequency: 2.34e-06, inWordle: false },
  { word: 'MOOED', frequency: 1.51e-08, inWordle: false },
  { word: 'MOOKS', frequency: 7.59e-08, inWordle: false },
  { word: 'MOOLA', frequency: 7.41e-08, inWordle: false },
  { word: 'MOOLI', frequency: 1.35e-08, inWordle: false },
  { word: 'MOONG', frequency: 4.79e-08, inWordle: false },
  { word: 'MOONS', frequency: 2.4e-06, inWordle: false },
  { word: 'MOONY', frequency: 6.46e-08, inWordle: false },
  { word: 'MOOPS', frequency: 1.38e-08, inWordle: false },
  { word: 'MOORS', frequency: 1.51e-06, inWordle: false },
  { word: 'MOOTS', frequency: 5.62e-08, inWordle: false },
  { word: 'MOOVE', frequency: 1.91e-08, inWordle: false },
  { word: 'MOPED', frequency: 6.03e-07, inWordle: false },
  { word: 'MOPES', frequency: 4.17e-08, inWordle: false },
  { word: 'MOPEY', frequency: 1.2e-07, inWordle: false },
  { word: 'MOPSY', frequency: 2.29e-08, inWordle: false },
  { word: 'MORAE', frequency: 1.29e-08, inWordle: false },
  { word: 'MORAS', frequency: 3.63e-08, inWordle: false },
  { word: 'MORAT', frequency: 2.4e-08, inWordle: false },
  { word: 'MORAY', frequency: 1.05e-06, inWordle: false },
  { word: 'MOREL', frequency: 4.17e-07, inWordle: false },
  { word: 'MORES', frequency: 6.61e-07, inWordle: false },
  { word: 'MORIA', frequency: 4.17e-07, inWordle: false },
  { word: 'MORNE', frequency: 1.95e-07, inWordle: false },
  { word: 'MORNS', frequency: 1.74e-08, inWordle: false },
  { word: 'MORRA', frequency: 1.12e-07, inWordle: false },
  { word: 'MORRO', frequency: 2.88e-07, inWordle: false },
  { word: 'MORSE', frequency: 3.31e-06, inWordle: false },
  { word: 'MORTS', frequency: 6.46e-08, inWordle: false },
  { word: 'MOSES', frequency: 9.55e-06, inWordle: false },
  { word: 'MOSEY', frequency: 1.51e-07, inWordle: false },
  { word: 'MOSSO', frequency: 4.57e-08, inWordle: false },
  { word: 'MOSTE', frequency: 1.74e-08, inWordle: false },
  { word: 'MOSTS', frequency: 1.41e-08, inWordle: false },
  { word: 'MOTEN', frequency: 4.9e-08, inWordle: false },
  { word: 'MOTES', frequency: 2.4e-07, inWordle: false },
  { word: 'MOTET', frequency: 9.12e-08, inWordle: false },
  { word: 'MOTHS', frequency: 1.62e-06, inWordle: false },
  { word: 'MOTTE', frequency: 3.16e-07, inWordle: false },
  { word: 'MOTTS', frequency: 3.31e-08, inWordle: false },
  { word: 'MOTTY', frequency: 1.48e-08, inWordle: false },
  { word: 'MOTUS', frequency: 6.31e-08, inWordle: false },
  { word: 'MOTZA', frequency: 1.35e-08, inWordle: false },
  { word: 'MOUCH', frequency: 2.04e-08, inWordle: false },
  { word: 'MOULD', frequency: 2.82e-06, inWordle: false },
  { word: 'MOUSY', frequency: 1.02e-07, inWordle: false },
  { word: 'MOVED', frequency: 0.000102, inWordle: false },
  { word: 'MOVES', frequency: 3.89e-05, inWordle: false },
  { word: 'MOWED', frequency: 5.89e-07, inWordle: false },
  { word: 'MOXIE', frequency: 3.55e-07, inWordle: false },
  { word: 'MOYLE', frequency: 1.2e-07, inWordle: false },
  { word: 'MOZES', frequency: 2.51e-08, inWordle: false },
  { word: 'MUCHO', frequency: 3.89e-07, inWordle: false },
  { word: 'MUCIN', frequency: 1.07e-07, inWordle: false },
  { word: 'MUCKS', frequency: 5.89e-08, inWordle: false },
  { word: 'MUCOR', frequency: 2.75e-08, inWordle: false },
  { word: 'MUDGE', frequency: 1.55e-07, inWordle: false },
  { word: 'MUDRA', frequency: 1.7e-07, inWordle: false },
  { word: 'MUFFS', frequency: 1.51e-07, inWordle: false },
  { word: 'MUFTI', frequency: 7.24e-07, inWordle: false },
  { word: 'MUGGA', frequency: 1.29e-08, inWordle: false },
  { word: 'MUGGS', frequency: 4.68e-08, inWordle: false },
  { word: 'MUGGY', frequency: 3.39e-07, inWordle: false },
  { word: 'MUHLY', frequency: 4.79e-08, inWordle: false },
  { word: 'MULES', frequency: 1.29e-06, inWordle: false },
  { word: 'MULEY', frequency: 5.62e-08, inWordle: false },
  { word: 'MULGA', frequency: 4.9e-08, inWordle: false },
  { word: 'MULLA', frequency: 1.66e-07, inWordle: false },
  { word: 'MULLS', frequency: 2.04e-07, inWordle: false },
  { word: 'MUMPS', frequency: 6.46e-07, inWordle: false },
  { word: 'MUMSY', frequency: 4.68e-08, inWordle: false },
  { word: 'MUNGA', frequency: 2.34e-08, inWordle: false },
  { word: 'MUNGE', frequency: 1.1e-08, inWordle: false },
  { word: 'MUNGO', frequency: 2.75e-07, inWordle: false },
  { word: 'MUNIS', frequency: 7.08e-08, inWordle: false },
  { word: 'MUNTU', frequency: 1.95e-08, inWordle: false },
  { word: 'MUONS', frequency: 9.33e-08, inWordle: false },
  { word: 'MURES', frequency: 3.31e-08, inWordle: false },
  { word: 'MUREX', frequency: 7.59e-08, inWordle: false },
  { word: 'MURID', frequency: 4.47e-08, inWordle: false },
  { word: 'MURKS', frequency: 1.23e-08, inWordle: false },
  { word: 'MURRA', frequency: 2e-08, inWordle: false },
  { word: 'MURRE', frequency: 2.09e-08, inWordle: false },
  { word: 'MURRI', frequency: 2.4e-08, inWordle: false },
  { word: 'MURRY', frequency: 1.78e-07, inWordle: false },
  { word: 'MURTI', frequency: 7.76e-08, inWordle: false },
  { word: 'MUSAR', frequency: 1.23e-08, inWordle: false },
  { word: 'MUSCA', frequency: 5.75e-08, inWordle: false },
  { word: 'MUSED', frequency: 4.68e-07, inWordle: false },
  { word: 'MUSER', frequency: 2.29e-08, inWordle: false },
  { word: 'MUSES', frequency: 1.1e-06, inWordle: false },
  { word: 'MUSHA', frequency: 5.75e-08, inWordle: false },
  { word: 'MUSKS', frequency: 3.16e-08, inWordle: false },
  { word: 'MUSOS', frequency: 2.19e-08, inWordle: false },
  { word: 'MUSSE', frequency: 1.86e-08, inWordle: false },
  { word: 'MUSSY', frequency: 3.8e-08, inWordle: false },
  { word: 'MUSTH', frequency: 2.88e-08, inWordle: false },
  { word: 'MUSTS', frequency: 8.91e-08, inWordle: false },
  { word: 'MUTCH', frequency: 1.51e-07, inWordle: false },
  { word: 'MUTED', frequency: 2.63e-06, inWordle: false },
  { word: 'MUTER', frequency: 2.34e-08, inWordle: false },
  { word: 'MUTES', frequency: 2.82e-07, inWordle: false },
  { word: 'MUTHA', frequency: 1.45e-07, inWordle: false },
  { word: 'MUTIS', frequency: 1.35e-08, inWordle: false },
  { word: 'MUTTS', frequency: 2.63e-07, inWordle: false },
  { word: 'MUZAK', frequency: 1.15e-07, inWordle: false },
  { word: 'MUZZY', frequency: 1e-07, inWordle: false },
  { word: 'MYALL', frequency: 4.17e-08, inWordle: false },
  { word: 'MYLAR', frequency: 2.34e-07, inWordle: false },
  { word: 'MYNAH', frequency: 4.37e-08, inWordle: false },
  { word: 'MYOMA', frequency: 1.7e-08, inWordle: false },
  { word: 'MYSID', frequency: 1.23e-08, inWordle: false },
  { word: 'MYTHS', frequency: 5.62e-06, inWordle: false },
  { word: 'NAANS', frequency: 1.38e-08, inWordle: false },
  { word: 'NABIS', frequency: 3.24e-08, inWordle: false },
  { word: 'NABLA', frequency: 1.41e-08, inWordle: false },
  { word: 'NABOB', frequency: 4.79e-08, inWordle: false },
  { word: 'NACHO', frequency: 1.05e-06, inWordle: false },
  { word: 'NACRE', frequency: 4.79e-08, inWordle: false },
  { word: 'NADAS', frequency: 1.07e-08, inWordle: false },
  { word: 'NAGAS', frequency: 1.41e-07, inWordle: false },
  { word: 'NAGGY', frequency: 3.47e-08, inWordle: false },
  { word: 'NAHAL', frequency: 8.13e-08, inWordle: false },
  { word: 'NAIAD', frequency: 5.89e-08, inWordle: false },
  { word: 'NAILS', frequency: 1.1e-05, inWordle: false },
  { word: 'NAIRA', frequency: 4.27e-07, inWordle: false },
  { word: 'NAIRU', frequency: 3.55e-08, inWordle: false },
  { word: 'NAKED', frequency: 2.69e-05, inWordle: false },
  { word: 'NALAS', frequency: 2.69e-08, inWordle: false },
  { word: 'NALED', frequency: 1.38e-08, inWordle: false },
  { word: 'NALLA', frequency: 4.79e-08, inWordle: false },
  { word: 'NAMED', frequency: 8.91e-05, inWordle: false },
  { word: 'NAMER', frequency: 4.79e-08, inWordle: false },
  { word: 'NAMES', frequency: 8.13e-05, inWordle: false },
  { word: 'NAMMA', frequency: 6.31e-08, inWordle: false },
  { word: 'NAMUS', frequency: 1.66e-08, inWordle: false },
  { word: 'NANAS', frequency: 6.92e-08, inWordle: false },
  { word: 'NANCE', frequency: 7.94e-07, inWordle: false },
  { word: 'NANCY', frequency: 1.38e-05, inWordle: false },
  { word: 'NANDU', frequency: 1e-07, inWordle: false },
  { word: 'NANNA', frequency: 3.16e-07, inWordle: false },
  { word: 'NANOS', frequency: 9.55e-08, inWordle: false },
  { word: 'NAPED', frequency: 2.09e-08, inWordle: false },
  { word: 'NAPES', frequency: 2.69e-08, inWordle: false },
  { word: 'NAPPA', frequency: 1.78e-07, inWordle: false },
  { word: 'NAPPE', frequency: 3.63e-08, inWordle: false },
  { word: 'NAPPY', frequency: 7.59e-07, inWordle: false },
  { word: 'NARAS', frequency: 2.09e-08, inWordle: false },
  { word: 'NARCO', frequency: 3.72e-07, inWordle: false },
  { word: 'NARCS', frequency: 8.71e-08, inWordle: false },
  { word: 'NARDS', frequency: 2.51e-08, inWordle: false },
  { word: 'NARES', frequency: 1.32e-07, inWordle: false },
  { word: 'NARIS', frequency: 2.09e-08, inWordle: false },
  { word: 'NARKS', frequency: 2e-08, inWordle: false },
  { word: 'NARKY', frequency: 2e-08, inWordle: false },
  { word: 'NARRE', frequency: 4.57e-08, inWordle: false },
  { word: 'NASHI', frequency: 6.61e-08, inWordle: false },
  { word: 'NATCH', frequency: 1.41e-07, inWordle: false },
  { word: 'NATES', frequency: 6.76e-08, inWordle: false },
  { word: 'NATTY', frequency: 5.62e-07, inWordle: false },
  { word: 'NAVAR', frequency: 1.95e-08, inWordle: false },
  { word: 'NAVES', frequency: 7.08e-08, inWordle: false },
  { word: 'NAVVY', frequency: 4.07e-08, inWordle: false },
  { word: 'NAWAB', frequency: 3.98e-07, inWordle: false },
  { word: 'NAZIR', frequency: 3.63e-07, inWordle: false },
  { word: 'NAZIS', frequency: 8.71e-06, inWordle: false },
  { word: 'NDUJA', frequency: 1.35e-08, inWordle: false },
  { word: 'NEALS', frequency: 2.51e-08, inWordle: false },
  { word: 'NEARS', frequency: 7.59e-07, inWordle: false },
  { word: 'NEATH', frequency: 6.92e-07, inWordle: false },
  { word: 'NEATS', frequency: 1.07e-08, inWordle: false },
  { word: 'NEBEL', frequency: 5.5e-08, inWordle: false },
  { word: 'NECKS', frequency: 2.51e-06, inWordle: false },
  { word: 'NEDDY', frequency: 8.91e-08, inWordle: false },
  { word: 'NEEDS', frequency: 0.000234, inWordle: false },
  { word: 'NEELD', frequency: 2.88e-08, inWordle: false },
  { word: 'NEELE', frequency: 2.51e-08, inWordle: false },
  { word: 'NEEPS', frequency: 2.09e-08, inWordle: false },
  { word: 'NEESE', frequency: 5.01e-08, inWordle: false },
  { word: 'NEGUS', frequency: 1.82e-07, inWordle: false },
  { word: 'NEIST', frequency: 1.26e-08, inWordle: false },
  { word: 'NELIS', frequency: 3.09e-08, inWordle: false },
  { word: 'NELLY', frequency: 1.45e-06, inWordle: false },
  { word: 'NEONS', frequency: 6.61e-08, inWordle: false },
  { word: 'NERAL', frequency: 2.88e-08, inWordle: false },
  { word: 'NERDS', frequency: 2.29e-06, inWordle: false },
  { word: 'NERKA', frequency: 1.32e-08, inWordle: false },
  { word: 'NERVY', frequency: 1.78e-07, inWordle: false },
  { word: 'NESTS', frequency: 2.69e-06, inWordle: false },
  { word: 'NETTY', frequency: 5.37e-08, inWordle: false },
  { word: 'NEVEL', frequency: 3.89e-08, inWordle: false },
  { word: 'NEVES', frequency: 3.55e-07, inWordle: false },
  { word: 'NEVUS', frequency: 8.71e-08, inWordle: false },
  { word: 'NEWBS', frequency: 3.24e-08, inWordle: false },
  { word: 'NEWEL', frequency: 7.59e-08, inWordle: false },
  { word: 'NEWSY', frequency: 8.32e-08, inWordle: false },
  { word: 'NEWTS', frequency: 1.62e-07, inWordle: false },
  { word: 'NEXTS', frequency: 1.05e-08, inWordle: false },
  { word: 'NEXUS', frequency: 4.47e-06, inWordle: false },
  { word: 'NGAIO', frequency: 2.95e-08, inWordle: false },
  { word: 'NGATI', frequency: 6.76e-08, inWordle: false },
  { word: 'NGOMA', frequency: 3.72e-08, inWordle: false },
  { word: 'NICAD', frequency: 1.86e-08, inWordle: false },
  { word: 'NICHT', frequency: 7.41e-07, inWordle: false },
  { word: 'NICKS', frequency: 1.17e-06, inWordle: false },
  { word: 'NICOL', frequency: 6.03e-07, inWordle: false },
  { word: 'NIDAL', frequency: 1.15e-07, inWordle: false },
  { word: 'NIDUS', frequency: 6.46e-08, inWordle: false },
  { word: 'NIEVE', frequency: 8.91e-08, inWordle: false },
  { word: 'NIFTY', frequency: 1.48e-06, inWordle: false },
  { word: 'NIGER', frequency: 2.82e-06, inWordle: false },
  { word: 'NIHIL', frequency: 1.55e-07, inWordle: false },
  { word: 'NIKAH', frequency: 8.51e-08, inWordle: false },
  { word: 'NINER', frequency: 2.04e-07, inWordle: false },
  { word: 'NINES', frequency: 6.92e-07, inWordle: false },
  { word: 'NINON', frequency: 5.62e-08, inWordle: false },
  { word: 'NIPPY', frequency: 2.4e-07, inWordle: false },
  { word: 'NIQAB', frequency: 3.24e-07, inWordle: false },
  { word: 'NISEI', frequency: 1.23e-07, inWordle: false },
  { word: 'NISSE', frequency: 3.24e-08, inWordle: false },
  { word: 'NISUS', frequency: 6.31e-08, inWordle: false },
  { word: 'NITER', frequency: 2.82e-08, inWordle: false },
  { word: 'NITES', frequency: 4.27e-08, inWordle: false },
  { word: 'NITON', frequency: 1.82e-08, inWordle: false },
  { word: 'NITRE', frequency: 3.24e-08, inWordle: false },
  { word: 'NITRO', frequency: 1.7e-06, inWordle: false },
  { word: 'NITTY', frequency: 5.01e-07, inWordle: false },
  { word: 'NIVAL', frequency: 1.48e-08, inWordle: false },
  { word: 'NIXED', frequency: 1.91e-07, inWordle: false },
  { word: 'NIXES', frequency: 4.9e-08, inWordle: false },
  { word: 'NIXIE', frequency: 7.59e-08, inWordle: false },
  { word: 'NIZAM', frequency: 3.55e-07, inWordle: false },
  { word: 'NKOSI', frequency: 1e-07, inWordle: false },
  { word: 'NOAHS', frequency: 4.07e-08, inWordle: false },
  { word: 'NOBBY', frequency: 1.7e-07, inWordle: false },
  { word: 'NOCKS', frequency: 1.78e-08, inWordle: false },
  { word: 'NODAL', frequency: 3.55e-07, inWordle: false },
  { word: 'NODDY', frequency: 1.66e-07, inWordle: false },
  { word: 'NODES', frequency: 6.03e-06, inWordle: false },
  { word: 'NODUS', frequency: 1.95e-08, inWordle: false },
  { word: 'NOELS', frequency: 2.69e-08, inWordle: false },
  { word: 'NOGGS', frequency: 1.48e-08, inWordle: false },
  { word: 'NOHOW', frequency: 2.69e-08, inWordle: false },
  { word: 'NOIRS', frequency: 1.38e-07, inWordle: false },
  { word: 'NOLES', frequency: 7.94e-08, inWordle: false },
  { word: 'NOMAS', frequency: 1.86e-08, inWordle: false },
  { word: 'NOMEN', frequency: 1.62e-07, inWordle: false },
  { word: 'NOMES', frequency: 4.07e-08, inWordle: false },
  { word: 'NOMIC', frequency: 1.66e-08, inWordle: false },
  { word: 'NOMOS', frequency: 1.23e-07, inWordle: false },
  { word: 'NONCE', frequency: 2.75e-07, inWordle: false },
  { word: 'NONES', frequency: 6.76e-08, inWordle: false },
  { word: 'NONET', frequency: 2.45e-08, inWordle: false },
  { word: 'NONIS', frequency: 7.41e-08, inWordle: false },
  { word: 'NONNY', frequency: 4.07e-08, inWordle: false },
  { word: 'NOOBS', frequency: 2.63e-07, inWordle: false },
  { word: 'NOOIT', frequency: 2.09e-08, inWordle: false },
  { word: 'NOOKS', frequency: 3.89e-07, inWordle: false },
  { word: 'NOOKY', frequency: 1.23e-08, inWordle: false },
  { word: 'NOONS', frequency: 5.13e-08, inWordle: false },
  { word: 'NOPAL', frequency: 4.68e-08, inWordle: false },
  { word: 'NORIA', frequency: 3.63e-08, inWordle: false },
  { word: 'NORIS', frequency: 2.95e-08, inWordle: false },
  { word: 'NORKS', frequency: 1.41e-08, inWordle: false },
  { word: 'NORMA', frequency: 2.14e-06, inWordle: false },
  { word: 'NORMS', frequency: 5.75e-06, inWordle: false },
  { word: 'NOSED', frequency: 1.38e-06, inWordle: false },
  { word: 'NOSER', frequency: 3.89e-08, inWordle: false },
  { word: 'NOSES', frequency: 2.82e-06, inWordle: false },
  { word: 'NOTED', frequency: 4.9e-05, inWordle: false },
  { word: 'NOTER', frequency: 1.86e-08, inWordle: false },
  { word: 'NOTES', frequency: 6.92e-05, inWordle: false },
  { word: 'NOTUM', frequency: 1.48e-08, inWordle: false },
  { word: 'NOUNS', frequency: 1.82e-06, inWordle: false },
  { word: 'NOVAE', frequency: 1.07e-07, inWordle: false },
  { word: 'NOVAS', frequency: 1.26e-07, inWordle: false },
  { word: 'NOVUM', frequency: 1.12e-07, inWordle: false },
  { word: 'NOWAY', frequency: 8.13e-08, inWordle: false },
  { word: 'NOYES', frequency: 4.17e-07, inWordle: false },
  { word: 'NUBBY', frequency: 4.47e-08, inWordle: false },
  { word: 'NUBIA', frequency: 2.82e-07, inWordle: false },
  { word: 'NUDES', frequency: 1.74e-06, inWordle: false },
  { word: 'NUDIE', frequency: 1.66e-07, inWordle: false },
  { word: 'NUKED', frequency: 2.45e-07, inWordle: false },
  { word: 'NUKES', frequency: 1.38e-06, inWordle: false },
  { word: 'NULLA', frequency: 1.02e-07, inWordle: false },
  { word: 'NULLS', frequency: 7.41e-08, inWordle: false },
  { word: 'NUMBS', frequency: 1.23e-07, inWordle: false },
  { word: 'NUMEN', frequency: 3.55e-08, inWordle: false },
  { word: 'NUMMY', frequency: 2e-08, inWordle: false },
  { word: 'NUTSO', frequency: 8.13e-08, inWordle: false },
  { word: 'NUTSY', frequency: 1.51e-08, inWordle: false },
  { word: 'NYALA', frequency: 3.55e-08, inWordle: false },
  { word: 'NYSSA', frequency: 3.02e-07, inWordle: false },
  { word: 'OAKED', frequency: 3.09e-08, inWordle: false },
  { word: 'OAKUM', frequency: 3.24e-08, inWordle: false },
  { word: 'OARED', frequency: 3.89e-08, inWordle: false },
  { word: 'OASES', frequency: 2.29e-07, inWordle: false },
  { word: 'OASIS', frequency: 3.63e-06, inWordle: false },
  { word: 'OATEN', frequency: 3.55e-08, inWordle: false },
  { word: 'OATHS', frequency: 8.13e-07, inWordle: false },
  { word: 'OBEAH', frequency: 6.46e-08, inWordle: false },
  { word: 'OBEYS', frequency: 4.68e-07, inWordle: false },
  { word: 'OBIIT', frequency: 1.51e-08, inWordle: false },
  { word: 'OBITS', frequency: 1.12e-07, inWordle: false },
  { word: 'OBJET', frequency: 1.07e-07, inWordle: false },
  { word: 'OBOES', frequency: 8.71e-08, inWordle: false },
  { word: 'OBOLI', frequency: 1.48e-08, inWordle: false },
  { word: 'OBOLS', frequency: 1.29e-08, inWordle: false },
  { word: 'OCCAM', frequency: 5.25e-08, inWordle: false },
  { word: 'OCHER', frequency: 1.1e-07, inWordle: false },
  { word: 'OCHRE', frequency: 4.9e-07, inWordle: false },
  { word: 'OCKER', frequency: 5.75e-08, inWordle: false },
  { word: 'OCTAN', frequency: 1.2e-08, inWordle: false },
  { word: 'OCTYL', frequency: 3.16e-08, inWordle: false },
  { word: 'OCULI', frequency: 5.37e-08, inWordle: false },
  { word: 'ODEON', frequency: 3.72e-07, inWordle: false },
  { word: 'ODEUM', frequency: 1.17e-08, inWordle: false },
  { word: 'ODIUM', frequency: 1e-07, inWordle: false },
  { word: 'ODORS', frequency: 9.33e-07, inWordle: false },
  { word: 'ODOUR', frequency: 9.12e-07, inWordle: false },
  { word: 'OFFED', frequency: 1.35e-07, inWordle: false },
  { word: 'OFFIE', frequency: 3.02e-08, inWordle: false },
  { word: 'OFLAG', frequency: 1.05e-08, inWordle: false },
  { word: 'OFTER', frequency: 3.09e-08, inWordle: false },
  { word: 'OGHAM', frequency: 3.63e-08, inWordle: false },
  { word: 'OGIVE', frequency: 4.17e-08, inWordle: false },
  { word: 'OGLED', frequency: 7.59e-08, inWordle: false },
  { word: 'OGLES', frequency: 2.95e-08, inWordle: false },
  { word: 'OGRES', frequency: 3.09e-07, inWordle: false },
  { word: 'OHMIC', frequency: 8.13e-08, inWordle: false },
  { word: 'OILED', frequency: 1.26e-06, inWordle: false },
  { word: 'OILER', frequency: 2.29e-07, inWordle: false },
  { word: 'OINKS', frequency: 1.12e-08, inWordle: false },
  { word: 'OKAPI', frequency: 7.08e-08, inWordle: false },
  { word: 'OKAYS', frequency: 5.01e-08, inWordle: false },
  { word: 'OLDIE', frequency: 4.47e-07, inWordle: false },
  { word: 'OLEIC', frequency: 1.55e-07, inWordle: false },
  { word: 'OLEIN', frequency: 1.12e-08, inWordle: false },
  { word: 'OLEUM', frequency: 5.62e-08, inWordle: false },
  { word: 'OLLAS', frequency: 1.1e-08, inWordle: false },
  { word: 'OLLER', frequency: 3.72e-08, inWordle: false },
  { word: 'OLLIE', frequency: 2e-06, inWordle: false },
  { word: 'OLOGY', frequency: 1.02e-07, inWordle: false },
  { word: 'OMENS', frequency: 5.89e-07, inWordle: false },
  { word: 'OMERS', frequency: 3.63e-08, inWordle: false },
  { word: 'OMITS', frequency: 5.13e-07, inWordle: false },
  { word: 'ONCES', frequency: 3.16e-08, inWordle: false },
  { word: 'ONELY', frequency: 3.55e-08, inWordle: false },
  { word: 'ONIUM', frequency: 1.17e-08, inWordle: false },
  { word: 'ONLAY', frequency: 1.86e-08, inWordle: false },
  { word: 'ONTIC', frequency: 2e-08, inWordle: false },
  { word: 'OOHED', frequency: 1.12e-08, inWordle: false },
  { word: 'OOMPH', frequency: 4.17e-07, inWordle: false },
  { word: 'OOZED', frequency: 2.19e-07, inWordle: false },
  { word: 'OOZES', frequency: 4.27e-07, inWordle: false },
  { word: 'OPALS', frequency: 2.19e-07, inWordle: false },
  { word: 'OPENS', frequency: 2.69e-05, inWordle: false },
  { word: 'OPING', frequency: 2.04e-08, inWordle: false },
  { word: 'OPPOS', frequency: 1.7e-08, inWordle: false },
  { word: 'OPSIN', frequency: 3.8e-08, inWordle: false },
  { word: 'OPTED', frequency: 5.62e-06, inWordle: false },
  { word: 'ORACH', frequency: 1.41e-08, inWordle: false },
  { word: 'ORACY', frequency: 1.23e-08, inWordle: false },
  { word: 'ORALS', frequency: 4.9e-08, inWordle: false },
  { word: 'ORANG', frequency: 4.9e-07, inWordle: false },
  { word: 'ORATE', frequency: 3.09e-08, inWordle: false },
  { word: 'ORBED', frequency: 2.45e-08, inWordle: false },
  { word: 'ORCAS', frequency: 5.5e-07, inWordle: false },
  { word: 'ORDOS', frequency: 6.31e-08, inWordle: false },
  { word: 'OREAD', frequency: 2e-08, inWordle: false },
  { word: 'ORGUE', frequency: 1.48e-08, inWordle: false },
  { word: 'ORIBI', frequency: 1.26e-08, inWordle: false },
  { word: 'ORIEL', frequency: 3.09e-07, inWordle: false },
  { word: 'ORLON', frequency: 1.62e-08, inWordle: false },
  { word: 'ORLOP', frequency: 1.23e-08, inWordle: false },
  { word: 'ORMER', frequency: 1.7e-08, inWordle: false },
  { word: 'ORRIS', frequency: 6.92e-08, inWordle: false },
  { word: 'ORTHO', frequency: 6.46e-07, inWordle: false },
  { word: 'ORVAL', frequency: 1.02e-07, inWordle: false },
  { word: 'OSCAR', frequency: 2.04e-05, inWordle: false },
  { word: 'OSIER', frequency: 3.47e-08, inWordle: false },
  { word: 'OSSIA', frequency: 1.91e-08, inWordle: false },
  { word: 'OSTIA', frequency: 2e-07, inWordle: false },
  { word: 'OTAKU', frequency: 4.57e-07, inWordle: false },
  { word: 'OTTAR', frequency: 1.7e-08, inWordle: false },
  { word: 'OTTOS', frequency: 3.89e-08, inWordle: false },
  { word: 'OUIJA', frequency: 5.5e-07, inWordle: false },
  { word: 'OUSTS', frequency: 6.31e-08, inWordle: false },
  { word: 'OUTED', frequency: 8.13e-07, inWordle: false },
  { word: 'OUTRE', frequency: 8.13e-08, inWordle: false },
  { word: 'OUTRO', frequency: 6.31e-07, inWordle: false },
  { word: 'OUTTA', frequency: 1.26e-05, inWordle: false },
  { word: 'OUZEL', frequency: 2.88e-08, inWordle: false },
  { word: 'OVALS', frequency: 2.95e-07, inWordle: false },
  { word: 'OVENS', frequency: 1.66e-06, inWordle: false },
  { word: 'OVERS', frequency: 3.63e-06, inWordle: false },
  { word: 'OVOLO', frequency: 1.82e-08, inWordle: false },
  { word: 'OVULE', frequency: 5.75e-08, inWordle: false },
  { word: 'OWLER', frequency: 1.38e-07, inWordle: false },
  { word: 'OWLET', frequency: 6.76e-08, inWordle: false },
  { word: 'OWNED', frequency: 5.75e-05, inWordle: false },
  { word: 'OXBOW', frequency: 1.48e-07, inWordle: false },
  { word: 'OXIME', frequency: 4.57e-08, inWordle: false },
  { word: 'OZEKI', frequency: 3.55e-08, inWordle: false },
  { word: 'OZZIE', frequency: 6.46e-07, inWordle: false },
  { word: 'PACAS', frequency: 1.05e-08, inWordle: false },
  { word: 'PACED', frequency: 3.63e-06, inWordle: false },
  { word: 'PACER', frequency: 5.13e-07, inWordle: false },
  { word: 'PACES', frequency: 1.48e-06, inWordle: false },
  { word: 'PACEY', frequency: 2.57e-07, inWordle: false },
  { word: 'PACHA', frequency: 2.57e-07, inWordle: false },
  { word: 'PACKS', frequency: 8.71e-06, inWordle: false },
  { word: 'PACOS', frequency: 1.78e-08, inWordle: false },
  { word: 'PACTA', frequency: 2.19e-08, inWordle: false },
  { word: 'PACTS', frequency: 4.07e-07, inWordle: false },
  { word: 'PADMA', frequency: 4.47e-07, inWordle: false },
  { word: 'PADRE', frequency: 1.29e-06, inWordle: false },
  { word: 'PADRI', frequency: 1.62e-08, inWordle: false },
  { word: 'PAEAN', frequency: 2.57e-07, inWordle: false },
  { word: 'PAEDO', frequency: 1.07e-07, inWordle: false },
  { word: 'PAEON', frequency: 1.23e-08, inWordle: false },
  { word: 'PAGED', frequency: 2.82e-07, inWordle: false },
  { word: 'PAGER', frequency: 4.27e-07, inWordle: false },
  { word: 'PAGES', frequency: 4.17e-05, inWordle: false },
  { word: 'PAILS', frequency: 1.41e-07, inWordle: false },
  { word: 'PAINS', frequency: 6.92e-06, inWordle: false },
  { word: 'PAIRE', frequency: 9.77e-08, inWordle: false },
  { word: 'PAIRS', frequency: 1.29e-05, inWordle: false },
  { word: 'PAISA', frequency: 2e-07, inWordle: false },
  { word: 'PAISE', frequency: 1.74e-07, inWordle: false },
  { word: 'PAKKA', frequency: 1e-07, inWordle: false },
  { word: 'PALAS', frequency: 3.72e-08, inWordle: false },
  { word: 'PALAY', frequency: 4.07e-08, inWordle: false },
  { word: 'PALEA', frequency: 1.95e-08, inWordle: false },
  { word: 'PALED', frequency: 1.91e-07, inWordle: false },
  { word: 'PALES', frequency: 5.37e-07, inWordle: false },
  { word: 'PALET', frequency: 2.51e-08, inWordle: false },
  { word: 'PALIS', frequency: 2.19e-08, inWordle: false },
  { word: 'PALLA', frequency: 7.08e-08, inWordle: false },
  { word: 'PALLS', frequency: 2.69e-08, inWordle: false },
  { word: 'PALLY', frequency: 2.75e-07, inWordle: false },
  { word: 'PALMS', frequency: 3.55e-06, inWordle: false },
  { word: 'PALMY', frequency: 3.98e-08, inWordle: false },
  { word: 'PALPI', frequency: 9.33e-08, inWordle: false },
  { word: 'PALPS', frequency: 9.33e-08, inWordle: false },
  { word: 'PAMPA', frequency: 1.91e-07, inWordle: false },
  { word: 'PANAX', frequency: 4.37e-08, inWordle: false },
  { word: 'PANCE', frequency: 2.14e-08, inWordle: false },
  { word: 'PANDA', frequency: 4.47e-06, inWordle: false },
  { word: 'PANDY', frequency: 6.76e-08, inWordle: false },
  { word: 'PANED', frequency: 9.12e-08, inWordle: false },
  { word: 'PANES', frequency: 7.76e-07, inWordle: false },
  { word: 'PANGA', frequency: 6.92e-08, inWordle: false },
  { word: 'PANGS', frequency: 3.98e-07, inWordle: false },
  { word: 'PANKO', frequency: 1.02e-07, inWordle: false },
  { word: 'PANNE', frequency: 5.37e-08, inWordle: false },
  { word: 'PANNI', frequency: 1.82e-08, inWordle: false },
  { word: 'PANTO', frequency: 2.51e-07, inWordle: false },
  { word: 'PANTS', frequency: 3.02e-05, inWordle: false },
  { word: 'PANTY', frequency: 9.33e-07, inWordle: false },
  { word: 'PAOLI', frequency: 1.78e-07, inWordle: false },
  { word: 'PAOLO', frequency: 2.51e-06, inWordle: false },
  { word: 'PAPAS', frequency: 2.82e-07, inWordle: false },
  { word: 'PAPAW', frequency: 5.37e-08, inWordle: false },
  { word: 'PAPES', frequency: 3.98e-08, inWordle: false },
  { word: 'PAPPI', frequency: 4.9e-08, inWordle: false },
  { word: 'PAPPY', frequency: 3.63e-07, inWordle: false },
  { word: 'PARAS', frequency: 4.79e-07, inWordle: false },
  { word: 'PARCH', frequency: 2.82e-08, inWordle: false },
  { word: 'PARDI', frequency: 7.59e-08, inWordle: false },
  { word: 'PARDS', frequency: 2.19e-08, inWordle: false },
  { word: 'PARDY', frequency: 6.92e-08, inWordle: false },
  { word: 'PARED', frequency: 5.62e-07, inWordle: false },
  { word: 'PAREN', frequency: 4.27e-08, inWordle: false },
  { word: 'PAREO', frequency: 1.41e-08, inWordle: false },
  { word: 'PARES', frequency: 1.48e-07, inWordle: false },
  { word: 'PARGO', frequency: 3.09e-08, inWordle: false },
  { word: 'PARIS', frequency: 6.61e-05, inWordle: false },
  { word: 'PARKI', frequency: 1.74e-08, inWordle: false },
  { word: 'PARKS', frequency: 2.14e-05, inWordle: false },
  { word: 'PARKY', frequency: 4.79e-08, inWordle: false },
  { word: 'PARLE', frequency: 1.78e-07, inWordle: false },
  { word: 'PARLY', frequency: 5.89e-08, inWordle: false },
  { word: 'PARMA', frequency: 1.02e-06, inWordle: false },
  { word: 'PAROL', frequency: 6.17e-08, inWordle: false },
  { word: 'PARRA', frequency: 4.47e-07, inWordle: false },
  { word: 'PARRS', frequency: 2.57e-08, inWordle: false },
  { word: 'PARTI', frequency: 5.89e-07, inWordle: false },
  { word: 'PARTS', frequency: 0.000117, inWordle: false },
  { word: 'PARVE', frequency: 1.29e-08, inWordle: false },
  { word: 'PARVO', frequency: 7.41e-08, inWordle: false },
  { word: 'PASEO', frequency: 2.51e-07, inWordle: false },
  { word: 'PASHA', frequency: 1.38e-06, inWordle: false },
  { word: 'PASSE', frequency: 3.39e-07, inWordle: false },
  { word: 'PASTS', frequency: 4.37e-07, inWordle: false },
  { word: 'PATED', frequency: 2.4e-08, inWordle: false },
  { word: 'PATEN', frequency: 8.51e-08, inWordle: false },
  { word: 'PATER', frequency: 3.31e-07, inWordle: false },
  { word: 'PATES', frequency: 4.47e-08, inWordle: false },
  { word: 'PATHS', frequency: 1.05e-05, inWordle: false },
  { word: 'PATIN', frequency: 5.5e-08, inWordle: false },
  { word: 'PATKA', frequency: 1.02e-08, inWordle: false },
  { word: 'PATTE', frequency: 3.24e-08, inWordle: false },
  { word: 'PAULS', frequency: 4.07e-07, inWordle: false },
  { word: 'PAVAN', frequency: 1.05e-07, inWordle: false },
  { word: 'PAVED', frequency: 4.17e-06, inWordle: false },
  { word: 'PAVER', frequency: 1.15e-07, inWordle: false },
  { word: 'PAVES', frequency: 3.16e-07, inWordle: false },
  { word: 'PAVIN', frequency: 4.17e-08, inWordle: false },
  { word: 'PAVIS', frequency: 1.38e-08, inWordle: false },
  { word: 'PAWED', frequency: 9.77e-08, inWordle: false },
  { word: 'PAWLS', frequency: 1.58e-08, inWordle: false },
  { word: 'PAWNS', frequency: 9.77e-07, inWordle: false },
  { word: 'PAYED', frequency: 8.91e-07, inWordle: false },
  { word: 'PAYOR', frequency: 6.76e-08, inWordle: false },
  { word: 'PEAKS', frequency: 7.41e-06, inWordle: false },
  { word: 'PEAKY', frequency: 2.95e-07, inWordle: false },
  { word: 'PEALS', frequency: 7.41e-08, inWordle: false },
  { word: 'PEARS', frequency: 1.45e-06, inWordle: false },
  { word: 'PEART', frequency: 1.55e-07, inWordle: false },
  { word: 'PEASE', frequency: 6.31e-07, inWordle: false },
  { word: 'PEATS', frequency: 1.17e-07, inWordle: false },
  { word: 'PEATY', frequency: 1.95e-07, inWordle: false },
  { word: 'PEAVY', frequency: 1.51e-07, inWordle: false },
  { word: 'PECKS', frequency: 1.91e-07, inWordle: false },
  { word: 'PECKY', frequency: 1.45e-08, inWordle: false },
  { word: 'PEDES', frequency: 9.55e-08, inWordle: false },
  { word: 'PEDIS', frequency: 1.29e-07, inWordle: false },
  { word: 'PEDRO', frequency: 5.62e-06, inWordle: false },
  { word: 'PEEKS', frequency: 3.98e-07, inWordle: false },
  { word: 'PEELS', frequency: 6.31e-07, inWordle: false },
  { word: 'PEENS', frequency: 2.04e-08, inWordle: false },
  { word: 'PEEPS', frequency: 1.26e-06, inWordle: false },
  { word: 'PEERS', frequency: 1.05e-05, inWordle: false },
  { word: 'PEERY', frequency: 3.47e-08, inWordle: false },
  { word: 'PEEVE', frequency: 6.31e-07, inWordle: false },
  { word: 'PEGGY', frequency: 3.72e-06, inWordle: false },
  { word: 'PEKAN', frequency: 2.34e-08, inWordle: false },
  { word: 'PEKIN', frequency: 2.14e-07, inWordle: false },
  { word: 'PEKOE', frequency: 5.13e-08, inWordle: false },
  { word: 'PELAS', frequency: 1.55e-08, inWordle: false },
  { word: 'PELES', frequency: 2.14e-08, inWordle: false },
  { word: 'PELLS', frequency: 3.31e-08, inWordle: false },
  { word: 'PELON', frequency: 2.51e-08, inWordle: false },
  { word: 'PELTS', frequency: 4.47e-07, inWordle: false },
  { word: 'PENDS', frequency: 1.74e-08, inWordle: false },
  { word: 'PENDU', frequency: 1.17e-08, inWordle: false },
  { word: 'PENES', frequency: 1.95e-08, inWordle: false },
  { word: 'PENGO', frequency: 1.82e-08, inWordle: false },
  { word: 'PENIS', frequency: 1.12e-05, inWordle: false },
  { word: 'PENNA', frequency: 1.66e-07, inWordle: false },
  { word: 'PENNI', frequency: 2.19e-08, inWordle: false },
  { word: 'PEONS', frequency: 1.86e-07, inWordle: false },
  { word: 'PEONY', frequency: 3.72e-07, inWordle: false },
  { word: 'PEPPY', frequency: 3.39e-07, inWordle: false },
  { word: 'PEPSI', frequency: 2.75e-06, inWordle: false },
  { word: 'PERAI', frequency: 1.41e-08, inWordle: false },
  { word: 'PERCE', frequency: 2.82e-07, inWordle: false },
  { word: 'PERCS', frequency: 8.71e-08, inWordle: false },
  { word: 'PERDU', frequency: 1.07e-07, inWordle: false },
  { word: 'PERDY', frequency: 2.09e-08, inWordle: false },
  { word: 'PEREA', frequency: 7.94e-08, inWordle: false },
  { word: 'PERES', frequency: 6.61e-07, inWordle: false },
  { word: 'PERIS', frequency: 1e-07, inWordle: false },
  { word: 'PERKS', frequency: 4.17e-06, inWordle: false },
  { word: 'PERMS', frequency: 1.2e-07, inWordle: false },
  { word: 'PERPS', frequency: 1.74e-07, inWordle: false },
  { word: 'PERRY', frequency: 1.66e-05, inWordle: false },
  { word: 'PERSE', frequency: 1.74e-07, inWordle: false },
  { word: 'PERVE', frequency: 2.82e-08, inWordle: false },
  { word: 'PERVO', frequency: 1.1e-08, inWordle: false },
  { word: 'PERVS', frequency: 1.7e-07, inWordle: false },
  { word: 'PERVY', frequency: 2.34e-07, inWordle: false },
  { word: 'PESOS', frequency: 1.7e-06, inWordle: false },
  { word: 'PESTS', frequency: 2.57e-06, inWordle: false },
  { word: 'PESTY', frequency: 1.51e-08, inWordle: false },
  { word: 'PETAR', frequency: 1.86e-07, inWordle: false },
  { word: 'PETER', frequency: 7.59e-05, inWordle: false },
  { word: 'PETIT', frequency: 1.86e-06, inWordle: false },
  { word: 'PETRE', frequency: 1.51e-07, inWordle: false },
  { word: 'PETRI', frequency: 9.55e-07, inWordle: false },
  { word: 'PETTI', frequency: 3.31e-08, inWordle: false },
  { word: 'PETTO', frequency: 2.69e-08, inWordle: false },
  { word: 'PEWEE', frequency: 4.37e-08, inWordle: false },
  { word: 'PHAGE', frequency: 4.57e-07, inWordle: false },
  { word: 'PHANG', frequency: 7.24e-08, inWordle: false },
  { word: 'PHARE', frequency: 5.62e-08, inWordle: false },
  { word: 'PHARM', frequency: 2.69e-07, inWordle: false },
  { word: 'PHIAL', frequency: 8.51e-08, inWordle: false },
  { word: 'PHISH', frequency: 5.13e-07, inWordle: false },
  { word: 'PHLOX', frequency: 2.24e-07, inWordle: false },
  { word: 'PHOCA', frequency: 2.95e-08, inWordle: false },
  { word: 'PHONO', frequency: 1.95e-07, inWordle: false },
  { word: 'PHOTS', frequency: 1.74e-08, inWordle: false },
  { word: 'PHYLA', frequency: 1.1e-07, inWordle: false },
  { word: 'PIANI', frequency: 1.62e-08, inWordle: false },
  { word: 'PICAS', frequency: 1.62e-08, inWordle: false },
  { word: 'PICKS', frequency: 1.74e-05, inWordle: false },
  { word: 'PICOT', frequency: 2e-07, inWordle: false },
  { word: 'PIERS', frequency: 3.24e-06, inWordle: false },
  { word: 'PIETA', frequency: 1.02e-07, inWordle: false },
  { word: 'PIEZO', frequency: 1.58e-07, inWordle: false },
  { word: 'PIGMY', frequency: 5.25e-08, inWordle: false },
  { word: 'PIKAS', frequency: 4.07e-08, inWordle: false },
  { word: 'PIKED', frequency: 2.57e-08, inWordle: false },
  { word: 'PIKER', frequency: 5.01e-08, inWordle: false },
  { word: 'PIKES', frequency: 5.62e-07, inWordle: false },
  { word: 'PIKEY', frequency: 6.92e-08, inWordle: false },
  { word: 'PIKUL', frequency: 2.04e-08, inWordle: false },
  { word: 'PILAF', frequency: 1.48e-07, inWordle: false },
  { word: 'PILAR', frequency: 6.61e-07, inWordle: false },
  { word: 'PILAU', frequency: 3.8e-08, inWordle: false },
  { word: 'PILCH', frequency: 3.72e-08, inWordle: false },
  { word: 'PILEA', frequency: 1.41e-08, inWordle: false },
  { word: 'PILED', frequency: 2.57e-06, inWordle: false },
  { word: 'PILES', frequency: 3.89e-06, inWordle: false },
  { word: 'PILIS', frequency: 1.74e-08, inWordle: false },
  { word: 'PILLS', frequency: 1.12e-05, inWordle: false },
  { word: 'PILUM', frequency: 1.95e-08, inWordle: false },
  { word: 'PILUS', frequency: 3.02e-08, inWordle: false },
  { word: 'PIMPS', frequency: 7.24e-07, inWordle: false },
  { word: 'PINAS', frequency: 4.9e-08, inWordle: false },
  { word: 'PINED', frequency: 1.1e-07, inWordle: false },
  { word: 'PINES', frequency: 2.75e-06, inWordle: false },
  { word: 'PINGO', frequency: 3.63e-08, inWordle: false },
  { word: 'PINGS', frequency: 8.51e-07, inWordle: false },
  { word: 'PINKO', frequency: 1.12e-07, inWordle: false },
  { word: 'PINKS', frequency: 6.31e-07, inWordle: false },
  { word: 'PINNA', frequency: 1.26e-07, inWordle: false },
  { word: 'PINNY', frequency: 4.07e-08, inWordle: false },
  { word: 'PINON', frequency: 7.59e-08, inWordle: false },
  { word: 'PINOT', frequency: 1.23e-06, inWordle: false },
  { word: 'PINTA', frequency: 1.15e-07, inWordle: false },
  { word: 'PINTS', frequency: 1.66e-06, inWordle: false },
  { word: 'PINUP', frequency: 2.09e-07, inWordle: false },
  { word: 'PIONS', frequency: 5.01e-08, inWordle: false },
  { word: 'PIOUS', frequency: 2.04e-06, inWordle: false },
  { word: 'PIPAL', frequency: 2.29e-08, inWordle: false },
  { word: 'PIPED', frequency: 9.12e-07, inWordle: false },
  { word: 'PIPES', frequency: 8.91e-06, inWordle: false },
  { word: 'PIPET', frequency: 1.48e-08, inWordle: false },
  { word: 'PIPIS', frequency: 1.23e-08, inWordle: false },
  { word: 'PIPIT', frequency: 7.41e-08, inWordle: false },
  { word: 'PIPPY', frequency: 3.89e-08, inWordle: false },
  { word: 'PIRLS', frequency: 1.48e-08, inWordle: false },
  { word: 'PIROG', frequency: 1.1e-08, inWordle: false },
  { word: 'PISCO', frequency: 1.55e-07, inWordle: false },
  { word: 'PISSY', frequency: 5.25e-07, inWordle: false },
  { word: 'PISTE', frequency: 2.45e-07, inWordle: false },
  { word: 'PITAS', frequency: 6.92e-08, inWordle: false },
  { word: 'PITON', frequency: 8.91e-08, inWordle: false },
  { word: 'PITOT', frequency: 8.91e-08, inWordle: false },
  { word: 'PITTA', frequency: 2.63e-07, inWordle: false },
  { word: 'PLACK', frequency: 2.57e-08, inWordle: false },
  { word: 'PLAGE', frequency: 1.32e-07, inWordle: false },
  { word: 'PLANS', frequency: 0.000102, inWordle: false },
  { word: 'PLASH', frequency: 2.04e-08, inWordle: false },
  { word: 'PLASM', frequency: 4.79e-08, inWordle: false },
  { word: 'PLAST', frequency: 6.92e-08, inWordle: false },
  { word: 'PLATS', frequency: 1.62e-07, inWordle: false },
  { word: 'PLATT', frequency: 1.15e-06, inWordle: false },
  { word: 'PLATY', frequency: 5.13e-08, inWordle: false },
  { word: 'PLAYA', frequency: 1.51e-06, inWordle: false },
  { word: 'PLAYS', frequency: 6.92e-05, inWordle: false },
  { word: 'PLEAS', frequency: 3.24e-06, inWordle: false },
  { word: 'PLEBE', frequency: 7.59e-08, inWordle: false },
  { word: 'PLEBS', frequency: 4.17e-07, inWordle: false },
  { word: 'PLENA', frequency: 7.41e-08, inWordle: false },
  { word: 'PLEWS', frequency: 1.58e-08, inWordle: false },
  { word: 'PLICA', frequency: 3.09e-08, inWordle: false },
  { word: 'PLIES', frequency: 3.98e-07, inWordle: false },
  { word: 'PLING', frequency: 3.16e-08, inWordle: false },
  { word: 'PLINK', frequency: 6.76e-08, inWordle: false },
  { word: 'PLODS', frequency: 5.01e-08, inWordle: false },
  { word: 'PLONK', frequency: 1.41e-07, inWordle: false },
  { word: 'PLOPS', frequency: 1.05e-07, inWordle: false },
  { word: 'PLOTS', frequency: 5.89e-06, inWordle: false },
  { word: 'PLOTZ', frequency: 4.17e-08, inWordle: false },
  { word: 'PLOWS', frequency: 4.9e-07, inWordle: false },
  { word: 'PLOYS', frequency: 1.62e-07, inWordle: false },
  { word: 'PLUGS', frequency: 2.95e-06, inWordle: false },
  { word: 'PLUMS', frequency: 9.33e-07, inWordle: false },
  { word: 'PLUTO', frequency: 2.24e-06, inWordle: false },
  { word: 'POACH', frequency: 4.79e-07, inWordle: false },
  { word: 'POCKS', frequency: 1.86e-08, inWordle: false },
  { word: 'POCKY', frequency: 1.05e-07, inWordle: false },
  { word: 'PODDY', frequency: 1.17e-08, inWordle: false },
  { word: 'PODGE', frequency: 1.66e-07, inWordle: false },
  { word: 'PODGY', frequency: 4.47e-08, inWordle: false },
  { word: 'PODIA', frequency: 2.4e-08, inWordle: false },
  { word: 'POEMS', frequency: 1.29e-05, inWordle: false },
  { word: 'POETS', frequency: 6.92e-06, inWordle: false },
  { word: 'POGGE', frequency: 3.02e-08, inWordle: false },
  { word: 'POILU', frequency: 1.95e-08, inWordle: false },
  { word: 'POKAL', frequency: 5.5e-08, inWordle: false },
  { word: 'POKED', frequency: 1.7e-06, inWordle: false },
  { word: 'POKES', frequency: 8.32e-07, inWordle: false },
  { word: 'POKEY', frequency: 3.47e-07, inWordle: false },
  { word: 'POKIE', frequency: 5.75e-08, inWordle: false },
  { word: 'POLED', frequency: 4.17e-08, inWordle: false },
  { word: 'POLES', frequency: 7.59e-06, inWordle: false },
  { word: 'POLEY', frequency: 5.89e-08, inWordle: false },
  { word: 'POLIO', frequency: 1.86e-06, inWordle: false },
  { word: 'POLIS', frequency: 5.5e-07, inWordle: false },
  { word: 'POLJE', frequency: 3.16e-08, inWordle: false },
  { word: 'POLKS', frequency: 1.55e-08, inWordle: false },
  { word: 'POLLS', frequency: 1.26e-05, inWordle: false },
  { word: 'POLLY', frequency: 2.51e-06, inWordle: false },
  { word: 'POLOS', frequency: 2.04e-07, inWordle: false },
  { word: 'POLYS', frequency: 5.13e-08, inWordle: false },
  { word: 'POMBE', frequency: 4.47e-08, inWordle: false },
  { word: 'POMES', frequency: 1.07e-08, inWordle: false },
  { word: 'POMMY', frequency: 5.01e-08, inWordle: false },
  { word: 'POMPS', frequency: 2.14e-08, inWordle: false },
  { word: 'PONCE', frequency: 7.76e-07, inWordle: false },
  { word: 'PONCY', frequency: 2.82e-08, inWordle: false },
  { word: 'PONDS', frequency: 2.88e-06, inWordle: false },
  { word: 'PONES', frequency: 1.55e-08, inWordle: false },
  { word: 'PONEY', frequency: 2.09e-08, inWordle: false },
  { word: 'PONGA', frequency: 4.68e-08, inWordle: false },
  { word: 'PONGO', frequency: 1.48e-07, inWordle: false },
  { word: 'PONGS', frequency: 3.24e-08, inWordle: false },
  { word: 'PONTS', frequency: 6.46e-08, inWordle: false },
  { word: 'PONTY', frequency: 1.86e-07, inWordle: false },
  { word: 'PONZU', frequency: 4.9e-08, inWordle: false },
  { word: 'POODS', frequency: 3.24e-08, inWordle: false },
  { word: 'POOED', frequency: 4.47e-08, inWordle: false },
  { word: 'POOFS', frequency: 7.76e-08, inWordle: false },
  { word: 'POOFY', frequency: 1.35e-07, inWordle: false },
  { word: 'POOHS', frequency: 2.63e-08, inWordle: false },
  { word: 'POOJA', frequency: 7.94e-07, inWordle: false },
  { word: 'POOKA', frequency: 5.37e-08, inWordle: false },
  { word: 'POOKS', frequency: 1.62e-08, inWordle: false },
  { word: 'POOLS', frequency: 7.41e-06, inWordle: false },
  { word: 'POONS', frequency: 1.35e-08, inWordle: false },
  { word: 'POOPS', frequency: 3.72e-07, inWordle: false },
  { word: 'POOPY', frequency: 3.16e-07, inWordle: false },
  { word: 'POORI', frequency: 3.24e-08, inWordle: false },
  { word: 'POORT', frequency: 3.09e-08, inWordle: false },
  { word: 'POOTS', frequency: 9.33e-08, inWordle: false },
  { word: 'POPES', frequency: 1.2e-06, inWordle: false },
  { word: 'POPPA', frequency: 3.63e-07, inWordle: false },
  { word: 'POPSY', frequency: 2.45e-08, inWordle: false },
  { word: 'PORED', frequency: 1.58e-07, inWordle: false },
  { word: 'PORES', frequency: 2.51e-06, inWordle: false },
  { word: 'PORGY', frequency: 1.78e-07, inWordle: false },
  { word: 'PORIN', frequency: 2e-08, inWordle: false },
  { word: 'PORKS', frequency: 1.78e-08, inWordle: false },
  { word: 'PORKY', frequency: 4.68e-07, inWordle: false },
  { word: 'PORNO', frequency: 2.29e-06, inWordle: false },
  { word: 'PORNS', frequency: 5.13e-08, inWordle: false },
  { word: 'PORNY', frequency: 3.02e-08, inWordle: false },
  { word: 'PORTA', frequency: 8.32e-07, inWordle: false },
  { word: 'PORTS', frequency: 1.17e-05, inWordle: false },
  { word: 'PORTY', frequency: 2.51e-08, inWordle: false },
  { word: 'POSED', frequency: 6.46e-06, inWordle: false },
  { word: 'POSES', frequency: 6.17e-06, inWordle: false },
  { word: 'POSEY', frequency: 8.32e-07, inWordle: false },
  { word: 'POSHO', frequency: 1.35e-08, inWordle: false },
  { word: 'POSTS', frequency: 4.47e-05, inWordle: false },
  { word: 'POTCH', frequency: 4.79e-08, inWordle: false },
  { word: 'POTES', frequency: 2.75e-08, inWordle: false },
  { word: 'POTIN', frequency: 1.2e-08, inWordle: false },
  { word: 'POTOO', frequency: 1.38e-08, inWordle: false },
  { word: 'POTSY', frequency: 1.15e-08, inWordle: false },
  { word: 'POTTO', frequency: 3.09e-08, inWordle: false },
  { word: 'POTTS', frequency: 1.38e-06, inWordle: false },
  { word: 'POTTY', frequency: 1.82e-06, inWordle: false },
  { word: 'POUFS', frequency: 1.35e-08, inWordle: false },
  { word: 'POULE', frequency: 3.63e-08, inWordle: false },
  { word: 'POULT', frequency: 1.78e-08, inWordle: false },
  { word: 'POURS', frequency: 1.66e-06, inWordle: false },
  { word: 'POUTS', frequency: 1.15e-07, inWordle: false },
  { word: 'POYNT', frequency: 1.23e-08, inWordle: false },
  { word: 'PRAMS', frequency: 1.23e-07, inWordle: false },
  { word: 'PRANA', frequency: 2e-07, inWordle: false },
  { word: 'PRANG', frequency: 1.26e-07, inWordle: false },
  { word: 'PRASE', frequency: 1.02e-08, inWordle: false },
  { word: 'PRATE', frequency: 3.31e-08, inWordle: false },
  { word: 'PRATS', frequency: 6.92e-08, inWordle: false },
  { word: 'PRATT', frequency: 3.89e-06, inWordle: false },
  { word: 'PRAYS', frequency: 1.26e-06, inWordle: false },
  { word: 'PREES', frequency: 1.74e-08, inWordle: false },
  { word: 'PREMS', frequency: 3.39e-08, inWordle: false },
  { word: 'PRENT', frequency: 2.24e-08, inWordle: false },
  { word: 'PREON', frequency: 1.02e-08, inWordle: false },
  { word: 'PREOP', frequency: 2.57e-08, inWordle: false },
  { word: 'PREPS', frequency: 2.95e-07, inWordle: false },
  { word: 'PRESA', frequency: 6.31e-08, inWordle: false },
  { word: 'PRESE', frequency: 4.07e-08, inWordle: false },
  { word: 'PREST', frequency: 1.02e-07, inWordle: false },
  { word: 'PREVE', frequency: 1.95e-08, inWordle: false },
  { word: 'PREXY', frequency: 1.38e-08, inWordle: false },
  { word: 'PREYS', frequency: 3.16e-07, inWordle: false },
  { word: 'PRICY', frequency: 1.66e-07, inWordle: false },
  { word: 'PRIER', frequency: 1.62e-08, inWordle: false },
  { word: 'PRIES', frequency: 7.08e-08, inWordle: false },
  { word: 'PRIGS', frequency: 2.69e-08, inWordle: false },
  { word: 'PRILL', frequency: 2.51e-08, inWordle: false },
  { word: 'PRIMA', frequency: 2.19e-06, inWordle: false },
  { word: 'PRIMI', frequency: 5.75e-08, inWordle: false },
  { word: 'PRIMP', frequency: 3.55e-08, inWordle: false },
  { word: 'PRIMS', frequency: 2.57e-08, inWordle: false },
  { word: 'PRINK', frequency: 1.12e-08, inWordle: false },
  { word: 'PRION', frequency: 3.31e-07, inWordle: false },
  { word: 'PRISE', frequency: 2.82e-07, inWordle: false },
  { word: 'PRISS', frequency: 3.72e-08, inWordle: false },
  { word: 'PROBS', frequency: 6.17e-07, inWordle: false },
  { word: 'PRODS', frequency: 2.14e-07, inWordle: false },
  { word: 'PROEM', frequency: 1.78e-08, inWordle: false },
  { word: 'PROFS', frequency: 3.31e-07, inWordle: false },
  { word: 'PROGS', frequency: 6.03e-08, inWordle: false },
  { word: 'PROLE', frequency: 6.17e-08, inWordle: false },
  { word: 'PROLL', frequency: 1.05e-08, inWordle: false },
  { word: 'PROMO', frequency: 6.46e-06, inWordle: false },
  { word: 'PROMS', frequency: 7.24e-07, inWordle: false },
  { word: 'PRONK', frequency: 3.47e-08, inWordle: false },
  { word: 'PROPS', frequency: 5.25e-06, inWordle: false },
  { word: 'PROSO', frequency: 1.17e-08, inWordle: false },
  { word: 'PROSS', frequency: 4.9e-08, inWordle: false },
  { word: 'PROST', frequency: 4.17e-07, inWordle: false },
  { word: 'PROSY', frequency: 1.07e-08, inWordle: false },
  { word: 'PROTO', frequency: 1.7e-06, inWordle: false },
  { word: 'PROWS', frequency: 2.24e-08, inWordle: false },
  { word: 'PRYER', frequency: 2.51e-08, inWordle: false },
  { word: 'PRYSE', frequency: 2.95e-08, inWordle: false },
  { word: 'PSEUD', frequency: 4.07e-08, inWordle: false },
  { word: 'PSHAW', frequency: 6.17e-08, inWordle: false },
  { word: 'PSION', frequency: 5.89e-08, inWordle: false },
  { word: 'PSOAS', frequency: 8.13e-08, inWordle: false },
  { word: 'PSYCH', frequency: 3.02e-06, inWordle: false },
  { word: 'PSYOP', frequency: 1.17e-07, inWordle: false },
  { word: 'PUBES', frequency: 4.79e-07, inWordle: false },
  { word: 'PUBIS', frequency: 1.86e-07, inWordle: false },
  { word: 'PUCES', frequency: 1.45e-08, inWordle: false },
  { word: 'PUCKS', frequency: 3.39e-07, inWordle: false },
  { word: 'PUDDY', frequency: 8.13e-08, inWordle: false },
  { word: 'PUDGE', frequency: 1.7e-07, inWordle: false },
  { word: 'PUFFA', frequency: 2e-08, inWordle: false },
  { word: 'PUFFS', frequency: 1.2e-06, inWordle: false },
  { word: 'PUGGY', frequency: 5.01e-08, inWordle: false },
  { word: 'PUJAS', frequency: 3.89e-08, inWordle: false },
  { word: 'PUKED', frequency: 5.75e-07, inWordle: false },
  { word: 'PUKER', frequency: 1.7e-08, inWordle: false },
  { word: 'PUKES', frequency: 1.55e-07, inWordle: false },
  { word: 'PUKEY', frequency: 2.95e-08, inWordle: false },
  { word: 'PUKKA', frequency: 8.13e-08, inWordle: false },
  { word: 'PULAO', frequency: 3.63e-08, inWordle: false },
  { word: 'PULIS', frequency: 3.02e-07, inWordle: false },
  { word: 'PULLI', frequency: 1.66e-08, inWordle: false },
  { word: 'PULLS', frequency: 1.02e-05, inWordle: false },
  { word: 'PULLY', frequency: 3.8e-08, inWordle: false },
  { word: 'PULMO', frequency: 1.82e-08, inWordle: false },
  { word: 'PULPS', frequency: 1.32e-07, inWordle: false },
  { word: 'PUMAS', frequency: 4.57e-07, inWordle: false },
  { word: 'PUMPS', frequency: 6.76e-06, inWordle: false },
  { word: 'PUNGA', frequency: 1.32e-08, inWordle: false },
  { word: 'PUNJI', frequency: 2.14e-08, inWordle: false },
  { word: 'PUNKS', frequency: 9.55e-07, inWordle: false },
  { word: 'PUNKY', frequency: 2.19e-07, inWordle: false },
  { word: 'PUNNY', frequency: 1.17e-07, inWordle: false },
  { word: 'PUNTO', frequency: 2.45e-07, inWordle: false },
  { word: 'PUNTS', frequency: 4.57e-07, inWordle: false },
  { word: 'PUPAE', frequency: 2.24e-07, inWordle: false },
  { word: 'PURES', frequency: 3.55e-08, inWordle: false },
  { word: 'PURIN', frequency: 2.34e-08, inWordle: false },
  { word: 'PURIS', frequency: 2.95e-08, inWordle: false },
  { word: 'PURLS', frequency: 1.82e-08, inWordle: false },
  { word: 'PURRS', frequency: 2.51e-07, inWordle: false },
  { word: 'PURTY', frequency: 1.12e-07, inWordle: false },
  { word: 'PUSSY', frequency: 1.74e-05, inWordle: false },
  { word: 'PUTON', frequency: 1.29e-08, inWordle: false },
  { word: 'PUTTI', frequency: 7.94e-08, inWordle: false },
  { word: 'PUTTO', frequency: 1.86e-08, inWordle: false },
  { word: 'PUTTS', frequency: 2.82e-07, inWordle: false },
  { word: 'PWNED', frequency: 8.13e-08, inWordle: false },
  { word: 'PYLON', frequency: 4.68e-07, inWordle: false },
  { word: 'PYNES', frequency: 1.05e-08, inWordle: false },
  { word: 'PYRAN', frequency: 1.17e-08, inWordle: false },
  { word: 'PYRES', frequency: 7.24e-08, inWordle: false },
  { word: 'PYREX', frequency: 3.24e-07, inWordle: false },
  { word: 'PYROS', frequency: 6.61e-08, inWordle: false },
  { word: 'PYXIS', frequency: 5.89e-08, inWordle: false },
  { word: 'QADIS', frequency: 1.1e-08, inWordle: false },
  { word: 'QANAT', frequency: 1.35e-08, inWordle: false },
  { word: 'QIBLA', frequency: 8.32e-08, inWordle: false },
  { word: 'QUADS', frequency: 5.89e-07, inWordle: false },
  { word: 'QUAFF', frequency: 6.61e-08, inWordle: false },
  { word: 'QUAIR', frequency: 1.05e-08, inWordle: false },
  { word: 'QUAIS', frequency: 2.4e-08, inWordle: false },
  { word: 'QUALE', frequency: 5.75e-08, inWordle: false },
  { word: 'QUANT', frequency: 3.72e-07, inWordle: false },
  { word: 'QUARE', frequency: 5.13e-08, inWordle: false },
  { word: 'QUATE', frequency: 2.75e-08, inWordle: false },
  { word: 'QUAYS', frequency: 3.39e-07, inWordle: false },
  { word: 'QUBIT', frequency: 1.48e-07, inWordle: false },
  { word: 'QUEAN', frequency: 1.2e-08, inWordle: false },
  { word: 'QUENA', frequency: 1.07e-08, inWordle: false },
  { word: 'QUERN', frequency: 3.89e-08, inWordle: false },
  { word: 'QUIDS', frequency: 7.24e-08, inWordle: false },
  { word: 'QUIFF', frequency: 1.15e-07, inWordle: false },
  { word: 'QUINA', frequency: 5.5e-08, inWordle: false },
  { word: 'QUINE', frequency: 2.29e-07, inWordle: false },
  { word: 'QUINO', frequency: 3.55e-08, inWordle: false },
  { word: 'QUINS', frequency: 9.12e-08, inWordle: false },
  { word: 'QUINT', frequency: 4.37e-07, inWordle: false },
  { word: 'QUIPS', frequency: 4.17e-07, inWordle: false },
  { word: 'QUIPU', frequency: 2.88e-08, inWordle: false },
  { word: 'QUIRE', frequency: 1.66e-07, inWordle: false },
  { word: 'QUIRT', frequency: 3.8e-08, inWordle: false },
  { word: 'QUIST', frequency: 9.33e-08, inWordle: false },
  { word: 'QUITS', frequency: 2.45e-06, inWordle: false },
  { word: 'QUOAD', frequency: 4.47e-08, inWordle: false },
  { word: 'QUOIN', frequency: 4.37e-08, inWordle: false },
  { word: 'QUOIT', frequency: 3.24e-08, inWordle: false },
  { word: 'QUOLL', frequency: 3.39e-08, inWordle: false },
  { word: 'RABAT', frequency: 3.98e-07, inWordle: false },
  { word: 'RACED', frequency: 3.89e-06, inWordle: false },
  { word: 'RACES', frequency: 2.4e-05, inWordle: false },
  { word: 'RACHE', frequency: 5.37e-08, inWordle: false },
  { word: 'RACKS', frequency: 2.34e-06, inWordle: false },
  { word: 'RACON', frequency: 1.29e-08, inWordle: false },
  { word: 'RADGE', frequency: 1.66e-08, inWordle: false },
  { word: 'RADIX', frequency: 1.78e-07, inWordle: false },
  { word: 'RADON', frequency: 7.76e-07, inWordle: false },
  { word: 'RAFTS', frequency: 7.59e-07, inWordle: false },
  { word: 'RAGAS', frequency: 7.24e-08, inWordle: false },
  { word: 'RAGED', frequency: 1.15e-06, inWordle: false },
  { word: 'RAGER', frequency: 2.69e-07, inWordle: false },
  { word: 'RAGES', frequency: 1.15e-06, inWordle: false },
  { word: 'RAGGA', frequency: 7.59e-08, inWordle: false },
  { word: 'RAGGS', frequency: 1.07e-08, inWordle: false },
  { word: 'RAGGY', frequency: 3.8e-08, inWordle: false },
  { word: 'RAIDS', frequency: 7.76e-06, inWordle: false },
  { word: 'RAILS', frequency: 6.17e-06, inWordle: false },
  { word: 'RAINE', frequency: 4.79e-07, inWordle: false },
  { word: 'RAINS', frequency: 6.92e-06, inWordle: false },
  { word: 'RAITA', frequency: 8.32e-08, inWordle: false },
  { word: 'RAJAS', frequency: 1.26e-07, inWordle: false },
  { word: 'RAKED', frequency: 7.24e-07, inWordle: false },
  { word: 'RAKER', frequency: 7.59e-08, inWordle: false },
  { word: 'RAKES', frequency: 5.13e-07, inWordle: false },
  { word: 'RAKIA', frequency: 2.14e-08, inWordle: false },
  { word: 'RALES', frequency: 3.63e-08, inWordle: false },
  { word: 'RAMAL', frequency: 4.57e-08, inWordle: false },
  { word: 'RAMEE', frequency: 1.82e-08, inWordle: false },
  { word: 'RAMET', frequency: 1.12e-08, inWordle: false },
  { word: 'RAMIE', frequency: 4.17e-08, inWordle: false },
  { word: 'RAMIN', frequency: 1.7e-07, inWordle: false },
  { word: 'RAMIS', frequency: 1.74e-07, inWordle: false },
  { word: 'RAMMY', frequency: 3.98e-08, inWordle: false },
  { word: 'RAMPS', frequency: 1.91e-06, inWordle: false },
  { word: 'RAMUS', frequency: 1.23e-07, inWordle: false },
  { word: 'RANAS', frequency: 1.91e-08, inWordle: false },
  { word: 'RANCE', frequency: 4.27e-07, inWordle: false },
  { word: 'RANDS', frequency: 1.35e-07, inWordle: false },
  { word: 'RANEE', frequency: 3.63e-08, inWordle: false },
  { word: 'RANGA', frequency: 1.45e-07, inWordle: false },
  { word: 'RANGI', frequency: 1.07e-07, inWordle: false },
  { word: 'RANGS', frequency: 1.55e-08, inWordle: false },
  { word: 'RANGY', frequency: 8.13e-08, inWordle: false },
  { word: 'RANIS', frequency: 1.7e-08, inWordle: false },
  { word: 'RANKE', frequency: 6.03e-08, inWordle: false },
  { word: 'RANKS', frequency: 1.7e-05, inWordle: false },
  { word: 'RANTS', frequency: 1.32e-06, inWordle: false },
  { word: 'RAPED', frequency: 1.2e-05, inWordle: false },
  { word: 'RAPER', frequency: 2e-07, inWordle: false },
  { word: 'RAPES', frequency: 2.29e-06, inWordle: false },
  { word: 'RAPHE', frequency: 6.76e-08, inWordle: false },
  { word: 'RAPPE', frequency: 2.95e-08, inWordle: false },
  { word: 'RARES', frequency: 2.19e-07, inWordle: false },
  { word: 'RASER', frequency: 1.12e-08, inWordle: false },
  { word: 'RASPS', frequency: 6.46e-08, inWordle: false },
  { word: 'RASSE', frequency: 1.17e-08, inWordle: false },
  { word: 'RASTA', frequency: 3.16e-07, inWordle: false },
  { word: 'RATAN', frequency: 2.09e-07, inWordle: false },
  { word: 'RATAS', frequency: 1.82e-08, inWordle: false },
  { word: 'RATCH', frequency: 2.04e-08, inWordle: false },
  { word: 'RATED', frequency: 2e-05, inWordle: false },
  { word: 'RATEL', frequency: 1.78e-08, inWordle: false },
  { word: 'RATER', frequency: 2e-07, inWordle: false },
  { word: 'RATES', frequency: 7.59e-05, inWordle: false },
  { word: 'RATHA', frequency: 6.03e-08, inWordle: false },
  { word: 'RATHE', frequency: 5.75e-08, inWordle: false },
  { word: 'RATHS', frequency: 4.17e-08, inWordle: false },
  { word: 'RAVED', frequency: 3.16e-07, inWordle: false },
  { word: 'RAVEL', frequency: 5.13e-07, inWordle: false },
  { word: 'RAVER', frequency: 1.55e-07, inWordle: false },
  { word: 'RAVES', frequency: 6.76e-07, inWordle: false },
  { word: 'RAVEY', frequency: 1.7e-08, inWordle: false },
  { word: 'RAVIN', frequency: 1.02e-07, inWordle: false },
  { word: 'RAWER', frequency: 4.17e-08, inWordle: false },
  { word: 'RAWLY', frequency: 2.4e-08, inWordle: false },
  { word: 'RAYAS', frequency: 2e-08, inWordle: false },
  { word: 'RAYED', frequency: 2.57e-07, inWordle: false },
  { word: 'RAYNE', frequency: 2.51e-07, inWordle: false },
  { word: 'RAZED', frequency: 6.17e-07, inWordle: false },
  { word: 'RAZEE', frequency: 1.26e-08, inWordle: false },
  { word: 'RAZER', frequency: 7.24e-07, inWordle: false },
  { word: 'RAZES', frequency: 2.63e-08, inWordle: false },
  { word: 'READS', frequency: 1.78e-05, inWordle: false },
  { word: 'REAIS', frequency: 1.2e-07, inWordle: false },
  { word: 'REALS', frequency: 5.37e-07, inWordle: false },
  { word: 'REAMS', frequency: 3.8e-07, inWordle: false },
  { word: 'REAPS', frequency: 2.19e-07, inWordle: false },
  { word: 'REARS', frequency: 3.98e-07, inWordle: false },
  { word: 'REATA', frequency: 3.02e-08, inWordle: false },
  { word: 'REATE', frequency: 1.48e-08, inWordle: false },
  { word: 'REAVE', frequency: 2.14e-08, inWordle: false },
  { word: 'REBBE', frequency: 2.24e-07, inWordle: false },
  { word: 'REBEC', frequency: 1.95e-08, inWordle: false },
  { word: 'REBID', frequency: 3.72e-08, inWordle: false },
  { word: 'REBUY', frequency: 6.92e-08, inWordle: false },
  { word: 'RECAL', frequency: 2.34e-08, inWordle: false },
  { word: 'RECCE', frequency: 1.66e-07, inWordle: false },
  { word: 'RECCO', frequency: 5.62e-08, inWordle: false },
  { word: 'RECIT', frequency: 1.78e-08, inWordle: false },
  { word: 'RECKS', frequency: 1.2e-08, inWordle: false },
  { word: 'RECON', frequency: 1.74e-06, inWordle: false },
  { word: 'RECTA', frequency: 5.5e-08, inWordle: false },
  { word: 'RECTI', frequency: 3.09e-08, inWordle: false },
  { word: 'RECTO', frequency: 1.74e-07, inWordle: false },
  { word: 'REDAN', frequency: 4.57e-08, inWordle: false },
  { word: 'REDDS', frequency: 3.39e-08, inWordle: false },
  { word: 'REDDY', frequency: 1.2e-06, inWordle: false },
  { word: 'REDES', frequency: 4.57e-08, inWordle: false },
  { word: 'REDID', frequency: 1.95e-07, inWordle: false },
  { word: 'REDON', frequency: 5.75e-08, inWordle: false },
  { word: 'REDOS', frequency: 1.74e-08, inWordle: false },
  { word: 'REDOX', frequency: 5.62e-07, inWordle: false },
  { word: 'REDUB', frequency: 1.58e-08, inWordle: false },
  { word: 'REDUX', frequency: 5.5e-07, inWordle: false },
  { word: 'REEDE', frequency: 3.47e-08, inWordle: false },
  { word: 'REEDS', frequency: 1.05e-06, inWordle: false },
  { word: 'REEFS', frequency: 2.29e-06, inWordle: false },
  { word: 'REEKS', frequency: 6.46e-07, inWordle: false },
  { word: 'REELS', frequency: 1.32e-06, inWordle: false },
  { word: 'REEVE', frequency: 8.13e-07, inWordle: false },
  { word: 'REFIX', frequency: 1.45e-08, inWordle: false },
  { word: 'REGAR', frequency: 3.89e-08, inWordle: false },
  { word: 'REGES', frequency: 1.82e-08, inWordle: false },
  { word: 'REGIE', frequency: 4.57e-08, inWordle: false },
  { word: 'REGNA', frequency: 3.02e-08, inWordle: false },
  { word: 'REIFY', frequency: 3.55e-08, inWordle: false },
  { word: 'REIKI', frequency: 3.89e-07, inWordle: false },
  { word: 'REINS', frequency: 2.04e-06, inWordle: false },
  { word: 'REIST', frequency: 3.02e-08, inWordle: false },
  { word: 'REJIG', frequency: 3.31e-08, inWordle: false },
  { word: 'REKEY', frequency: 1.38e-08, inWordle: false },
  { word: 'RELET', frequency: 1.35e-08, inWordle: false },
  { word: 'RELIE', frequency: 1.51e-08, inWordle: false },
  { word: 'RELIT', frequency: 4.47e-08, inWordle: false },
  { word: 'REMAN', frequency: 1.05e-07, inWordle: false },
  { word: 'REMAP', frequency: 8.71e-08, inWordle: false },
  { word: 'REMEN', frequency: 1.38e-08, inWordle: false },
  { word: 'REMIX', frequency: 9.77e-06, inWordle: false },
  { word: 'RENAY', frequency: 1.91e-08, inWordle: false },
  { word: 'RENDS', frequency: 3.16e-08, inWordle: false },
  { word: 'RENGA', frequency: 3.89e-08, inWordle: false },
  { word: 'RENIN', frequency: 1.23e-07, inWordle: false },
  { word: 'RENNE', frequency: 6.17e-08, inWordle: false },
  { word: 'RENOS', frequency: 6.03e-08, inWordle: false },
  { word: 'RENTS', frequency: 3.8e-06, inWordle: false },
  { word: 'REORG', frequency: 3.98e-08, inWordle: false },
  { word: 'REPIN', frequency: 7.41e-08, inWordle: false },
  { word: 'REPOS', frequency: 2.69e-07, inWordle: false },
  { word: 'REPOT', frequency: 6.61e-08, inWordle: false },
  { word: 'REPRO', frequency: 1.78e-07, inWordle: false },
  { word: 'RERAN', frequency: 3.39e-08, inWordle: false },
  { word: 'RESID', frequency: 3.24e-08, inWordle: false },
  { word: 'RESIT', frequency: 7.76e-08, inWordle: false },
  { word: 'RESTO', frequency: 3.55e-07, inWordle: false },
  { word: 'RESTS', frequency: 4.37e-06, inWordle: false },
  { word: 'RESUS', frequency: 2.51e-08, inWordle: false },
  { word: 'RETIE', frequency: 2.19e-08, inWordle: false },
  { word: 'RETOX', frequency: 1.7e-08, inWordle: false },
  { word: 'REVIE', frequency: 1.45e-07, inWordle: false },
  { word: 'REXES', frequency: 3.39e-08, inWordle: false },
  { word: 'RHEAS', frequency: 3.02e-08, inWordle: false },
  { word: 'RHEUM', frequency: 6.17e-08, inWordle: false },
  { word: 'RHINE', frequency: 1.91e-06, inWordle: false },
  { word: 'RHODY', frequency: 3.72e-08, inWordle: false },
  { word: 'RHOMB', frequency: 2.75e-08, inWordle: false },
  { word: 'RHONE', frequency: 4.57e-07, inWordle: false },
  { word: 'RHUMB', frequency: 2.45e-08, inWordle: false },
  { word: 'RHYNE', frequency: 6.46e-08, inWordle: false },
  { word: 'RIADS', frequency: 1.51e-08, inWordle: false },
  { word: 'RIALS', frequency: 1.17e-07, inWordle: false },
  { word: 'RIANT', frequency: 1.55e-08, inWordle: false },
  { word: 'RIATA', frequency: 2.88e-08, inWordle: false },
  { word: 'RIBAS', frequency: 8.32e-08, inWordle: false },
  { word: 'RIBBY', frequency: 1.7e-08, inWordle: false },
  { word: 'RIBES', frequency: 9.12e-08, inWordle: false },
  { word: 'RICED', frequency: 2.69e-08, inWordle: false },
  { word: 'RICER', frequency: 6.31e-08, inWordle: false },
  { word: 'RICES', frequency: 7.76e-08, inWordle: false },
  { word: 'RICEY', frequency: 1.07e-08, inWordle: false },
  { word: 'RICHT', frequency: 1.38e-07, inWordle: false },
  { word: 'RICIN', frequency: 2.51e-07, inWordle: false },
  { word: 'RICKS', frequency: 4.47e-07, inWordle: false },
  { word: 'RIDES', frequency: 1.15e-05, inWordle: false },
  { word: 'RIDGY', frequency: 1.15e-08, inWordle: false },
  { word: 'RIDIC', frequency: 7.76e-08, inWordle: false },
  { word: 'RIELS', frequency: 1.32e-08, inWordle: false },
  { word: 'RIFFS', frequency: 1.26e-06, inWordle: false },
  { word: 'RIFTS', frequency: 5.62e-07, inWordle: false },
  { word: 'RIGGS', frequency: 1.23e-06, inWordle: false },
  { word: 'RIGOL', frequency: 1.17e-08, inWordle: false },
  { word: 'RILED', frequency: 6.92e-07, inWordle: false },
  { word: 'RILES', frequency: 1.62e-07, inWordle: false },
  { word: 'RILEY', frequency: 7.94e-06, inWordle: false },
  { word: 'RILLE', frequency: 2.19e-08, inWordle: false },
  { word: 'RILLS', frequency: 2.95e-08, inWordle: false },
  { word: 'RIMED', frequency: 1.07e-08, inWordle: false },
  { word: 'RIMER', frequency: 5.25e-08, inWordle: false },
  { word: 'RIMES', frequency: 2.51e-07, inWordle: false },
  { word: 'RINDS', frequency: 2.09e-07, inWordle: false },
  { word: 'RINDY', frequency: 1.26e-08, inWordle: false },
  { word: 'RINES', frequency: 2.4e-08, inWordle: false },
  { word: 'RINGS', frequency: 2.14e-05, inWordle: false },
  { word: 'RINKS', frequency: 3.63e-07, inWordle: false },
  { word: 'RIOJA', frequency: 2.63e-07, inWordle: false },
  { word: 'RIOTS', frequency: 7.41e-06, inWordle: false },
  { word: 'RIPED', frequency: 1.66e-08, inWordle: false },
  { word: 'RIPPS', frequency: 1.07e-08, inWordle: false },
  { word: 'RISES', frequency: 1.17e-05, inWordle: false },
  { word: 'RISHI', frequency: 5.62e-07, inWordle: false },
  { word: 'RISKS', frequency: 2.24e-05, inWordle: false },
  { word: 'RISUS', frequency: 3.09e-08, inWordle: false },
  { word: 'RITES', frequency: 2.75e-06, inWordle: false },
  { word: 'RITTS', frequency: 4.68e-08, inWordle: false },
  { word: 'RITZY', frequency: 1.7e-07, inWordle: false },
  { word: 'RIVAS', frequency: 3.55e-07, inWordle: false },
  { word: 'RIVED', frequency: 1.62e-08, inWordle: false },
  { word: 'RIVEN', frequency: 5.25e-07, inWordle: false },
  { word: 'RIVES', frequency: 1.7e-07, inWordle: false },
  { word: 'RIYAL', frequency: 4.9e-08, inWordle: false },
  { word: 'ROADS', frequency: 3.55e-05, inWordle: false },
  { word: 'ROAMS', frequency: 3.31e-07, inWordle: false },
  { word: 'ROANS', frequency: 2.75e-08, inWordle: false },
  { word: 'ROARS', frequency: 8.13e-07, inWordle: false },
  { word: 'ROARY', frequency: 2.29e-08, inWordle: false },
  { word: 'ROBED', frequency: 2.69e-07, inWordle: false },
  { word: 'ROBES', frequency: 2.45e-06, inWordle: false },
  { word: 'ROBLE', frequency: 5.25e-08, inWordle: false },
  { word: 'ROCKS', frequency: 2.4e-05, inWordle: false },
  { word: 'RODES', frequency: 7.76e-08, inWordle: false },
  { word: 'ROIDS', frequency: 1.12e-07, inWordle: false },
  { word: 'ROILS', frequency: 2.63e-08, inWordle: false },
  { word: 'ROJAK', frequency: 2.4e-08, inWordle: false },
  { word: 'ROKER', frequency: 1.7e-07, inWordle: false },
  { word: 'ROLES', frequency: 2.75e-05, inWordle: false },
  { word: 'ROLFS', frequency: 1.66e-08, inWordle: false },
  { word: 'ROLLS', frequency: 1.7e-05, inWordle: false },
  { word: 'ROMAN', frequency: 3.16e-05, inWordle: false },
  { word: 'ROMEO', frequency: 5.13e-06, inWordle: false },
  { word: 'ROMPS', frequency: 9.77e-08, inWordle: false },
  { word: 'RONDE', frequency: 1.95e-07, inWordle: false },
  { word: 'RONDO', frequency: 1.07e-06, inWordle: false },
  { word: 'RONEO', frequency: 1.17e-08, inWordle: false },
  { word: 'RONIN', frequency: 5.89e-07, inWordle: false },
  { word: 'RONNE', frequency: 2.63e-08, inWordle: false },
  { word: 'ROODS', frequency: 2.75e-08, inWordle: false },
  { word: 'ROOFS', frequency: 3.8e-06, inWordle: false },
  { word: 'ROOKS', frequency: 3.63e-07, inWordle: false },
  { word: 'ROOKY', frequency: 1.35e-08, inWordle: false },
  { word: 'ROOMS', frequency: 3.63e-05, inWordle: false },
  { word: 'ROOSA', frequency: 4.79e-08, inWordle: false },
  { word: 'ROOSE', frequency: 2.14e-07, inWordle: false },
  { word: 'ROOTS', frequency: 2.19e-05, inWordle: false },
  { word: 'ROOTY', frequency: 1.07e-07, inWordle: false },
  { word: 'ROPED', frequency: 6.76e-07, inWordle: false },
  { word: 'ROPER', frequency: 1.17e-06, inWordle: false },
  { word: 'ROPES', frequency: 4.57e-06, inWordle: false },
  { word: 'ROPEY', frequency: 8.32e-08, inWordle: false },
  { word: 'ROQUE', frequency: 3.63e-07, inWordle: false },
  { word: 'RORIE', frequency: 2.75e-08, inWordle: false },
  { word: 'RORTS', frequency: 2.82e-08, inWordle: false },
  { word: 'RORTY', frequency: 9.12e-08, inWordle: false },
  { word: 'ROSES', frequency: 1.02e-05, inWordle: false },
  { word: 'ROSET', frequency: 2.4e-08, inWordle: false },
  { word: 'ROSHI', frequency: 2e-07, inWordle: false },
  { word: 'ROSIN', frequency: 3.39e-07, inWordle: false },
  { word: 'ROSTI', frequency: 3.47e-08, inWordle: false },
  { word: 'ROTAN', frequency: 2.75e-08, inWordle: false },
  { word: 'ROTAS', frequency: 5.25e-08, inWordle: false },
  { word: 'ROTCH', frequency: 3.98e-08, inWordle: false },
  { word: 'ROTES', frequency: 3.39e-08, inWordle: false },
  { word: 'ROTIS', frequency: 4.9e-08, inWordle: false },
  { word: 'ROTON', frequency: 1.7e-08, inWordle: false },
  { word: 'ROUEN', frequency: 5.89e-07, inWordle: false },
  { word: 'ROULE', frequency: 2.45e-08, inWordle: false },
  { word: 'ROUST', frequency: 3.89e-08, inWordle: false },
  { word: 'ROUTH', frequency: 1.32e-07, inWordle: false },
  { word: 'ROUTS', frequency: 1.23e-07, inWordle: false },
  { word: 'ROVED', frequency: 3.89e-08, inWordle: false },
  { word: 'ROVEN', frequency: 2.51e-08, inWordle: false },
  { word: 'ROVES', frequency: 2.75e-08, inWordle: false },
  { word: 'ROWAN', frequency: 2.09e-06, inWordle: false },
  { word: 'ROWED', frequency: 6.03e-07, inWordle: false },
  { word: 'ROWEL', frequency: 1.86e-08, inWordle: false },
  { word: 'ROWEN', frequency: 1.07e-07, inWordle: false },
  { word: 'RUANA', frequency: 1.23e-08, inWordle: false },
  { word: 'RUBBY', frequency: 3.39e-08, inWordle: false },
  { word: 'RUBEL', frequency: 9.12e-08, inWordle: false },
  { word: 'RUBES', frequency: 1.66e-07, inWordle: false },
  { word: 'RUBIN', frequency: 2.24e-06, inWordle: false },
  { word: 'RUBLE', frequency: 4.17e-07, inWordle: false },
  { word: 'RUBUS', frequency: 1.05e-07, inWordle: false },
  { word: 'RUCHE', frequency: 2.09e-08, inWordle: false },
  { word: 'RUCKS', frequency: 8.51e-08, inWordle: false },
  { word: 'RUDAS', frequency: 1.74e-08, inWordle: false },
  { word: 'RUDDS', frequency: 1.38e-08, inWordle: false },
  { word: 'RUDES', frequency: 1.91e-08, inWordle: false },
  { word: 'RUDIE', frequency: 4.27e-08, inWordle: false },
  { word: 'RUDIS', frequency: 3.02e-08, inWordle: false },
  { word: 'RUEDA', frequency: 1.1e-07, inWordle: false },
  { word: 'RUFFE', frequency: 1.32e-08, inWordle: false },
  { word: 'RUFFS', frequency: 5.25e-08, inWordle: false },
  { word: 'RUGAE', frequency: 3.63e-08, inWordle: false },
  { word: 'RUGAL', frequency: 2.19e-08, inWordle: false },
  { word: 'RUING', frequency: 4.37e-08, inWordle: false },
  { word: 'RUINS', frequency: 1.05e-05, inWordle: false },
  { word: 'RULED', frequency: 2e-05, inWordle: false },
  { word: 'RULES', frequency: 0.000115, inWordle: false },
  { word: 'RUMAL', frequency: 1.26e-08, inWordle: false },
  { word: 'RUMBO', frequency: 2.69e-08, inWordle: false },
  { word: 'RUMEN', frequency: 2e-07, inWordle: false },
  { word: 'RUMMY', frequency: 2.34e-07, inWordle: false },
  { word: 'RUMPS', frequency: 5.13e-08, inWordle: false },
  { word: 'RUMPY', frequency: 1.51e-08, inWordle: false },
  { word: 'RUNED', frequency: 1.26e-08, inWordle: false },
  { word: 'RUNES', frequency: 7.76e-07, inWordle: false },
  { word: 'RUNGS', frequency: 3.55e-07, inWordle: false },
  { word: 'RUNIC', frequency: 2.45e-07, inWordle: false },
  { word: 'RUNNY', frequency: 8.71e-07, inWordle: false },
  { word: 'RUNTS', frequency: 6.17e-08, inWordle: false },
  { word: 'RUNTY', frequency: 2.45e-08, inWordle: false },
  { word: 'RUSES', frequency: 6.92e-08, inWordle: false },
  { word: 'RUSHY', frequency: 3.02e-08, inWordle: false },
  { word: 'RUSKS', frequency: 3.16e-08, inWordle: false },
  { word: 'RUSSE', frequency: 2e-07, inWordle: false },
  { word: 'RUSTS', frequency: 1.15e-07, inWordle: false },
  { word: 'RUTHS', frequency: 2.69e-08, inWordle: false },
  { word: 'RUTIN', frequency: 3.63e-08, inWordle: false },
  { word: 'RUTTY', frequency: 3.16e-08, inWordle: false },
  { word: 'RYALS', frequency: 1.29e-08, inWordle: false },
  { word: 'SABAL', frequency: 5.62e-08, inWordle: false },
  { word: 'SABER', frequency: 1.51e-06, inWordle: false },
  { word: 'SABES', frequency: 6.17e-08, inWordle: false },
  { word: 'SABHA', frequency: 1.26e-06, inWordle: false },
  { word: 'SABIN', frequency: 3.09e-07, inWordle: false },
  { word: 'SABIR', frequency: 7.94e-08, inWordle: false },
  { word: 'SABLE', frequency: 9.77e-07, inWordle: false },
  { word: 'SABOT', frequency: 1.15e-07, inWordle: false },
  { word: 'SABRA', frequency: 3.24e-07, inWordle: false },
  { word: 'SABRE', frequency: 1.05e-06, inWordle: false },
  { word: 'SACKS', frequency: 3.89e-06, inWordle: false },
  { word: 'SACRA', frequency: 4.79e-07, inWordle: false },
  { word: 'SADDO', frequency: 1.7e-08, inWordle: false },
  { word: 'SADHU', frequency: 1.58e-07, inWordle: false },
  { word: 'SADZA', frequency: 1.02e-08, inWordle: false },
  { word: 'SAFED', frequency: 8.91e-08, inWordle: false },
  { word: 'SAFES', frequency: 5.89e-07, inWordle: false },
  { word: 'SAGAS', frequency: 4.07e-07, inWordle: false },
  { word: 'SAGER', frequency: 3.09e-07, inWordle: false },
  { word: 'SAGES', frequency: 8.32e-07, inWordle: false },
  { word: 'SAGGY', frequency: 5.01e-07, inWordle: false },
  { word: 'SAHEB', frequency: 3.63e-07, inWordle: false },
  { word: 'SAHIB', frequency: 1.02e-06, inWordle: false },
  { word: 'SAIDS', frequency: 4.37e-08, inWordle: false },
  { word: 'SAIGA', frequency: 1.02e-07, inWordle: false },
  { word: 'SAILS', frequency: 3.31e-06, inWordle: false },
  { word: 'SAINE', frequency: 3.24e-08, inWordle: false },
  { word: 'SAINS', frequency: 5.37e-08, inWordle: false },
  { word: 'SAITH', frequency: 8.71e-07, inWordle: false },
  { word: 'SAKAI', frequency: 3.16e-07, inWordle: false },
  { word: 'SAKER', frequency: 1.1e-07, inWordle: false },
  { word: 'SAKES', frequency: 7.94e-07, inWordle: false },
  { word: 'SAKIS', frequency: 1.91e-08, inWordle: false },
  { word: 'SAKTI', frequency: 9.12e-08, inWordle: false },
  { word: 'SALAL', frequency: 3.89e-08, inWordle: false },
  { word: 'SALAT', frequency: 1.66e-07, inWordle: false },
  { word: 'SALEP', frequency: 1.58e-08, inWordle: false },
  { word: 'SALES', frequency: 0.000105, inWordle: false },
  { word: 'SALIC', frequency: 6.31e-08, inWordle: false },
  { word: 'SALIX', frequency: 2.19e-07, inWordle: false },
  { word: 'SALLE', frequency: 1.48e-06, inWordle: false },
  { word: 'SALMI', frequency: 3.89e-08, inWordle: false },
  { word: 'SALOP', frequency: 1.02e-07, inWordle: false },
  { word: 'SALPA', frequency: 1.95e-08, inWordle: false },
  { word: 'SALPS', frequency: 2.75e-08, inWordle: false },
  { word: 'SALTO', frequency: 1.07e-07, inWordle: false },
  { word: 'SALTS', frequency: 2.57e-06, inWordle: false },
  { word: 'SALUT', frequency: 2.09e-07, inWordle: false },
  { word: 'SAMAN', frequency: 1.02e-07, inWordle: false },
  { word: 'SAMAS', frequency: 3.55e-08, inWordle: false },
  { word: 'SAMBA', frequency: 1.51e-06, inWordle: false },
  { word: 'SAMBO', frequency: 3.24e-07, inWordle: false },
  { word: 'SAMEK', frequency: 1.1e-08, inWordle: false },
  { word: 'SAMEL', frequency: 1.55e-08, inWordle: false },
  { word: 'SAMEN', frequency: 3.55e-08, inWordle: false },
  { word: 'SAMES', frequency: 4.57e-08, inWordle: false },
  { word: 'SAMEY', frequency: 5.75e-08, inWordle: false },
  { word: 'SAMMY', frequency: 3.98e-06, inWordle: false },
  { word: 'SANDS', frequency: 6.46e-06, inWordle: false },
  { word: 'SANES', frequency: 1.78e-08, inWordle: false },
  { word: 'SANGA', frequency: 1.1e-07, inWordle: false },
  { word: 'SANGH', frequency: 3.39e-07, inWordle: false },
  { word: 'SANGO', frequency: 1.41e-07, inWordle: false },
  { word: 'SANGS', frequency: 2.34e-08, inWordle: false },
  { word: 'SANKO', frequency: 3.55e-08, inWordle: false },
  { word: 'SANSA', frequency: 8.91e-07, inWordle: false },
  { word: 'SANTO', frequency: 2.29e-06, inWordle: false },
  { word: 'SANTS', frequency: 9.12e-08, inWordle: false },
  { word: 'SAOLA', frequency: 1.66e-08, inWordle: false },
  { word: 'SAPAN', frequency: 1.82e-08, inWordle: false },
  { word: 'SAPID', frequency: 1.05e-08, inWordle: false },
  { word: 'SAPOR', frequency: 1.12e-08, inWordle: false },
  { word: 'SARAN', frequency: 3.98e-07, inWordle: false },
  { word: 'SAREE', frequency: 4.27e-07, inWordle: false },
  { word: 'SARGE', frequency: 3.47e-07, inWordle: false },
  { word: 'SARIN', frequency: 6.17e-07, inWordle: false },
  { word: 'SARIS', frequency: 2.51e-07, inWordle: false },
  { word: 'SARKS', frequency: 1.26e-08, inWordle: false },
  { word: 'SARKY', frequency: 2.69e-08, inWordle: false },
  { word: 'SAROD', frequency: 2.29e-08, inWordle: false },
  { word: 'SAROS', frequency: 6.46e-08, inWordle: false },
  { word: 'SARUS', frequency: 1.23e-08, inWordle: false },
  { word: 'SASIN', frequency: 1.23e-08, inWordle: false },
  { word: 'SASSE', frequency: 1.86e-07, inWordle: false },
  { word: 'SATAY', frequency: 1.74e-07, inWordle: false },
  { word: 'SATED', frequency: 2.69e-07, inWordle: false },
  { word: 'SATEM', frequency: 1.78e-08, inWordle: false },
  { word: 'SATES', frequency: 1.26e-07, inWordle: false },
  { word: 'SATIS', frequency: 8.71e-08, inWordle: false },
  { word: 'SAULS', frequency: 3.63e-08, inWordle: false },
  { word: 'SAULT', frequency: 4.47e-07, inWordle: false },
  { word: 'SAURY', frequency: 3.24e-08, inWordle: false },
  { word: 'SAVED', frequency: 4.68e-05, inWordle: false },
  { word: 'SAVER', frequency: 1.86e-06, inWordle: false },
  { word: 'SAVES', frequency: 1.17e-05, inWordle: false },
  { word: 'SAVIN', frequency: 3.63e-07, inWordle: false },
  { word: 'SAWAH', frequency: 2.14e-08, inWordle: false },
  { word: 'SAWED', frequency: 6.31e-07, inWordle: false },
  { word: 'SAWER', frequency: 3.55e-08, inWordle: false },
  { word: 'SAXES', frequency: 4.57e-08, inWordle: false },
  { word: 'SAYED', frequency: 4.07e-07, inWordle: false },
  { word: 'SAYER', frequency: 3.16e-07, inWordle: false },
  { word: 'SAYID', frequency: 1.74e-07, inWordle: false },
  { word: 'SAYON', frequency: 1.32e-08, inWordle: false },
  { word: 'SCABS', frequency: 3.8e-07, inWordle: false },
  { word: 'SCADS', frequency: 7.59e-08, inWordle: false },
  { word: 'SCAFF', frequency: 1.26e-08, inWordle: false },
  { word: 'SCALA', frequency: 1.02e-06, inWordle: false },
  { word: 'SCAMS', frequency: 2.34e-06, inWordle: false },
  { word: 'SCAND', frequency: 2.82e-08, inWordle: false },
  { word: 'SCANS', frequency: 4.17e-06, inWordle: false },
  { word: 'SCAPA', frequency: 1.1e-07, inWordle: false },
  { word: 'SCAPE', frequency: 5.13e-07, inWordle: false },
  { word: 'SCARP', frequency: 1.91e-07, inWordle: false },
  { word: 'SCARS', frequency: 5.75e-06, inWordle: false },
  { word: 'SCART', frequency: 5.75e-08, inWordle: false },
  { word: 'SCATS', frequency: 6.17e-08, inWordle: false },
  { word: 'SCATT', frequency: 1.2e-08, inWordle: false },
  { word: 'SCAUP', frequency: 5.5e-08, inWordle: false },
  { word: 'SCENA', frequency: 4.27e-08, inWordle: false },
  { word: 'SCHMO', frequency: 6.31e-08, inWordle: false },
  { word: 'SCHUL', frequency: 1.91e-08, inWordle: false },
  { word: 'SCHWA', frequency: 7.24e-08, inWordle: false },
  { word: 'SCOOT', frequency: 6.17e-07, inWordle: false },
  { word: 'SCOPA', frequency: 4.27e-08, inWordle: false },
  { word: 'SCOPS', frequency: 3.02e-08, inWordle: false },
  { word: 'SCOTS', frequency: 5.5e-06, inWordle: false },
  { word: 'SCOWS', frequency: 2.04e-08, inWordle: false },
  { word: 'SCRAG', frequency: 3.02e-08, inWordle: false },
  { word: 'SCRAN', frequency: 5.01e-08, inWordle: false },
  { word: 'SCRAT', frequency: 4.57e-08, inWordle: false },
  { word: 'SCRAY', frequency: 1.05e-08, inWordle: false },
  { word: 'SCRIM', frequency: 3.16e-07, inWordle: false },
  { word: 'SCRIP', frequency: 3.98e-07, inWordle: false },
  { word: 'SCROD', frequency: 1.45e-08, inWordle: false },
  { word: 'SCUDI', frequency: 3.63e-08, inWordle: false },
  { word: 'SCUDO', frequency: 2.95e-08, inWordle: false },
  { word: 'SCUDS', frequency: 5.01e-08, inWordle: false },
  { word: 'SCUFF', frequency: 2.82e-07, inWordle: false },
  { word: 'SCULL', frequency: 1.95e-07, inWordle: false },
  { word: 'SCULP', frequency: 1.7e-08, inWordle: false },
  { word: 'SCUMS', frequency: 8.71e-08, inWordle: false },
  { word: 'SCURF', frequency: 1.7e-08, inWordle: false },
  { word: 'SCUSE', frequency: 1.2e-07, inWordle: false },
  { word: 'SCUTE', frequency: 3.89e-08, inWordle: false },
  { word: 'SCUZZ', frequency: 3.39e-08, inWordle: false },
  { word: 'SEALS', frequency: 7.08e-06, inWordle: false },
  { word: 'SEAMS', frequency: 2.09e-06, inWordle: false },
  { word: 'SEAMY', frequency: 6.61e-08, inWordle: false },
  { word: 'SEANS', frequency: 1.95e-08, inWordle: false },
  { word: 'SEARS', frequency: 3.09e-06, inWordle: false },
  { word: 'SEASE', frequency: 1.78e-08, inWordle: false },
  { word: 'SEATS', frequency: 3.39e-05, inWordle: false },
  { word: 'SEBUM', frequency: 1.41e-07, inWordle: false },
  { word: 'SECCO', frequency: 5.37e-08, inWordle: false },
  { word: 'SECHS', frequency: 4.17e-08, inWordle: false },
  { word: 'SECTS', frequency: 1.38e-06, inWordle: false },
  { word: 'SEDER', frequency: 3.55e-07, inWordle: false },
  { word: 'SEDES', frequency: 2.88e-08, inWordle: false },
  { word: 'SEDGE', frequency: 2.45e-07, inWordle: false },
  { word: 'SEDUM', frequency: 1e-07, inWordle: false },
  { word: 'SEEDS', frequency: 1.91e-05, inWordle: false },
  { word: 'SEEKS', frequency: 1.35e-05, inWordle: false },
  { word: 'SEELY', frequency: 1.62e-07, inWordle: false },
  { word: 'SEEMS', frequency: 0.000174, inWordle: false },
  { word: 'SEEPS', frequency: 4.68e-07, inWordle: false },
  { word: 'SEERS', frequency: 2.63e-07, inWordle: false },
  { word: 'SEFER', frequency: 1.29e-07, inWordle: false },
  { word: 'SEGAR', frequency: 6.46e-08, inWordle: false },
  { word: 'SEGNI', frequency: 2.29e-08, inWordle: false },
  { word: 'SEGNO', frequency: 2.82e-08, inWordle: false },
  { word: 'SEINE', frequency: 1.48e-06, inWordle: false },
  { word: 'SEIZA', frequency: 2.14e-08, inWordle: false },
  { word: 'SELAH', frequency: 2.75e-07, inWordle: false },
  { word: 'SELES', frequency: 7.41e-08, inWordle: false },
  { word: 'SELFS', frequency: 7.41e-08, inWordle: false },
  { word: 'SELLA', frequency: 1.95e-07, inWordle: false },
  { word: 'SELLE', frequency: 6.46e-08, inWordle: false },
  { word: 'SELLS', frequency: 1.23e-05, inWordle: false },
  { word: 'SELVA', frequency: 1.55e-07, inWordle: false },
  { word: 'SEMES', frequency: 1.2e-08, inWordle: false },
  { word: 'SEMIS', frequency: 1.15e-06, inWordle: false },
  { word: 'SENDS', frequency: 1.41e-05, inWordle: false },
  { word: 'SENGI', frequency: 1.82e-08, inWordle: false },
  { word: 'SENNA', frequency: 8.71e-07, inWordle: false },
  { word: 'SENOR', frequency: 4.07e-07, inWordle: false },
  { word: 'SENSA', frequency: 5.62e-08, inWordle: false },
  { word: 'SENSI', frequency: 9.33e-08, inWordle: false },
  { word: 'SENTE', frequency: 5.5e-08, inWordle: false },
  { word: 'SENTI', frequency: 6.17e-08, inWordle: false },
  { word: 'SENTS', frequency: 2.19e-08, inWordle: false },
  { word: 'SENZA', frequency: 1.48e-07, inWordle: false },
  { word: 'SEPAL', frequency: 6.46e-08, inWordle: false },
  { word: 'SEPOY', frequency: 1.26e-07, inWordle: false },
  { word: 'SEPTA', frequency: 5.01e-07, inWordle: false },
  { word: 'SEPTS', frequency: 2.95e-08, inWordle: false },
  { word: 'SERAC', frequency: 1.26e-08, inWordle: false },
  { word: 'SERAI', frequency: 5.89e-08, inWordle: false },
  { word: 'SERAL', frequency: 1.58e-08, inWordle: false },
  { word: 'SERED', frequency: 1.17e-08, inWordle: false },
  { word: 'SERER', frequency: 1.7e-08, inWordle: false },
  { word: 'SERES', frequency: 5.37e-08, inWordle: false },
  { word: 'SERFS', frequency: 5.01e-07, inWordle: false },
  { word: 'SERGE', frequency: 1.66e-06, inWordle: false },
  { word: 'SERIN', frequency: 4.17e-08, inWordle: false },
  { word: 'SERON', frequency: 2.34e-08, inWordle: false },
  { word: 'SEROW', frequency: 1.58e-08, inWordle: false },
  { word: 'SERRA', frequency: 8.13e-07, inWordle: false },
  { word: 'SERRE', frequency: 8.71e-08, inWordle: false },
  { word: 'SERRY', frequency: 5.25e-08, inWordle: false },
  { word: 'SERVO', frequency: 7.94e-07, inWordle: false },
  { word: 'SESSA', frequency: 5.01e-08, inWordle: false },
  { word: 'SETAE', frequency: 1.7e-07, inWordle: false },
  { word: 'SETON', frequency: 6.92e-07, inWordle: false },
  { word: 'SETTS', frequency: 6.61e-08, inWordle: false },
  { word: 'SEWED', frequency: 7.76e-07, inWordle: false },
  { word: 'SEWEL', frequency: 1.91e-08, inWordle: false },
  { word: 'SEWIN', frequency: 1.91e-08, inWordle: false },
  { word: 'SEXED', frequency: 3.02e-07, inWordle: false },
  { word: 'SEXES', frequency: 2.69e-06, inWordle: false },
  { word: 'SEXTO', frequency: 2.82e-08, inWordle: false },
  { word: 'SEXTS', frequency: 6.46e-08, inWordle: false },
  { word: 'SHADS', frequency: 1.62e-08, inWordle: false },
  { word: 'SHAGS', frequency: 9.77e-08, inWordle: false },
  { word: 'SHAHS', frequency: 7.24e-08, inWordle: false },
  { word: 'SHAKO', frequency: 4.9e-08, inWordle: false },
  { word: 'SHALY', frequency: 1.35e-08, inWordle: false },
  { word: 'SHAMA', frequency: 1.1e-07, inWordle: false },
  { word: 'SHAMS', frequency: 4.47e-07, inWordle: false },
  { word: 'SHAND', frequency: 2.88e-07, inWordle: false },
  { word: 'SHANS', frequency: 2.57e-08, inWordle: false },
  { word: 'SHARN', frequency: 2.57e-08, inWordle: false },
  { word: 'SHASH', frequency: 1.41e-08, inWordle: false },
  { word: 'SHAUL', frequency: 1.41e-07, inWordle: false },
  { word: 'SHAWM', frequency: 1.51e-08, inWordle: false },
  { word: 'SHAWN', frequency: 6.46e-06, inWordle: false },
  { word: 'SHAWS', frequency: 8.71e-08, inWordle: false },
  { word: 'SHAYA', frequency: 4.37e-08, inWordle: false },
  { word: 'SHAYS', frequency: 1.1e-07, inWordle: false },
  { word: 'SHEAF', frequency: 3.98e-07, inWordle: false },
  { word: 'SHEDS', frequency: 3.02e-06, inWordle: false },
  { word: 'SHEEL', frequency: 1.95e-08, inWordle: false },
  { word: 'SHEOL', frequency: 1.17e-07, inWordle: false },
  { word: 'SHERD', frequency: 2.75e-08, inWordle: false },
  { word: 'SHERE', frequency: 2.4e-07, inWordle: false },
  { word: 'SHERO', frequency: 1.29e-07, inWordle: false },
  { word: 'SHEVA', frequency: 2.34e-07, inWordle: false },
  { word: 'SHEWN', frequency: 4.47e-08, inWordle: false },
  { word: 'SHEWS', frequency: 2.45e-08, inWordle: false },
  { word: 'SHIEL', frequency: 1.32e-07, inWordle: false },
  { word: 'SHIER', frequency: 2.82e-08, inWordle: false },
  { word: 'SHIES', frequency: 9.12e-08, inWordle: false },
  { word: 'SHILL', frequency: 4.79e-07, inWordle: false },
  { word: 'SHIMS', frequency: 1.2e-07, inWordle: false },
  { word: 'SHINS', frequency: 4.79e-07, inWordle: false },
  { word: 'SHIPS', frequency: 3.55e-05, inWordle: false },
  { word: 'SHISH', frequency: 1.1e-07, inWordle: false },
  { word: 'SHISO', frequency: 4.9e-08, inWordle: false },
  { word: 'SHITE', frequency: 2.04e-06, inWordle: false },
  { word: 'SHITS', frequency: 4.37e-06, inWordle: false },
  { word: 'SHIUR', frequency: 1.86e-08, inWordle: false },
  { word: 'SHIVA', frequency: 2.14e-06, inWordle: false },
  { word: 'SHIVE', frequency: 4.47e-08, inWordle: false },
  { word: 'SHIVS', frequency: 3.09e-08, inWordle: false },
  { word: 'SHOAT', frequency: 1.26e-08, inWordle: false },
  { word: 'SHOED', frequency: 3.24e-08, inWordle: false },
  { word: 'SHOES', frequency: 4.68e-05, inWordle: false },
  { word: 'SHOGI', frequency: 9.12e-08, inWordle: false },
  { word: 'SHOJI', frequency: 1.86e-07, inWordle: false },
  { word: 'SHOJO', frequency: 7.76e-08, inWordle: false },
  { word: 'SHOLA', frequency: 1.17e-07, inWordle: false },
  { word: 'SHOOL', frequency: 3.98e-08, inWordle: false },
  { word: 'SHOON', frequency: 2.04e-08, inWordle: false },
  { word: 'SHOOS', frequency: 3.39e-08, inWordle: false },
  { word: 'SHOPE', frequency: 4.17e-08, inWordle: false },
  { word: 'SHOPS', frequency: 2.19e-05, inWordle: false },
  { word: 'SHOTS', frequency: 4.27e-05, inWordle: false },
  { word: 'SHOTT', frequency: 2.69e-08, inWordle: false },
  { word: 'SHOWS', frequency: 0.00017, inWordle: false },
  { word: 'SHOYU', frequency: 5.37e-08, inWordle: false },
  { word: 'SHRED', frequency: 2.09e-06, inWordle: false },
  { word: 'SHTUM', frequency: 1.07e-08, inWordle: false },
  { word: 'SHULE', frequency: 1.41e-08, inWordle: false },
  { word: 'SHULS', frequency: 1.26e-08, inWordle: false },
  { word: 'SHUNS', frequency: 2.09e-07, inWordle: false },
  { word: 'SHURA', frequency: 3.24e-07, inWordle: false },
  { word: 'SHUTE', frequency: 2.19e-07, inWordle: false },
  { word: 'SHUTS', frequency: 3.09e-06, inWordle: false },
  { word: 'SHYER', frequency: 5.25e-08, inWordle: false },
  { word: 'SIBYL', frequency: 2.82e-07, inWordle: false },
  { word: 'SICHT', frequency: 2.34e-08, inWordle: false },
  { word: 'SICKO', frequency: 3.55e-07, inWordle: false },
  { word: 'SICKS', frequency: 3.31e-08, inWordle: false },
  { word: 'SICKY', frequency: 2.63e-08, inWordle: false },
  { word: 'SIDED', frequency: 8.71e-06, inWordle: false },
  { word: 'SIDER', frequency: 2.29e-07, inWordle: false },
  { word: 'SIDES', frequency: 5.37e-05, inWordle: false },
  { word: 'SIDHE', frequency: 8.51e-08, inWordle: false },
  { word: 'SIDLE', frequency: 1e-07, inWordle: false },
  { word: 'SIEUR', frequency: 1.51e-07, inWordle: false },
  { word: 'SIFTS', frequency: 7.08e-08, inWordle: false },
  { word: 'SIGHS', frequency: 2.4e-06, inWordle: false },
  { word: 'SIGIL', frequency: 2.34e-07, inWordle: false },
  { word: 'SIGLA', frequency: 1.32e-08, inWordle: false },
  { word: 'SIGNA', frequency: 9.12e-08, inWordle: false },
  { word: 'SIGNS', frequency: 5.13e-05, inWordle: false },
  { word: 'SIKES', frequency: 2.82e-07, inWordle: false },
  { word: 'SILEN', frequency: 1.66e-08, inWordle: false },
  { word: 'SILER', frequency: 1.29e-07, inWordle: false },
  { word: 'SILES', frequency: 4.07e-08, inWordle: false },
  { word: 'SILEX', frequency: 7.41e-08, inWordle: false },
  { word: 'SILKS', frequency: 6.17e-07, inWordle: false },
  { word: 'SILLS', frequency: 6.17e-07, inWordle: false },
  { word: 'SILOS', frequency: 8.71e-07, inWordle: false },
  { word: 'SILTS', frequency: 5.37e-08, inWordle: false },
  { word: 'SILTY', frequency: 1.29e-07, inWordle: false },
  { word: 'SILVA', frequency: 5.89e-06, inWordle: false },
  { word: 'SIMAR', frequency: 2.57e-08, inWordle: false },
  { word: 'SIMAS', frequency: 4.68e-08, inWordle: false },
  { word: 'SIMBA', frequency: 8.71e-07, inWordle: false },
  { word: 'SIMPS', frequency: 7.24e-08, inWordle: false },
  { word: 'SIMUL', frequency: 6.92e-08, inWordle: false },
  { word: 'SINDS', frequency: 1.23e-08, inWordle: false },
  { word: 'SINES', frequency: 1.23e-07, inWordle: false },
  { word: 'SINGS', frequency: 7.76e-06, inWordle: false },
  { word: 'SINKS', frequency: 2.95e-06, inWordle: false },
  { word: 'SINUS', frequency: 1.91e-06, inWordle: false },
  { word: 'SIPES', frequency: 4.9e-08, inWordle: false },
  { word: 'SIPPY', frequency: 3.09e-07, inWordle: false },
  { word: 'SIRED', frequency: 4.47e-07, inWordle: false },
  { word: 'SIREE', frequency: 4.68e-08, inWordle: false },
  { word: 'SIRES', frequency: 3.31e-07, inWordle: false },
  { word: 'SIRIS', frequency: 3.98e-08, inWordle: false },
  { word: 'SIRUP', frequency: 2e-08, inWordle: false },
  { word: 'SISAL', frequency: 1.55e-07, inWordle: false },
  { word: 'SISTA', frequency: 1.58e-07, inWordle: false },
  { word: 'SITAR', frequency: 2.57e-07, inWordle: false },
  { word: 'SITED', frequency: 5.62e-07, inWordle: false },
  { word: 'SITES', frequency: 5.5e-05, inWordle: false },
  { word: 'SITHE', frequency: 1.15e-08, inWordle: false },
  { word: 'SITKA', frequency: 4.47e-07, inWordle: false },
  { word: 'SITUS', frequency: 1e-07, inWordle: false },
  { word: 'SIVER', frequency: 6.76e-08, inWordle: false },
  { word: 'SIXER', frequency: 1.12e-07, inWordle: false },
  { word: 'SIXES', frequency: 8.13e-07, inWordle: false },
  { word: 'SIXTE', frequency: 1.2e-08, inWordle: false },
  { word: 'SIZAR', frequency: 1.38e-08, inWordle: false },
  { word: 'SIZED', frequency: 1.86e-05, inWordle: false },
  { word: 'SIZER', frequency: 8.71e-08, inWordle: false },
  { word: 'SIZES', frequency: 1.51e-05, inWordle: false },
  { word: 'SKAGS', frequency: 1.17e-08, inWordle: false },
  { word: 'SKALD', frequency: 3.55e-08, inWordle: false },
  { word: 'SKANK', frequency: 4.79e-07, inWordle: false },
  { word: 'SKEEN', frequency: 9.77e-08, inWordle: false },
  { word: 'SKEES', frequency: 1.74e-08, inWordle: false },
  { word: 'SKEET', frequency: 5.01e-07, inWordle: false },
  { word: 'SKEIN', frequency: 2.19e-07, inWordle: false },
  { word: 'SKELL', frequency: 6.31e-08, inWordle: false },
  { word: 'SKELP', frequency: 1.66e-08, inWordle: false },
  { word: 'SKENE', frequency: 1.17e-07, inWordle: false },
  { word: 'SKEWS', frequency: 1.91e-07, inWordle: false },
  { word: 'SKIDS', frequency: 5.25e-07, inWordle: false },
  { word: 'SKIED', frequency: 2.88e-07, inWordle: false },
  { word: 'SKIES', frequency: 8.13e-06, inWordle: false },
  { word: 'SKIMO', frequency: 1.12e-08, inWordle: false },
  { word: 'SKIMS', frequency: 1.26e-07, inWordle: false },
  { word: 'SKINK', frequency: 1.38e-07, inWordle: false },
  { word: 'SKINS', frequency: 6.17e-06, inWordle: false },
  { word: 'SKINT', frequency: 2.63e-07, inWordle: false },
  { word: 'SKIPS', frequency: 1.41e-06, inWordle: false },
  { word: 'SKIRL', frequency: 2.04e-08, inWordle: false },
  { word: 'SKITE', frequency: 1.07e-08, inWordle: false },
  { word: 'SKITS', frequency: 7.59e-07, inWordle: false },
  { word: 'SKIVE', frequency: 4.37e-08, inWordle: false },
  { word: 'SKOAL', frequency: 6.61e-08, inWordle: false },
  { word: 'SKOOL', frequency: 2.19e-07, inWordle: false },
  { word: 'SKORT', frequency: 3.24e-08, inWordle: false },
  { word: 'SKUAS', frequency: 4.07e-08, inWordle: false },
  { word: 'SLABS', frequency: 1.58e-06, inWordle: false },
  { word: 'SLADE', frequency: 1.78e-06, inWordle: false },
  { word: 'SLAGS', frequency: 2.51e-07, inWordle: false },
  { word: 'SLAKE', frequency: 1.02e-07, inWordle: false },
  { word: 'SLAMS', frequency: 4.27e-06, inWordle: false },
  { word: 'SLANE', frequency: 8.13e-08, inWordle: false },
  { word: 'SLANK', frequency: 2.29e-08, inWordle: false },
  { word: 'SLAPS', frequency: 1.48e-06, inWordle: false },
  { word: 'SLATS', frequency: 4.79e-07, inWordle: false },
  { word: 'SLATY', frequency: 1.1e-07, inWordle: false },
  { word: 'SLAYS', frequency: 3.39e-07, inWordle: false },
  { word: 'SLEDS', frequency: 3.72e-07, inWordle: false },
  { word: 'SLEWS', frequency: 1.32e-08, inWordle: false },
  { word: 'SLIER', frequency: 1.29e-08, inWordle: false },
  { word: 'SLIMS', frequency: 1.62e-07, inWordle: false },
  { word: 'SLIPS', frequency: 4.07e-06, inWordle: false },
  { word: 'SLITS', frequency: 7.59e-07, inWordle: false },
  { word: 'SLIVE', frequency: 3.09e-08, inWordle: false },
  { word: 'SLOAN', frequency: 2.75e-06, inWordle: false },
  { word: 'SLOBS', frequency: 1.74e-07, inWordle: false },
  { word: 'SLOES', frequency: 2.82e-08, inWordle: false },
  { word: 'SLOGS', frequency: 3.63e-08, inWordle: false },
  { word: 'SLOMO', frequency: 5.13e-08, inWordle: false },
  { word: 'SLOOT', frequency: 1.38e-07, inWordle: false },
  { word: 'SLOPS', frequency: 7.24e-08, inWordle: false },
  { word: 'SLOTS', frequency: 6.76e-06, inWordle: false },
  { word: 'SLOWS', frequency: 2.45e-06, inWordle: false },
  { word: 'SLOYD', frequency: 1.66e-08, inWordle: false },
  { word: 'SLUFF', frequency: 1.05e-08, inWordle: false },
  { word: 'SLUGS', frequency: 1.12e-06, inWordle: false },
  { word: 'SLUMS', frequency: 1.58e-06, inWordle: false },
  { word: 'SLURS', frequency: 1.32e-06, inWordle: false },
  { word: 'SLUTS', frequency: 1.55e-06, inWordle: false },
  { word: 'SMARM', frequency: 2.24e-08, inWordle: false },
  { word: 'SMITS', frequency: 1.26e-07, inWordle: false },
  { word: 'SMOKO', frequency: 3.55e-08, inWordle: false },
  { word: 'SMOLT', frequency: 3.31e-08, inWordle: false },
  { word: 'SMOOT', frequency: 2.45e-07, inWordle: false },
  { word: 'SMORE', frequency: 2.63e-08, inWordle: false },
  { word: 'SMOUT', frequency: 3.63e-08, inWordle: false },
  { word: 'SMUSH', frequency: 8.91e-08, inWordle: false },
  { word: 'SMUTS', frequency: 2.57e-07, inWordle: false },
  { word: 'SNAFU', frequency: 3.47e-07, inWordle: false },
  { word: 'SNAGS', frequency: 4.47e-07, inWordle: false },
  { word: 'SNAPS', frequency: 4.57e-06, inWordle: false },
  { word: 'SNARF', frequency: 4.17e-08, inWordle: false },
  { word: 'SNARK', frequency: 4.47e-07, inWordle: false },
  { word: 'SNEAD', frequency: 2.4e-07, inWordle: false },
  { word: 'SNEED', frequency: 1.74e-07, inWordle: false },
  { word: 'SNELL', frequency: 7.76e-07, inWordle: false },
  { word: 'SNICK', frequency: 5.13e-08, inWordle: false },
  { word: 'SNIPS', frequency: 1.78e-07, inWordle: false },
  { word: 'SNOBS', frequency: 3.98e-07, inWordle: false },
  { word: 'SNOEK', frequency: 2.69e-08, inWordle: false },
  { word: 'SNOGS', frequency: 1.74e-08, inWordle: false },
  { word: 'SNOKE', frequency: 9.33e-08, inWordle: false },
  { word: 'SNOOD', frequency: 6.31e-08, inWordle: false },
  { word: 'SNOOK', frequency: 3.02e-07, inWordle: false },
  { word: 'SNOOT', frequency: 8.71e-08, inWordle: false },
  { word: 'SNOTS', frequency: 1.86e-08, inWordle: false },
  { word: 'SNOWS', frequency: 9.33e-07, inWordle: false },
  { word: 'SNUBS', frequency: 2.14e-07, inWordle: false },
  { word: 'SNUGS', frequency: 2.82e-08, inWordle: false },
  { word: 'SOAKS', frequency: 3.8e-07, inWordle: false },
  { word: 'SOAPS', frequency: 1.55e-06, inWordle: false },
  { word: 'SOARE', frequency: 1.58e-08, inWordle: false },
  { word: 'SOARS', frequency: 7.41e-07, inWordle: false },
  { word: 'SOAVE', frequency: 5.5e-08, inWordle: false },
  { word: 'SOCKO', frequency: 2.75e-08, inWordle: false },
  { word: 'SOCKS', frequency: 1.07e-05, inWordle: false },
  { word: 'SOCLE', frequency: 2.69e-08, inWordle: false },
  { word: 'SODAS', frequency: 8.13e-07, inWordle: false },
  { word: 'SODDY', frequency: 5.75e-08, inWordle: false },
  { word: 'SODIC', frequency: 2.14e-08, inWordle: false },
  { word: 'SODOM', frequency: 7.24e-07, inWordle: false },
  { word: 'SOFAR', frequency: 7.94e-08, inWordle: false },
  { word: 'SOFAS', frequency: 7.24e-07, inWordle: false },
  { word: 'SOFTS', frequency: 6.03e-08, inWordle: false },
  { word: 'SOFTY', frequency: 1.62e-07, inWordle: false },
  { word: 'SOILS', frequency: 3.72e-06, inWordle: false },
  { word: 'SOKEN', frequency: 2.51e-08, inWordle: false },
  { word: 'SOKOL', frequency: 1.48e-07, inWordle: false },
  { word: 'SOLAH', frequency: 1.29e-08, inWordle: false },
  { word: 'SOLAN', frequency: 8.13e-08, inWordle: false },
  { word: 'SOLAS', frequency: 2e-07, inWordle: false },
  { word: 'SOLDE', frequency: 2.09e-08, inWordle: false },
  { word: 'SOLDI', frequency: 5.5e-08, inWordle: false },
  { word: 'SOLDO', frequency: 4.9e-08, inWordle: false },
  { word: 'SOLED', frequency: 1.91e-07, inWordle: false },
  { word: 'SOLER', frequency: 2.29e-07, inWordle: false },
  { word: 'SOLES', frequency: 1.51e-06, inWordle: false },
  { word: 'SOLON', frequency: 4.57e-07, inWordle: false },
  { word: 'SOLOS', frequency: 2.14e-06, inWordle: false },
  { word: 'SOLUM', frequency: 5.62e-08, inWordle: false },
  { word: 'SOLUS', frequency: 2e-07, inWordle: false },
  { word: 'SOMAN', frequency: 6.92e-08, inWordle: false },
  { word: 'SOMAS', frequency: 1.91e-08, inWordle: false },
  { word: 'SONCE', frequency: 1.29e-08, inWordle: false },
  { word: 'SONDE', frequency: 2.57e-08, inWordle: false },
  { word: 'SONES', frequency: 8.32e-08, inWordle: false },
  { word: 'SONGS', frequency: 6.92e-05, inWordle: false },
  { word: 'SONNE', frequency: 2.09e-07, inWordle: false },
  { word: 'SONNY', frequency: 4.37e-06, inWordle: false },
  { word: 'SOOKS', frequency: 1.35e-08, inWordle: false },
  { word: 'SOOKY', frequency: 1.58e-08, inWordle: false },
  { word: 'SOOTS', frequency: 1.2e-08, inWordle: false },
  { word: 'SOPHS', frequency: 1.82e-08, inWordle: false },
  { word: 'SOPHY', frequency: 1.15e-07, inWordle: false },
  { word: 'SOPOR', frequency: 2.09e-08, inWordle: false },
  { word: 'SOPPY', frequency: 2e-07, inWordle: false },
  { word: 'SOPRA', frequency: 1.05e-07, inWordle: false },
  { word: 'SORAS', frequency: 1.45e-08, inWordle: false },
  { word: 'SORBO', frequency: 7.59e-08, inWordle: false },
  { word: 'SORBS', frequency: 1.74e-08, inWordle: false },
  { word: 'SORDO', frequency: 4.07e-08, inWordle: false },
  { word: 'SORED', frequency: 1.38e-08, inWordle: false },
  { word: 'SOREL', frequency: 2.04e-07, inWordle: false },
  { word: 'SORER', frequency: 2.51e-08, inWordle: false },
  { word: 'SORES', frequency: 1.07e-06, inWordle: false },
  { word: 'SOREX', frequency: 3.09e-08, inWordle: false },
  { word: 'SORTA', frequency: 1.95e-06, inWordle: false },
  { word: 'SORTS', frequency: 1.62e-05, inWordle: false },
  { word: 'SOUCE', frequency: 2.29e-08, inWordle: false },
  { word: 'SOUGH', frequency: 3.89e-08, inWordle: false },
  { word: 'SOUKS', frequency: 8.32e-08, inWordle: false },
  { word: 'SOULS', frequency: 1.62e-05, inWordle: false },
  { word: 'SOUPS', frequency: 1.26e-06, inWordle: false },
  { word: 'SOUPY', frequency: 1.91e-07, inWordle: false },
  { word: 'SOURS', frequency: 2.24e-07, inWordle: false },
  { word: 'SOUSE', frequency: 5.37e-08, inWordle: false },
  { word: 'SOWED', frequency: 3.89e-07, inWordle: false },
  { word: 'SOWLE', frequency: 1.05e-08, inWordle: false },
  { word: 'SOYUZ', frequency: 7.94e-07, inWordle: false },
  { word: 'SOZIN', frequency: 2.24e-08, inWordle: false },
  { word: 'SPACY', frequency: 4.9e-08, inWordle: false },
  { word: 'SPAIN', frequency: 3.89e-05, inWordle: false },
  { word: 'SPAKE', frequency: 3.55e-07, inWordle: false },
  { word: 'SPALL', frequency: 1.62e-07, inWordle: false },
  { word: 'SPAMS', frequency: 2.09e-07, inWordle: false },
  { word: 'SPANG', frequency: 6.92e-08, inWordle: false },
  { word: 'SPANS', frequency: 3.02e-06, inWordle: false },
  { word: 'SPARS', frequency: 2.88e-07, inWordle: false },
  { word: 'SPART', frequency: 2.09e-08, inWordle: false },
  { word: 'SPATE', frequency: 6.17e-07, inWordle: false },
  { word: 'SPATS', frequency: 2.82e-07, inWordle: false },
  { word: 'SPAYS', frequency: 1.32e-08, inWordle: false },
  { word: 'SPAZA', frequency: 1.66e-08, inWordle: false },
  { word: 'SPAZZ', frequency: 5.89e-08, inWordle: false },
  { word: 'SPEAL', frequency: 1.05e-08, inWordle: false },
  { word: 'SPEAN', frequency: 4.17e-08, inWordle: false },
  { word: 'SPECS', frequency: 3.47e-06, inWordle: false },
  { word: 'SPECT', frequency: 2.14e-07, inWordle: false },
  { word: 'SPEEL', frequency: 2.29e-08, inWordle: false },
  { word: 'SPEER', frequency: 4.79e-07, inWordle: false },
  { word: 'SPEIR', frequency: 2.29e-08, inWordle: false },
  { word: 'SPEWS', frequency: 2.82e-07, inWordle: false },
  { word: 'SPICA', frequency: 2.09e-07, inWordle: false },
  { word: 'SPICK', frequency: 8.32e-08, inWordle: false },
  { word: 'SPICS', frequency: 2.88e-08, inWordle: false },
  { word: 'SPIDE', frequency: 1.48e-08, inWordle: false },
  { word: 'SPIER', frequency: 7.08e-08, inWordle: false },
  { word: 'SPIES', frequency: 5.01e-06, inWordle: false },
  { word: 'SPIFF', frequency: 7.08e-08, inWordle: false },
  { word: 'SPILE', frequency: 1.66e-08, inWordle: false },
  { word: 'SPINA', frequency: 4.68e-07, inWordle: false },
  { word: 'SPINK', frequency: 1.82e-07, inWordle: false },
  { word: 'SPINS', frequency: 3.24e-06, inWordle: false },
  { word: 'SPIRT', frequency: 6.92e-08, inWordle: false },
  { word: 'SPITS', frequency: 1.2e-06, inWordle: false },
  { word: 'SPITZ', frequency: 3.47e-07, inWordle: false },
  { word: 'SPIVS', frequency: 2.14e-08, inWordle: false },
  { word: 'SPLAY', frequency: 1.23e-07, inWordle: false },
  { word: 'SPODE', frequency: 9.55e-08, inWordle: false },
  { word: 'SPOOR', frequency: 1.26e-07, inWordle: false },
  { word: 'SPORK', frequency: 1.35e-07, inWordle: false },
  { word: 'SPOTS', frequency: 2.14e-05, inWordle: false },
  { word: 'SPRAG', frequency: 1.41e-08, inWordle: false },
  { word: 'SPRAT', frequency: 9.55e-08, inWordle: false },
  { word: 'SPRED', frequency: 2.82e-08, inWordle: false },
  { word: 'SPRIT', frequency: 1.07e-07, inWordle: false },
  { word: 'SPROG', frequency: 5.13e-08, inWordle: false },
  { word: 'SPRUE', frequency: 1.12e-07, inWordle: false },
  { word: 'SPUDS', frequency: 2.95e-07, inWordle: false },
  { word: 'SPUME', frequency: 2.69e-08, inWordle: false },
  { word: 'SPURS', frequency: 1e-05, inWordle: false },
  { word: 'SQUAB', frequency: 9.33e-08, inWordle: false },
  { word: 'SQUAW', frequency: 4.79e-07, inWordle: false },
  { word: 'SQUID', frequency: 2.75e-06, inWordle: false },
  { word: 'SQUIZ', frequency: 1.7e-08, inWordle: false },
  { word: 'STABS', frequency: 1.12e-06, inWordle: false },
  { word: 'STADE', frequency: 5.13e-07, inWordle: false },
  { word: 'STAGS', frequency: 3.72e-07, inWordle: false },
  { word: 'STAGY', frequency: 2.24e-08, inWordle: false },
  { word: 'STANE', frequency: 8.32e-08, inWordle: false },
  { word: 'STANG', frequency: 2.14e-07, inWordle: false },
  { word: 'STAPH', frequency: 3.72e-07, inWordle: false },
  { word: 'STARN', frequency: 2.04e-08, inWordle: false },
  { word: 'STARR', frequency: 2.57e-06, inWordle: false },
  { word: 'STARS', frequency: 7.24e-05, inWordle: false },
  { word: 'STATS', frequency: 2.14e-05, inWordle: false },
  { word: 'STAYS', frequency: 1.82e-05, inWordle: false },
  { word: 'STEAR', frequency: 2.14e-08, inWordle: false },
  { word: 'STEDE', frequency: 2.69e-08, inWordle: false },
  { word: 'STEEK', frequency: 1.91e-08, inWordle: false },
  { word: 'STEEM', frequency: 5.13e-08, inWordle: false },
  { word: 'STEEN', frequency: 5.5e-07, inWordle: false },
  { word: 'STEIL', frequency: 3.02e-08, inWordle: false },
  { word: 'STELA', frequency: 1.29e-07, inWordle: false },
  { word: 'STELE', frequency: 2.19e-07, inWordle: false },
  { word: 'STELL', frequency: 1.2e-07, inWordle: false },
  { word: 'STEMS', frequency: 6.76e-06, inWordle: false },
  { word: 'STENO', frequency: 1.38e-07, inWordle: false },
  { word: 'STENS', frequency: 2.45e-08, inWordle: false },
  { word: 'STENT', frequency: 6.61e-07, inWordle: false },
  { word: 'STEPS', frequency: 5.37e-05, inWordle: false },
  { word: 'STEPT', frequency: 2.29e-08, inWordle: false },
  { word: 'STERE', frequency: 1.58e-08, inWordle: false },
  { word: 'STETS', frequency: 2.69e-08, inWordle: false },
  { word: 'STEWS', frequency: 4.47e-07, inWordle: false },
  { word: 'STEWY', frequency: 1.82e-08, inWordle: false },
  { word: 'STICH', frequency: 1.15e-07, inWordle: false },
  { word: 'STIES', frequency: 3.24e-08, inWordle: false },
  { word: 'STILE', frequency: 2.45e-07, inWordle: false },
  { word: 'STIMS', frequency: 3.63e-08, inWordle: false },
  { word: 'STIPA', frequency: 4.37e-08, inWordle: false },
  { word: 'STIPE', frequency: 5.37e-07, inWordle: false },
  { word: 'STIRK', frequency: 4.37e-08, inWordle: false },
  { word: 'STIRS', frequency: 9.77e-07, inWordle: false },
  { word: 'STIVE', frequency: 1.35e-08, inWordle: false },
  { word: 'STOAT', frequency: 1.1e-07, inWordle: false },
  { word: 'STOEP', frequency: 1.66e-08, inWordle: false },
  { word: 'STOMA', frequency: 1.62e-07, inWordle: false },
  { word: 'STONG', frequency: 8.32e-08, inWordle: false },
  { word: 'STONK', frequency: 1.48e-08, inWordle: false },
  { word: 'STOOK', frequency: 2.24e-08, inWordle: false },
  { word: 'STOPE', frequency: 2.88e-08, inWordle: false },
  { word: 'STOPS', frequency: 2.51e-05, inWordle: false },
  { word: 'STOPT', frequency: 2.82e-08, inWordle: false },
  { word: 'STOSS', frequency: 2.82e-08, inWordle: false },
  { word: 'STOTT', frequency: 3.55e-07, inWordle: false },
  { word: 'STOUP', frequency: 3.72e-08, inWordle: false },
  { word: 'STOUR', frequency: 1.58e-07, inWordle: false },
  { word: 'STOWS', frequency: 4.79e-08, inWordle: false },
  { word: 'STRAD', frequency: 5.75e-08, inWordle: false },
  { word: 'STREP', frequency: 5.37e-07, inWordle: false },
  { word: 'STREW', frequency: 4.27e-08, inWordle: false },
  { word: 'STRIA', frequency: 4.37e-08, inWordle: false },
  { word: 'STRIM', frequency: 1.35e-08, inWordle: false },
  { word: 'STROP', frequency: 1.66e-07, inWordle: false },
  { word: 'STROW', frequency: 1.2e-08, inWordle: false },
  { word: 'STROY', frequency: 3.16e-08, inWordle: false },
  { word: 'STRUM', frequency: 3.02e-07, inWordle: false },
  { word: 'STUBS', frequency: 6.76e-07, inWordle: false },
  { word: 'STUDE', frequency: 3.39e-08, inWordle: false },
  { word: 'STUDS', frequency: 2.19e-06, inWordle: false },
  { word: 'STULL', frequency: 7.76e-08, inWordle: false },
  { word: 'STUMM', frequency: 4.17e-08, inWordle: false },
  { word: 'STUNS', frequency: 7.76e-07, inWordle: false },
  { word: 'STUPA', frequency: 2e-07, inWordle: false },
  { word: 'STUPE', frequency: 1.29e-08, inWordle: false },
  { word: 'STURE', frequency: 5.01e-08, inWordle: false },
  { word: 'STURT', frequency: 4.37e-07, inWordle: false },
  { word: 'STYES', frequency: 2.24e-08, inWordle: false },
  { word: 'STYLI', frequency: 3.55e-08, inWordle: false },
  { word: 'STYLO', frequency: 9.12e-08, inWordle: false },
  { word: 'SUBAH', frequency: 4.27e-08, inWordle: false },
  { word: 'SUBBY', frequency: 3.55e-08, inWordle: false },
  { word: 'SUBER', frequency: 4.17e-08, inWordle: false },
  { word: 'SUBHA', frequency: 5.62e-08, inWordle: false },
  { word: 'SUCCI', frequency: 1.02e-08, inWordle: false },
  { word: 'SUCKS', frequency: 2.4e-05, inWordle: false },
  { word: 'SUCKY', frequency: 4.07e-07, inWordle: false },
  { word: 'SUCRE', frequency: 2.82e-07, inWordle: false },
  { word: 'SUDSY', frequency: 4.68e-08, inWordle: false },
  { word: 'SUEDE', frequency: 1.78e-06, inWordle: false },
  { word: 'SUGAN', frequency: 1.12e-08, inWordle: false },
  { word: 'SUITS', frequency: 1.78e-05, inWordle: false },
  { word: 'SUKUK', frequency: 1.15e-07, inWordle: false },
  { word: 'SULCI', frequency: 5.75e-08, inWordle: false },
  { word: 'SULFA', frequency: 8.51e-08, inWordle: false },
  { word: 'SULFO', frequency: 1.41e-08, inWordle: false },
  { word: 'SULKS', frequency: 9.55e-08, inWordle: false },
  { word: 'SUMMA', frequency: 6.61e-07, inWordle: false },
  { word: 'SUMOS', frequency: 2.19e-08, inWordle: false },
  { word: 'SUMPS', frequency: 4.07e-08, inWordle: false },
  { word: 'SUNNA', frequency: 1.23e-07, inWordle: false },
  { word: 'SUNUP', frequency: 6.03e-08, inWordle: false },
  { word: 'SUPES', frequency: 1.05e-07, inWordle: false },
  { word: 'SUPRA', frequency: 1.2e-06, inWordle: false },
  { word: 'SURAH', frequency: 3.47e-07, inWordle: false },
  { word: 'SURAL', frequency: 2.45e-08, inWordle: false },
  { word: 'SURAS', frequency: 5.01e-08, inWordle: false },
  { word: 'SURAT', frequency: 7.24e-07, inWordle: false },
  { word: 'SURDS', frequency: 1.05e-08, inWordle: false },
  { word: 'SURED', frequency: 1.07e-08, inWordle: false },
  { word: 'SURES', frequency: 3.24e-08, inWordle: false },
  { word: 'SURFS', frequency: 1.66e-07, inWordle: false },
  { word: 'SURFY', frequency: 1.41e-08, inWordle: false },
  { word: 'SURRA', frequency: 2.24e-08, inWordle: false },
  { word: 'SUTOR', frequency: 2.57e-08, inWordle: false },
  { word: 'SUTRA', frequency: 8.13e-07, inWordle: false },
  { word: 'SUTTA', frequency: 1.7e-07, inWordle: false },
  { word: 'SWABS', frequency: 4.37e-07, inWordle: false },
  { word: 'SWAGE', frequency: 3.72e-08, inWordle: false },
  { word: 'SWAGS', frequency: 9.55e-08, inWordle: false },
  { word: 'SWAIL', frequency: 2.09e-08, inWordle: false },
  { word: 'SWAIN', frequency: 1e-06, inWordle: false },
  { word: 'SWALE', frequency: 1.45e-07, inWordle: false },
  { word: 'SWAMY', frequency: 4.07e-07, inWordle: false },
  { word: 'SWANG', frequency: 4.68e-08, inWordle: false },
  { word: 'SWANK', frequency: 4.57e-07, inWordle: false },
  { word: 'SWANS', frequency: 2.14e-06, inWordle: false },
  { word: 'SWAPS', frequency: 1.41e-06, inWordle: false },
  { word: 'SWARD', frequency: 8.51e-08, inWordle: false },
  { word: 'SWARE', frequency: 6.76e-08, inWordle: false },
  { word: 'SWARF', frequency: 3.39e-08, inWordle: false },
  { word: 'SWART', frequency: 1.45e-07, inWordle: false },
  { word: 'SWATS', frequency: 1.05e-07, inWordle: false },
  { word: 'SWAYS', frequency: 2.69e-07, inWordle: false },
  { word: 'SWEDE', frequency: 1.12e-06, inWordle: false },
  { word: 'SWEED', frequency: 2.09e-08, inWordle: false },
  { word: 'SWIGS', frequency: 5.25e-08, inWordle: false },
  { word: 'SWIMS', frequency: 1.02e-06, inWordle: false },
  { word: 'SWINK', frequency: 4.37e-08, inWordle: false },
  { word: 'SWIPE', frequency: 3.8e-06, inWordle: false },
  { word: 'SWIRE', frequency: 1.86e-07, inWordle: false },
  { word: 'SWISS', frequency: 1.62e-05, inWordle: false },
  { word: 'SWITH', frequency: 2.29e-08, inWordle: false },
  { word: 'SWIZZ', frequency: 1.86e-07, inWordle: false },
  { word: 'SWOLE', frequency: 2.34e-07, inWordle: false },
  { word: 'SWOTS', frequency: 1.66e-08, inWordle: false },
  { word: 'SYBIL', frequency: 8.13e-07, inWordle: false },
  { word: 'SYKES', frequency: 1.95e-06, inWordle: false },
  { word: 'SYLPH', frequency: 9.55e-08, inWordle: false },
  { word: 'SYLVA', frequency: 1.2e-07, inWordle: false },
  { word: 'SYNCH', frequency: 3.39e-07, inWordle: false },
  { word: 'SYNCS', frequency: 2.75e-07, inWordle: false },
  { word: 'SYNTH', frequency: 2.24e-06, inWordle: false },
  { word: 'SYRAH', frequency: 2.75e-07, inWordle: false },
  { word: 'SYREN', frequency: 6.03e-08, inWordle: false },
  { word: 'SYSOP', frequency: 2.88e-08, inWordle: false },
  { word: 'SYTHE', frequency: 1.1e-08, inWordle: false },
  { word: 'TABER', frequency: 2.51e-07, inWordle: false },
  { word: 'TABES', frequency: 4.79e-08, inWordle: false },
  { word: 'TABID', frequency: 1.41e-08, inWordle: false },
  { word: 'TABLA', frequency: 1.48e-07, inWordle: false },
  { word: 'TABOR', frequency: 6.03e-07, inWordle: false },
  { word: 'TABUN', frequency: 3.16e-08, inWordle: false },
  { word: 'TABUS', frequency: 1.45e-08, inWordle: false },
  { word: 'TACAN', frequency: 2.82e-08, inWordle: false },
  { word: 'TACET', frequency: 1.32e-08, inWordle: false },
  { word: 'TACHE', frequency: 1.07e-07, inWordle: false },
  { word: 'TACHO', frequency: 3.72e-08, inWordle: false },
  { word: 'TACKS', frequency: 4.57e-07, inWordle: false },
  { word: 'TACOS', frequency: 2.69e-06, inWordle: false },
  { word: 'TACTS', frequency: 1.23e-08, inWordle: false },
  { word: 'TAELS', frequency: 1.55e-07, inWordle: false },
  { word: 'TAIGA', frequency: 4.17e-07, inWordle: false },
  { word: 'TAIKO', frequency: 1.7e-07, inWordle: false },
  { word: 'TAILS', frequency: 4.79e-06, inWordle: false },
  { word: 'TAINS', frequency: 1.02e-08, inWordle: false },
  { word: 'TAIRA', frequency: 8.13e-08, inWordle: false },
  { word: 'TAKAS', frequency: 1.78e-08, inWordle: false },
  { word: 'TAKES', frequency: 0.000151, inWordle: false },
  { word: 'TAKIN', frequency: 1.62e-06, inWordle: false },
  { word: 'TAKIS', frequency: 1.32e-07, inWordle: false },
  { word: 'TALAK', frequency: 2.4e-08, inWordle: false },
  { word: 'TALAQ', frequency: 9.77e-08, inWordle: false },
  { word: 'TALAR', frequency: 3.63e-08, inWordle: false },
  { word: 'TALAS', frequency: 5.25e-08, inWordle: false },
  { word: 'TALEA', frequency: 1.05e-08, inWordle: false },
  { word: 'TALER', frequency: 3.24e-08, inWordle: false },
  { word: 'TALES', frequency: 1.26e-05, inWordle: false },
  { word: 'TALKS', frequency: 4.07e-05, inWordle: false },
  { word: 'TALKY', frequency: 1.12e-07, inWordle: false },
  { word: 'TALLS', frequency: 3.09e-08, inWordle: false },
  { word: 'TALMA', frequency: 4.37e-08, inWordle: false },
  { word: 'TALPA', frequency: 3.8e-08, inWordle: false },
  { word: 'TALUK', frequency: 1.82e-07, inWordle: false },
  { word: 'TALUS', frequency: 2.4e-07, inWordle: false },
  { word: 'TAMAL', frequency: 4.27e-08, inWordle: false },
  { word: 'TAMED', frequency: 1.02e-06, inWordle: false },
  { word: 'TAMES', frequency: 1.17e-07, inWordle: false },
  { word: 'TAMIN', frequency: 2.19e-08, inWordle: false },
  { word: 'TAMIS', frequency: 1.62e-08, inWordle: false },
  { word: 'TAMMY', frequency: 2.24e-06, inWordle: false },
  { word: 'TAMPS', frequency: 2.09e-08, inWordle: false },
  { word: 'TANAS', frequency: 1.58e-08, inWordle: false },
  { word: 'TANGA', frequency: 1.86e-07, inWordle: false },
  { word: 'TANGI', frequency: 7.41e-08, inWordle: false },
  { word: 'TANGS', frequency: 8.51e-08, inWordle: false },
  { word: 'TANKA', frequency: 1.51e-07, inWordle: false },
  { word: 'TANKS', frequency: 1.86e-05, inWordle: false },
  { word: 'TANKY', frequency: 3.24e-08, inWordle: false },
  { word: 'TANNA', frequency: 1.58e-07, inWordle: false },
  { word: 'TANSY', frequency: 1.48e-07, inWordle: false },
  { word: 'TANTI', frequency: 5.62e-08, inWordle: false },
  { word: 'TANTO', frequency: 3.98e-07, inWordle: false },
  { word: 'TANTY', frequency: 1.45e-08, inWordle: false },
  { word: 'TAPAS', frequency: 7.24e-07, inWordle: false },
  { word: 'TAPED', frequency: 3.16e-06, inWordle: false },
  { word: 'TAPES', frequency: 6.61e-06, inWordle: false },
  { word: 'TAPIS', frequency: 4.07e-08, inWordle: false },
  { word: 'TAPPA', frequency: 2.82e-08, inWordle: false },
  { word: 'TARAS', frequency: 2.14e-07, inWordle: false },
  { word: 'TARDO', frequency: 1.07e-08, inWordle: false },
  { word: 'TARES', frequency: 7.94e-08, inWordle: false },
  { word: 'TARGA', frequency: 1.41e-07, inWordle: false },
  { word: 'TARGE', frequency: 6.03e-08, inWordle: false },
  { word: 'TARNS', frequency: 4.9e-08, inWordle: false },
  { word: 'TAROK', frequency: 1.95e-08, inWordle: false },
  { word: 'TAROS', frequency: 1.12e-08, inWordle: false },
  { word: 'TARPS', frequency: 2.29e-07, inWordle: false },
  { word: 'TARRY', frequency: 2.69e-07, inWordle: false },
  { word: 'TARSI', frequency: 7.08e-08, inWordle: false },
  { word: 'TARTS', frequency: 9.55e-07, inWordle: false },
  { word: 'TARTY', frequency: 2.82e-08, inWordle: false },
  { word: 'TASED', frequency: 1.7e-07, inWordle: false },
  { word: 'TASER', frequency: 1.41e-06, inWordle: false },
  { word: 'TASES', frequency: 1.45e-08, inWordle: false },
  { word: 'TASKS', frequency: 1.7e-05, inWordle: false },
  { word: 'TASSA', frequency: 1.02e-08, inWordle: false },
  { word: 'TASSE', frequency: 2.88e-08, inWordle: false },
  { word: 'TASSO', frequency: 1.66e-07, inWordle: false },
  { word: 'TATAR', frequency: 6.17e-07, inWordle: false },
  { word: 'TATER', frequency: 3.98e-07, inWordle: false },
  { word: 'TATES', frequency: 9.77e-08, inWordle: false },
  { word: 'TATOU', frequency: 1.55e-08, inWordle: false },
  { word: 'TATTS', frequency: 2.57e-07, inWordle: false },
  { word: 'TAUBE', frequency: 5.89e-08, inWordle: false },
  { word: 'TAUPE', frequency: 3.47e-07, inWordle: false },
  { word: 'TAVAS', frequency: 1.62e-08, inWordle: false },
  { word: 'TAWAS', frequency: 4.47e-08, inWordle: false },
  { word: 'TAWSE', frequency: 1.95e-08, inWordle: false },
  { word: 'TAXED', frequency: 3.31e-06, inWordle: false },
  { word: 'TAXES', frequency: 4.47e-05, inWordle: false },
  { word: 'TAXIS', frequency: 2.75e-06, inWordle: false },
  { word: 'TAXOL', frequency: 6.61e-08, inWordle: false },
  { word: 'TAXON', frequency: 3.16e-07, inWordle: false },
  { word: 'TAXUS', frequency: 5.01e-08, inWordle: false },
  { word: 'TAZZA', frequency: 3.72e-08, inWordle: false },
  { word: 'TEALS', frequency: 4.07e-08, inWordle: false },
  { word: 'TEAMS', frequency: 9.33e-05, inWordle: false },
  { word: 'TEARS', frequency: 2.95e-05, inWordle: false },
  { word: 'TEATS', frequency: 1.86e-07, inWordle: false },
  { word: 'TECHS', frequency: 8.32e-07, inWordle: false },
  { word: 'TECHY', frequency: 1.58e-07, inWordle: false },
  { word: 'TECTA', frequency: 1.45e-08, inWordle: false },
  { word: 'TEEMS', frequency: 1e-07, inWordle: false },
  { word: 'TEENS', frequency: 1.45e-05, inWordle: false },
  { word: 'TEENY', frequency: 1.12e-06, inWordle: false },
  { word: 'TEERS', frequency: 1.91e-08, inWordle: false },
  { word: 'TEGUS', frequency: 1.45e-08, inWordle: false },
  { word: 'TELCO', frequency: 3.89e-07, inWordle: false },
  { word: 'TELES', frequency: 8.13e-08, inWordle: false },
  { word: 'TELEX', frequency: 2.19e-07, inWordle: false },
  { word: 'TELIA', frequency: 5.13e-08, inWordle: false },
  { word: 'TELIC', frequency: 4.07e-08, inWordle: false },
  { word: 'TELLS', frequency: 6.03e-05, inWordle: false },
  { word: 'TELLY', frequency: 1.58e-06, inWordle: false },
  { word: 'TELOS', frequency: 2.09e-07, inWordle: false },
  { word: 'TEMES', frequency: 1.02e-08, inWordle: false },
  { word: 'TEMPI', frequency: 8.13e-08, inWordle: false },
  { word: 'TEMPS', frequency: 2.14e-06, inWordle: false },
  { word: 'TEMPT', frequency: 1.66e-06, inWordle: false },
  { word: 'TENCH', frequency: 1.7e-07, inWordle: false },
  { word: 'TENDS', frequency: 1.32e-05, inWordle: false },
  { word: 'TENDU', frequency: 3.89e-08, inWordle: false },
  { word: 'TENES', frequency: 1.66e-08, inWordle: false },
  { word: 'TENGE', frequency: 7.24e-08, inWordle: false },
  { word: 'TENIA', frequency: 2.95e-08, inWordle: false },
  { word: 'TENNE', frequency: 2.45e-08, inWordle: false },
  { word: 'TENNO', frequency: 8.13e-08, inWordle: false },
  { word: 'TENNY', frequency: 5.37e-08, inWordle: false },
  { word: 'TENON', frequency: 1.55e-07, inWordle: false },
  { word: 'TENTS', frequency: 3.98e-06, inWordle: false },
  { word: 'TENUE', frequency: 3.31e-08, inWordle: false },
  { word: 'TERAI', frequency: 1e-07, inWordle: false },
  { word: 'TERAS', frequency: 3.8e-08, inWordle: false },
  { word: 'TERCE', frequency: 1.7e-08, inWordle: false },
  { word: 'TEREK', frequency: 6.46e-08, inWordle: false },
  { word: 'TERES', frequency: 9.77e-08, inWordle: false },
  { word: 'TERFS', frequency: 6.46e-08, inWordle: false },
  { word: 'TERGA', frequency: 1.02e-08, inWordle: false },
  { word: 'TERMS', frequency: 0.000126, inWordle: false },
  { word: 'TERNE', frequency: 1.26e-08, inWordle: false },
  { word: 'TERNS', frequency: 3.24e-07, inWordle: false },
  { word: 'TERRY', frequency: 1.74e-05, inWordle: false },
  { word: 'TESLA', frequency: 5.89e-06, inWordle: false },
  { word: 'TESTA', frequency: 3.16e-07, inWordle: false },
  { word: 'TESTE', frequency: 7.24e-08, inWordle: false },
  { word: 'TESTS', frequency: 4.68e-05, inWordle: false },
  { word: 'TETES', frequency: 1.1e-08, inWordle: false },
  { word: 'TETRA', frequency: 5.25e-07, inWordle: false },
  { word: 'TEXAS', frequency: 7.76e-05, inWordle: false },
  { word: 'TEXTS', frequency: 2.19e-05, inWordle: false },
  { word: 'THACK', frequency: 1.91e-08, inWordle: false },
  { word: 'THALE', frequency: 2.45e-08, inWordle: false },
  { word: 'THALI', frequency: 8.13e-08, inWordle: false },
  { word: 'THANA', frequency: 1.62e-07, inWordle: false },
  { word: 'THANE', frequency: 7.59e-07, inWordle: false },
  { word: 'THANG', frequency: 6.61e-07, inWordle: false },
  { word: 'THANS', frequency: 1.95e-08, inWordle: false },
  { word: 'THANX', frequency: 2.57e-07, inWordle: false },
  { word: 'THAWS', frequency: 1.55e-07, inWordle: false },
  { word: 'THEBE', frequency: 4.9e-08, inWordle: false },
  { word: 'THECA', frequency: 2.88e-08, inWordle: false },
  { word: 'THEED', frequency: 2.95e-08, inWordle: false },
  { word: 'THEEK', frequency: 1.02e-08, inWordle: false },
  { word: 'THEES', frequency: 2.95e-08, inWordle: false },
  { word: 'THEGN', frequency: 1.62e-08, inWordle: false },
  { word: 'THEIN', frequency: 2.24e-07, inWordle: false },
  { word: 'THEMA', frequency: 1.05e-07, inWordle: false },
  { word: 'THENS', frequency: 1.66e-08, inWordle: false },
  { word: 'THERM', frequency: 1e-07, inWordle: false },
  { word: 'THETE', frequency: 3.55e-08, inWordle: false },
  { word: 'THIGS', frequency: 2.24e-08, inWordle: false },
  { word: 'THILL', frequency: 4.37e-08, inWordle: false },
  { word: 'THINE', frequency: 2.04e-06, inWordle: false },
  { word: 'THINS', frequency: 3.72e-07, inWordle: false },
  { word: 'THIOL', frequency: 1.26e-07, inWordle: false },
  { word: 'THOLE', frequency: 9.12e-08, inWordle: false },
  { word: 'THORO', frequency: 1.58e-08, inWordle: false },
  { word: 'THORP', frequency: 3.39e-07, inWordle: false },
  { word: 'THOUS', frequency: 6.92e-08, inWordle: false },
  { word: 'THRID', frequency: 4.17e-08, inWordle: false },
  { word: 'THRIP', frequency: 1.07e-08, inWordle: false },
  { word: 'THROE', frequency: 1.74e-08, inWordle: false },
  { word: 'THUDS', frequency: 9.77e-08, inWordle: false },
  { word: 'THUGS', frequency: 3.63e-06, inWordle: false },
  { word: 'THUJA', frequency: 5.5e-08, inWordle: false },
  { word: 'THUNK', frequency: 3.98e-07, inWordle: false },
  { word: 'THURL', frequency: 2.95e-08, inWordle: false },
  { word: 'TICAL', frequency: 2.75e-08, inWordle: false },
  { word: 'TICHY', frequency: 5.13e-08, inWordle: false },
  { word: 'TICKS', frequency: 2.4e-06, inWordle: false },
  { word: 'TICKY', frequency: 1.2e-07, inWordle: false },
  { word: 'TIDDY', frequency: 1.15e-07, inWordle: false },
  { word: 'TIDED', frequency: 1.62e-08, inWordle: false },
  { word: 'TIDES', frequency: 2.95e-06, inWordle: false },
  { word: 'TIERS', frequency: 1.78e-06, inWordle: false },
  { word: 'TIFFS', frequency: 7.59e-08, inWordle: false },
  { word: 'TIGES', frequency: 1.86e-08, inWordle: false },
  { word: 'TIKES', frequency: 6.46e-08, inWordle: false },
  { word: 'TIKIS', frequency: 2e-08, inWordle: false },
  { word: 'TIKKA', frequency: 3.39e-07, inWordle: false },
  { word: 'TILAK', frequency: 2.14e-07, inWordle: false },
  { word: 'TILED', frequency: 1e-06, inWordle: false },
  { word: 'TILER', frequency: 8.13e-08, inWordle: false },
  { word: 'TILES', frequency: 5.13e-06, inWordle: false },
  { word: 'TILLS', frequency: 2.88e-07, inWordle: false },
  { word: 'TILLY', frequency: 8.71e-07, inWordle: false },
  { word: 'TILTH', frequency: 3.47e-08, inWordle: false },
  { word: 'TILTS', frequency: 6.17e-07, inWordle: false },
  { word: 'TIMBO', frequency: 8.71e-08, inWordle: false },
  { word: 'TIMED', frequency: 4.17e-06, inWordle: false },
  { word: 'TIMES', frequency: 0.000363, inWordle: false },
  { word: 'TIMON', frequency: 4.79e-07, inWordle: false },
  { word: 'TIMPS', frequency: 1.07e-08, inWordle: false },
  { word: 'TINAS', frequency: 1.02e-08, inWordle: false },
  { word: 'TINCT', frequency: 1.29e-08, inWordle: false },
  { word: 'TINEA', frequency: 1.58e-07, inWordle: false },
  { word: 'TINED', frequency: 1.51e-08, inWordle: false },
  { word: 'TINES', frequency: 2.14e-07, inWordle: false },
  { word: 'TINGE', frequency: 6.76e-07, inWordle: false },
  { word: 'TINGS', frequency: 1.91e-07, inWordle: false },
  { word: 'TINKS', frequency: 2.51e-08, inWordle: false },
  { word: 'TINNY', frequency: 2.4e-07, inWordle: false },
  { word: 'TINTS', frequency: 3.98e-07, inWordle: false },
  { word: 'TIPIS', frequency: 5.62e-08, inWordle: false },
  { word: 'TIPPY', frequency: 3.09e-07, inWordle: false },
  { word: 'TIRED', frequency: 5.13e-05, inWordle: false },
  { word: 'TIRES', frequency: 1.07e-05, inWordle: false },
  { word: 'TIROS', frequency: 4.9e-08, inWordle: false },
  { word: 'TITCH', frequency: 6.03e-08, inWordle: false },
  { word: 'TITER', frequency: 1e-07, inWordle: false },
  { word: 'TITIS', frequency: 2.4e-08, inWordle: false },
  { word: 'TITRE', frequency: 7.94e-08, inWordle: false },
  { word: 'TITTY', frequency: 1.02e-06, inWordle: false },
  { word: 'TIZZY', frequency: 1.86e-07, inWordle: false },
  { word: 'TOADS', frequency: 7.94e-07, inWordle: false },
  { word: 'TOADY', frequency: 1.38e-07, inWordle: false },
  { word: 'TOCKS', frequency: 3.47e-08, inWordle: false },
  { word: 'TOFFS', frequency: 8.13e-08, inWordle: false },
  { word: 'TOFTS', frequency: 2.19e-08, inWordle: false },
  { word: 'TOGAS', frequency: 6.92e-08, inWordle: false },
  { word: 'TOILE', frequency: 7.24e-08, inWordle: false },
  { word: 'TOILS', frequency: 1.45e-07, inWordle: false },
  { word: 'TOING', frequency: 2.04e-08, inWordle: false },
  { word: 'TOITS', frequency: 1.48e-08, inWordle: false },
  { word: 'TOKAY', frequency: 7.76e-08, inWordle: false },
  { word: 'TOKED', frequency: 1.58e-08, inWordle: false },
  { word: 'TOKER', frequency: 5.25e-08, inWordle: false },
  { word: 'TOKES', frequency: 5.62e-08, inWordle: false },
  { word: 'TOLAN', frequency: 6.31e-08, inWordle: false },
  { word: 'TOLAR', frequency: 3.63e-08, inWordle: false },
  { word: 'TOLAS', frequency: 1.17e-08, inWordle: false },
  { word: 'TOLES', frequency: 5.75e-08, inWordle: false },
  { word: 'TOLLS', frequency: 2e-06, inWordle: false },
  { word: 'TOLLY', frequency: 8.91e-08, inWordle: false },
  { word: 'TOMAN', frequency: 7.24e-08, inWordle: false },
  { word: 'TOMBS', frequency: 2.19e-06, inWordle: false },
  { word: 'TOMES', frequency: 4.07e-07, inWordle: false },
  { word: 'TOMMY', frequency: 1.45e-05, inWordle: false },
  { word: 'TOMOS', frequency: 7.41e-08, inWordle: false },
  { word: 'TONDO', frequency: 8.91e-08, inWordle: false },
  { word: 'TONED', frequency: 3.02e-06, inWordle: false },
  { word: 'TONER', frequency: 1.17e-06, inWordle: false },
  { word: 'TONES', frequency: 5.75e-06, inWordle: false },
  { word: 'TONEY', frequency: 1.95e-07, inWordle: false },
  { word: 'TONGS', frequency: 6.31e-07, inWordle: false },
  { word: 'TONKA', frequency: 2.24e-07, inWordle: false },
  { word: 'TONKS', frequency: 2.4e-07, inWordle: false },
  { word: 'TONNE', frequency: 1.62e-06, inWordle: false },
  { word: 'TONUS', frequency: 3.31e-08, inWordle: false },
  { word: 'TOOLS', frequency: 3.89e-05, inWordle: false },
  { word: 'TOOMS', frequency: 3.63e-08, inWordle: false },
  { word: 'TOONS', frequency: 3.31e-07, inWordle: false },
  { word: 'TOOTS', frequency: 4.07e-07, inWordle: false },
  { word: 'TOPER', frequency: 1.38e-08, inWordle: false },
  { word: 'TOPES', frequency: 3.55e-08, inWordle: false },
  { word: 'TOPHI', frequency: 1.32e-08, inWordle: false },
  { word: 'TOPOI', frequency: 2.51e-08, inWordle: false },
  { word: 'TOPOS', frequency: 1.17e-07, inWordle: false },
  { word: 'TOPPY', frequency: 5.75e-08, inWordle: false },
  { word: 'TOQUE', frequency: 1.35e-07, inWordle: false },
  { word: 'TORAH', frequency: 2.57e-06, inWordle: false },
  { word: 'TORAN', frequency: 4.47e-08, inWordle: false },
  { word: 'TORAS', frequency: 1.23e-08, inWordle: false },
  { word: 'TORES', frequency: 1.15e-08, inWordle: false },
  { word: 'TORIC', frequency: 8.71e-08, inWordle: false },
  { word: 'TORII', frequency: 1.62e-07, inWordle: false },
  { word: 'TOROS', frequency: 1.91e-07, inWordle: false },
  { word: 'TORSE', frequency: 1.17e-08, inWordle: false },
  { word: 'TORTA', frequency: 1.1e-07, inWordle: false },
  { word: 'TORTE', frequency: 1.29e-07, inWordle: false },
  { word: 'TORTS', frequency: 4.57e-07, inWordle: false },
  { word: 'TOTED', frequency: 5.62e-08, inWordle: false },
  { word: 'TOTER', frequency: 1.32e-08, inWordle: false },
  { word: 'TOTES', frequency: 8.71e-07, inWordle: false },
  { word: 'TOTTY', frequency: 9.33e-08, inWordle: false },
  { word: 'TOURS', frequency: 1.38e-05, inWordle: false },
  { word: 'TOUSE', frequency: 1.7e-08, inWordle: false },
  { word: 'TOUTS', frequency: 5.01e-07, inWordle: false },
  { word: 'TOWED', frequency: 2.4e-06, inWordle: false },
  { word: 'TOWIE', frequency: 1.62e-07, inWordle: false },
  { word: 'TOWNS', frequency: 2.45e-05, inWordle: false },
  { word: 'TOWNY', frequency: 2.34e-08, inWordle: false },
  { word: 'TOWSE', frequency: 1.48e-08, inWordle: false },
  { word: 'TOYED', frequency: 4.79e-07, inWordle: false },
  { word: 'TOYON', frequency: 1.74e-08, inWordle: false },
  { word: 'TRADS', frequency: 2.45e-08, inWordle: false },
  { word: 'TRAGI', frequency: 5.37e-08, inWordle: false },
  { word: 'TRAMS', frequency: 1.12e-06, inWordle: false },
  { word: 'TRANK', frequency: 5.89e-08, inWordle: false },
  { word: 'TRANQ', frequency: 9.55e-08, inWordle: false },
  { word: 'TRANS', frequency: 2.57e-05, inWordle: false },
  { word: 'TRANT', frequency: 1.12e-07, inWordle: false },
  { word: 'TRAPS', frequency: 5.75e-06, inWordle: false },
  { word: 'TRAPT', frequency: 2.29e-08, inWordle: false },
  { word: 'TRAVE', frequency: 6.31e-08, inWordle: false },
  { word: 'TRAYS', frequency: 1.74e-06, inWordle: false },
  { word: 'TRECK', frequency: 2.51e-08, inWordle: false },
  { word: 'TREED', frequency: 8.32e-08, inWordle: false },
  { word: 'TREEN', frequency: 5.89e-08, inWordle: false },
  { word: 'TREES', frequency: 4.9e-05, inWordle: false },
  { word: 'TREKS', frequency: 3.39e-07, inWordle: false },
  { word: 'TREMA', frequency: 1.48e-08, inWordle: false },
  { word: 'TRESS', frequency: 2.24e-07, inWordle: false },
  { word: 'TREWS', frequency: 6.61e-08, inWordle: false },
  { word: 'TREYS', frequency: 5.25e-08, inWordle: false },
  { word: 'TRIAC', frequency: 3.02e-08, inWordle: false },
  { word: 'TRIER', frequency: 7.08e-07, inWordle: false },
  { word: 'TRIES', frequency: 3.39e-05, inWordle: false },
  { word: 'TRIGO', frequency: 5.25e-08, inWordle: false },
  { word: 'TRIGS', frequency: 1.1e-08, inWordle: false },
  { word: 'TRIKE', frequency: 2.63e-07, inWordle: false },
  { word: 'TRILL', frequency: 5.37e-07, inWordle: false },
  { word: 'TRIMS', frequency: 5.89e-07, inWordle: false },
  { word: 'TRINE', frequency: 2.88e-07, inWordle: false },
  { word: 'TRIOL', frequency: 1.35e-08, inWordle: false },
  { word: 'TRIOS', frequency: 3.47e-07, inWordle: false },
  { word: 'TRIPS', frequency: 1.7e-05, inWordle: false },
  { word: 'TRIST', frequency: 1.07e-07, inWordle: false },
  { word: 'TROAD', frequency: 2.19e-08, inWordle: false },
  { word: 'TROGS', frequency: 1.66e-08, inWordle: false },
  { word: 'TROIS', frequency: 6.46e-07, inWordle: false },
  { word: 'TROMP', frequency: 1.15e-07, inWordle: false },
  { word: 'TRONA', frequency: 5.89e-08, inWordle: false },
  { word: 'TRONC', frequency: 3.31e-08, inWordle: false },
  { word: 'TRONE', frequency: 2.82e-08, inWordle: false },
  { word: 'TRONS', frequency: 2.45e-08, inWordle: false },
  { word: 'TROTH', frequency: 1.38e-07, inWordle: false },
  { word: 'TROTS', frequency: 2.63e-07, inWordle: false },
  { word: 'TROWS', frequency: 1.86e-08, inWordle: false },
  { word: 'TROYS', frequency: 1.74e-08, inWordle: false },
  { word: 'TRUED', frequency: 3.55e-08, inWordle: false },
  { word: 'TRUES', frequency: 2.69e-08, inWordle: false },
  { word: 'TRULL', frequency: 5.89e-08, inWordle: false },
  { word: 'TSARS', frequency: 1.66e-07, inWordle: false },
  { word: 'TSUBA', frequency: 3.24e-08, inWordle: false },
  { word: 'TSUBO', frequency: 1.74e-08, inWordle: false },
  { word: 'TUART', frequency: 1.48e-08, inWordle: false },
  { word: 'TUATH', frequency: 1.12e-08, inWordle: false },
  { word: 'TUBAS', frequency: 6.92e-08, inWordle: false },
  { word: 'TUBBY', frequency: 4.57e-07, inWordle: false },
  { word: 'TUBED', frequency: 1.02e-07, inWordle: false },
  { word: 'TUBES', frequency: 8.71e-06, inWordle: false },
  { word: 'TUCKS', frequency: 4.27e-07, inWordle: false },
  { word: 'TUFFS', frequency: 6.31e-08, inWordle: false },
  { word: 'TUFTS', frequency: 1.26e-06, inWordle: false },
  { word: 'TUFTY', frequency: 3.8e-08, inWordle: false },
  { word: 'TUILE', frequency: 2.34e-08, inWordle: false },
  { word: 'TULES', frequency: 1.29e-08, inWordle: false },
  { word: 'TULPA', frequency: 3.39e-08, inWordle: false },
  { word: 'TULSI', frequency: 4.47e-07, inWordle: false },
  { word: 'TUMID', frequency: 2e-08, inWordle: false },
  { word: 'TUMMY', frequency: 2.69e-06, inWordle: false },
  { word: 'TUNAS', frequency: 1.15e-07, inWordle: false },
  { word: 'TUNED', frequency: 7.41e-06, inWordle: false },
  { word: 'TUNER', frequency: 8.13e-07, inWordle: false },
  { word: 'TUNES', frequency: 6.61e-06, inWordle: false },
  { word: 'TUNNY', frequency: 7.24e-08, inWordle: false },
  { word: 'TUPLE', frequency: 2.75e-07, inWordle: false },
  { word: 'TUQUE', frequency: 2.88e-08, inWordle: false },
  { word: 'TURDS', frequency: 3.55e-07, inWordle: false },
  { word: 'TURFS', frequency: 5.01e-08, inWordle: false },
  { word: 'TURKS', frequency: 4.57e-06, inWordle: false },
  { word: 'TURNS', frequency: 5.75e-05, inWordle: false },
  { word: 'TURNT', frequency: 9.77e-08, inWordle: false },
  { word: 'TURPS', frequency: 4.68e-08, inWordle: false },
  { word: 'TUSHY', frequency: 6.03e-08, inWordle: false },
  { word: 'TUSKS', frequency: 6.31e-07, inWordle: false },
  { word: 'TUSKY', frequency: 1.15e-08, inWordle: false },
  { word: 'TUTEE', frequency: 1.15e-08, inWordle: false },
  { word: 'TUTTI', frequency: 4.57e-07, inWordle: false },
  { word: 'TUTTY', frequency: 2.19e-08, inWordle: false },
  { word: 'TUTUS', frequency: 1.29e-07, inWordle: false },
  { word: 'TUXES', frequency: 7.59e-08, inWordle: false },
  { word: 'TWAIN', frequency: 2.45e-06, inWordle: false },
  { word: 'TWATS', frequency: 4.17e-07, inWordle: false },
  { word: 'TWEEL', frequency: 1.91e-08, inWordle: false },
  { word: 'TWEEN', frequency: 6.92e-07, inWordle: false },
  { word: 'TWEEP', frequency: 7.76e-08, inWordle: false },
  { word: 'TWERK', frequency: 3.47e-07, inWordle: false },
  { word: 'TWERP', frequency: 1.29e-07, inWordle: false },
  { word: 'TWIGS', frequency: 1.32e-06, inWordle: false },
  { word: 'TWILL', frequency: 4.57e-07, inWordle: false },
  { word: 'TWINK', frequency: 8.51e-07, inWordle: false },
  { word: 'TWINS', frequency: 1.41e-05, inWordle: false },
  { word: 'TWIRP', frequency: 1.38e-08, inWordle: false },
  { word: 'TWITE', frequency: 2.24e-08, inWordle: false },
  { word: 'TWITS', frequency: 1.86e-07, inWordle: false },
  { word: 'TYERS', frequency: 7.59e-08, inWordle: false },
  { word: 'TYKES', frequency: 1.02e-07, inWordle: false },
  { word: 'TYLER', frequency: 1.48e-05, inWordle: false },
  { word: 'TYNES', frequency: 6.31e-08, inWordle: false },
  { word: 'TYPED', frequency: 3.31e-06, inWordle: false },
  { word: 'TYPES', frequency: 7.08e-05, inWordle: false },
  { word: 'TYPIC', frequency: 2.88e-08, inWordle: false },
  { word: 'TYPOS', frequency: 1.02e-06, inWordle: false },
  { word: 'TYRAN', frequency: 3.16e-08, inWordle: false },
  { word: 'TYRED', frequency: 4.17e-08, inWordle: false },
  { word: 'TYRES', frequency: 3.31e-06, inWordle: false },
  { word: 'TYROS', frequency: 3.89e-08, inWordle: false },
  { word: 'UGALI', frequency: 2.69e-08, inWordle: false },
  { word: 'UHLAN', frequency: 1.95e-08, inWordle: false },
  { word: 'UHURU', frequency: 4.27e-07, inWordle: false },
  { word: 'UKASE', frequency: 2.51e-08, inWordle: false },
  { word: 'ULAMA', frequency: 1.78e-07, inWordle: false },
  { word: 'ULEMA', frequency: 1.41e-07, inWordle: false },
  { word: 'ULNAR', frequency: 2.45e-07, inWordle: false },
  { word: 'ULPAN', frequency: 1.26e-08, inWordle: false },
  { word: 'UMAMI', frequency: 2.4e-07, inWordle: false },
  { word: 'UMBEL', frequency: 5.25e-08, inWordle: false },
  { word: 'UMBER', frequency: 2.45e-07, inWordle: false },
  { word: 'UMBLE', frequency: 1.78e-08, inWordle: false },
  { word: 'UMIAK', frequency: 1.78e-08, inWordle: false },
  { word: 'UMMAH', frequency: 3.09e-07, inWordle: false },
  { word: 'UMRAH', frequency: 1.23e-07, inWordle: false },
  { word: 'UNARY', frequency: 8.51e-08, inWordle: false },
  { word: 'UNBAN', frequency: 6.92e-08, inWordle: false },
  { word: 'UNBAR', frequency: 1.15e-08, inWordle: false },
  { word: 'UNBOX', frequency: 1.02e-07, inWordle: false },
  { word: 'UNCAP', frequency: 2.34e-08, inWordle: false },
  { word: 'UNCIA', frequency: 1.35e-08, inWordle: false },
  { word: 'UNCUS', frequency: 1.62e-08, inWordle: false },
  { word: 'UNFIX', frequency: 1.32e-08, inWordle: false },
  { word: 'UNHIP', frequency: 2.09e-08, inWordle: false },
  { word: 'UNICA', frequency: 6.61e-08, inWordle: false },
  { word: 'UNITS', frequency: 5.89e-05, inWordle: false },
  { word: 'UNJAM', frequency: 1.29e-08, inWordle: false },
  { word: 'UNMAN', frequency: 1.29e-08, inWordle: false },
  { word: 'UNPIN', frequency: 2.75e-08, inWordle: false },
  { word: 'UNSAY', frequency: 3.24e-08, inWordle: false },
  { word: 'UNSEE', frequency: 4.07e-07, inWordle: false },
  { word: 'UNSEX', frequency: 1.7e-08, inWordle: false },
  { word: 'UPDOS', frequency: 2.09e-08, inWordle: false },
  { word: 'UPEND', frequency: 1.82e-07, inWordle: false },
  { word: 'UPLAY', frequency: 8.13e-08, inWordle: false },
  { word: 'UPPED', frequency: 1.17e-06, inWordle: false },
  { word: 'UPSEE', frequency: 1.41e-08, inWordle: false },
  { word: 'URATE', frequency: 6.31e-08, inWordle: false },
  { word: 'URBEX', frequency: 3.98e-08, inWordle: false },
  { word: 'UREAS', frequency: 2.19e-08, inWordle: false },
  { word: 'URENA', frequency: 5.62e-08, inWordle: false },
  { word: 'URGED', frequency: 1.02e-05, inWordle: false },
  { word: 'URGES', frequency: 4.9e-06, inWordle: false },
  { word: 'URMAN', frequency: 1.41e-08, inWordle: false },
  { word: 'URSAE', frequency: 1.66e-08, inWordle: false },
  { word: 'USERS', frequency: 6.31e-05, inWordle: false },
  { word: 'USNEA', frequency: 1.74e-08, inWordle: false },
  { word: 'USQUE', frequency: 3.8e-08, inWordle: false },
  { word: 'USURY', frequency: 3.47e-07, inWordle: false },
  { word: 'UTERI', frequency: 5.37e-08, inWordle: false },
  { word: 'UVEAL', frequency: 4.79e-08, inWordle: false },
  { word: 'UVULA', frequency: 9.55e-08, inWordle: false },
  { word: 'VACUA', frequency: 2.04e-08, inWordle: false },
  { word: 'VAGAL', frequency: 1.29e-07, inWordle: false },
  { word: 'VAGUS', frequency: 2.45e-07, inWordle: false },
  { word: 'VAILS', frequency: 1.7e-08, inWordle: false },
  { word: 'VAKIL', frequency: 7.08e-08, inWordle: false },
  { word: 'VALES', frequency: 1.15e-07, inWordle: false },
  { word: 'VALIS', frequency: 3.8e-08, inWordle: false },
  { word: 'VALSE', frequency: 7.41e-08, inWordle: false },
  { word: 'VAMPS', frequency: 3.89e-07, inWordle: false },
  { word: 'VAMPY', frequency: 6.92e-08, inWordle: false },
  { word: 'VANDA', frequency: 2e-07, inWordle: false },
  { word: 'VANES', frequency: 2e-07, inWordle: false },
  { word: 'VAPED', frequency: 3.63e-08, inWordle: false },
  { word: 'VAPER', frequency: 4.37e-08, inWordle: false },
  { word: 'VAPES', frequency: 1.62e-07, inWordle: false },
  { word: 'VARAN', frequency: 3.98e-08, inWordle: false },
  { word: 'VARAS', frequency: 6.31e-08, inWordle: false },
  { word: 'VARDY', frequency: 4.9e-07, inWordle: false },
  { word: 'VARES', frequency: 2e-08, inWordle: false },
  { word: 'VARIA', frequency: 1.7e-07, inWordle: false },
  { word: 'VARIX', frequency: 3.16e-08, inWordle: false },
  { word: 'VARNA', frequency: 6.03e-07, inWordle: false },
  { word: 'VARUS', frequency: 2.57e-07, inWordle: false },
  { word: 'VARVE', frequency: 1.12e-08, inWordle: false },
  { word: 'VASAL', frequency: 1.23e-08, inWordle: false },
  { word: 'VASES', frequency: 1.29e-06, inWordle: false },
  { word: 'VASTY', frequency: 1.7e-08, inWordle: false },
  { word: 'VATIC', frequency: 1.51e-08, inWordle: false },
  { word: 'VEALE', frequency: 6.17e-08, inWordle: false },
  { word: 'VEENA', frequency: 1.58e-07, inWordle: false },
  { word: 'VEERS', frequency: 3.47e-07, inWordle: false },
  { word: 'VEERY', frequency: 2.95e-08, inWordle: false },
  { word: 'VEGAS', frequency: 2.63e-05, inWordle: false },
  { word: 'VEGES', frequency: 3.63e-08, inWordle: false },
  { word: 'VEGIE', frequency: 2.4e-08, inWordle: false },
  { word: 'VEILS', frequency: 7.08e-07, inWordle: false },
  { word: 'VEINS', frequency: 5.75e-06, inWordle: false },
  { word: 'VEINY', frequency: 1.2e-07, inWordle: false },
  { word: 'VELAR', frequency: 2e-07, inWordle: false },
  { word: 'VELDT', frequency: 8.13e-08, inWordle: false },
  { word: 'VELES', frequency: 4.07e-08, inWordle: false },
  { word: 'VELLS', frequency: 1.07e-08, inWordle: false },
  { word: 'VELUM', frequency: 4.57e-08, inWordle: false },
  { word: 'VENAL', frequency: 2.19e-07, inWordle: false },
  { word: 'VENDS', frequency: 1.95e-08, inWordle: false },
  { word: 'VENGE', frequency: 4.17e-08, inWordle: false },
  { word: 'VENTS', frequency: 2.09e-06, inWordle: false },
  { word: 'VENUS', frequency: 6.46e-06, inWordle: false },
  { word: 'VERBS', frequency: 2.75e-06, inWordle: false },
  { word: 'VERRA', frequency: 4.37e-08, inWordle: false },
  { word: 'VERRY', frequency: 1.23e-07, inWordle: false },
  { word: 'VERST', frequency: 2.04e-08, inWordle: false },
  { word: 'VERTS', frequency: 9.12e-08, inWordle: false },
  { word: 'VERTU', frequency: 1.05e-07, inWordle: false },
  { word: 'VESPA', frequency: 3.89e-07, inWordle: false },
  { word: 'VESTA', frequency: 3.89e-07, inWordle: false },
  { word: 'VESTS', frequency: 1.55e-06, inWordle: false },
  { word: 'VETCH', frequency: 1.51e-07, inWordle: false },
  { word: 'VEXED', frequency: 6.46e-07, inWordle: false },
  { word: 'VEXES', frequency: 6.46e-08, inWordle: false },
  { word: 'VIALS', frequency: 1e-06, inWordle: false },
  { word: 'VIBES', frequency: 3.55e-06, inWordle: false },
  { word: 'VIBEY', frequency: 2.4e-08, inWordle: false },
  { word: 'VICES', frequency: 1.02e-06, inWordle: false },
  { word: 'VICHY', frequency: 5.5e-07, inWordle: false },
  { word: 'VIERS', frequency: 1.1e-08, inWordle: false },
  { word: 'VIEWS', frequency: 6.76e-05, inWordle: false },
  { word: 'VIGIA', frequency: 1.07e-08, inWordle: false },
  { word: 'VILDE', frequency: 4.79e-08, inWordle: false },
  { word: 'VILER', frequency: 1.91e-08, inWordle: false },
  { word: 'VILLI', frequency: 1.07e-07, inWordle: false },
  { word: 'VILLS', frequency: 2.34e-08, inWordle: false },
  { word: 'VINAL', frequency: 2e-08, inWordle: false },
  { word: 'VINAS', frequency: 1.55e-08, inWordle: false },
  { word: 'VINCA', frequency: 8.32e-08, inWordle: false },
  { word: 'VINER', frequency: 1.82e-07, inWordle: false },
  { word: 'VINES', frequency: 3.72e-06, inWordle: false },
  { word: 'VINOS', frequency: 2.4e-08, inWordle: false },
  { word: 'VIOLS', frequency: 4.57e-08, inWordle: false },
  { word: 'VIREO', frequency: 9.77e-08, inWordle: false },
  { word: 'VIRES', frequency: 1.05e-07, inWordle: false },
  { word: 'VIRGA', frequency: 3.47e-08, inWordle: false },
  { word: 'VIRGE', frequency: 4.27e-08, inWordle: false },
  { word: 'VIRTU', frequency: 8.51e-08, inWordle: false },
  { word: 'VISAS', frequency: 2.95e-06, inWordle: false },
  { word: 'VISES', frequency: 3.39e-08, inWordle: false },
  { word: 'VISON', frequency: 5.25e-08, inWordle: false },
  { word: 'VISTO', frequency: 8.91e-08, inWordle: false },
  { word: 'VITAE', frequency: 6.31e-07, inWordle: false },
  { word: 'VITAS', frequency: 8.71e-08, inWordle: false },
  { word: 'VITEX', frequency: 4.9e-08, inWordle: false },
  { word: 'VITRO', frequency: 2.63e-06, inWordle: false },
  { word: 'VITTA', frequency: 2.69e-08, inWordle: false },
  { word: 'VIVAS', frequency: 5.62e-08, inWordle: false },
  { word: 'VIVAT', frequency: 4.47e-08, inWordle: false },
  { word: 'VIVER', frequency: 1.62e-08, inWordle: false },
  { word: 'VIVES', frequency: 1.48e-07, inWordle: false },
  { word: 'VIZIR', frequency: 1.58e-08, inWordle: false },
  { word: 'VIZOR', frequency: 1.45e-08, inWordle: false },
  { word: 'VLOGS', frequency: 3.55e-07, inWordle: false },
  { word: 'VOCAB', frequency: 3.8e-07, inWordle: false },
  { word: 'VOCES', frequency: 9.12e-08, inWordle: false },
  { word: 'VODOU', frequency: 6.92e-08, inWordle: false },
  { word: 'VODUN', frequency: 2.29e-08, inWordle: false },
  { word: 'VOIDS', frequency: 6.46e-07, inWordle: false },
  { word: 'VOILE', frequency: 1e-07, inWordle: false },
  { word: 'VOLAR', frequency: 6.03e-08, inWordle: false },
  { word: 'VOLES', frequency: 2.82e-07, inWordle: false },
  { word: 'VOLKS', frequency: 6.92e-08, inWordle: false },
  { word: 'VOLTA', frequency: 9.55e-07, inWordle: false },
  { word: 'VOLTE', frequency: 2.88e-07, inWordle: false },
  { word: 'VOLTI', frequency: 1.02e-08, inWordle: false },
  { word: 'VOLTS', frequency: 1.58e-06, inWordle: false },
  { word: 'VOLVA', frequency: 1.74e-08, inWordle: false },
  { word: 'VOLVE', frequency: 1.1e-08, inWordle: false },
  { word: 'VOMER', frequency: 2.82e-08, inWordle: false },
  { word: 'VOTED', frequency: 4.17e-05, inWordle: false },
  { word: 'VOTES', frequency: 4.37e-05, inWordle: false },
  { word: 'VOWED', frequency: 2.45e-06, inWordle: false },
  { word: 'VOXEL', frequency: 2.14e-07, inWordle: false },
  { word: 'VROOM', frequency: 5.25e-07, inWordle: false },
  { word: 'VROUW', frequency: 2.51e-08, inWordle: false },
  { word: 'VULGO', frequency: 1.55e-08, inWordle: false },
  { word: 'VULNS', frequency: 1.1e-08, inWordle: false },
  { word: 'VULVA', frequency: 5.5e-07, inWordle: false },
  { word: 'WACKO', frequency: 2.4e-07, inWordle: false },
  { word: 'WACKS', frequency: 2.45e-08, inWordle: false },
  { word: 'WADDY', frequency: 8.32e-08, inWordle: false },
  { word: 'WADED', frequency: 3.8e-07, inWordle: false },
  { word: 'WADER', frequency: 6.61e-08, inWordle: false },
  { word: 'WADES', frequency: 1.55e-07, inWordle: false },
  { word: 'WADGE', frequency: 1.12e-08, inWordle: false },
  { word: 'WADIS', frequency: 4.17e-08, inWordle: false },
  { word: 'WAFTS', frequency: 1.17e-07, inWordle: false },
  { word: 'WAGED', frequency: 1.58e-06, inWordle: false },
  { word: 'WAGES', frequency: 1.78e-05, inWordle: false },
  { word: 'WAGGA', frequency: 4.9e-07, inWordle: false },
  { word: 'WAGYU', frequency: 1.82e-07, inWordle: false },
  { word: 'WAHOO', frequency: 3.72e-07, inWordle: false },
  { word: 'WAIDE', frequency: 1.62e-08, inWordle: false },
  { word: 'WAIFS', frequency: 9.33e-08, inWordle: false },
  { word: 'WAILS', frequency: 2.82e-07, inWordle: false },
  { word: 'WAINS', frequency: 2.04e-08, inWordle: false },
  { word: 'WAITE', frequency: 9.33e-07, inWordle: false },
  { word: 'WAITS', frequency: 4.79e-06, inWordle: false },
  { word: 'WAKAS', frequency: 1.45e-08, inWordle: false },
  { word: 'WAKED', frequency: 1.23e-07, inWordle: false },
  { word: 'WAKEN', frequency: 1.95e-07, inWordle: false },
  { word: 'WAKER', frequency: 1.58e-07, inWordle: false },
  { word: 'WAKES', frequency: 4.79e-06, inWordle: false },
  { word: 'WALDO', frequency: 1.91e-06, inWordle: false },
  { word: 'WALER', frequency: 1.35e-08, inWordle: false },
  { word: 'WALES', frequency: 3.98e-05, inWordle: false },
  { word: 'WALIS', frequency: 2.51e-08, inWordle: false },
  { word: 'WALKS', frequency: 2.09e-05, inWordle: false },
  { word: 'WALLA', frequency: 8.32e-07, inWordle: false },
  { word: 'WALLS', frequency: 4.17e-05, inWordle: false },
  { word: 'WALLY', frequency: 2.82e-06, inWordle: false },
  { word: 'WANDS', frequency: 5.75e-07, inWordle: false },
  { word: 'WANED', frequency: 7.41e-07, inWordle: false },
  { word: 'WANES', frequency: 2.19e-07, inWordle: false },
  { word: 'WANGS', frequency: 6.61e-08, inWordle: false },
  { word: 'WANKS', frequency: 7.41e-08, inWordle: false },
  { word: 'WANKY', frequency: 5.89e-08, inWordle: false },
  { word: 'WANLY', frequency: 2.69e-08, inWordle: false },
  { word: 'WANNA', frequency: 0.00011, inWordle: false },
  { word: 'WANTS', frequency: 0.000174, inWordle: false },
  { word: 'WANTY', frequency: 1.51e-08, inWordle: false },
  { word: 'WARBY', frequency: 1.1e-07, inWordle: false },
  { word: 'WARDS', frequency: 4.37e-06, inWordle: false },
  { word: 'WARES', frequency: 1.51e-06, inWordle: false },
  { word: 'WAREZ', frequency: 7.59e-08, inWordle: false },
  { word: 'WARKS', frequency: 2.57e-08, inWordle: false },
  { word: 'WARMS', frequency: 1.55e-06, inWordle: false },
  { word: 'WARNS', frequency: 5.37e-06, inWordle: false },
  { word: 'WARPS', frequency: 2.75e-07, inWordle: false },
  { word: 'WARRE', frequency: 6.17e-08, inWordle: false },
  { word: 'WARTS', frequency: 1.02e-06, inWordle: false },
  { word: 'WASHY', frequency: 4.07e-07, inWordle: false },
  { word: 'WASPS', frequency: 2e-06, inWordle: false },
  { word: 'WASPY', frequency: 3.72e-08, inWordle: false },
  { word: 'WATTS', frequency: 6.17e-06, inWordle: false },
  { word: 'WAUGH', frequency: 8.71e-07, inWordle: false },
  { word: 'WAVED', frequency: 3.47e-06, inWordle: false },
  { word: 'WAVES', frequency: 2.34e-05, inWordle: false },
  { word: 'WAVEY', frequency: 7.59e-08, inWordle: false },
  { word: 'WAXED', frequency: 1.2e-06, inWordle: false },
  { word: 'WAXER', frequency: 3.24e-08, inWordle: false },
  { word: 'WAXES', frequency: 4.47e-07, inWordle: false },
  { word: 'WAZIR', frequency: 1.91e-07, inWordle: false },
  { word: 'WAZOO', frequency: 1.32e-07, inWordle: false },
  { word: 'WEALD', frequency: 2e-07, inWordle: false },
  { word: 'WEANS', frequency: 5.37e-08, inWordle: false },
  { word: 'WEARS', frequency: 1.2e-05, inWordle: false },
  { word: 'WEBBY', frequency: 2.4e-07, inWordle: false },
  { word: 'WEBER', frequency: 3.98e-06, inWordle: false },
  { word: 'WECHT', frequency: 3.39e-08, inWordle: false },
  { word: 'WEDEL', frequency: 6.61e-08, inWordle: false },
  { word: 'WEDGY', frequency: 1.41e-08, inWordle: false },
  { word: 'WEEDS', frequency: 3.31e-06, inWordle: false },
  { word: 'WEEKE', frequency: 3.8e-08, inWordle: false },
  { word: 'WEEKS', frequency: 0.000155, inWordle: false },
  { word: 'WEEMS', frequency: 2.19e-07, inWordle: false },
  { word: 'WEENY', frequency: 1.35e-07, inWordle: false },
  { word: 'WEEPS', frequency: 6.03e-07, inWordle: false },
  { word: 'WEEPY', frequency: 2.19e-07, inWordle: false },
  { word: 'WEFTS', frequency: 3.98e-08, inWordle: false },
  { word: 'WEIRS', frequency: 2.09e-07, inWordle: false },
  { word: 'WEISE', frequency: 2.29e-07, inWordle: false },
  { word: 'WELDS', frequency: 4.37e-07, inWordle: false },
  { word: 'WELKE', frequency: 3.24e-08, inWordle: false },
  { word: 'WELLS', frequency: 1.78e-05, inWordle: false },
  { word: 'WELLY', frequency: 1.62e-07, inWordle: false },
  { word: 'WELTS', frequency: 1.86e-07, inWordle: false },
  { word: 'WENDS', frequency: 7.24e-08, inWordle: false },
  { word: 'WENGE', frequency: 3.39e-08, inWordle: false },
  { word: 'WESTS', frequency: 5.13e-07, inWordle: false },
  { word: 'WETLY', frequency: 2.57e-08, inWordle: false },
  { word: 'WHANG', frequency: 6.76e-08, inWordle: false },
  { word: 'WHARE', frequency: 1.05e-07, inWordle: false },
  { word: 'WHATA', frequency: 8.13e-08, inWordle: false },
  { word: 'WHATS', frequency: 7.59e-06, inWordle: false },
  { word: 'WHEAL', frequency: 1.32e-07, inWordle: false },
  { word: 'WHEEN', frequency: 3.39e-08, inWordle: false },
  { word: 'WHELK', frequency: 7.94e-08, inWordle: false },
  { word: 'WHELM', frequency: 2e-08, inWordle: false },
  { word: 'WHENS', frequency: 8.51e-08, inWordle: false },
  { word: 'WHETS', frequency: 4.9e-08, inWordle: false },
  { word: 'WHIGS', frequency: 6.31e-07, inWordle: false },
  { word: 'WHIMS', frequency: 8.71e-07, inWordle: false },
  { word: 'WHINS', frequency: 1.41e-08, inWordle: false },
  { word: 'WHIPS', frequency: 1.55e-06, inWordle: false },
  { word: 'WHIRR', frequency: 1.02e-07, inWordle: false },
  { word: 'WHIRS', frequency: 2.34e-08, inWordle: false },
  { word: 'WHISH', frequency: 1.05e-07, inWordle: false },
  { word: 'WHIST', frequency: 2.51e-07, inWordle: false },
  { word: 'WHITS', frequency: 1.51e-08, inWordle: false },
  { word: 'WHITY', frequency: 1.7e-08, inWordle: false },
  { word: 'WHIZZ', frequency: 3.09e-07, inWordle: false },
  { word: 'WHOMP', frequency: 7.41e-08, inWordle: false },
  { word: 'WHOOF', frequency: 1.35e-08, inWordle: false },
  { word: 'WHOOT', frequency: 2.82e-08, inWordle: false },
  { word: 'WHORE', frequency: 7.24e-06, inWordle: false },
  { word: 'WHORL', frequency: 3.63e-07, inWordle: false },
  { word: 'WHOSO', frequency: 1e-07, inWordle: false },
  { word: 'WHUMP', frequency: 2.24e-08, inWordle: false },
  { word: 'WICCA', frequency: 3.98e-07, inWordle: false },
  { word: 'WICKS', frequency: 6.61e-07, inWordle: false },
  { word: 'WICKY', frequency: 3.63e-08, inWordle: false },
  { word: 'WIDES', frequency: 9.55e-08, inWordle: false },
  { word: 'WIFED', frequency: 1.66e-08, inWordle: false },
  { word: 'WIFES', frequency: 3.24e-07, inWordle: false },
  { word: 'WIFEY', frequency: 3.31e-07, inWordle: false },
  { word: 'WIGAN', frequency: 2.63e-06, inWordle: false },
  { word: 'WIGGA', frequency: 1.45e-08, inWordle: false },
  { word: 'WIGGY', frequency: 8.32e-08, inWordle: false },
  { word: 'WIKIS', frequency: 2.4e-07, inWordle: false },
  { word: 'WILCO', frequency: 3.31e-07, inWordle: false },
  { word: 'WILDS', frequency: 7.94e-07, inWordle: false },
  { word: 'WILES', frequency: 5.13e-07, inWordle: false },
  { word: 'WILGA', frequency: 1.02e-08, inWordle: false },
  { word: 'WILIS', frequency: 1.35e-08, inWordle: false },
  { word: 'WILLS', frequency: 4.07e-06, inWordle: false },
  { word: 'WILTS', frequency: 2.24e-07, inWordle: false },
  { word: 'WIMPS', frequency: 2.45e-07, inWordle: false },
  { word: 'WINDS', frequency: 1.66e-05, inWordle: false },
  { word: 'WINED', frequency: 1.12e-07, inWordle: false },
  { word: 'WINES', frequency: 6.31e-06, inWordle: false },
  { word: 'WINEY', frequency: 2.95e-08, inWordle: false },
  { word: 'WINGE', frequency: 3.8e-08, inWordle: false },
  { word: 'WINGS', frequency: 2.75e-05, inWordle: false },
  { word: 'WINGY', frequency: 2.29e-08, inWordle: false },
  { word: 'WINKS', frequency: 6.31e-07, inWordle: false },
  { word: 'WINNA', frequency: 2.69e-08, inWordle: false },
  { word: 'WINNS', frequency: 1.1e-08, inWordle: false },
  { word: 'WINOS', frequency: 3.72e-08, inWordle: false },
  { word: 'WIPED', frequency: 7.24e-06, inWordle: false },
  { word: 'WIPER', frequency: 6.46e-07, inWordle: false },
  { word: 'WIPES', frequency: 2.51e-06, inWordle: false },
  { word: 'WIRED', frequency: 6.31e-06, inWordle: false },
  { word: 'WIRES', frequency: 7.08e-06, inWordle: false },
  { word: 'WISED', frequency: 1.02e-07, inWordle: false },
  { word: 'WISES', frequency: 2.69e-08, inWordle: false },
  { word: 'WISPS', frequency: 2.75e-07, inWordle: false },
  { word: 'WITAN', frequency: 4.57e-08, inWordle: false },
  { word: 'WITHE', frequency: 1.29e-07, inWordle: false },
  { word: 'WITHS', frequency: 2.04e-08, inWordle: false },
  { word: 'WITHY', frequency: 6.46e-08, inWordle: false },
  { word: 'WIVES', frequency: 1.2e-05, inWordle: false },
  { word: 'WODGE', frequency: 1.74e-08, inWordle: false },
  { word: 'WOLDS', frequency: 8.71e-08, inWordle: false },
  { word: 'WOLFS', frequency: 1.38e-07, inWordle: false },
  { word: 'WOLLY', frequency: 3.47e-08, inWordle: false },
  { word: 'WOLVE', frequency: 1.15e-08, inWordle: false },
  { word: 'WOMBS', frequency: 1.86e-07, inWordle: false },
  { word: 'WOMYN', frequency: 5.37e-08, inWordle: false },
  { word: 'WONGA', frequency: 1.23e-07, inWordle: false },
  { word: 'WONKS', frequency: 9.12e-08, inWordle: false },
  { word: 'WONKY', frequency: 6.92e-07, inWordle: false },
  { word: 'WOODS', frequency: 2.82e-05, inWordle: false },
  { word: 'WOOED', frequency: 3.31e-07, inWordle: false },
  { word: 'WOOFS', frequency: 3.02e-08, inWordle: false },
  { word: 'WOOFY', frequency: 1.91e-08, inWordle: false },
  { word: 'WOOLS', frequency: 1.02e-07, inWordle: false },
  { word: 'WOOPS', frequency: 2.51e-07, inWordle: false },
  { word: 'WOOSH', frequency: 7.24e-08, inWordle: false },
  { word: 'WOOTZ', frequency: 1.78e-08, inWordle: false },
  { word: 'WORDS', frequency: 0.000178, inWordle: false },
  { word: 'WORKS', frequency: 0.000195, inWordle: false },
  { word: 'WORMS', frequency: 6.03e-06, inWordle: false },
  { word: 'WORMY', frequency: 1.07e-07, inWordle: false },
  { word: 'WORTS', frequency: 3.8e-08, inWordle: false },
  { word: 'WOWED', frequency: 4.17e-07, inWordle: false },
  { word: 'WOWEE', frequency: 7.76e-08, inWordle: false },
  { word: 'WRANG', frequency: 1.48e-08, inWordle: false },
  { word: 'WRAPS', frequency: 3.72e-06, inWordle: false },
  { word: 'WRAPT', frequency: 1.41e-08, inWordle: false },
  { word: 'WRENS', frequency: 1.66e-07, inWordle: false },
  { word: 'WRITS', frequency: 3.55e-07, inWordle: false },
  { word: 'WROTH', frequency: 1.26e-07, inWordle: false },
  { word: 'WURST', frequency: 1.62e-07, inWordle: false },
  { word: 'WUSHU', frequency: 1.58e-07, inWordle: false },
  { word: 'WUSSY', frequency: 8.32e-08, inWordle: false },
  { word: 'WUXIA', frequency: 5.75e-08, inWordle: false },
  { word: 'WYLES', frequency: 3.24e-08, inWordle: false },
  { word: 'WYNNS', frequency: 2.75e-08, inWordle: false },
  { word: 'XEBEC', frequency: 1.45e-08, inWordle: false },
  { word: 'XENIA', frequency: 2.95e-07, inWordle: false },
  { word: 'XENON', frequency: 7.94e-07, inWordle: false },
  { word: 'XERIC', frequency: 4.47e-08, inWordle: false },
  { word: 'XEROX', frequency: 1.02e-06, inWordle: false },
  { word: 'XRAYS', frequency: 8.51e-08, inWordle: false },
  { word: 'XYLAN', frequency: 2.82e-08, inWordle: false },
  { word: 'XYLEM', frequency: 1.62e-07, inWordle: false },
  { word: 'YABBA', frequency: 6.61e-08, inWordle: false },
  { word: 'YABBY', frequency: 2.14e-08, inWordle: false },
  { word: 'YAGER', frequency: 1.02e-07, inWordle: false },
  { word: 'YAHOO', frequency: 7.24e-06, inWordle: false },
  { word: 'YAKKA', frequency: 2.69e-08, inWordle: false },
  { word: 'YALES', frequency: 1.02e-08, inWordle: false },
  { word: 'YAMEN', frequency: 5.89e-08, inWordle: false },
  { word: 'YANGS', frequency: 6.17e-08, inWordle: false },
  { word: 'YANKS', frequency: 1.07e-06, inWordle: false },
  { word: 'YAPPY', frequency: 7.24e-08, inWordle: false },
  { word: 'YARDS', frequency: 3.24e-05, inWordle: false },
  { word: 'YARNS', frequency: 8.51e-07, inWordle: false },
  { word: 'YATES', frequency: 3.02e-06, inWordle: false },
  { word: 'YAWED', frequency: 1.05e-08, inWordle: false },
  { word: 'YAWLS', frequency: 1.32e-08, inWordle: false },
  { word: 'YAWNS', frequency: 4.57e-07, inWordle: false },
  { word: 'YEAHS', frequency: 1.32e-07, inWordle: false },
  { word: 'YEARD', frequency: 1.95e-08, inWordle: false },
  { word: 'YEARS', frequency: 0.000912, inWordle: false },
  { word: 'YEESH', frequency: 1.66e-07, inWordle: false },
  { word: 'YELLS', frequency: 2.82e-06, inWordle: false },
  { word: 'YELPS', frequency: 1.2e-07, inWordle: false },
  { word: 'YENTA', frequency: 1.62e-08, inWordle: false },
  { word: 'YENTE', frequency: 1.2e-08, inWordle: false },
  { word: 'YERBA', frequency: 2.19e-07, inWordle: false },
  { word: 'YESES', frequency: 9.33e-08, inWordle: false },
  { word: 'YETIS', frequency: 7.41e-08, inWordle: false },
  { word: 'YIKES', frequency: 2.75e-06, inWordle: false },
  { word: 'YIPES', frequency: 4.17e-08, inWordle: false },
  { word: 'YIPPY', frequency: 3.02e-08, inWordle: false },
  { word: 'YOBBO', frequency: 1.38e-08, inWordle: false },
  { word: 'YODEL', frequency: 2.19e-07, inWordle: false },
  { word: 'YOGAS', frequency: 8.51e-08, inWordle: false },
  { word: 'YOGIC', frequency: 2e-07, inWordle: false },
  { word: 'YOGIN', frequency: 2.14e-08, inWordle: false },
  { word: 'YOGIS', frequency: 1.91e-07, inWordle: false },
  { word: 'YOKED', frequency: 2.14e-07, inWordle: false },
  { word: 'YOKEL', frequency: 8.13e-08, inWordle: false },
  { word: 'YOKER', frequency: 2e-08, inWordle: false },
  { word: 'YOKES', frequency: 1.17e-07, inWordle: false },
  { word: 'YOLKS', frequency: 6.76e-07, inWordle: false },
  { word: 'YOLKY', frequency: 1.12e-08, inWordle: false },
  { word: 'YONIS', frequency: 1.38e-08, inWordle: false },
  { word: 'YONKS', frequency: 4.68e-08, inWordle: false },
  { word: 'YORKS', frequency: 3.09e-07, inWordle: false },
  { word: 'YOURN', frequency: 1.78e-08, inWordle: false },
  { word: 'YOURS', frequency: 5.62e-05, inWordle: false },
  { word: 'YOUSE', frequency: 1.91e-07, inWordle: false },
  { word: 'YOWIE', frequency: 2.95e-08, inWordle: false },
  { word: 'YOWLS', frequency: 1.82e-08, inWordle: false },
  { word: 'YOWZA', frequency: 7.24e-08, inWordle: false },
  { word: 'YUANS', frequency: 1.7e-08, inWordle: false },
  { word: 'YUCCA', frequency: 4.47e-07, inWordle: false },
  { word: 'YUCKS', frequency: 1.78e-08, inWordle: false },
  { word: 'YUCKY', frequency: 3.02e-07, inWordle: false },
  { word: 'YUGAS', frequency: 2.24e-08, inWordle: false },
  { word: 'YUKOS', frequency: 7.59e-08, inWordle: false },
  { word: 'YULAN', frequency: 1.78e-08, inWordle: false },
  { word: 'YUMMO', frequency: 1.74e-08, inWordle: false },
  { word: 'YUMMY', frequency: 3.47e-06, inWordle: false },
  { word: 'YUPPY', frequency: 3.16e-08, inWordle: false },
  { word: 'YURTS', frequency: 1e-07, inWordle: false },
  { word: 'ZACKS', frequency: 3.02e-07, inWordle: false },
  { word: 'ZAIDA', frequency: 2.45e-08, inWordle: false },
  { word: 'ZAIRE', frequency: 7.76e-07, inWordle: false },
  { word: 'ZAKAT', frequency: 2.14e-07, inWordle: false },
  { word: 'ZAMAN', frequency: 3.39e-07, inWordle: false },
  { word: 'ZAMBO', frequency: 3.09e-08, inWordle: false },
  { word: 'ZAMIA', frequency: 1.7e-08, inWordle: false },
  { word: 'ZANJA', frequency: 1.1e-08, inWordle: false },
  { word: 'ZANTE', frequency: 9.55e-08, inWordle: false },
  { word: 'ZANZA', frequency: 1.45e-08, inWordle: false },
  { word: 'ZAPPY', frequency: 3.47e-08, inWordle: false },
  { word: 'ZAZEN', frequency: 9.33e-08, inWordle: false },
  { word: 'ZENDO', frequency: 2.29e-08, inWordle: false },
  { word: 'ZEROS', frequency: 1.15e-06, inWordle: false },
  { word: 'ZETAS', frequency: 2.88e-07, inWordle: false },
  { word: 'ZILCH', frequency: 2.95e-07, inWordle: false },
  { word: 'ZILLA', frequency: 2.29e-07, inWordle: false },
  { word: 'ZINEB', frequency: 2.19e-08, inWordle: false },
  { word: 'ZINES', frequency: 2.04e-07, inWordle: false },
  { word: 'ZINGS', frequency: 5.13e-08, inWordle: false },
  { word: 'ZINGY', frequency: 6.92e-08, inWordle: false },
  { word: 'ZINKE', frequency: 1.41e-07, inWordle: false },
  { word: 'ZIPPO', frequency: 2.82e-07, inWordle: false },
  { word: 'ZIPPY', frequency: 3.31e-07, inWordle: false },
  { word: 'ZLOTY', frequency: 1.12e-07, inWordle: false },
  { word: 'ZOMBI', frequency: 5.25e-08, inWordle: false },
  { word: 'ZONDA', frequency: 8.51e-08, inWordle: false },
  { word: 'ZONED', frequency: 1.45e-06, inWordle: false },
  { word: 'ZONER', frequency: 2.4e-08, inWordle: false },
  { word: 'ZONES', frequency: 1.32e-05, inWordle: false },
  { word: 'ZOOEY', frequency: 3.8e-07, inWordle: false },
  { word: 'ZOOID', frequency: 2.04e-08, inWordle: false },
  { word: 'ZOOKS', frequency: 1.62e-08, inWordle: false },
  { word: 'ZOOMS', frequency: 5.25e-07, inWordle: false },
  { word: 'ZORRO', frequency: 5.62e-07, inWordle: false },
  { word: 'ZOUKS', frequency: 1.58e-08, inWordle: false },
  { word: 'ZOWIE', frequency: 9.33e-08, inWordle: false },
  { word: 'ZULUS', frequency: 2.34e-07, inWordle: false },
  { word: 'ZUPAN', frequency: 2.04e-08, inWordle: false },
  { word: 'ZUPPA', frequency: 2.63e-08, inWordle: false },
  { word: 'ZYGON', frequency: 5.25e-08, inWordle: false },
].sort((a, b) => b.frequency - a.frequency);
